import { jsx as p, Fragment as pt, jsxs as ae } from "react/jsx-runtime";
import * as d from "react";
import N, { useState as rr, useLayoutEffect as pi, useMemo as wn, useContext as mi, createContext as hi, forwardRef as gi, createElement as To, useCallback as Re, useRef as Jn, useEffect as gp } from "react";
import * as yr from "react-dom";
import vp from "react-dom";
function vi(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (n = vi(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function bi() {
  for (var e, t, n = 0, r = "", o = arguments.length; n < o; n++) (e = arguments[n]) && (t = vi(e)) && (r && (r += " "), r += t);
  return r;
}
const bp = (e, t) => {
  const n = new Array(e.length + t.length);
  for (let r = 0; r < e.length; r++)
    n[r] = e[r];
  for (let r = 0; r < t.length; r++)
    n[e.length + r] = t[r];
  return n;
}, yp = (e, t) => ({
  classGroupId: e,
  validator: t
}), yi = (e = /* @__PURE__ */ new Map(), t = null, n) => ({
  nextPart: e,
  validators: t,
  classGroupId: n
}), or = "-", ss = [], wp = "arbitrary..", xp = (e) => {
  const t = Cp(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = e;
  return {
    getClassGroupId: (s) => {
      if (s.startsWith("[") && s.endsWith("]"))
        return Sp(s);
      const i = s.split(or), l = i[0] === "" && i.length > 1 ? 1 : 0;
      return wi(i, l, t);
    },
    getConflictingClassGroupIds: (s, i) => {
      if (i) {
        const l = r[s], c = n[s];
        return l ? c ? bp(c, l) : l : c || ss;
      }
      return n[s] || ss;
    }
  };
}, wi = (e, t, n) => {
  if (e.length - t === 0)
    return n.classGroupId;
  const o = e[t], a = n.nextPart.get(o);
  if (a) {
    const c = wi(e, t + 1, a);
    if (c) return c;
  }
  const s = n.validators;
  if (s === null)
    return;
  const i = t === 0 ? e.join(or) : e.slice(t).join(or), l = s.length;
  for (let c = 0; c < l; c++) {
    const f = s[c];
    if (f.validator(i))
      return f.classGroupId;
  }
}, Sp = (e) => e.slice(1, -1).indexOf(":") === -1 ? void 0 : (() => {
  const t = e.slice(1, -1), n = t.indexOf(":"), r = t.slice(0, n);
  return r ? wp + r : void 0;
})(), Cp = (e) => {
  const {
    theme: t,
    classGroups: n
  } = e;
  return kp(n, t);
}, kp = (e, t) => {
  const n = yi();
  for (const r in e) {
    const o = e[r];
    na(o, n, r, t);
  }
  return n;
}, na = (e, t, n, r) => {
  const o = e.length;
  for (let a = 0; a < o; a++) {
    const s = e[a];
    Ep(s, t, n, r);
  }
}, Ep = (e, t, n, r) => {
  if (typeof e == "string") {
    Mp(e, t, n);
    return;
  }
  if (typeof e == "function") {
    Pp(e, t, n, r);
    return;
  }
  Dp(e, t, n, r);
}, Mp = (e, t, n) => {
  const r = e === "" ? t : xi(t, e);
  r.classGroupId = n;
}, Pp = (e, t, n, r) => {
  if (Op(e)) {
    na(e(r), t, n, r);
    return;
  }
  t.validators === null && (t.validators = []), t.validators.push(yp(n, e));
}, Dp = (e, t, n, r) => {
  const o = Object.entries(e), a = o.length;
  for (let s = 0; s < a; s++) {
    const [i, l] = o[s];
    na(l, xi(t, i), n, r);
  }
}, xi = (e, t) => {
  let n = e;
  const r = t.split(or), o = r.length;
  for (let a = 0; a < o; a++) {
    const s = r[a];
    let i = n.nextPart.get(s);
    i || (i = yi(), n.nextPart.set(s, i)), n = i;
  }
  return n;
}, Op = (e) => "isThemeGetter" in e && e.isThemeGetter === !0, Np = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ Object.create(null), r = /* @__PURE__ */ Object.create(null);
  const o = (a, s) => {
    n[a] = s, t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ Object.create(null));
  };
  return {
    get(a) {
      let s = n[a];
      if (s !== void 0)
        return s;
      if ((s = r[a]) !== void 0)
        return o(a, s), s;
    },
    set(a, s) {
      a in n ? n[a] = s : o(a, s);
    }
  };
}, Ao = "!", is = ":", _p = [], ls = (e, t, n, r, o) => ({
  modifiers: e,
  hasImportantModifier: t,
  baseClassName: n,
  maybePostfixModifierPosition: r,
  isExternal: o
}), Rp = (e) => {
  const {
    prefix: t,
    experimentalParseClassName: n
  } = e;
  let r = (o) => {
    const a = [];
    let s = 0, i = 0, l = 0, c;
    const f = o.length;
    for (let g = 0; g < f; g++) {
      const v = o[g];
      if (s === 0 && i === 0) {
        if (v === is) {
          a.push(o.slice(l, g)), l = g + 1;
          continue;
        }
        if (v === "/") {
          c = g;
          continue;
        }
      }
      v === "[" ? s++ : v === "]" ? s-- : v === "(" ? i++ : v === ")" && i--;
    }
    const u = a.length === 0 ? o : o.slice(l);
    let m = u, h = !1;
    u.endsWith(Ao) ? (m = u.slice(0, -1), h = !0) : (
      /**
       * In Tailwind CSS v3 the important modifier was at the start of the base class name. This is still supported for legacy reasons.
       * @see https://github.com/dcastil/tailwind-merge/issues/513#issuecomment-2614029864
       */
      u.startsWith(Ao) && (m = u.slice(1), h = !0)
    );
    const b = c && c > l ? c - l : void 0;
    return ls(a, h, m, b);
  };
  if (t) {
    const o = t + is, a = r;
    r = (s) => s.startsWith(o) ? a(s.slice(o.length)) : ls(_p, !1, s, void 0, !0);
  }
  if (n) {
    const o = r;
    r = (a) => n({
      className: a,
      parseClassName: o
    });
  }
  return r;
}, Tp = (e) => {
  const t = /* @__PURE__ */ new Map();
  return e.orderSensitiveModifiers.forEach((n, r) => {
    t.set(n, 1e6 + r);
  }), (n) => {
    const r = [];
    let o = [];
    for (let a = 0; a < n.length; a++) {
      const s = n[a], i = s[0] === "[", l = t.has(s);
      i || l ? (o.length > 0 && (o.sort(), r.push(...o), o = []), r.push(s)) : o.push(s);
    }
    return o.length > 0 && (o.sort(), r.push(...o)), r;
  };
}, Ap = (e) => ({
  cache: Np(e.cacheSize),
  parseClassName: Rp(e),
  sortModifiers: Tp(e),
  ...xp(e)
}), Ip = /\s+/, Wp = (e, t) => {
  const {
    parseClassName: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: o,
    sortModifiers: a
  } = t, s = [], i = e.trim().split(Ip);
  let l = "";
  for (let c = i.length - 1; c >= 0; c -= 1) {
    const f = i[c], {
      isExternal: u,
      modifiers: m,
      hasImportantModifier: h,
      baseClassName: b,
      maybePostfixModifierPosition: g
    } = n(f);
    if (u) {
      l = f + (l.length > 0 ? " " + l : l);
      continue;
    }
    let v = !!g, y = r(v ? b.substring(0, g) : b);
    if (!y) {
      if (!v) {
        l = f + (l.length > 0 ? " " + l : l);
        continue;
      }
      if (y = r(b), !y) {
        l = f + (l.length > 0 ? " " + l : l);
        continue;
      }
      v = !1;
    }
    const w = m.length === 0 ? "" : m.length === 1 ? m[0] : a(m).join(":"), x = h ? w + Ao : w, S = x + y;
    if (s.indexOf(S) > -1)
      continue;
    s.push(S);
    const k = o(y, v);
    for (let C = 0; C < k.length; ++C) {
      const E = k[C];
      s.push(x + E);
    }
    l = f + (l.length > 0 ? " " + l : l);
  }
  return l;
}, Fp = (...e) => {
  let t = 0, n, r, o = "";
  for (; t < e.length; )
    (n = e[t++]) && (r = Si(n)) && (o && (o += " "), o += r);
  return o;
}, Si = (e) => {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (t = Si(e[r])) && (n && (n += " "), n += t);
  return n;
}, Lp = (e, ...t) => {
  let n, r, o, a;
  const s = (l) => {
    const c = t.reduce((f, u) => u(f), e());
    return n = Ap(c), r = n.cache.get, o = n.cache.set, a = i, i(l);
  }, i = (l) => {
    const c = r(l);
    if (c)
      return c;
    const f = Wp(l, n);
    return o(l, f), f;
  };
  return a = s, (...l) => a(Fp(...l));
}, $p = [], ye = (e) => {
  const t = (n) => n[e] || $p;
  return t.isThemeGetter = !0, t;
}, Ci = /^\[(?:(\w[\w-]*):)?(.+)\]$/i, ki = /^\((?:(\w[\w-]*):)?(.+)\)$/i, zp = /^\d+(?:\.\d+)?\/\d+(?:\.\d+)?$/, Bp = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, Yp = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, Hp = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/, Vp = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, Gp = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, lt = (e) => zp.test(e), ne = (e) => !!e && !Number.isNaN(Number(e)), ct = (e) => !!e && Number.isInteger(Number(e)), co = (e) => e.endsWith("%") && ne(e.slice(0, -1)), Qe = (e) => Bp.test(e), Ei = () => !0, Up = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  Yp.test(e) && !Hp.test(e)
), ra = () => !1, jp = (e) => Vp.test(e), Kp = (e) => Gp.test(e), qp = (e) => !V(e) && !G(e), Xp = (e) => bt(e, Di, ra), V = (e) => Ci.test(e), Mt = (e) => bt(e, Oi, Up), cs = (e) => bt(e, om, ne), Zp = (e) => bt(e, _i, Ei), Qp = (e) => bt(e, Ni, ra), ds = (e) => bt(e, Mi, ra), Jp = (e) => bt(e, Pi, Kp), Vn = (e) => bt(e, Ri, jp), G = (e) => ki.test(e), fn = (e) => At(e, Oi), em = (e) => At(e, Ni), us = (e) => At(e, Mi), tm = (e) => At(e, Di), nm = (e) => At(e, Pi), Gn = (e) => At(e, Ri, !0), rm = (e) => At(e, _i, !0), bt = (e, t, n) => {
  const r = Ci.exec(e);
  return r ? r[1] ? t(r[1]) : n(r[2]) : !1;
}, At = (e, t, n = !1) => {
  const r = ki.exec(e);
  return r ? r[1] ? t(r[1]) : n : !1;
}, Mi = (e) => e === "position" || e === "percentage", Pi = (e) => e === "image" || e === "url", Di = (e) => e === "length" || e === "size" || e === "bg-size", Oi = (e) => e === "length", om = (e) => e === "number", Ni = (e) => e === "family-name", _i = (e) => e === "number" || e === "weight", Ri = (e) => e === "shadow", am = () => {
  const e = ye("color"), t = ye("font"), n = ye("text"), r = ye("font-weight"), o = ye("tracking"), a = ye("leading"), s = ye("breakpoint"), i = ye("container"), l = ye("spacing"), c = ye("radius"), f = ye("shadow"), u = ye("inset-shadow"), m = ye("text-shadow"), h = ye("drop-shadow"), b = ye("blur"), g = ye("perspective"), v = ye("aspect"), y = ye("ease"), w = ye("animate"), x = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], S = () => [
    "center",
    "top",
    "bottom",
    "left",
    "right",
    "top-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-top",
    "top-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-top",
    "bottom-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-bottom",
    "bottom-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-bottom"
  ], k = () => [...S(), G, V], C = () => ["auto", "hidden", "clip", "visible", "scroll"], E = () => ["auto", "contain", "none"], M = () => [G, V, l], O = () => [lt, "full", "auto", ...M()], R = () => [ct, "none", "subgrid", G, V], W = () => ["auto", {
    span: ["full", ct, G, V]
  }, ct, G, V], Y = () => [ct, "auto", G, V], K = () => ["auto", "min", "max", "fr", G, V], H = () => ["start", "end", "center", "between", "around", "evenly", "stretch", "baseline", "center-safe", "end-safe"], Q = () => ["start", "end", "center", "stretch", "center-safe", "end-safe"], $ = () => ["auto", ...M()], q = () => [lt, "auto", "full", "dvw", "dvh", "lvw", "lvh", "svw", "svh", "min", "max", "fit", ...M()], z = () => [lt, "screen", "full", "dvw", "lvw", "svw", "min", "max", "fit", ...M()], T = () => [lt, "screen", "full", "lh", "dvh", "lvh", "svh", "min", "max", "fit", ...M()], I = () => [e, G, V], le = () => [...S(), us, ds, {
    position: [G, V]
  }], D = () => ["no-repeat", {
    repeat: ["", "x", "y", "space", "round"]
  }], j = () => ["auto", "cover", "contain", tm, Xp, {
    size: [G, V]
  }], X = () => [co, fn, Mt], F = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    "full",
    c,
    G,
    V
  ], U = () => ["", ne, fn, Mt], _ = () => ["solid", "dashed", "dotted", "double"], ee = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], Z = () => [ne, co, us, ds], re = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    b,
    G,
    V
  ], ce = () => ["none", ne, G, V], pe = () => ["none", ne, G, V], Se = () => [ne, G, V], Pe = () => [lt, "full", ...M()];
  return {
    cacheSize: 500,
    theme: {
      animate: ["spin", "ping", "pulse", "bounce"],
      aspect: ["video"],
      blur: [Qe],
      breakpoint: [Qe],
      color: [Ei],
      container: [Qe],
      "drop-shadow": [Qe],
      ease: ["in", "out", "in-out"],
      font: [qp],
      "font-weight": ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black"],
      "inset-shadow": [Qe],
      leading: ["none", "tight", "snug", "normal", "relaxed", "loose"],
      perspective: ["dramatic", "near", "normal", "midrange", "distant", "none"],
      radius: [Qe],
      shadow: [Qe],
      spacing: ["px", ne],
      text: [Qe],
      "text-shadow": [Qe],
      tracking: ["tighter", "tight", "normal", "wide", "wider", "widest"]
    },
    classGroups: {
      // --------------
      // --- Layout ---
      // --------------
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", lt, V, G, v]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       * @deprecated since Tailwind CSS v4.0.0
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [ne, V, G, i]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": x()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": x()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Screen Reader Only
       * @see https://tailwindcss.com/docs/display#screen-reader-only
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: k()
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: C()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": C()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": C()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: E()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": E()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": E()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Inset
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: O()
      }],
      /**
       * Inset Inline
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": O()
      }],
      /**
       * Inset Block
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": O()
      }],
      /**
       * Inset Inline Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       * @todo class group will be renamed to `inset-s` in next major release
       */
      start: [{
        "inset-s": O(),
        /**
         * @deprecated since Tailwind CSS v4.2.0 in favor of `inset-s-*` utilities.
         * @see https://github.com/tailwindlabs/tailwindcss/pull/19613
         */
        start: O()
      }],
      /**
       * Inset Inline End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       * @todo class group will be renamed to `inset-e` in next major release
       */
      end: [{
        "inset-e": O(),
        /**
         * @deprecated since Tailwind CSS v4.2.0 in favor of `inset-e-*` utilities.
         * @see https://github.com/tailwindlabs/tailwindcss/pull/19613
         */
        end: O()
      }],
      /**
       * Inset Block Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-bs": [{
        "inset-bs": O()
      }],
      /**
       * Inset Block End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-be": [{
        "inset-be": O()
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: O()
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: O()
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: O()
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: O()
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: [ct, "auto", G, V]
      }],
      // ------------------------
      // --- Flexbox and Grid ---
      // ------------------------
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: [lt, "full", "auto", i, ...M()]
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["nowrap", "wrap", "wrap-reverse"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: [ne, lt, "auto", "initial", "none", V]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: ["", ne, G, V]
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: ["", ne, G, V]
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: [ct, "first", "last", "none", G, V]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": R()
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: W()
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": Y()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": Y()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": R()
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: W()
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": Y()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": Y()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": K()
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": K()
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: M()
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": M()
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": M()
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: [...H(), "normal"]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": [...Q(), "normal"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", ...Q()]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...H()]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: [...Q(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", ...Q(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": H()
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": [...Q(), "baseline"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", ...Q()]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: M()
      }],
      /**
       * Padding Inline
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: M()
      }],
      /**
       * Padding Block
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: M()
      }],
      /**
       * Padding Inline Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: M()
      }],
      /**
       * Padding Inline End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: M()
      }],
      /**
       * Padding Block Start
       * @see https://tailwindcss.com/docs/padding
       */
      pbs: [{
        pbs: M()
      }],
      /**
       * Padding Block End
       * @see https://tailwindcss.com/docs/padding
       */
      pbe: [{
        pbe: M()
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: M()
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: M()
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: M()
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: M()
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: $()
      }],
      /**
       * Margin Inline
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: $()
      }],
      /**
       * Margin Block
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: $()
      }],
      /**
       * Margin Inline Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: $()
      }],
      /**
       * Margin Inline End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: $()
      }],
      /**
       * Margin Block Start
       * @see https://tailwindcss.com/docs/margin
       */
      mbs: [{
        mbs: $()
      }],
      /**
       * Margin Block End
       * @see https://tailwindcss.com/docs/margin
       */
      mbe: [{
        mbe: $()
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: $()
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: $()
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: $()
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: $()
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x": [{
        "space-x": M()
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y": [{
        "space-y": M()
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y-reverse": ["space-y-reverse"],
      // --------------
      // --- Sizing ---
      // --------------
      /**
       * Size
       * @see https://tailwindcss.com/docs/width#setting-both-width-and-height
       */
      size: [{
        size: q()
      }],
      /**
       * Inline Size
       * @see https://tailwindcss.com/docs/width
       */
      "inline-size": [{
        inline: ["auto", ...z()]
      }],
      /**
       * Min-Inline Size
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-inline-size": [{
        "min-inline": ["auto", ...z()]
      }],
      /**
       * Max-Inline Size
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-inline-size": [{
        "max-inline": ["none", ...z()]
      }],
      /**
       * Block Size
       * @see https://tailwindcss.com/docs/height
       */
      "block-size": [{
        block: ["auto", ...T()]
      }],
      /**
       * Min-Block Size
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-block-size": [{
        "min-block": ["auto", ...T()]
      }],
      /**
       * Max-Block Size
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-block-size": [{
        "max-block": ["none", ...T()]
      }],
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: [i, "screen", ...q()]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [
          i,
          "screen",
          /** Deprecated. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "none",
          ...q()
        ]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [
          i,
          "screen",
          "none",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "prose",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          {
            screen: [s]
          },
          ...q()
        ]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: ["screen", "lh", ...q()]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["screen", "lh", "none", ...q()]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": ["screen", "lh", ...q()]
      }],
      // ------------------
      // --- Typography ---
      // ------------------
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", n, fn, Mt]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: [r, rm, Zp]
      }],
      /**
       * Font Stretch
       * @see https://tailwindcss.com/docs/font-stretch
       */
      "font-stretch": [{
        "font-stretch": ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded", co, V]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [em, Qp, t]
      }],
      /**
       * Font Feature Settings
       * @see https://tailwindcss.com/docs/font-feature-settings
       */
      "font-features": [{
        "font-features": [V]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: [o, G, V]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": [ne, "none", G, cs]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: [
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          a,
          ...M()
        ]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", G, V]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["disc", "decimal", "none", G, V]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://v3.tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: I()
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: I()
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [..._(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: [ne, "from-font", "auto", G, Mt]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: I()
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": [ne, "auto", G, V]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: M()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", G, V]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Overflow Wrap
       * @see https://tailwindcss.com/docs/overflow-wrap
       */
      wrap: [{
        wrap: ["break-word", "anywhere", "normal"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", G, V]
      }],
      // -------------------
      // --- Backgrounds ---
      // -------------------
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: le()
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: D()
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: j()
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          linear: [{
            to: ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
          }, ct, G, V],
          radial: ["", G, V],
          conic: [ct, G, V]
        }, nm, Jp]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: I()
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: X()
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: X()
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: X()
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: I()
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: I()
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: I()
      }],
      // ---------------
      // --- Borders ---
      // ---------------
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: F()
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": F()
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": F()
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": F()
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": F()
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": F()
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": F()
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": F()
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": F()
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": F()
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": F()
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": F()
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": F()
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": F()
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": F()
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: U()
      }],
      /**
       * Border Width Inline
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": U()
      }],
      /**
       * Border Width Block
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": U()
      }],
      /**
       * Border Width Inline Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": U()
      }],
      /**
       * Border Width Inline End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": U()
      }],
      /**
       * Border Width Block Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-bs": [{
        "border-bs": U()
      }],
      /**
       * Border Width Block End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-be": [{
        "border-be": U()
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": U()
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": U()
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": U()
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": U()
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x": [{
        "divide-x": U()
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y": [{
        "divide-y": U()
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [..._(), "hidden", "none"]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
       */
      "divide-style": [{
        divide: [..._(), "hidden", "none"]
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: I()
      }],
      /**
       * Border Color Inline
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": I()
      }],
      /**
       * Border Color Block
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": I()
      }],
      /**
       * Border Color Inline Start
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": I()
      }],
      /**
       * Border Color Inline End
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": I()
      }],
      /**
       * Border Color Block Start
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-bs": [{
        "border-bs": I()
      }],
      /**
       * Border Color Block End
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-be": [{
        "border-be": I()
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": I()
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": I()
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": I()
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": I()
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: I()
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [..._(), "none", "hidden"]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [ne, G, V]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: ["", ne, fn, Mt]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: I()
      }],
      // ---------------
      // --- Effects ---
      // ---------------
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          f,
          Gn,
          Vn
        ]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
       */
      "shadow-color": [{
        shadow: I()
      }],
      /**
       * Inset Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
       */
      "inset-shadow": [{
        "inset-shadow": ["none", u, Gn, Vn]
      }],
      /**
       * Inset Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
       */
      "inset-shadow-color": [{
        "inset-shadow": I()
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
       */
      "ring-w": [{
        ring: U()
      }],
      /**
       * Ring Width Inset
       * @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
       */
      "ring-color": [{
        ring: I()
      }],
      /**
       * Ring Offset Width
       * @see https://v3.tailwindcss.com/docs/ring-offset-width
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-w": [{
        "ring-offset": [ne, Mt]
      }],
      /**
       * Ring Offset Color
       * @see https://v3.tailwindcss.com/docs/ring-offset-color
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-color": [{
        "ring-offset": I()
      }],
      /**
       * Inset Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
       */
      "inset-ring-w": [{
        "inset-ring": U()
      }],
      /**
       * Inset Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
       */
      "inset-ring-color": [{
        "inset-ring": I()
      }],
      /**
       * Text Shadow
       * @see https://tailwindcss.com/docs/text-shadow
       */
      "text-shadow": [{
        "text-shadow": ["none", m, Gn, Vn]
      }],
      /**
       * Text Shadow Color
       * @see https://tailwindcss.com/docs/text-shadow#setting-the-shadow-color
       */
      "text-shadow-color": [{
        "text-shadow": I()
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [ne, G, V]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...ee(), "plus-darker", "plus-lighter"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": ee()
      }],
      /**
       * Mask Clip
       * @see https://tailwindcss.com/docs/mask-clip
       */
      "mask-clip": [{
        "mask-clip": ["border", "padding", "content", "fill", "stroke", "view"]
      }, "mask-no-clip"],
      /**
       * Mask Composite
       * @see https://tailwindcss.com/docs/mask-composite
       */
      "mask-composite": [{
        mask: ["add", "subtract", "intersect", "exclude"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image-linear-pos": [{
        "mask-linear": [ne]
      }],
      "mask-image-linear-from-pos": [{
        "mask-linear-from": Z()
      }],
      "mask-image-linear-to-pos": [{
        "mask-linear-to": Z()
      }],
      "mask-image-linear-from-color": [{
        "mask-linear-from": I()
      }],
      "mask-image-linear-to-color": [{
        "mask-linear-to": I()
      }],
      "mask-image-t-from-pos": [{
        "mask-t-from": Z()
      }],
      "mask-image-t-to-pos": [{
        "mask-t-to": Z()
      }],
      "mask-image-t-from-color": [{
        "mask-t-from": I()
      }],
      "mask-image-t-to-color": [{
        "mask-t-to": I()
      }],
      "mask-image-r-from-pos": [{
        "mask-r-from": Z()
      }],
      "mask-image-r-to-pos": [{
        "mask-r-to": Z()
      }],
      "mask-image-r-from-color": [{
        "mask-r-from": I()
      }],
      "mask-image-r-to-color": [{
        "mask-r-to": I()
      }],
      "mask-image-b-from-pos": [{
        "mask-b-from": Z()
      }],
      "mask-image-b-to-pos": [{
        "mask-b-to": Z()
      }],
      "mask-image-b-from-color": [{
        "mask-b-from": I()
      }],
      "mask-image-b-to-color": [{
        "mask-b-to": I()
      }],
      "mask-image-l-from-pos": [{
        "mask-l-from": Z()
      }],
      "mask-image-l-to-pos": [{
        "mask-l-to": Z()
      }],
      "mask-image-l-from-color": [{
        "mask-l-from": I()
      }],
      "mask-image-l-to-color": [{
        "mask-l-to": I()
      }],
      "mask-image-x-from-pos": [{
        "mask-x-from": Z()
      }],
      "mask-image-x-to-pos": [{
        "mask-x-to": Z()
      }],
      "mask-image-x-from-color": [{
        "mask-x-from": I()
      }],
      "mask-image-x-to-color": [{
        "mask-x-to": I()
      }],
      "mask-image-y-from-pos": [{
        "mask-y-from": Z()
      }],
      "mask-image-y-to-pos": [{
        "mask-y-to": Z()
      }],
      "mask-image-y-from-color": [{
        "mask-y-from": I()
      }],
      "mask-image-y-to-color": [{
        "mask-y-to": I()
      }],
      "mask-image-radial": [{
        "mask-radial": [G, V]
      }],
      "mask-image-radial-from-pos": [{
        "mask-radial-from": Z()
      }],
      "mask-image-radial-to-pos": [{
        "mask-radial-to": Z()
      }],
      "mask-image-radial-from-color": [{
        "mask-radial-from": I()
      }],
      "mask-image-radial-to-color": [{
        "mask-radial-to": I()
      }],
      "mask-image-radial-shape": [{
        "mask-radial": ["circle", "ellipse"]
      }],
      "mask-image-radial-size": [{
        "mask-radial": [{
          closest: ["side", "corner"],
          farthest: ["side", "corner"]
        }]
      }],
      "mask-image-radial-pos": [{
        "mask-radial-at": S()
      }],
      "mask-image-conic-pos": [{
        "mask-conic": [ne]
      }],
      "mask-image-conic-from-pos": [{
        "mask-conic-from": Z()
      }],
      "mask-image-conic-to-pos": [{
        "mask-conic-to": Z()
      }],
      "mask-image-conic-from-color": [{
        "mask-conic-from": I()
      }],
      "mask-image-conic-to-color": [{
        "mask-conic-to": I()
      }],
      /**
       * Mask Mode
       * @see https://tailwindcss.com/docs/mask-mode
       */
      "mask-mode": [{
        mask: ["alpha", "luminance", "match"]
      }],
      /**
       * Mask Origin
       * @see https://tailwindcss.com/docs/mask-origin
       */
      "mask-origin": [{
        "mask-origin": ["border", "padding", "content", "fill", "stroke", "view"]
      }],
      /**
       * Mask Position
       * @see https://tailwindcss.com/docs/mask-position
       */
      "mask-position": [{
        mask: le()
      }],
      /**
       * Mask Repeat
       * @see https://tailwindcss.com/docs/mask-repeat
       */
      "mask-repeat": [{
        mask: D()
      }],
      /**
       * Mask Size
       * @see https://tailwindcss.com/docs/mask-size
       */
      "mask-size": [{
        mask: j()
      }],
      /**
       * Mask Type
       * @see https://tailwindcss.com/docs/mask-type
       */
      "mask-type": [{
        "mask-type": ["alpha", "luminance"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image": [{
        mask: ["none", G, V]
      }],
      // ---------------
      // --- Filters ---
      // ---------------
      /**
       * Filter
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          G,
          V
        ]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: re()
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [ne, G, V]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [ne, G, V]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          h,
          Gn,
          Vn
        ]
      }],
      /**
       * Drop Shadow Color
       * @see https://tailwindcss.com/docs/filter-drop-shadow#setting-the-shadow-color
       */
      "drop-shadow-color": [{
        "drop-shadow": I()
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: ["", ne, G, V]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [ne, G, V]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: ["", ne, G, V]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [ne, G, V]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: ["", ne, G, V]
      }],
      /**
       * Backdrop Filter
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          G,
          V
        ]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": re()
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [ne, G, V]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [ne, G, V]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": ["", ne, G, V]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [ne, G, V]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": ["", ne, G, V]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [ne, G, V]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [ne, G, V]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": ["", ne, G, V]
      }],
      // --------------
      // --- Tables ---
      // --------------
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": M()
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": M()
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": M()
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // ---------------------------------
      // --- Transitions and Animation ---
      // ---------------------------------
      /**
       * Transition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["", "all", "colors", "opacity", "shadow", "transform", "none", G, V]
      }],
      /**
       * Transition Behavior
       * @see https://tailwindcss.com/docs/transition-behavior
       */
      "transition-behavior": [{
        transition: ["normal", "discrete"]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: [ne, "initial", G, V]
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "initial", y, G, V]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: [ne, G, V]
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", w, G, V]
      }],
      // ------------------
      // --- Transforms ---
      // ------------------
      /**
       * Backface Visibility
       * @see https://tailwindcss.com/docs/backface-visibility
       */
      backface: [{
        backface: ["hidden", "visible"]
      }],
      /**
       * Perspective
       * @see https://tailwindcss.com/docs/perspective
       */
      perspective: [{
        perspective: [g, G, V]
      }],
      /**
       * Perspective Origin
       * @see https://tailwindcss.com/docs/perspective-origin
       */
      "perspective-origin": [{
        "perspective-origin": k()
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: ce()
      }],
      /**
       * Rotate X
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-x": [{
        "rotate-x": ce()
      }],
      /**
       * Rotate Y
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-y": [{
        "rotate-y": ce()
      }],
      /**
       * Rotate Z
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-z": [{
        "rotate-z": ce()
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: pe()
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": pe()
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": pe()
      }],
      /**
       * Scale Z
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-z": [{
        "scale-z": pe()
      }],
      /**
       * Scale 3D
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-3d": ["scale-3d"],
      /**
       * Skew
       * @see https://tailwindcss.com/docs/skew
       */
      skew: [{
        skew: Se()
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": Se()
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": Se()
      }],
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: [G, V, "", "none", "gpu", "cpu"]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: k()
      }],
      /**
       * Transform Style
       * @see https://tailwindcss.com/docs/transform-style
       */
      "transform-style": [{
        transform: ["3d", "flat"]
      }],
      /**
       * Translate
       * @see https://tailwindcss.com/docs/translate
       */
      translate: [{
        translate: Pe()
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": Pe()
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": Pe()
      }],
      /**
       * Translate Z
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-z": [{
        "translate-z": Pe()
      }],
      /**
       * Translate None
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-none": ["translate-none"],
      // ---------------------
      // --- Interactivity ---
      // ---------------------
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: I()
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: I()
      }],
      /**
       * Color Scheme
       * @see https://tailwindcss.com/docs/color-scheme
       */
      "color-scheme": [{
        scheme: ["normal", "dark", "light", "light-dark", "only-dark", "only-light"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", G, V]
      }],
      /**
       * Field Sizing
       * @see https://tailwindcss.com/docs/field-sizing
       */
      "field-sizing": [{
        "field-sizing": ["fixed", "content"]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["auto", "none"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "", "y", "x"]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": M()
      }],
      /**
       * Scroll Margin Inline
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": M()
      }],
      /**
       * Scroll Margin Block
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": M()
      }],
      /**
       * Scroll Margin Inline Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": M()
      }],
      /**
       * Scroll Margin Inline End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": M()
      }],
      /**
       * Scroll Margin Block Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mbs": [{
        "scroll-mbs": M()
      }],
      /**
       * Scroll Margin Block End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mbe": [{
        "scroll-mbe": M()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": M()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": M()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": M()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": M()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": M()
      }],
      /**
       * Scroll Padding Inline
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": M()
      }],
      /**
       * Scroll Padding Block
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": M()
      }],
      /**
       * Scroll Padding Inline Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": M()
      }],
      /**
       * Scroll Padding Inline End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": M()
      }],
      /**
       * Scroll Padding Block Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pbs": [{
        "scroll-pbs": M()
      }],
      /**
       * Scroll Padding Block End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pbe": [{
        "scroll-pbe": M()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": M()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": M()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": M()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": M()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", G, V]
      }],
      // -----------
      // --- SVG ---
      // -----------
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: ["none", ...I()]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [ne, fn, Mt, cs]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: ["none", ...I()]
      }],
      // ---------------------
      // --- Accessibility ---
      // ---------------------
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "inset-bs", "inset-be", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pbs", "pbe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mbs", "mbe", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-x", "border-w-y", "border-w-s", "border-w-e", "border-w-bs", "border-w-be", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-x", "border-color-y", "border-color-s", "border-color-e", "border-color-bs", "border-color-be", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      translate: ["translate-x", "translate-y", "translate-none"],
      "translate-none": ["translate", "translate-x", "translate-y", "translate-z"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mbs", "scroll-mbe", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pbs", "scroll-pbe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    },
    orderSensitiveModifiers: ["*", "**", "after", "backdrop", "before", "details-content", "file", "first-letter", "first-line", "marker", "placeholder", "selection"]
  };
}, sm = /* @__PURE__ */ Lp(am);
function P(...e) {
  return sm(bi(e));
}
const fs = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, ps = bi, tn = (e, t) => (n) => {
  var r;
  if (t?.variants == null) return ps(e, n?.class, n?.className);
  const { variants: o, defaultVariants: a } = t, s = Object.keys(o).map((c) => {
    const f = n?.[c], u = a?.[c];
    if (f === null) return null;
    const m = fs(f) || fs(u);
    return o[c][m];
  }), i = n && Object.entries(n).reduce((c, f) => {
    let [u, m] = f;
    return m === void 0 || (c[u] = m), c;
  }, {}), l = t == null || (r = t.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((c, f) => {
    let { class: u, className: m, ...h } = f;
    return Object.entries(h).every((b) => {
      let [g, v] = b;
      return Array.isArray(v) ? v.includes({
        ...a,
        ...i
      }[g]) : {
        ...a,
        ...i
      }[g] === v;
    }) ? [
      ...c,
      u,
      m
    ] : c;
  }, []);
  return ps(e, s, l, n?.class, n?.className);
};
function ms(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function nt(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((o) => {
      const a = ms(o, t);
      return !n && typeof a == "function" && (n = !0), a;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const a = r[o];
          typeof a == "function" ? a() : ms(e[o], null);
        }
      };
  };
}
function J(...e) {
  return d.useCallback(nt(...e), e);
}
// @__NO_SIDE_EFFECTS__
function mt(e) {
  const t = /* @__PURE__ */ im(e), n = d.forwardRef((r, o) => {
    const { children: a, ...s } = r, i = d.Children.toArray(a), l = i.find(lm);
    if (l) {
      const c = l.props.children, f = i.map((u) => u === l ? d.Children.count(c) > 1 ? d.Children.only(null) : d.isValidElement(c) ? c.props.children : null : u);
      return /* @__PURE__ */ p(t, { ...s, ref: o, children: d.isValidElement(c) ? d.cloneElement(c, void 0, f) : null });
    }
    return /* @__PURE__ */ p(t, { ...s, ref: o, children: a });
  });
  return n.displayName = `${e}.Slot`, n;
}
var Ti = /* @__PURE__ */ mt("Slot");
// @__NO_SIDE_EFFECTS__
function im(e) {
  const t = d.forwardRef((n, r) => {
    const { children: o, ...a } = n;
    if (d.isValidElement(o)) {
      const s = dm(o), i = cm(a, o.props);
      return o.type !== d.Fragment && (i.ref = r ? nt(r, s) : s), d.cloneElement(o, i);
    }
    return d.Children.count(o) > 1 ? d.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var Ai = /* @__PURE__ */ Symbol("radix.slottable");
// @__NO_SIDE_EFFECTS__
function Ii(e) {
  const t = ({ children: n }) => /* @__PURE__ */ p(pt, { children: n });
  return t.displayName = `${e}.Slottable`, t.__radixId = Ai, t;
}
function lm(e) {
  return d.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === Ai;
}
function cm(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], a = t[r];
    /^on[A-Z]/.test(r) ? o && a ? n[r] = (...i) => {
      const l = a(...i);
      return o(...i), l;
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...a } : r === "className" && (n[r] = [o, a].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function dm(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var um = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], L = um.reduce((e, t) => {
  const n = /* @__PURE__ */ mt(`Primitive.${t}`), r = d.forwardRef((o, a) => {
    const { asChild: s, ...i } = o, l = s ? n : t;
    return typeof window < "u" && (window[/* @__PURE__ */ Symbol.for("radix-ui")] = !0), /* @__PURE__ */ p(l, { ...i, ref: a });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function Wi(e, t) {
  e && yr.flushSync(() => e.dispatchEvent(t));
}
var Fi = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), fm = "VisuallyHidden", Li = d.forwardRef(
  (e, t) => /* @__PURE__ */ p(
    L.span,
    {
      ...e,
      ref: t,
      style: { ...Fi, ...e.style }
    }
  )
);
Li.displayName = fm;
var pm = Li;
function mm(e, t) {
  const n = d.createContext(t), r = (a) => {
    const { children: s, ...i } = a, l = d.useMemo(() => i, Object.values(i));
    return /* @__PURE__ */ p(n.Provider, { value: l, children: s });
  };
  r.displayName = e + "Provider";
  function o(a) {
    const s = d.useContext(n);
    if (s) return s;
    if (t !== void 0) return t;
    throw new Error(`\`${a}\` must be used within \`${e}\``);
  }
  return [r, o];
}
function xe(e, t = []) {
  let n = [];
  function r(a, s) {
    const i = d.createContext(s), l = n.length;
    n = [...n, s];
    const c = (u) => {
      const { scope: m, children: h, ...b } = u, g = m?.[e]?.[l] || i, v = d.useMemo(() => b, Object.values(b));
      return /* @__PURE__ */ p(g.Provider, { value: v, children: h });
    };
    c.displayName = a + "Provider";
    function f(u, m) {
      const h = m?.[e]?.[l] || i, b = d.useContext(h);
      if (b) return b;
      if (s !== void 0) return s;
      throw new Error(`\`${u}\` must be used within \`${a}\``);
    }
    return [c, f];
  }
  const o = () => {
    const a = n.map((s) => d.createContext(s));
    return function(i) {
      const l = i?.[e] || a;
      return d.useMemo(
        () => ({ [`__scope${e}`]: { ...i, [e]: l } }),
        [i, l]
      );
    };
  };
  return o.scopeName = e, [r, hm(o, ...t)];
}
function hm(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(a) {
      const s = r.reduce((i, { useScope: l, scopeName: c }) => {
        const u = l(a)[`__scope${c}`];
        return { ...i, ...u };
      }, {});
      return d.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function Dn(e) {
  const t = e + "CollectionProvider", [n, r] = xe(t), [o, a] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), s = (g) => {
    const { scope: v, children: y } = g, w = N.useRef(null), x = N.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ p(o, { scope: v, itemMap: x, collectionRef: w, children: y });
  };
  s.displayName = t;
  const i = e + "CollectionSlot", l = /* @__PURE__ */ mt(i), c = N.forwardRef(
    (g, v) => {
      const { scope: y, children: w } = g, x = a(i, y), S = J(v, x.collectionRef);
      return /* @__PURE__ */ p(l, { ref: S, children: w });
    }
  );
  c.displayName = i;
  const f = e + "CollectionItemSlot", u = "data-radix-collection-item", m = /* @__PURE__ */ mt(f), h = N.forwardRef(
    (g, v) => {
      const { scope: y, children: w, ...x } = g, S = N.useRef(null), k = J(v, S), C = a(f, y);
      return N.useEffect(() => (C.itemMap.set(S, { ref: S, ...x }), () => {
        C.itemMap.delete(S);
      })), /* @__PURE__ */ p(m, { [u]: "", ref: k, children: w });
    }
  );
  h.displayName = f;
  function b(g) {
    const v = a(e + "CollectionConsumer", g);
    return N.useCallback(() => {
      const w = v.collectionRef.current;
      if (!w) return [];
      const x = Array.from(w.querySelectorAll(`[${u}]`));
      return Array.from(v.itemMap.values()).sort(
        (C, E) => x.indexOf(C.ref.current) - x.indexOf(E.ref.current)
      );
    }, [v.collectionRef, v.itemMap]);
  }
  return [
    { Provider: s, Slot: c, ItemSlot: h },
    b,
    r
  ];
}
function A(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e?.(o), n === !1 || !o.defaultPrevented)
      return t?.(o);
  };
}
var ve = globalThis?.document ? d.useLayoutEffect : () => {
}, gm = d[" useInsertionEffect ".trim().toString()] || ve;
function ke({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  },
  caller: r
}) {
  const [o, a, s] = vm({
    defaultProp: t,
    onChange: n
  }), i = e !== void 0, l = i ? e : o;
  {
    const f = d.useRef(e !== void 0);
    d.useEffect(() => {
      const u = f.current;
      u !== i && console.warn(
        `${r} is changing from ${u ? "controlled" : "uncontrolled"} to ${i ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), f.current = i;
    }, [i, r]);
  }
  const c = d.useCallback(
    (f) => {
      if (i) {
        const u = bm(f) ? f(e) : f;
        u !== e && s.current?.(u);
      } else
        a(f);
    },
    [i, e, a, s]
  );
  return [l, c];
}
function vm({
  defaultProp: e,
  onChange: t
}) {
  const [n, r] = d.useState(e), o = d.useRef(n), a = d.useRef(t);
  return gm(() => {
    a.current = t;
  }, [t]), d.useEffect(() => {
    o.current !== n && (a.current?.(n), o.current = n);
  }, [n, o]), [n, r, a];
}
function bm(e) {
  return typeof e == "function";
}
function ym(e, t) {
  return d.useReducer((n, r) => t[n][r] ?? n, e);
}
var Ce = (e) => {
  const { present: t, children: n } = e, r = wm(t), o = typeof n == "function" ? n({ present: r.isPresent }) : d.Children.only(n), a = J(r.ref, xm(o));
  return typeof n == "function" || r.isPresent ? d.cloneElement(o, { ref: a }) : null;
};
Ce.displayName = "Presence";
function wm(e) {
  const [t, n] = d.useState(), r = d.useRef(null), o = d.useRef(e), a = d.useRef("none"), s = e ? "mounted" : "unmounted", [i, l] = ym(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return d.useEffect(() => {
    const c = Un(r.current);
    a.current = i === "mounted" ? c : "none";
  }, [i]), ve(() => {
    const c = r.current, f = o.current;
    if (f !== e) {
      const m = a.current, h = Un(c);
      e ? l("MOUNT") : h === "none" || c?.display === "none" ? l("UNMOUNT") : l(f && m !== h ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, l]), ve(() => {
    if (t) {
      let c;
      const f = t.ownerDocument.defaultView ?? window, u = (h) => {
        const g = Un(r.current).includes(CSS.escape(h.animationName));
        if (h.target === t && g && (l("ANIMATION_END"), !o.current)) {
          const v = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", c = f.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = v);
          });
        }
      }, m = (h) => {
        h.target === t && (a.current = Un(r.current));
      };
      return t.addEventListener("animationstart", m), t.addEventListener("animationcancel", u), t.addEventListener("animationend", u), () => {
        f.clearTimeout(c), t.removeEventListener("animationstart", m), t.removeEventListener("animationcancel", u), t.removeEventListener("animationend", u);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(i),
    ref: d.useCallback((c) => {
      r.current = c ? getComputedStyle(c) : null, n(c);
    }, [])
  };
}
function Un(e) {
  return e?.animationName || "none";
}
function xm(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Sm = d[" useId ".trim().toString()] || (() => {
}), Cm = 0;
function ge(e) {
  const [t, n] = d.useState(Sm());
  return ve(() => {
    n((r) => r ?? String(Cm++));
  }, [e]), t ? `radix-${t}` : "";
}
var wr = "Collapsible", [km, $i] = xe(wr), [Em, oa] = km(wr), zi = d.forwardRef(
  (e, t) => {
    const {
      __scopeCollapsible: n,
      open: r,
      defaultOpen: o,
      disabled: a,
      onOpenChange: s,
      ...i
    } = e, [l, c] = ke({
      prop: r,
      defaultProp: o ?? !1,
      onChange: s,
      caller: wr
    });
    return /* @__PURE__ */ p(
      Em,
      {
        scope: n,
        disabled: a,
        contentId: ge(),
        open: l,
        onOpenToggle: d.useCallback(() => c((f) => !f), [c]),
        children: /* @__PURE__ */ p(
          L.div,
          {
            "data-state": la(l),
            "data-disabled": a ? "" : void 0,
            ...i,
            ref: t
          }
        )
      }
    );
  }
);
zi.displayName = wr;
var Bi = "CollapsibleTrigger", aa = d.forwardRef(
  (e, t) => {
    const { __scopeCollapsible: n, ...r } = e, o = oa(Bi, n);
    return /* @__PURE__ */ p(
      L.button,
      {
        type: "button",
        "aria-controls": o.contentId,
        "aria-expanded": o.open || !1,
        "data-state": la(o.open),
        "data-disabled": o.disabled ? "" : void 0,
        disabled: o.disabled,
        ...r,
        ref: t,
        onClick: A(e.onClick, o.onOpenToggle)
      }
    );
  }
);
aa.displayName = Bi;
var sa = "CollapsibleContent", ia = d.forwardRef(
  (e, t) => {
    const { forceMount: n, ...r } = e, o = oa(sa, e.__scopeCollapsible);
    return /* @__PURE__ */ p(Ce, { present: n || o.open, children: ({ present: a }) => /* @__PURE__ */ p(Mm, { ...r, ref: t, present: a }) });
  }
);
ia.displayName = sa;
var Mm = d.forwardRef((e, t) => {
  const { __scopeCollapsible: n, present: r, children: o, ...a } = e, s = oa(sa, n), [i, l] = d.useState(r), c = d.useRef(null), f = J(t, c), u = d.useRef(0), m = u.current, h = d.useRef(0), b = h.current, g = s.open || i, v = d.useRef(g), y = d.useRef(void 0);
  return d.useEffect(() => {
    const w = requestAnimationFrame(() => v.current = !1);
    return () => cancelAnimationFrame(w);
  }, []), ve(() => {
    const w = c.current;
    if (w) {
      y.current = y.current || {
        transitionDuration: w.style.transitionDuration,
        animationName: w.style.animationName
      }, w.style.transitionDuration = "0s", w.style.animationName = "none";
      const x = w.getBoundingClientRect();
      u.current = x.height, h.current = x.width, v.current || (w.style.transitionDuration = y.current.transitionDuration, w.style.animationName = y.current.animationName), l(r);
    }
  }, [s.open, r]), /* @__PURE__ */ p(
    L.div,
    {
      "data-state": la(s.open),
      "data-disabled": s.disabled ? "" : void 0,
      id: s.contentId,
      hidden: !g,
      ...a,
      ref: f,
      style: {
        "--radix-collapsible-content-height": m ? `${m}px` : void 0,
        "--radix-collapsible-content-width": b ? `${b}px` : void 0,
        ...e.style
      },
      children: g && o
    }
  );
});
function la(e) {
  return e ? "open" : "closed";
}
var Yi = zi, Pm = aa, Dm = ia, Om = d.createContext(void 0);
function It(e) {
  const t = d.useContext(Om);
  return e || t || "ltr";
}
var Be = "Accordion", Nm = ["Home", "End", "ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"], [ca, _m, Rm] = Dn(Be), [xr] = xe(Be, [
  Rm,
  $i
]), da = $i(), Hi = N.forwardRef(
  (e, t) => {
    const { type: n, ...r } = e, o = r, a = r;
    return /* @__PURE__ */ p(ca.Provider, { scope: e.__scopeAccordion, children: n === "multiple" ? /* @__PURE__ */ p(Wm, { ...a, ref: t }) : /* @__PURE__ */ p(Im, { ...o, ref: t }) });
  }
);
Hi.displayName = Be;
var [Vi, Tm] = xr(Be), [Gi, Am] = xr(
  Be,
  { collapsible: !1 }
), Im = N.forwardRef(
  (e, t) => {
    const {
      value: n,
      defaultValue: r,
      onValueChange: o = () => {
      },
      collapsible: a = !1,
      ...s
    } = e, [i, l] = ke({
      prop: n,
      defaultProp: r ?? "",
      onChange: o,
      caller: Be
    });
    return /* @__PURE__ */ p(
      Vi,
      {
        scope: e.__scopeAccordion,
        value: N.useMemo(() => i ? [i] : [], [i]),
        onItemOpen: l,
        onItemClose: N.useCallback(() => a && l(""), [a, l]),
        children: /* @__PURE__ */ p(Gi, { scope: e.__scopeAccordion, collapsible: a, children: /* @__PURE__ */ p(Ui, { ...s, ref: t }) })
      }
    );
  }
), Wm = N.forwardRef((e, t) => {
  const {
    value: n,
    defaultValue: r,
    onValueChange: o = () => {
    },
    ...a
  } = e, [s, i] = ke({
    prop: n,
    defaultProp: r ?? [],
    onChange: o,
    caller: Be
  }), l = N.useCallback(
    (f) => i((u = []) => [...u, f]),
    [i]
  ), c = N.useCallback(
    (f) => i((u = []) => u.filter((m) => m !== f)),
    [i]
  );
  return /* @__PURE__ */ p(
    Vi,
    {
      scope: e.__scopeAccordion,
      value: s,
      onItemOpen: l,
      onItemClose: c,
      children: /* @__PURE__ */ p(Gi, { scope: e.__scopeAccordion, collapsible: !0, children: /* @__PURE__ */ p(Ui, { ...a, ref: t }) })
    }
  );
}), [Fm, Sr] = xr(Be), Ui = N.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, disabled: r, dir: o, orientation: a = "vertical", ...s } = e, i = N.useRef(null), l = J(i, t), c = _m(n), u = It(o) === "ltr", m = A(e.onKeyDown, (h) => {
      if (!Nm.includes(h.key)) return;
      const b = h.target, g = c().filter((M) => !M.ref.current?.disabled), v = g.findIndex((M) => M.ref.current === b), y = g.length;
      if (v === -1) return;
      h.preventDefault();
      let w = v;
      const x = 0, S = y - 1, k = () => {
        w = v + 1, w > S && (w = x);
      }, C = () => {
        w = v - 1, w < x && (w = S);
      };
      switch (h.key) {
        case "Home":
          w = x;
          break;
        case "End":
          w = S;
          break;
        case "ArrowRight":
          a === "horizontal" && (u ? k() : C());
          break;
        case "ArrowDown":
          a === "vertical" && k();
          break;
        case "ArrowLeft":
          a === "horizontal" && (u ? C() : k());
          break;
        case "ArrowUp":
          a === "vertical" && C();
          break;
      }
      const E = w % y;
      g[E].ref.current?.focus();
    });
    return /* @__PURE__ */ p(
      Fm,
      {
        scope: n,
        disabled: r,
        direction: o,
        orientation: a,
        children: /* @__PURE__ */ p(ca.Slot, { scope: n, children: /* @__PURE__ */ p(
          L.div,
          {
            ...s,
            "data-orientation": a,
            ref: l,
            onKeyDown: r ? void 0 : m
          }
        ) })
      }
    );
  }
), ar = "AccordionItem", [Lm, ua] = xr(ar), ji = N.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, value: r, ...o } = e, a = Sr(ar, n), s = Tm(ar, n), i = da(n), l = ge(), c = r && s.value.includes(r) || !1, f = a.disabled || e.disabled;
    return /* @__PURE__ */ p(
      Lm,
      {
        scope: n,
        open: c,
        disabled: f,
        triggerId: l,
        children: /* @__PURE__ */ p(
          Yi,
          {
            "data-orientation": a.orientation,
            "data-state": Ji(c),
            ...i,
            ...o,
            ref: t,
            disabled: f,
            open: c,
            onOpenChange: (u) => {
              u ? s.onItemOpen(r) : s.onItemClose(r);
            }
          }
        )
      }
    );
  }
);
ji.displayName = ar;
var Ki = "AccordionHeader", qi = N.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...r } = e, o = Sr(Be, n), a = ua(Ki, n);
    return /* @__PURE__ */ p(
      L.h3,
      {
        "data-orientation": o.orientation,
        "data-state": Ji(a.open),
        "data-disabled": a.disabled ? "" : void 0,
        ...r,
        ref: t
      }
    );
  }
);
qi.displayName = Ki;
var Io = "AccordionTrigger", Xi = N.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...r } = e, o = Sr(Be, n), a = ua(Io, n), s = Am(Io, n), i = da(n);
    return /* @__PURE__ */ p(ca.ItemSlot, { scope: n, children: /* @__PURE__ */ p(
      Pm,
      {
        "aria-disabled": a.open && !s.collapsible || void 0,
        "data-orientation": o.orientation,
        id: a.triggerId,
        ...i,
        ...r,
        ref: t
      }
    ) });
  }
);
Xi.displayName = Io;
var Zi = "AccordionContent", Qi = N.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...r } = e, o = Sr(Be, n), a = ua(Zi, n), s = da(n);
    return /* @__PURE__ */ p(
      Dm,
      {
        role: "region",
        "aria-labelledby": a.triggerId,
        "data-orientation": o.orientation,
        ...s,
        ...r,
        ref: t,
        style: {
          "--radix-accordion-content-height": "var(--radix-collapsible-content-height)",
          "--radix-accordion-content-width": "var(--radix-collapsible-content-width)",
          ...e.style
        }
      }
    );
  }
);
Qi.displayName = Zi;
function Ji(e) {
  return e ? "open" : "closed";
}
var $m = Hi, zm = ji, Bm = qi, Ym = Xi, Hm = Qi;
function we(e) {
  const t = d.useRef(e);
  return d.useEffect(() => {
    t.current = e;
  }), d.useMemo(() => (...n) => t.current?.(...n), []);
}
function Vm(e, t = globalThis?.document) {
  const n = we(e);
  d.useEffect(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var Gm = "DismissableLayer", Wo = "dismissableLayer.update", Um = "dismissableLayer.pointerDownOutside", jm = "dismissableLayer.focusOutside", hs, el = d.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), nn = d.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: a,
      onInteractOutside: s,
      onDismiss: i,
      ...l
    } = e, c = d.useContext(el), [f, u] = d.useState(null), m = f?.ownerDocument ?? globalThis?.document, [, h] = d.useState({}), b = J(t, (E) => u(E)), g = Array.from(c.layers), [v] = [...c.layersWithOutsidePointerEventsDisabled].slice(-1), y = g.indexOf(v), w = f ? g.indexOf(f) : -1, x = c.layersWithOutsidePointerEventsDisabled.size > 0, S = w >= y, k = Xm((E) => {
      const M = E.target, O = [...c.branches].some((R) => R.contains(M));
      !S || O || (o?.(E), s?.(E), E.defaultPrevented || i?.());
    }, m), C = Zm((E) => {
      const M = E.target;
      [...c.branches].some((R) => R.contains(M)) || (a?.(E), s?.(E), E.defaultPrevented || i?.());
    }, m);
    return Vm((E) => {
      w === c.layers.size - 1 && (r?.(E), !E.defaultPrevented && i && (E.preventDefault(), i()));
    }, m), d.useEffect(() => {
      if (f)
        return n && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (hs = m.body.style.pointerEvents, m.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(f)), c.layers.add(f), gs(), () => {
          n && c.layersWithOutsidePointerEventsDisabled.size === 1 && (m.body.style.pointerEvents = hs);
        };
    }, [f, m, n, c]), d.useEffect(() => () => {
      f && (c.layers.delete(f), c.layersWithOutsidePointerEventsDisabled.delete(f), gs());
    }, [f, c]), d.useEffect(() => {
      const E = () => h({});
      return document.addEventListener(Wo, E), () => document.removeEventListener(Wo, E);
    }, []), /* @__PURE__ */ p(
      L.div,
      {
        ...l,
        ref: b,
        style: {
          pointerEvents: x ? S ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: A(e.onFocusCapture, C.onFocusCapture),
        onBlurCapture: A(e.onBlurCapture, C.onBlurCapture),
        onPointerDownCapture: A(
          e.onPointerDownCapture,
          k.onPointerDownCapture
        )
      }
    );
  }
);
nn.displayName = Gm;
var Km = "DismissableLayerBranch", qm = d.forwardRef((e, t) => {
  const n = d.useContext(el), r = d.useRef(null), o = J(t, r);
  return d.useEffect(() => {
    const a = r.current;
    if (a)
      return n.branches.add(a), () => {
        n.branches.delete(a);
      };
  }, [n.branches]), /* @__PURE__ */ p(L.div, { ...e, ref: o });
});
qm.displayName = Km;
function Xm(e, t = globalThis?.document) {
  const n = we(e), r = d.useRef(!1), o = d.useRef(() => {
  });
  return d.useEffect(() => {
    const a = (i) => {
      if (i.target && !r.current) {
        let l = function() {
          tl(
            Um,
            n,
            c,
            { discrete: !0 }
          );
        };
        const c = { originalEvent: i };
        i.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = l, t.addEventListener("click", o.current, { once: !0 })) : l();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, s = window.setTimeout(() => {
      t.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(s), t.removeEventListener("pointerdown", a), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function Zm(e, t = globalThis?.document) {
  const n = we(e), r = d.useRef(!1);
  return d.useEffect(() => {
    const o = (a) => {
      a.target && !r.current && tl(jm, n, { originalEvent: a }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function gs() {
  const e = new CustomEvent(Wo);
  document.dispatchEvent(e);
}
function tl(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, a = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? Wi(o, a) : o.dispatchEvent(a);
}
var uo = "focusScope.autoFocusOnMount", fo = "focusScope.autoFocusOnUnmount", vs = { bubbles: !1, cancelable: !0 }, Qm = "FocusScope", On = d.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: a,
    ...s
  } = e, [i, l] = d.useState(null), c = we(o), f = we(a), u = d.useRef(null), m = J(t, (g) => l(g)), h = d.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  d.useEffect(() => {
    if (r) {
      let g = function(x) {
        if (h.paused || !i) return;
        const S = x.target;
        i.contains(S) ? u.current = S : ut(u.current, { select: !0 });
      }, v = function(x) {
        if (h.paused || !i) return;
        const S = x.relatedTarget;
        S !== null && (i.contains(S) || ut(u.current, { select: !0 }));
      }, y = function(x) {
        if (document.activeElement === document.body)
          for (const k of x)
            k.removedNodes.length > 0 && ut(i);
      };
      document.addEventListener("focusin", g), document.addEventListener("focusout", v);
      const w = new MutationObserver(y);
      return i && w.observe(i, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", g), document.removeEventListener("focusout", v), w.disconnect();
      };
    }
  }, [r, i, h.paused]), d.useEffect(() => {
    if (i) {
      ys.add(h);
      const g = document.activeElement;
      if (!i.contains(g)) {
        const y = new CustomEvent(uo, vs);
        i.addEventListener(uo, c), i.dispatchEvent(y), y.defaultPrevented || (Jm(oh(nl(i)), { select: !0 }), document.activeElement === g && ut(i));
      }
      return () => {
        i.removeEventListener(uo, c), setTimeout(() => {
          const y = new CustomEvent(fo, vs);
          i.addEventListener(fo, f), i.dispatchEvent(y), y.defaultPrevented || ut(g ?? document.body, { select: !0 }), i.removeEventListener(fo, f), ys.remove(h);
        }, 0);
      };
    }
  }, [i, c, f, h]);
  const b = d.useCallback(
    (g) => {
      if (!n && !r || h.paused) return;
      const v = g.key === "Tab" && !g.altKey && !g.ctrlKey && !g.metaKey, y = document.activeElement;
      if (v && y) {
        const w = g.currentTarget, [x, S] = eh(w);
        x && S ? !g.shiftKey && y === S ? (g.preventDefault(), n && ut(x, { select: !0 })) : g.shiftKey && y === x && (g.preventDefault(), n && ut(S, { select: !0 })) : y === w && g.preventDefault();
      }
    },
    [n, r, h.paused]
  );
  return /* @__PURE__ */ p(L.div, { tabIndex: -1, ...s, ref: m, onKeyDown: b });
});
On.displayName = Qm;
function Jm(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (ut(r, { select: t }), document.activeElement !== n) return;
}
function eh(e) {
  const t = nl(e), n = bs(t, e), r = bs(t.reverse(), e);
  return [n, r];
}
function nl(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function bs(e, t) {
  for (const n of e)
    if (!th(n, { upTo: t })) return n;
}
function th(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function nh(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function ut(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && nh(e) && t && e.select();
  }
}
var ys = rh();
function rh() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && n?.pause(), e = ws(e, t), e.unshift(t);
    },
    remove(t) {
      e = ws(e, t), e[0]?.resume();
    }
  };
}
function ws(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function oh(e) {
  return e.filter((t) => t.tagName !== "A");
}
var ah = "Portal", rn = d.forwardRef((e, t) => {
  const { container: n, ...r } = e, [o, a] = d.useState(!1);
  ve(() => a(!0), []);
  const s = n || o && globalThis?.document?.body;
  return s ? vp.createPortal(/* @__PURE__ */ p(L.div, { ...r, ref: t }), s) : null;
});
rn.displayName = ah;
var po = 0;
function Cr() {
  d.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? xs()), document.body.insertAdjacentElement("beforeend", e[1] ?? xs()), po++, () => {
      po === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), po--;
    };
  }, []);
}
function xs() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var Ge = function() {
  return Ge = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, Ge.apply(this, arguments);
};
function rl(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function sh(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, o = t.length, a; r < o; r++)
    (a || !(r in t)) && (a || (a = Array.prototype.slice.call(t, 0, r)), a[r] = t[r]);
  return e.concat(a || Array.prototype.slice.call(t));
}
var er = "right-scroll-bar-position", tr = "width-before-scroll-bar", ih = "with-scroll-bars-hidden", lh = "--removed-body-scroll-bar-size";
function mo(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function ch(e, t) {
  var n = rr(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var dh = typeof window < "u" ? d.useLayoutEffect : d.useEffect, Ss = /* @__PURE__ */ new WeakMap();
function uh(e, t) {
  var n = ch(null, function(r) {
    return e.forEach(function(o) {
      return mo(o, r);
    });
  });
  return dh(function() {
    var r = Ss.get(n);
    if (r) {
      var o = new Set(r), a = new Set(e), s = n.current;
      o.forEach(function(i) {
        a.has(i) || mo(i, null);
      }), a.forEach(function(i) {
        o.has(i) || mo(i, s);
      });
    }
    Ss.set(n, e);
  }, [e]), n;
}
function fh(e) {
  return e;
}
function ph(e, t) {
  t === void 0 && (t = fh);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(a) {
      var s = t(a, r);
      return n.push(s), function() {
        n = n.filter(function(i) {
          return i !== s;
        });
      };
    },
    assignSyncMedium: function(a) {
      for (r = !0; n.length; ) {
        var s = n;
        n = [], s.forEach(a);
      }
      n = {
        push: function(i) {
          return a(i);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(a) {
      r = !0;
      var s = [];
      if (n.length) {
        var i = n;
        n = [], i.forEach(a), s = n;
      }
      var l = function() {
        var f = s;
        s = [], f.forEach(a);
      }, c = function() {
        return Promise.resolve().then(l);
      };
      c(), n = {
        push: function(f) {
          s.push(f), c();
        },
        filter: function(f) {
          return s = s.filter(f), n;
        }
      };
    }
  };
  return o;
}
function mh(e) {
  e === void 0 && (e = {});
  var t = ph(null);
  return t.options = Ge({ async: !0, ssr: !1 }, e), t;
}
var ol = function(e) {
  var t = e.sideCar, n = rl(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return d.createElement(r, Ge({}, n));
};
ol.isSideCarExport = !0;
function hh(e, t) {
  return e.useMedium(t), ol;
}
var al = mh(), ho = function() {
}, kr = d.forwardRef(function(e, t) {
  var n = d.useRef(null), r = d.useState({
    onScrollCapture: ho,
    onWheelCapture: ho,
    onTouchMoveCapture: ho
  }), o = r[0], a = r[1], s = e.forwardProps, i = e.children, l = e.className, c = e.removeScrollBar, f = e.enabled, u = e.shards, m = e.sideCar, h = e.noRelative, b = e.noIsolation, g = e.inert, v = e.allowPinchZoom, y = e.as, w = y === void 0 ? "div" : y, x = e.gapMode, S = rl(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), k = m, C = uh([n, t]), E = Ge(Ge({}, S), o);
  return d.createElement(
    d.Fragment,
    null,
    f && d.createElement(k, { sideCar: al, removeScrollBar: c, shards: u, noRelative: h, noIsolation: b, inert: g, setCallbacks: a, allowPinchZoom: !!v, lockRef: n, gapMode: x }),
    s ? d.cloneElement(d.Children.only(i), Ge(Ge({}, E), { ref: C })) : d.createElement(w, Ge({}, E, { className: l, ref: C }), i)
  );
});
kr.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
kr.classNames = {
  fullWidth: tr,
  zeroRight: er
};
var gh = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function vh() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = gh();
  return t && e.setAttribute("nonce", t), e;
}
function bh(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function yh(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var wh = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = vh()) && (bh(t, n), yh(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, xh = function() {
  var e = wh();
  return function(t, n) {
    d.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, sl = function() {
  var e = xh(), t = function(n) {
    var r = n.styles, o = n.dynamic;
    return e(r, o), null;
  };
  return t;
}, Sh = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, go = function(e) {
  return parseInt(e || "", 10) || 0;
}, Ch = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [go(n), go(r), go(o)];
}, kh = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return Sh;
  var t = Ch(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, Eh = sl(), jt = "data-scroll-locked", Mh = function(e, t, n, r) {
  var o = e.left, a = e.top, s = e.right, i = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(ih, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(i, "px ").concat(r, `;
  }
  body[`).concat(jt, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(a, `px;
    padding-right: `).concat(s, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(i, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(i, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(er, ` {
    right: `).concat(i, "px ").concat(r, `;
  }
  
  .`).concat(tr, ` {
    margin-right: `).concat(i, "px ").concat(r, `;
  }
  
  .`).concat(er, " .").concat(er, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(tr, " .").concat(tr, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(jt, `] {
    `).concat(lh, ": ").concat(i, `px;
  }
`);
}, Cs = function() {
  var e = parseInt(document.body.getAttribute(jt) || "0", 10);
  return isFinite(e) ? e : 0;
}, Ph = function() {
  d.useEffect(function() {
    return document.body.setAttribute(jt, (Cs() + 1).toString()), function() {
      var e = Cs() - 1;
      e <= 0 ? document.body.removeAttribute(jt) : document.body.setAttribute(jt, e.toString());
    };
  }, []);
}, Dh = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r;
  Ph();
  var a = d.useMemo(function() {
    return kh(o);
  }, [o]);
  return d.createElement(Eh, { styles: Mh(a, !t, o, n ? "" : "!important") });
}, Fo = !1;
if (typeof window < "u")
  try {
    var jn = Object.defineProperty({}, "passive", {
      get: function() {
        return Fo = !0, !0;
      }
    });
    window.addEventListener("test", jn, jn), window.removeEventListener("test", jn, jn);
  } catch {
    Fo = !1;
  }
var $t = Fo ? { passive: !1 } : !1, Oh = function(e) {
  return e.tagName === "TEXTAREA";
}, il = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !Oh(e) && n[t] === "visible")
  );
}, Nh = function(e) {
  return il(e, "overflowY");
}, _h = function(e) {
  return il(e, "overflowX");
}, ks = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var o = ll(e, r);
    if (o) {
      var a = cl(e, r), s = a[1], i = a[2];
      if (s > i)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, Rh = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, Th = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, ll = function(e, t) {
  return e === "v" ? Nh(t) : _h(t);
}, cl = function(e, t) {
  return e === "v" ? Rh(t) : Th(t);
}, Ah = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, Ih = function(e, t, n, r, o) {
  var a = Ah(e, window.getComputedStyle(t).direction), s = a * r, i = n.target, l = t.contains(i), c = !1, f = s > 0, u = 0, m = 0;
  do {
    if (!i)
      break;
    var h = cl(e, i), b = h[0], g = h[1], v = h[2], y = g - v - a * b;
    (b || y) && ll(e, i) && (u += y, m += b);
    var w = i.parentNode;
    i = w && w.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? w.host : w;
  } while (
    // portaled content
    !l && i !== document.body || // self content
    l && (t.contains(i) || t === i)
  );
  return (f && Math.abs(u) < 1 || !f && Math.abs(m) < 1) && (c = !0), c;
}, Kn = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Es = function(e) {
  return [e.deltaX, e.deltaY];
}, Ms = function(e) {
  return e && "current" in e ? e.current : e;
}, Wh = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, Fh = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, Lh = 0, zt = [];
function $h(e) {
  var t = d.useRef([]), n = d.useRef([0, 0]), r = d.useRef(), o = d.useState(Lh++)[0], a = d.useState(sl)[0], s = d.useRef(e);
  d.useEffect(function() {
    s.current = e;
  }, [e]), d.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var g = sh([e.lockRef.current], (e.shards || []).map(Ms), !0).filter(Boolean);
      return g.forEach(function(v) {
        return v.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), g.forEach(function(v) {
          return v.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var i = d.useCallback(function(g, v) {
    if ("touches" in g && g.touches.length === 2 || g.type === "wheel" && g.ctrlKey)
      return !s.current.allowPinchZoom;
    var y = Kn(g), w = n.current, x = "deltaX" in g ? g.deltaX : w[0] - y[0], S = "deltaY" in g ? g.deltaY : w[1] - y[1], k, C = g.target, E = Math.abs(x) > Math.abs(S) ? "h" : "v";
    if ("touches" in g && E === "h" && C.type === "range")
      return !1;
    var M = window.getSelection(), O = M && M.anchorNode, R = O ? O === C || O.contains(C) : !1;
    if (R)
      return !1;
    var W = ks(E, C);
    if (!W)
      return !0;
    if (W ? k = E : (k = E === "v" ? "h" : "v", W = ks(E, C)), !W)
      return !1;
    if (!r.current && "changedTouches" in g && (x || S) && (r.current = k), !k)
      return !0;
    var Y = r.current || k;
    return Ih(Y, v, g, Y === "h" ? x : S);
  }, []), l = d.useCallback(function(g) {
    var v = g;
    if (!(!zt.length || zt[zt.length - 1] !== a)) {
      var y = "deltaY" in v ? Es(v) : Kn(v), w = t.current.filter(function(k) {
        return k.name === v.type && (k.target === v.target || v.target === k.shadowParent) && Wh(k.delta, y);
      })[0];
      if (w && w.should) {
        v.cancelable && v.preventDefault();
        return;
      }
      if (!w) {
        var x = (s.current.shards || []).map(Ms).filter(Boolean).filter(function(k) {
          return k.contains(v.target);
        }), S = x.length > 0 ? i(v, x[0]) : !s.current.noIsolation;
        S && v.cancelable && v.preventDefault();
      }
    }
  }, []), c = d.useCallback(function(g, v, y, w) {
    var x = { name: g, delta: v, target: y, should: w, shadowParent: zh(y) };
    t.current.push(x), setTimeout(function() {
      t.current = t.current.filter(function(S) {
        return S !== x;
      });
    }, 1);
  }, []), f = d.useCallback(function(g) {
    n.current = Kn(g), r.current = void 0;
  }, []), u = d.useCallback(function(g) {
    c(g.type, Es(g), g.target, i(g, e.lockRef.current));
  }, []), m = d.useCallback(function(g) {
    c(g.type, Kn(g), g.target, i(g, e.lockRef.current));
  }, []);
  d.useEffect(function() {
    return zt.push(a), e.setCallbacks({
      onScrollCapture: u,
      onWheelCapture: u,
      onTouchMoveCapture: m
    }), document.addEventListener("wheel", l, $t), document.addEventListener("touchmove", l, $t), document.addEventListener("touchstart", f, $t), function() {
      zt = zt.filter(function(g) {
        return g !== a;
      }), document.removeEventListener("wheel", l, $t), document.removeEventListener("touchmove", l, $t), document.removeEventListener("touchstart", f, $t);
    };
  }, []);
  var h = e.removeScrollBar, b = e.inert;
  return d.createElement(
    d.Fragment,
    null,
    b ? d.createElement(a, { styles: Fh(o) }) : null,
    h ? d.createElement(Dh, { noRelative: e.noRelative, gapMode: e.gapMode }) : null
  );
}
function zh(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const Bh = hh(al, $h);
var Nn = d.forwardRef(function(e, t) {
  return d.createElement(kr, Ge({}, e, { ref: t, sideCar: Bh }));
});
Nn.classNames = kr.classNames;
var Yh = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, Bt = /* @__PURE__ */ new WeakMap(), qn = /* @__PURE__ */ new WeakMap(), Xn = {}, vo = 0, dl = function(e) {
  return e && (e.host || dl(e.parentNode));
}, Hh = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = dl(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, Vh = function(e, t, n, r) {
  var o = Hh(t, Array.isArray(e) ? e : [e]);
  Xn[n] || (Xn[n] = /* @__PURE__ */ new WeakMap());
  var a = Xn[n], s = [], i = /* @__PURE__ */ new Set(), l = new Set(o), c = function(u) {
    !u || i.has(u) || (i.add(u), c(u.parentNode));
  };
  o.forEach(c);
  var f = function(u) {
    !u || l.has(u) || Array.prototype.forEach.call(u.children, function(m) {
      if (i.has(m))
        f(m);
      else
        try {
          var h = m.getAttribute(r), b = h !== null && h !== "false", g = (Bt.get(m) || 0) + 1, v = (a.get(m) || 0) + 1;
          Bt.set(m, g), a.set(m, v), s.push(m), g === 1 && b && qn.set(m, !0), v === 1 && m.setAttribute(n, "true"), b || m.setAttribute(r, "true");
        } catch (y) {
          console.error("aria-hidden: cannot operate on ", m, y);
        }
    });
  };
  return f(t), i.clear(), vo++, function() {
    s.forEach(function(u) {
      var m = Bt.get(u) - 1, h = a.get(u) - 1;
      Bt.set(u, m), a.set(u, h), m || (qn.has(u) || u.removeAttribute(r), qn.delete(u)), h || u.removeAttribute(n);
    }), vo--, vo || (Bt = /* @__PURE__ */ new WeakMap(), Bt = /* @__PURE__ */ new WeakMap(), qn = /* @__PURE__ */ new WeakMap(), Xn = {});
  };
}, Er = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), o = Yh(e);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live], script"))), Vh(r, o, n, "aria-hidden")) : function() {
    return null;
  };
}, Mr = "Dialog", [ul, fl] = xe(Mr), [Gh, Ye] = ul(Mr), pl = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: a,
    modal: s = !0
  } = e, i = d.useRef(null), l = d.useRef(null), [c, f] = ke({
    prop: r,
    defaultProp: o ?? !1,
    onChange: a,
    caller: Mr
  });
  return /* @__PURE__ */ p(
    Gh,
    {
      scope: t,
      triggerRef: i,
      contentRef: l,
      contentId: ge(),
      titleId: ge(),
      descriptionId: ge(),
      open: c,
      onOpenChange: f,
      onOpenToggle: d.useCallback(() => f((u) => !u), [f]),
      modal: s,
      children: n
    }
  );
};
pl.displayName = Mr;
var ml = "DialogTrigger", hl = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Ye(ml, n), a = J(t, o.triggerRef);
    return /* @__PURE__ */ p(
      L.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": ma(o.open),
        ...r,
        ref: a,
        onClick: A(e.onClick, o.onOpenToggle)
      }
    );
  }
);
hl.displayName = ml;
var fa = "DialogPortal", [Uh, gl] = ul(fa, {
  forceMount: void 0
}), vl = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: o } = e, a = Ye(fa, t);
  return /* @__PURE__ */ p(Uh, { scope: t, forceMount: n, children: d.Children.map(r, (s) => /* @__PURE__ */ p(Ce, { present: n || a.open, children: /* @__PURE__ */ p(rn, { asChild: !0, container: o, children: s }) })) });
};
vl.displayName = fa;
var sr = "DialogOverlay", bl = d.forwardRef(
  (e, t) => {
    const n = gl(sr, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, a = Ye(sr, e.__scopeDialog);
    return a.modal ? /* @__PURE__ */ p(Ce, { present: r || a.open, children: /* @__PURE__ */ p(Kh, { ...o, ref: t }) }) : null;
  }
);
bl.displayName = sr;
var jh = /* @__PURE__ */ mt("DialogOverlay.RemoveScroll"), Kh = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Ye(sr, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ p(Nn, { as: jh, allowPinchZoom: !0, shards: [o.contentRef], children: /* @__PURE__ */ p(
        L.div,
        {
          "data-state": ma(o.open),
          ...r,
          ref: t,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), Ot = "DialogContent", yl = d.forwardRef(
  (e, t) => {
    const n = gl(Ot, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, a = Ye(Ot, e.__scopeDialog);
    return /* @__PURE__ */ p(Ce, { present: r || a.open, children: a.modal ? /* @__PURE__ */ p(qh, { ...o, ref: t }) : /* @__PURE__ */ p(Xh, { ...o, ref: t }) });
  }
);
yl.displayName = Ot;
var qh = d.forwardRef(
  (e, t) => {
    const n = Ye(Ot, e.__scopeDialog), r = d.useRef(null), o = J(t, n.contentRef, r);
    return d.useEffect(() => {
      const a = r.current;
      if (a) return Er(a);
    }, []), /* @__PURE__ */ p(
      wl,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: A(e.onCloseAutoFocus, (a) => {
          a.preventDefault(), n.triggerRef.current?.focus();
        }),
        onPointerDownOutside: A(e.onPointerDownOutside, (a) => {
          const s = a.detail.originalEvent, i = s.button === 0 && s.ctrlKey === !0;
          (s.button === 2 || i) && a.preventDefault();
        }),
        onFocusOutside: A(
          e.onFocusOutside,
          (a) => a.preventDefault()
        )
      }
    );
  }
), Xh = d.forwardRef(
  (e, t) => {
    const n = Ye(Ot, e.__scopeDialog), r = d.useRef(!1), o = d.useRef(!1);
    return /* @__PURE__ */ p(
      wl,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (a) => {
          e.onCloseAutoFocus?.(a), a.defaultPrevented || (r.current || n.triggerRef.current?.focus(), a.preventDefault()), r.current = !1, o.current = !1;
        },
        onInteractOutside: (a) => {
          e.onInteractOutside?.(a), a.defaultPrevented || (r.current = !0, a.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const s = a.target;
          n.triggerRef.current?.contains(s) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && o.current && a.preventDefault();
        }
      }
    );
  }
), wl = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: a, ...s } = e, i = Ye(Ot, n), l = d.useRef(null), c = J(t, l);
    return Cr(), /* @__PURE__ */ ae(pt, { children: [
      /* @__PURE__ */ p(
        On,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: o,
          onUnmountAutoFocus: a,
          children: /* @__PURE__ */ p(
            nn,
            {
              role: "dialog",
              id: i.contentId,
              "aria-describedby": i.descriptionId,
              "aria-labelledby": i.titleId,
              "data-state": ma(i.open),
              ...s,
              ref: c,
              onDismiss: () => i.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ ae(pt, { children: [
        /* @__PURE__ */ p(Qh, { titleId: i.titleId }),
        /* @__PURE__ */ p(eg, { contentRef: l, descriptionId: i.descriptionId })
      ] })
    ] });
  }
), pa = "DialogTitle", xl = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Ye(pa, n);
    return /* @__PURE__ */ p(L.h2, { id: o.titleId, ...r, ref: t });
  }
);
xl.displayName = pa;
var Sl = "DialogDescription", Cl = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Ye(Sl, n);
    return /* @__PURE__ */ p(L.p, { id: o.descriptionId, ...r, ref: t });
  }
);
Cl.displayName = Sl;
var kl = "DialogClose", El = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Ye(kl, n);
    return /* @__PURE__ */ p(
      L.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: A(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
El.displayName = kl;
function ma(e) {
  return e ? "open" : "closed";
}
var Ml = "DialogTitleWarning", [Zh, Pl] = mm(Ml, {
  contentName: Ot,
  titleName: pa,
  docsSlug: "dialog"
}), Qh = ({ titleId: e }) => {
  const t = Pl(Ml), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return d.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, Jh = "DialogDescriptionWarning", eg = ({ contentRef: e, descriptionId: t }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${Pl(Jh).contentName}}.`;
  return d.useEffect(() => {
    const o = e.current?.getAttribute("aria-describedby");
    t && o && (document.getElementById(t) || console.warn(r));
  }, [r, e, t]), null;
}, Pr = pl, ha = hl, Dr = vl, Or = bl, Nr = yl, ga = xl, va = Cl, Wt = El, Dl = "AlertDialog", [tg] = xe(Dl, [
  fl
]), at = fl(), Ol = (e) => {
  const { __scopeAlertDialog: t, ...n } = e, r = at(t);
  return /* @__PURE__ */ p(Pr, { ...r, ...n, modal: !0 });
};
Ol.displayName = Dl;
var ng = "AlertDialogTrigger", Nl = d.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...r } = e, o = at(n);
    return /* @__PURE__ */ p(ha, { ...o, ...r, ref: t });
  }
);
Nl.displayName = ng;
var rg = "AlertDialogPortal", _l = (e) => {
  const { __scopeAlertDialog: t, ...n } = e, r = at(t);
  return /* @__PURE__ */ p(Dr, { ...r, ...n });
};
_l.displayName = rg;
var og = "AlertDialogOverlay", Rl = d.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...r } = e, o = at(n);
    return /* @__PURE__ */ p(Or, { ...o, ...r, ref: t });
  }
);
Rl.displayName = og;
var Kt = "AlertDialogContent", [ag, sg] = tg(Kt), ig = /* @__PURE__ */ Ii("AlertDialogContent"), Tl = d.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, children: r, ...o } = e, a = at(n), s = d.useRef(null), i = J(t, s), l = d.useRef(null);
    return /* @__PURE__ */ p(
      Zh,
      {
        contentName: Kt,
        titleName: Al,
        docsSlug: "alert-dialog",
        children: /* @__PURE__ */ p(ag, { scope: n, cancelRef: l, children: /* @__PURE__ */ ae(
          Nr,
          {
            role: "alertdialog",
            ...a,
            ...o,
            ref: i,
            onOpenAutoFocus: A(o.onOpenAutoFocus, (c) => {
              c.preventDefault(), l.current?.focus({ preventScroll: !0 });
            }),
            onPointerDownOutside: (c) => c.preventDefault(),
            onInteractOutside: (c) => c.preventDefault(),
            children: [
              /* @__PURE__ */ p(ig, { children: r }),
              /* @__PURE__ */ p(cg, { contentRef: s })
            ]
          }
        ) })
      }
    );
  }
);
Tl.displayName = Kt;
var Al = "AlertDialogTitle", Il = d.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...r } = e, o = at(n);
    return /* @__PURE__ */ p(ga, { ...o, ...r, ref: t });
  }
);
Il.displayName = Al;
var Wl = "AlertDialogDescription", Fl = d.forwardRef((e, t) => {
  const { __scopeAlertDialog: n, ...r } = e, o = at(n);
  return /* @__PURE__ */ p(va, { ...o, ...r, ref: t });
});
Fl.displayName = Wl;
var lg = "AlertDialogAction", Ll = d.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...r } = e, o = at(n);
    return /* @__PURE__ */ p(Wt, { ...o, ...r, ref: t });
  }
);
Ll.displayName = lg;
var $l = "AlertDialogCancel", zl = d.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...r } = e, { cancelRef: o } = sg($l, n), a = at(n), s = J(t, o);
    return /* @__PURE__ */ p(Wt, { ...a, ...r, ref: s });
  }
);
zl.displayName = $l;
var cg = ({ contentRef: e }) => {
  const t = `\`${Kt}\` requires a description for the component to be accessible for screen reader users.

You can add a description to the \`${Kt}\` by passing a \`${Wl}\` component as a child, which also benefits sighted users by adding visible context to the dialog.

Alternatively, you can use your own component as a description by assigning it an \`id\` and passing the same value to the \`aria-describedby\` prop in \`${Kt}\`. If the description is confusing or duplicative for sighted users, you can use the \`@radix-ui/react-visually-hidden\` primitive as a wrapper around your description component.

For more information, see https://radix-ui.com/primitives/docs/components/alert-dialog`;
  return d.useEffect(() => {
    document.getElementById(
      e.current?.getAttribute("aria-describedby")
    ) || console.warn(t);
  }, [t, e]), null;
}, dg = Ol, ug = Nl, fg = _l, pg = Rl, mg = Tl, hg = Ll, gg = zl, vg = Il, bg = Fl, Zn = { exports: {} }, bo = {};
var Ps;
function yg() {
  if (Ps) return bo;
  Ps = 1;
  var e = N;
  function t(u, m) {
    return u === m && (u !== 0 || 1 / u === 1 / m) || u !== u && m !== m;
  }
  var n = typeof Object.is == "function" ? Object.is : t, r = e.useState, o = e.useEffect, a = e.useLayoutEffect, s = e.useDebugValue;
  function i(u, m) {
    var h = m(), b = r({ inst: { value: h, getSnapshot: m } }), g = b[0].inst, v = b[1];
    return a(
      function() {
        g.value = h, g.getSnapshot = m, l(g) && v({ inst: g });
      },
      [u, h, m]
    ), o(
      function() {
        return l(g) && v({ inst: g }), u(function() {
          l(g) && v({ inst: g });
        });
      },
      [u]
    ), s(h), h;
  }
  function l(u) {
    var m = u.getSnapshot;
    u = u.value;
    try {
      var h = m();
      return !n(u, h);
    } catch {
      return !0;
    }
  }
  function c(u, m) {
    return m();
  }
  var f = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? c : i;
  return bo.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : f, bo;
}
var yo = {};
var Ds;
function wg() {
  return Ds || (Ds = 1, process.env.NODE_ENV !== "production" && (function() {
    function e(h, b) {
      return h === b && (h !== 0 || 1 / h === 1 / b) || h !== h && b !== b;
    }
    function t(h, b) {
      f || o.startTransition === void 0 || (f = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var g = b();
      if (!u) {
        var v = b();
        a(g, v) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), u = !0);
      }
      v = s({
        inst: { value: g, getSnapshot: b }
      });
      var y = v[0].inst, w = v[1];
      return l(
        function() {
          y.value = g, y.getSnapshot = b, n(y) && w({ inst: y });
        },
        [h, g, b]
      ), i(
        function() {
          return n(y) && w({ inst: y }), h(function() {
            n(y) && w({ inst: y });
          });
        },
        [h]
      ), c(g), g;
    }
    function n(h) {
      var b = h.getSnapshot;
      h = h.value;
      try {
        var g = b();
        return !a(h, g);
      } catch {
        return !0;
      }
    }
    function r(h, b) {
      return b();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var o = N, a = typeof Object.is == "function" ? Object.is : e, s = o.useState, i = o.useEffect, l = o.useLayoutEffect, c = o.useDebugValue, f = !1, u = !1, m = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? r : t;
    yo.useSyncExternalStore = o.useSyncExternalStore !== void 0 ? o.useSyncExternalStore : m, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })()), yo;
}
var Os;
function xg() {
  return Os || (Os = 1, process.env.NODE_ENV === "production" ? Zn.exports = yg() : Zn.exports = wg()), Zn.exports;
}
var Sg = xg();
function Cg() {
  return Sg.useSyncExternalStore(
    kg,
    () => !0,
    () => !1
  );
}
function kg() {
  return () => {
  };
}
var ba = "Avatar", [Eg] = xe(ba), [Mg, Bl] = Eg(ba), Yl = d.forwardRef(
  (e, t) => {
    const { __scopeAvatar: n, ...r } = e, [o, a] = d.useState("idle");
    return /* @__PURE__ */ p(
      Mg,
      {
        scope: n,
        imageLoadingStatus: o,
        onImageLoadingStatusChange: a,
        children: /* @__PURE__ */ p(L.span, { ...r, ref: t })
      }
    );
  }
);
Yl.displayName = ba;
var Hl = "AvatarImage", Vl = d.forwardRef(
  (e, t) => {
    const { __scopeAvatar: n, src: r, onLoadingStatusChange: o = () => {
    }, ...a } = e, s = Bl(Hl, n), i = Pg(r, a), l = we((c) => {
      o(c), s.onImageLoadingStatusChange(c);
    });
    return ve(() => {
      i !== "idle" && l(i);
    }, [i, l]), i === "loaded" ? /* @__PURE__ */ p(L.img, { ...a, ref: t, src: r }) : null;
  }
);
Vl.displayName = Hl;
var Gl = "AvatarFallback", Ul = d.forwardRef(
  (e, t) => {
    const { __scopeAvatar: n, delayMs: r, ...o } = e, a = Bl(Gl, n), [s, i] = d.useState(r === void 0);
    return d.useEffect(() => {
      if (r !== void 0) {
        const l = window.setTimeout(() => i(!0), r);
        return () => window.clearTimeout(l);
      }
    }, [r]), s && a.imageLoadingStatus !== "loaded" ? /* @__PURE__ */ p(L.span, { ...o, ref: t }) : null;
  }
);
Ul.displayName = Gl;
function Ns(e, t) {
  return e ? t ? (e.src !== t && (e.src = t), e.complete && e.naturalWidth > 0 ? "loaded" : "loading") : "error" : "idle";
}
function Pg(e, { referrerPolicy: t, crossOrigin: n }) {
  const r = Cg(), o = d.useRef(null), a = r ? (o.current || (o.current = new window.Image()), o.current) : null, [s, i] = d.useState(
    () => Ns(a, e)
  );
  return ve(() => {
    i(Ns(a, e));
  }, [a, e]), ve(() => {
    const l = (u) => () => {
      i(u);
    };
    if (!a) return;
    const c = l("loaded"), f = l("error");
    return a.addEventListener("load", c), a.addEventListener("error", f), t && (a.referrerPolicy = t), typeof n == "string" && (a.crossOrigin = n), () => {
      a.removeEventListener("load", c), a.removeEventListener("error", f);
    };
  }, [a, n, t]), s;
}
var Dg = Yl, Og = Vl, Ng = Ul;
function _r(e) {
  const t = d.useRef({ value: e, previous: e });
  return d.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
function Rr(e) {
  const [t, n] = d.useState(void 0);
  return ve(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const a = o[0];
        let s, i;
        if ("borderBoxSize" in a) {
          const l = a.borderBoxSize, c = Array.isArray(l) ? l[0] : l;
          s = c.inlineSize, i = c.blockSize;
        } else
          s = e.offsetWidth, i = e.offsetHeight;
        n({ width: s, height: i });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var Tr = "Checkbox", [_g] = xe(Tr), [Rg, ya] = _g(Tr);
function Tg(e) {
  const {
    __scopeCheckbox: t,
    checked: n,
    children: r,
    defaultChecked: o,
    disabled: a,
    form: s,
    name: i,
    onCheckedChange: l,
    required: c,
    value: f = "on",
    // @ts-expect-error
    internal_do_not_use_render: u
  } = e, [m, h] = ke({
    prop: n,
    defaultProp: o ?? !1,
    onChange: l,
    caller: Tr
  }), [b, g] = d.useState(null), [v, y] = d.useState(null), w = d.useRef(!1), x = b ? !!s || !!b.closest("form") : (
    // We set this to true by default so that events bubble to forms without JS (SSR)
    !0
  ), S = {
    checked: m,
    disabled: a,
    setChecked: h,
    control: b,
    setControl: g,
    name: i,
    form: s,
    value: f,
    hasConsumerStoppedPropagationRef: w,
    required: c,
    defaultChecked: ft(o) ? !1 : o,
    isFormControl: x,
    bubbleInput: v,
    setBubbleInput: y
  };
  return /* @__PURE__ */ p(
    Rg,
    {
      scope: t,
      ...S,
      children: Ag(u) ? u(S) : r
    }
  );
}
var jl = "CheckboxTrigger", Kl = d.forwardRef(
  ({ __scopeCheckbox: e, onKeyDown: t, onClick: n, ...r }, o) => {
    const {
      control: a,
      value: s,
      disabled: i,
      checked: l,
      required: c,
      setControl: f,
      setChecked: u,
      hasConsumerStoppedPropagationRef: m,
      isFormControl: h,
      bubbleInput: b
    } = ya(jl, e), g = J(o, f), v = d.useRef(l);
    return d.useEffect(() => {
      const y = a?.form;
      if (y) {
        const w = () => u(v.current);
        return y.addEventListener("reset", w), () => y.removeEventListener("reset", w);
      }
    }, [a, u]), /* @__PURE__ */ p(
      L.button,
      {
        type: "button",
        role: "checkbox",
        "aria-checked": ft(l) ? "mixed" : l,
        "aria-required": c,
        "data-state": ec(l),
        "data-disabled": i ? "" : void 0,
        disabled: i,
        value: s,
        ...r,
        ref: g,
        onKeyDown: A(t, (y) => {
          y.key === "Enter" && y.preventDefault();
        }),
        onClick: A(n, (y) => {
          u((w) => ft(w) ? !0 : !w), b && h && (m.current = y.isPropagationStopped(), m.current || y.stopPropagation());
        })
      }
    );
  }
);
Kl.displayName = jl;
var ql = d.forwardRef(
  (e, t) => {
    const {
      __scopeCheckbox: n,
      name: r,
      checked: o,
      defaultChecked: a,
      required: s,
      disabled: i,
      value: l,
      onCheckedChange: c,
      form: f,
      ...u
    } = e;
    return /* @__PURE__ */ p(
      Tg,
      {
        __scopeCheckbox: n,
        checked: o,
        defaultChecked: a,
        disabled: i,
        required: s,
        onCheckedChange: c,
        name: r,
        form: f,
        value: l,
        internal_do_not_use_render: ({ isFormControl: m }) => /* @__PURE__ */ ae(pt, { children: [
          /* @__PURE__ */ p(
            Kl,
            {
              ...u,
              ref: t,
              __scopeCheckbox: n
            }
          ),
          m && /* @__PURE__ */ p(
            Jl,
            {
              __scopeCheckbox: n
            }
          )
        ] })
      }
    );
  }
);
ql.displayName = Tr;
var Xl = "CheckboxIndicator", Zl = d.forwardRef(
  (e, t) => {
    const { __scopeCheckbox: n, forceMount: r, ...o } = e, a = ya(Xl, n);
    return /* @__PURE__ */ p(
      Ce,
      {
        present: r || ft(a.checked) || a.checked === !0,
        children: /* @__PURE__ */ p(
          L.span,
          {
            "data-state": ec(a.checked),
            "data-disabled": a.disabled ? "" : void 0,
            ...o,
            ref: t,
            style: { pointerEvents: "none", ...e.style }
          }
        )
      }
    );
  }
);
Zl.displayName = Xl;
var Ql = "CheckboxBubbleInput", Jl = d.forwardRef(
  ({ __scopeCheckbox: e, ...t }, n) => {
    const {
      control: r,
      hasConsumerStoppedPropagationRef: o,
      checked: a,
      defaultChecked: s,
      required: i,
      disabled: l,
      name: c,
      value: f,
      form: u,
      bubbleInput: m,
      setBubbleInput: h
    } = ya(Ql, e), b = J(n, h), g = _r(a), v = Rr(r);
    d.useEffect(() => {
      const w = m;
      if (!w) return;
      const x = window.HTMLInputElement.prototype, k = Object.getOwnPropertyDescriptor(
        x,
        "checked"
      ).set, C = !o.current;
      if (g !== a && k) {
        const E = new Event("click", { bubbles: C });
        w.indeterminate = ft(a), k.call(w, ft(a) ? !1 : a), w.dispatchEvent(E);
      }
    }, [m, g, a, o]);
    const y = d.useRef(ft(a) ? !1 : a);
    return /* @__PURE__ */ p(
      L.input,
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: s ?? y.current,
        required: i,
        disabled: l,
        name: c,
        value: f,
        form: u,
        ...t,
        tabIndex: -1,
        ref: b,
        style: {
          ...t.style,
          ...v,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0,
          // We transform because the input is absolutely positioned but we have
          // rendered it **after** the button. This pulls it back to sit on top
          // of the button.
          transform: "translateX(-100%)"
        }
      }
    );
  }
);
Jl.displayName = Ql;
function Ag(e) {
  return typeof e == "function";
}
function ft(e) {
  return e === "indeterminate";
}
function ec(e) {
  return ft(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
const Ig = ["top", "right", "bottom", "left"], ht = Math.min, Oe = Math.max, ir = Math.round, Qn = Math.floor, Ke = (e) => ({
  x: e,
  y: e
}), Wg = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Lo(e, t, n) {
  return Oe(e, ht(t, n));
}
function rt(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function ot(e) {
  return e.split("-")[0];
}
function on(e) {
  return e.split("-")[1];
}
function wa(e) {
  return e === "x" ? "y" : "x";
}
function xa(e) {
  return e === "y" ? "height" : "width";
}
function Ue(e) {
  const t = e[0];
  return t === "t" || t === "b" ? "y" : "x";
}
function Sa(e) {
  return wa(Ue(e));
}
function Fg(e, t, n) {
  n === void 0 && (n = !1);
  const r = on(e), o = Sa(e), a = xa(o);
  let s = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[a] > t.floating[a] && (s = lr(s)), [s, lr(s)];
}
function Lg(e) {
  const t = lr(e);
  return [$o(e), t, $o(t)];
}
function $o(e) {
  return e.includes("start") ? e.replace("start", "end") : e.replace("end", "start");
}
const _s = ["left", "right"], Rs = ["right", "left"], $g = ["top", "bottom"], zg = ["bottom", "top"];
function Bg(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? Rs : _s : t ? _s : Rs;
    case "left":
    case "right":
      return t ? $g : zg;
    default:
      return [];
  }
}
function Yg(e, t, n, r) {
  const o = on(e);
  let a = Bg(ot(e), n === "start", r);
  return o && (a = a.map((s) => s + "-" + o), t && (a = a.concat(a.map($o)))), a;
}
function lr(e) {
  const t = ot(e);
  return Wg[t] + e.slice(t.length);
}
function Hg(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function tc(e) {
  return typeof e != "number" ? Hg(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function cr(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: o
  } = e;
  return {
    width: r,
    height: o,
    top: n,
    left: t,
    right: t + r,
    bottom: n + o,
    x: t,
    y: n
  };
}
function Ts(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const a = Ue(t), s = Sa(t), i = xa(s), l = ot(t), c = a === "y", f = r.x + r.width / 2 - o.width / 2, u = r.y + r.height / 2 - o.height / 2, m = r[i] / 2 - o[i] / 2;
  let h;
  switch (l) {
    case "top":
      h = {
        x: f,
        y: r.y - o.height
      };
      break;
    case "bottom":
      h = {
        x: f,
        y: r.y + r.height
      };
      break;
    case "right":
      h = {
        x: r.x + r.width,
        y: u
      };
      break;
    case "left":
      h = {
        x: r.x - o.width,
        y: u
      };
      break;
    default:
      h = {
        x: r.x,
        y: r.y
      };
  }
  switch (on(t)) {
    case "start":
      h[s] -= m * (n && c ? -1 : 1);
      break;
    case "end":
      h[s] += m * (n && c ? -1 : 1);
      break;
  }
  return h;
}
async function Vg(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: a,
    rects: s,
    elements: i,
    strategy: l
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: f = "viewport",
    elementContext: u = "floating",
    altBoundary: m = !1,
    padding: h = 0
  } = rt(t, e), b = tc(h), v = i[m ? u === "floating" ? "reference" : "floating" : u], y = cr(await a.getClippingRect({
    element: (n = await (a.isElement == null ? void 0 : a.isElement(v))) == null || n ? v : v.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(i.floating)),
    boundary: c,
    rootBoundary: f,
    strategy: l
  })), w = u === "floating" ? {
    x: r,
    y: o,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, x = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(i.floating)), S = await (a.isElement == null ? void 0 : a.isElement(x)) ? await (a.getScale == null ? void 0 : a.getScale(x)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, k = cr(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: i,
    rect: w,
    offsetParent: x,
    strategy: l
  }) : w);
  return {
    top: (y.top - k.top + b.top) / S.y,
    bottom: (k.bottom - y.bottom + b.bottom) / S.y,
    left: (y.left - k.left + b.left) / S.x,
    right: (k.right - y.right + b.right) / S.x
  };
}
const Gg = 50, Ug = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: a = [],
    platform: s
  } = n, i = s.detectOverflow ? s : {
    ...s,
    detectOverflow: Vg
  }, l = await (s.isRTL == null ? void 0 : s.isRTL(t));
  let c = await s.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: f,
    y: u
  } = Ts(c, r, l), m = r, h = 0;
  const b = {};
  for (let g = 0; g < a.length; g++) {
    const v = a[g];
    if (!v)
      continue;
    const {
      name: y,
      fn: w
    } = v, {
      x,
      y: S,
      data: k,
      reset: C
    } = await w({
      x: f,
      y: u,
      initialPlacement: r,
      placement: m,
      strategy: o,
      middlewareData: b,
      rects: c,
      platform: i,
      elements: {
        reference: e,
        floating: t
      }
    });
    f = x ?? f, u = S ?? u, b[y] = {
      ...b[y],
      ...k
    }, C && h < Gg && (h++, typeof C == "object" && (C.placement && (m = C.placement), C.rects && (c = C.rects === !0 ? await s.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : C.rects), {
      x: f,
      y: u
    } = Ts(c, m, l)), g = -1);
  }
  return {
    x: f,
    y: u,
    placement: m,
    strategy: o,
    middlewareData: b
  };
}, jg = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: o,
      rects: a,
      platform: s,
      elements: i,
      middlewareData: l
    } = t, {
      element: c,
      padding: f = 0
    } = rt(e, t) || {};
    if (c == null)
      return {};
    const u = tc(f), m = {
      x: n,
      y: r
    }, h = Sa(o), b = xa(h), g = await s.getDimensions(c), v = h === "y", y = v ? "top" : "left", w = v ? "bottom" : "right", x = v ? "clientHeight" : "clientWidth", S = a.reference[b] + a.reference[h] - m[h] - a.floating[b], k = m[h] - a.reference[h], C = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(c));
    let E = C ? C[x] : 0;
    (!E || !await (s.isElement == null ? void 0 : s.isElement(C))) && (E = i.floating[x] || a.floating[b]);
    const M = S / 2 - k / 2, O = E / 2 - g[b] / 2 - 1, R = ht(u[y], O), W = ht(u[w], O), Y = R, K = E - g[b] - W, H = E / 2 - g[b] / 2 + M, Q = Lo(Y, H, K), $ = !l.arrow && on(o) != null && H !== Q && a.reference[b] / 2 - (H < Y ? R : W) - g[b] / 2 < 0, q = $ ? H < Y ? H - Y : H - K : 0;
    return {
      [h]: m[h] + q,
      data: {
        [h]: Q,
        centerOffset: H - Q - q,
        ...$ && {
          alignmentOffset: q
        }
      },
      reset: $
    };
  }
}), Kg = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        middlewareData: a,
        rects: s,
        initialPlacement: i,
        platform: l,
        elements: c
      } = t, {
        mainAxis: f = !0,
        crossAxis: u = !0,
        fallbackPlacements: m,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: b = "none",
        flipAlignment: g = !0,
        ...v
      } = rt(e, t);
      if ((n = a.arrow) != null && n.alignmentOffset)
        return {};
      const y = ot(o), w = Ue(i), x = ot(i) === i, S = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), k = m || (x || !g ? [lr(i)] : Lg(i)), C = b !== "none";
      !m && C && k.push(...Yg(i, g, b, S));
      const E = [i, ...k], M = await l.detectOverflow(t, v), O = [];
      let R = ((r = a.flip) == null ? void 0 : r.overflows) || [];
      if (f && O.push(M[y]), u) {
        const H = Fg(o, s, S);
        O.push(M[H[0]], M[H[1]]);
      }
      if (R = [...R, {
        placement: o,
        overflows: O
      }], !O.every((H) => H <= 0)) {
        var W, Y;
        const H = (((W = a.flip) == null ? void 0 : W.index) || 0) + 1, Q = E[H];
        if (Q && (!(u === "alignment" ? w !== Ue(Q) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        R.every((z) => Ue(z.placement) === w ? z.overflows[0] > 0 : !0)))
          return {
            data: {
              index: H,
              overflows: R
            },
            reset: {
              placement: Q
            }
          };
        let $ = (Y = R.filter((q) => q.overflows[0] <= 0).sort((q, z) => q.overflows[1] - z.overflows[1])[0]) == null ? void 0 : Y.placement;
        if (!$)
          switch (h) {
            case "bestFit": {
              var K;
              const q = (K = R.filter((z) => {
                if (C) {
                  const T = Ue(z.placement);
                  return T === w || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  T === "y";
                }
                return !0;
              }).map((z) => [z.placement, z.overflows.filter((T) => T > 0).reduce((T, I) => T + I, 0)]).sort((z, T) => z[1] - T[1])[0]) == null ? void 0 : K[0];
              q && ($ = q);
              break;
            }
            case "initialPlacement":
              $ = i;
              break;
          }
        if (o !== $)
          return {
            reset: {
              placement: $
            }
          };
      }
      return {};
    }
  };
};
function As(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function Is(e) {
  return Ig.some((t) => e[t] >= 0);
}
const qg = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n,
        platform: r
      } = t, {
        strategy: o = "referenceHidden",
        ...a
      } = rt(e, t);
      switch (o) {
        case "referenceHidden": {
          const s = await r.detectOverflow(t, {
            ...a,
            elementContext: "reference"
          }), i = As(s, n.reference);
          return {
            data: {
              referenceHiddenOffsets: i,
              referenceHidden: Is(i)
            }
          };
        }
        case "escaped": {
          const s = await r.detectOverflow(t, {
            ...a,
            altBoundary: !0
          }), i = As(s, n.floating);
          return {
            data: {
              escapedOffsets: i,
              escaped: Is(i)
            }
          };
        }
        default:
          return {};
      }
    }
  };
}, nc = /* @__PURE__ */ new Set(["left", "top"]);
async function Xg(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, a = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), s = ot(n), i = on(n), l = Ue(n) === "y", c = nc.has(s) ? -1 : 1, f = a && l ? -1 : 1, u = rt(t, e);
  let {
    mainAxis: m,
    crossAxis: h,
    alignmentAxis: b
  } = typeof u == "number" ? {
    mainAxis: u,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: u.mainAxis || 0,
    crossAxis: u.crossAxis || 0,
    alignmentAxis: u.alignmentAxis
  };
  return i && typeof b == "number" && (h = i === "end" ? b * -1 : b), l ? {
    x: h * f,
    y: m * c
  } : {
    x: m * c,
    y: h * f
  };
}
const Zg = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: o,
        y: a,
        placement: s,
        middlewareData: i
      } = t, l = await Xg(t, e);
      return s === ((n = i.offset) == null ? void 0 : n.placement) && (r = i.arrow) != null && r.alignmentOffset ? {} : {
        x: o + l.x,
        y: a + l.y,
        data: {
          ...l,
          placement: s
        }
      };
    }
  };
}, Qg = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: o,
        platform: a
      } = t, {
        mainAxis: s = !0,
        crossAxis: i = !1,
        limiter: l = {
          fn: (y) => {
            let {
              x: w,
              y: x
            } = y;
            return {
              x: w,
              y: x
            };
          }
        },
        ...c
      } = rt(e, t), f = {
        x: n,
        y: r
      }, u = await a.detectOverflow(t, c), m = Ue(ot(o)), h = wa(m);
      let b = f[h], g = f[m];
      if (s) {
        const y = h === "y" ? "top" : "left", w = h === "y" ? "bottom" : "right", x = b + u[y], S = b - u[w];
        b = Lo(x, b, S);
      }
      if (i) {
        const y = m === "y" ? "top" : "left", w = m === "y" ? "bottom" : "right", x = g + u[y], S = g - u[w];
        g = Lo(x, g, S);
      }
      const v = l.fn({
        ...t,
        [h]: b,
        [m]: g
      });
      return {
        ...v,
        data: {
          x: v.x - n,
          y: v.y - r,
          enabled: {
            [h]: s,
            [m]: i
          }
        }
      };
    }
  };
}, Jg = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: o,
        rects: a,
        middlewareData: s
      } = t, {
        offset: i = 0,
        mainAxis: l = !0,
        crossAxis: c = !0
      } = rt(e, t), f = {
        x: n,
        y: r
      }, u = Ue(o), m = wa(u);
      let h = f[m], b = f[u];
      const g = rt(i, t), v = typeof g == "number" ? {
        mainAxis: g,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...g
      };
      if (l) {
        const x = m === "y" ? "height" : "width", S = a.reference[m] - a.floating[x] + v.mainAxis, k = a.reference[m] + a.reference[x] - v.mainAxis;
        h < S ? h = S : h > k && (h = k);
      }
      if (c) {
        var y, w;
        const x = m === "y" ? "width" : "height", S = nc.has(ot(o)), k = a.reference[u] - a.floating[x] + (S && ((y = s.offset) == null ? void 0 : y[u]) || 0) + (S ? 0 : v.crossAxis), C = a.reference[u] + a.reference[x] + (S ? 0 : ((w = s.offset) == null ? void 0 : w[u]) || 0) - (S ? v.crossAxis : 0);
        b < k ? b = k : b > C && (b = C);
      }
      return {
        [m]: h,
        [u]: b
      };
    }
  };
}, ev = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        rects: a,
        platform: s,
        elements: i
      } = t, {
        apply: l = () => {
        },
        ...c
      } = rt(e, t), f = await s.detectOverflow(t, c), u = ot(o), m = on(o), h = Ue(o) === "y", {
        width: b,
        height: g
      } = a.floating;
      let v, y;
      u === "top" || u === "bottom" ? (v = u, y = m === (await (s.isRTL == null ? void 0 : s.isRTL(i.floating)) ? "start" : "end") ? "left" : "right") : (y = u, v = m === "end" ? "top" : "bottom");
      const w = g - f.top - f.bottom, x = b - f.left - f.right, S = ht(g - f[v], w), k = ht(b - f[y], x), C = !t.middlewareData.shift;
      let E = S, M = k;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (M = x), (r = t.middlewareData.shift) != null && r.enabled.y && (E = w), C && !m) {
        const R = Oe(f.left, 0), W = Oe(f.right, 0), Y = Oe(f.top, 0), K = Oe(f.bottom, 0);
        h ? M = b - 2 * (R !== 0 || W !== 0 ? R + W : Oe(f.left, f.right)) : E = g - 2 * (Y !== 0 || K !== 0 ? Y + K : Oe(f.top, f.bottom));
      }
      await l({
        ...t,
        availableWidth: M,
        availableHeight: E
      });
      const O = await s.getDimensions(i.floating);
      return b !== O.width || g !== O.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Ar() {
  return typeof window < "u";
}
function an(e) {
  return rc(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Ne(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function qe(e) {
  var t;
  return (t = (rc(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function rc(e) {
  return Ar() ? e instanceof Node || e instanceof Ne(e).Node : !1;
}
function $e(e) {
  return Ar() ? e instanceof Element || e instanceof Ne(e).Element : !1;
}
function st(e) {
  return Ar() ? e instanceof HTMLElement || e instanceof Ne(e).HTMLElement : !1;
}
function Ws(e) {
  return !Ar() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Ne(e).ShadowRoot;
}
function _n(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = ze(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && o !== "inline" && o !== "contents";
}
function tv(e) {
  return /^(table|td|th)$/.test(an(e));
}
function Ir(e) {
  try {
    if (e.matches(":popover-open"))
      return !0;
  } catch {
  }
  try {
    return e.matches(":modal");
  } catch {
    return !1;
  }
}
const nv = /transform|translate|scale|rotate|perspective|filter/, rv = /paint|layout|strict|content/, Pt = (e) => !!e && e !== "none";
let wo;
function Ca(e) {
  const t = $e(e) ? ze(e) : e;
  return Pt(t.transform) || Pt(t.translate) || Pt(t.scale) || Pt(t.rotate) || Pt(t.perspective) || !ka() && (Pt(t.backdropFilter) || Pt(t.filter)) || nv.test(t.willChange || "") || rv.test(t.contain || "");
}
function ov(e) {
  let t = gt(e);
  for (; st(t) && !Xt(t); ) {
    if (Ca(t))
      return t;
    if (Ir(t))
      return null;
    t = gt(t);
  }
  return null;
}
function ka() {
  return wo == null && (wo = typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none")), wo;
}
function Xt(e) {
  return /^(html|body|#document)$/.test(an(e));
}
function ze(e) {
  return Ne(e).getComputedStyle(e);
}
function Wr(e) {
  return $e(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function gt(e) {
  if (an(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Ws(e) && e.host || // Fallback.
    qe(e)
  );
  return Ws(t) ? t.host : t;
}
function oc(e) {
  const t = gt(e);
  return Xt(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : st(t) && _n(t) ? t : oc(t);
}
function xn(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = oc(e), a = o === ((r = e.ownerDocument) == null ? void 0 : r.body), s = Ne(o);
  if (a) {
    const i = zo(s);
    return t.concat(s, s.visualViewport || [], _n(o) ? o : [], i && n ? xn(i) : []);
  } else
    return t.concat(o, xn(o, [], n));
}
function zo(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function ac(e) {
  const t = ze(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = st(e), a = o ? e.offsetWidth : n, s = o ? e.offsetHeight : r, i = ir(n) !== a || ir(r) !== s;
  return i && (n = a, r = s), {
    width: n,
    height: r,
    $: i
  };
}
function Ea(e) {
  return $e(e) ? e : e.contextElement;
}
function qt(e) {
  const t = Ea(e);
  if (!st(t))
    return Ke(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: a
  } = ac(t);
  let s = (a ? ir(n.width) : n.width) / r, i = (a ? ir(n.height) : n.height) / o;
  return (!s || !Number.isFinite(s)) && (s = 1), (!i || !Number.isFinite(i)) && (i = 1), {
    x: s,
    y: i
  };
}
const av = /* @__PURE__ */ Ke(0);
function sc(e) {
  const t = Ne(e);
  return !ka() || !t.visualViewport ? av : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function sv(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== Ne(e) ? !1 : t;
}
function Nt(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), a = Ea(e);
  let s = Ke(1);
  t && (r ? $e(r) && (s = qt(r)) : s = qt(e));
  const i = sv(a, n, r) ? sc(a) : Ke(0);
  let l = (o.left + i.x) / s.x, c = (o.top + i.y) / s.y, f = o.width / s.x, u = o.height / s.y;
  if (a) {
    const m = Ne(a), h = r && $e(r) ? Ne(r) : r;
    let b = m, g = zo(b);
    for (; g && r && h !== b; ) {
      const v = qt(g), y = g.getBoundingClientRect(), w = ze(g), x = y.left + (g.clientLeft + parseFloat(w.paddingLeft)) * v.x, S = y.top + (g.clientTop + parseFloat(w.paddingTop)) * v.y;
      l *= v.x, c *= v.y, f *= v.x, u *= v.y, l += x, c += S, b = Ne(g), g = zo(b);
    }
  }
  return cr({
    width: f,
    height: u,
    x: l,
    y: c
  });
}
function Fr(e, t) {
  const n = Wr(e).scrollLeft;
  return t ? t.left + n : Nt(qe(e)).left + n;
}
function ic(e, t) {
  const n = e.getBoundingClientRect(), r = n.left + t.scrollLeft - Fr(e, n), o = n.top + t.scrollTop;
  return {
    x: r,
    y: o
  };
}
function iv(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: o
  } = e;
  const a = o === "fixed", s = qe(r), i = t ? Ir(t.floating) : !1;
  if (r === s || i && a)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = Ke(1);
  const f = Ke(0), u = st(r);
  if ((u || !u && !a) && ((an(r) !== "body" || _n(s)) && (l = Wr(r)), u)) {
    const h = Nt(r);
    c = qt(r), f.x = h.x + r.clientLeft, f.y = h.y + r.clientTop;
  }
  const m = s && !u && !a ? ic(s, l) : Ke(0);
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - l.scrollLeft * c.x + f.x + m.x,
    y: n.y * c.y - l.scrollTop * c.y + f.y + m.y
  };
}
function lv(e) {
  return Array.from(e.getClientRects());
}
function cv(e) {
  const t = qe(e), n = Wr(e), r = e.ownerDocument.body, o = Oe(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), a = Oe(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let s = -n.scrollLeft + Fr(e);
  const i = -n.scrollTop;
  return ze(r).direction === "rtl" && (s += Oe(t.clientWidth, r.clientWidth) - o), {
    width: o,
    height: a,
    x: s,
    y: i
  };
}
const Fs = 25;
function dv(e, t) {
  const n = Ne(e), r = qe(e), o = n.visualViewport;
  let a = r.clientWidth, s = r.clientHeight, i = 0, l = 0;
  if (o) {
    a = o.width, s = o.height;
    const f = ka();
    (!f || f && t === "fixed") && (i = o.offsetLeft, l = o.offsetTop);
  }
  const c = Fr(r);
  if (c <= 0) {
    const f = r.ownerDocument, u = f.body, m = getComputedStyle(u), h = f.compatMode === "CSS1Compat" && parseFloat(m.marginLeft) + parseFloat(m.marginRight) || 0, b = Math.abs(r.clientWidth - u.clientWidth - h);
    b <= Fs && (a -= b);
  } else c <= Fs && (a += c);
  return {
    width: a,
    height: s,
    x: i,
    y: l
  };
}
function uv(e, t) {
  const n = Nt(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, a = st(e) ? qt(e) : Ke(1), s = e.clientWidth * a.x, i = e.clientHeight * a.y, l = o * a.x, c = r * a.y;
  return {
    width: s,
    height: i,
    x: l,
    y: c
  };
}
function Ls(e, t, n) {
  let r;
  if (t === "viewport")
    r = dv(e, n);
  else if (t === "document")
    r = cv(qe(e));
  else if ($e(t))
    r = uv(t, n);
  else {
    const o = sc(e);
    r = {
      x: t.x - o.x,
      y: t.y - o.y,
      width: t.width,
      height: t.height
    };
  }
  return cr(r);
}
function lc(e, t) {
  const n = gt(e);
  return n === t || !$e(n) || Xt(n) ? !1 : ze(n).position === "fixed" || lc(n, t);
}
function fv(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = xn(e, [], !1).filter((i) => $e(i) && an(i) !== "body"), o = null;
  const a = ze(e).position === "fixed";
  let s = a ? gt(e) : e;
  for (; $e(s) && !Xt(s); ) {
    const i = ze(s), l = Ca(s);
    !l && i.position === "fixed" && (o = null), (a ? !l && !o : !l && i.position === "static" && !!o && (o.position === "absolute" || o.position === "fixed") || _n(s) && !l && lc(e, s)) ? r = r.filter((f) => f !== s) : o = i, s = gt(s);
  }
  return t.set(e, r), r;
}
function pv(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const s = [...n === "clippingAncestors" ? Ir(t) ? [] : fv(t, this._c) : [].concat(n), r], i = Ls(t, s[0], o);
  let l = i.top, c = i.right, f = i.bottom, u = i.left;
  for (let m = 1; m < s.length; m++) {
    const h = Ls(t, s[m], o);
    l = Oe(h.top, l), c = ht(h.right, c), f = ht(h.bottom, f), u = Oe(h.left, u);
  }
  return {
    width: c - u,
    height: f - l,
    x: u,
    y: l
  };
}
function mv(e) {
  const {
    width: t,
    height: n
  } = ac(e);
  return {
    width: t,
    height: n
  };
}
function hv(e, t, n) {
  const r = st(t), o = qe(t), a = n === "fixed", s = Nt(e, !0, a, t);
  let i = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Ke(0);
  function c() {
    l.x = Fr(o);
  }
  if (r || !r && !a)
    if ((an(t) !== "body" || _n(o)) && (i = Wr(t)), r) {
      const h = Nt(t, !0, a, t);
      l.x = h.x + t.clientLeft, l.y = h.y + t.clientTop;
    } else o && c();
  a && !r && o && c();
  const f = o && !r && !a ? ic(o, i) : Ke(0), u = s.left + i.scrollLeft - l.x - f.x, m = s.top + i.scrollTop - l.y - f.y;
  return {
    x: u,
    y: m,
    width: s.width,
    height: s.height
  };
}
function xo(e) {
  return ze(e).position === "static";
}
function $s(e, t) {
  if (!st(e) || ze(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return qe(e) === n && (n = n.ownerDocument.body), n;
}
function cc(e, t) {
  const n = Ne(e);
  if (Ir(e))
    return n;
  if (!st(e)) {
    let o = gt(e);
    for (; o && !Xt(o); ) {
      if ($e(o) && !xo(o))
        return o;
      o = gt(o);
    }
    return n;
  }
  let r = $s(e, t);
  for (; r && tv(r) && xo(r); )
    r = $s(r, t);
  return r && Xt(r) && xo(r) && !Ca(r) ? n : r || ov(e) || n;
}
const gv = async function(e) {
  const t = this.getOffsetParent || cc, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: hv(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function vv(e) {
  return ze(e).direction === "rtl";
}
const bv = {
  convertOffsetParentRelativeRectToViewportRelativeRect: iv,
  getDocumentElement: qe,
  getClippingRect: pv,
  getOffsetParent: cc,
  getElementRects: gv,
  getClientRects: lv,
  getDimensions: mv,
  getScale: qt,
  isElement: $e,
  isRTL: vv
};
function dc(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function yv(e, t) {
  let n = null, r;
  const o = qe(e);
  function a() {
    var i;
    clearTimeout(r), (i = n) == null || i.disconnect(), n = null;
  }
  function s(i, l) {
    i === void 0 && (i = !1), l === void 0 && (l = 1), a();
    const c = e.getBoundingClientRect(), {
      left: f,
      top: u,
      width: m,
      height: h
    } = c;
    if (i || t(), !m || !h)
      return;
    const b = Qn(u), g = Qn(o.clientWidth - (f + m)), v = Qn(o.clientHeight - (u + h)), y = Qn(f), x = {
      rootMargin: -b + "px " + -g + "px " + -v + "px " + -y + "px",
      threshold: Oe(0, ht(1, l)) || 1
    };
    let S = !0;
    function k(C) {
      const E = C[0].intersectionRatio;
      if (E !== l) {
        if (!S)
          return s();
        E ? s(!1, E) : r = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      E === 1 && !dc(c, e.getBoundingClientRect()) && s(), S = !1;
    }
    try {
      n = new IntersectionObserver(k, {
        ...x,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(k, x);
    }
    n.observe(e);
  }
  return s(!0), a;
}
function wv(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: a = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: i = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, c = Ea(e), f = o || a ? [...c ? xn(c) : [], ...t ? xn(t) : []] : [];
  f.forEach((y) => {
    o && y.addEventListener("scroll", n, {
      passive: !0
    }), a && y.addEventListener("resize", n);
  });
  const u = c && i ? yv(c, n) : null;
  let m = -1, h = null;
  s && (h = new ResizeObserver((y) => {
    let [w] = y;
    w && w.target === c && h && t && (h.unobserve(t), cancelAnimationFrame(m), m = requestAnimationFrame(() => {
      var x;
      (x = h) == null || x.observe(t);
    })), n();
  }), c && !l && h.observe(c), t && h.observe(t));
  let b, g = l ? Nt(e) : null;
  l && v();
  function v() {
    const y = Nt(e);
    g && !dc(g, y) && n(), g = y, b = requestAnimationFrame(v);
  }
  return n(), () => {
    var y;
    f.forEach((w) => {
      o && w.removeEventListener("scroll", n), a && w.removeEventListener("resize", n);
    }), u?.(), (y = h) == null || y.disconnect(), h = null, l && cancelAnimationFrame(b);
  };
}
const xv = Zg, Sv = Qg, Cv = Kg, kv = ev, Ev = qg, zs = jg, Mv = Jg, Pv = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: bv,
    ...n
  }, a = {
    ...o.platform,
    _c: r
  };
  return Ug(e, t, {
    ...o,
    platform: a
  });
};
var Dv = typeof document < "u", Ov = function() {
}, nr = Dv ? pi : Ov;
function dr(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (r = n; r-- !== 0; )
        if (!dr(e[r], t[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const a = o[r];
      if (!(a === "_owner" && e.$$typeof) && !dr(e[a], t[a]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function uc(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Bs(e, t) {
  const n = uc(e);
  return Math.round(t * n) / n;
}
function So(e) {
  const t = d.useRef(e);
  return nr(() => {
    t.current = e;
  }), t;
}
function Nv(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: a,
      floating: s
    } = {},
    transform: i = !0,
    whileElementsMounted: l,
    open: c
  } = e, [f, u] = d.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [m, h] = d.useState(r);
  dr(m, r) || h(r);
  const [b, g] = d.useState(null), [v, y] = d.useState(null), w = d.useCallback((z) => {
    z !== C.current && (C.current = z, g(z));
  }, []), x = d.useCallback((z) => {
    z !== E.current && (E.current = z, y(z));
  }, []), S = a || b, k = s || v, C = d.useRef(null), E = d.useRef(null), M = d.useRef(f), O = l != null, R = So(l), W = So(o), Y = So(c), K = d.useCallback(() => {
    if (!C.current || !E.current)
      return;
    const z = {
      placement: t,
      strategy: n,
      middleware: m
    };
    W.current && (z.platform = W.current), Pv(C.current, E.current, z).then((T) => {
      const I = {
        ...T,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: Y.current !== !1
      };
      H.current && !dr(M.current, I) && (M.current = I, yr.flushSync(() => {
        u(I);
      }));
    });
  }, [m, t, n, W, Y]);
  nr(() => {
    c === !1 && M.current.isPositioned && (M.current.isPositioned = !1, u((z) => ({
      ...z,
      isPositioned: !1
    })));
  }, [c]);
  const H = d.useRef(!1);
  nr(() => (H.current = !0, () => {
    H.current = !1;
  }), []), nr(() => {
    if (S && (C.current = S), k && (E.current = k), S && k) {
      if (R.current)
        return R.current(S, k, K);
      K();
    }
  }, [S, k, K, R, O]);
  const Q = d.useMemo(() => ({
    reference: C,
    floating: E,
    setReference: w,
    setFloating: x
  }), [w, x]), $ = d.useMemo(() => ({
    reference: S,
    floating: k
  }), [S, k]), q = d.useMemo(() => {
    const z = {
      position: n,
      left: 0,
      top: 0
    };
    if (!$.floating)
      return z;
    const T = Bs($.floating, f.x), I = Bs($.floating, f.y);
    return i ? {
      ...z,
      transform: "translate(" + T + "px, " + I + "px)",
      ...uc($.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: T,
      top: I
    };
  }, [n, i, $.floating, f.x, f.y]);
  return d.useMemo(() => ({
    ...f,
    update: K,
    refs: Q,
    elements: $,
    floatingStyles: q
  }), [f, K, Q, $, q]);
}
const _v = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: o
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? zs({
        element: r.current,
        padding: o
      }).fn(n) : {} : r ? zs({
        element: r,
        padding: o
      }).fn(n) : {};
    }
  };
}, Rv = (e, t) => {
  const n = xv(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, Tv = (e, t) => {
  const n = Sv(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, Av = (e, t) => ({
  fn: Mv(e).fn,
  options: [e, t]
}), Iv = (e, t) => {
  const n = Cv(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, Wv = (e, t) => {
  const n = kv(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, Fv = (e, t) => {
  const n = Ev(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, Lv = (e, t) => {
  const n = _v(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
};
var $v = "Arrow", fc = d.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: o = 5, ...a } = e;
  return /* @__PURE__ */ p(
    L.svg,
    {
      ...a,
      ref: t,
      width: r,
      height: o,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ p("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
fc.displayName = $v;
var zv = fc, Ma = "Popper", [pc, yt] = xe(Ma), [Bv, mc] = pc(Ma), hc = (e) => {
  const { __scopePopper: t, children: n } = e, [r, o] = d.useState(null);
  return /* @__PURE__ */ p(Bv, { scope: t, anchor: r, onAnchorChange: o, children: n });
};
hc.displayName = Ma;
var gc = "PopperAnchor", vc = d.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...o } = e, a = mc(gc, n), s = d.useRef(null), i = J(t, s), l = d.useRef(null);
    return d.useEffect(() => {
      const c = l.current;
      l.current = r?.current || s.current, c !== l.current && a.onAnchorChange(l.current);
    }), r ? null : /* @__PURE__ */ p(L.div, { ...o, ref: i });
  }
);
vc.displayName = gc;
var Pa = "PopperContent", [Yv, Hv] = pc(Pa), bc = d.forwardRef(
  (e, t) => {
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: o = 0,
      align: a = "center",
      alignOffset: s = 0,
      arrowPadding: i = 0,
      avoidCollisions: l = !0,
      collisionBoundary: c = [],
      collisionPadding: f = 0,
      sticky: u = "partial",
      hideWhenDetached: m = !1,
      updatePositionStrategy: h = "optimized",
      onPlaced: b,
      ...g
    } = e, v = mc(Pa, n), [y, w] = d.useState(null), x = J(t, (_) => w(_)), [S, k] = d.useState(null), C = Rr(S), E = C?.width ?? 0, M = C?.height ?? 0, O = r + (a !== "center" ? "-" + a : ""), R = typeof f == "number" ? f : { top: 0, right: 0, bottom: 0, left: 0, ...f }, W = Array.isArray(c) ? c : [c], Y = W.length > 0, K = {
      padding: R,
      boundary: W.filter(Gv),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: Y
    }, { refs: H, floatingStyles: Q, placement: $, isPositioned: q, middlewareData: z } = Nv({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: O,
      whileElementsMounted: (..._) => wv(..._, {
        animationFrame: h === "always"
      }),
      elements: {
        reference: v.anchor
      },
      middleware: [
        Rv({ mainAxis: o + M, alignmentAxis: s }),
        l && Tv({
          mainAxis: !0,
          crossAxis: !1,
          limiter: u === "partial" ? Av() : void 0,
          ...K
        }),
        l && Iv({ ...K }),
        Wv({
          ...K,
          apply: ({ elements: _, rects: ee, availableWidth: Z, availableHeight: re }) => {
            const { width: ce, height: pe } = ee.reference, Se = _.floating.style;
            Se.setProperty("--radix-popper-available-width", `${Z}px`), Se.setProperty("--radix-popper-available-height", `${re}px`), Se.setProperty("--radix-popper-anchor-width", `${ce}px`), Se.setProperty("--radix-popper-anchor-height", `${pe}px`);
          }
        }),
        S && Lv({ element: S, padding: i }),
        Uv({ arrowWidth: E, arrowHeight: M }),
        m && Fv({ strategy: "referenceHidden", ...K })
      ]
    }), [T, I] = xc($), le = we(b);
    ve(() => {
      q && le?.();
    }, [q, le]);
    const D = z.arrow?.x, j = z.arrow?.y, X = z.arrow?.centerOffset !== 0, [F, U] = d.useState();
    return ve(() => {
      y && U(window.getComputedStyle(y).zIndex);
    }, [y]), /* @__PURE__ */ p(
      "div",
      {
        ref: H.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...Q,
          transform: q ? Q.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: F,
          "--radix-popper-transform-origin": [
            z.transformOrigin?.x,
            z.transformOrigin?.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...z.hide?.referenceHidden && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ p(
          Yv,
          {
            scope: n,
            placedSide: T,
            onArrowChange: k,
            arrowX: D,
            arrowY: j,
            shouldHideArrow: X,
            children: /* @__PURE__ */ p(
              L.div,
              {
                "data-side": T,
                "data-align": I,
                ...g,
                ref: x,
                style: {
                  ...g.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: q ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
bc.displayName = Pa;
var yc = "PopperArrow", Vv = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, wc = d.forwardRef(function(t, n) {
  const { __scopePopper: r, ...o } = t, a = Hv(yc, r), s = Vv[a.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ p(
      "span",
      {
        ref: a.onArrowChange,
        style: {
          position: "absolute",
          left: a.arrowX,
          top: a.arrowY,
          [s]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[a.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[a.placedSide],
          visibility: a.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ p(
          zv,
          {
            ...o,
            ref: n,
            style: {
              ...o.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
wc.displayName = yc;
function Gv(e) {
  return e !== null;
}
var Uv = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    const { placement: n, rects: r, middlewareData: o } = t, s = o.arrow?.centerOffset !== 0, i = s ? 0 : e.arrowWidth, l = s ? 0 : e.arrowHeight, [c, f] = xc(n), u = { start: "0%", center: "50%", end: "100%" }[f], m = (o.arrow?.x ?? 0) + i / 2, h = (o.arrow?.y ?? 0) + l / 2;
    let b = "", g = "";
    return c === "bottom" ? (b = s ? u : `${m}px`, g = `${-l}px`) : c === "top" ? (b = s ? u : `${m}px`, g = `${r.floating.height + l}px`) : c === "right" ? (b = `${-l}px`, g = s ? u : `${h}px`) : c === "left" && (b = `${r.floating.width + l}px`, g = s ? u : `${h}px`), { data: { x: b, y: g } };
  }
});
function xc(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var Rn = hc, Tn = vc, Lr = bc, $r = wc, Co = "rovingFocusGroup.onEntryFocus", jv = { bubbles: !1, cancelable: !0 }, An = "RovingFocusGroup", [Bo, Sc, Kv] = Dn(An), [qv, zr] = xe(
  An,
  [Kv]
), [Xv, Zv] = qv(An), Cc = d.forwardRef(
  (e, t) => /* @__PURE__ */ p(Bo.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ p(Bo.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ p(Qv, { ...e, ref: t }) }) })
);
Cc.displayName = An;
var Qv = d.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: r,
    loop: o = !1,
    dir: a,
    currentTabStopId: s,
    defaultCurrentTabStopId: i,
    onCurrentTabStopIdChange: l,
    onEntryFocus: c,
    preventScrollOnEntryFocus: f = !1,
    ...u
  } = e, m = d.useRef(null), h = J(t, m), b = It(a), [g, v] = ke({
    prop: s,
    defaultProp: i ?? null,
    onChange: l,
    caller: An
  }), [y, w] = d.useState(!1), x = we(c), S = Sc(n), k = d.useRef(!1), [C, E] = d.useState(0);
  return d.useEffect(() => {
    const M = m.current;
    if (M)
      return M.addEventListener(Co, x), () => M.removeEventListener(Co, x);
  }, [x]), /* @__PURE__ */ p(
    Xv,
    {
      scope: n,
      orientation: r,
      dir: b,
      loop: o,
      currentTabStopId: g,
      onItemFocus: d.useCallback(
        (M) => v(M),
        [v]
      ),
      onItemShiftTab: d.useCallback(() => w(!0), []),
      onFocusableItemAdd: d.useCallback(
        () => E((M) => M + 1),
        []
      ),
      onFocusableItemRemove: d.useCallback(
        () => E((M) => M - 1),
        []
      ),
      children: /* @__PURE__ */ p(
        L.div,
        {
          tabIndex: y || C === 0 ? -1 : 0,
          "data-orientation": r,
          ...u,
          ref: h,
          style: { outline: "none", ...e.style },
          onMouseDown: A(e.onMouseDown, () => {
            k.current = !0;
          }),
          onFocus: A(e.onFocus, (M) => {
            const O = !k.current;
            if (M.target === M.currentTarget && O && !y) {
              const R = new CustomEvent(Co, jv);
              if (M.currentTarget.dispatchEvent(R), !R.defaultPrevented) {
                const W = S().filter(($) => $.focusable), Y = W.find(($) => $.active), K = W.find(($) => $.id === g), Q = [Y, K, ...W].filter(
                  Boolean
                ).map(($) => $.ref.current);
                Mc(Q, f);
              }
            }
            k.current = !1;
          }),
          onBlur: A(e.onBlur, () => w(!1))
        }
      )
    }
  );
}), kc = "RovingFocusGroupItem", Ec = d.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: r = !0,
      active: o = !1,
      tabStopId: a,
      children: s,
      ...i
    } = e, l = ge(), c = a || l, f = Zv(kc, n), u = f.currentTabStopId === c, m = Sc(n), { onFocusableItemAdd: h, onFocusableItemRemove: b, currentTabStopId: g } = f;
    return d.useEffect(() => {
      if (r)
        return h(), () => b();
    }, [r, h, b]), /* @__PURE__ */ p(
      Bo.ItemSlot,
      {
        scope: n,
        id: c,
        focusable: r,
        active: o,
        children: /* @__PURE__ */ p(
          L.span,
          {
            tabIndex: u ? 0 : -1,
            "data-orientation": f.orientation,
            ...i,
            ref: t,
            onMouseDown: A(e.onMouseDown, (v) => {
              r ? f.onItemFocus(c) : v.preventDefault();
            }),
            onFocus: A(e.onFocus, () => f.onItemFocus(c)),
            onKeyDown: A(e.onKeyDown, (v) => {
              if (v.key === "Tab" && v.shiftKey) {
                f.onItemShiftTab();
                return;
              }
              if (v.target !== v.currentTarget) return;
              const y = tb(v, f.orientation, f.dir);
              if (y !== void 0) {
                if (v.metaKey || v.ctrlKey || v.altKey || v.shiftKey) return;
                v.preventDefault();
                let x = m().filter((S) => S.focusable).map((S) => S.ref.current);
                if (y === "last") x.reverse();
                else if (y === "prev" || y === "next") {
                  y === "prev" && x.reverse();
                  const S = x.indexOf(v.currentTarget);
                  x = f.loop ? nb(x, S + 1) : x.slice(S + 1);
                }
                setTimeout(() => Mc(x));
              }
            }),
            children: typeof s == "function" ? s({ isCurrentTabStop: u, hasTabStop: g != null }) : s
          }
        )
      }
    );
  }
);
Ec.displayName = kc;
var Jv = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function eb(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function tb(e, t, n) {
  const r = eb(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return Jv[r];
}
function Mc(e, t = !1) {
  const n = document.activeElement;
  for (const r of e)
    if (r === n || (r.focus({ preventScroll: t }), document.activeElement !== n)) return;
}
function nb(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var Pc = Cc, Dc = Ec, Yo = ["Enter", " "], rb = ["ArrowDown", "PageUp", "Home"], Oc = ["ArrowUp", "PageDown", "End"], ob = [...rb, ...Oc], ab = {
  ltr: [...Yo, "ArrowRight"],
  rtl: [...Yo, "ArrowLeft"]
}, sb = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, In = "Menu", [Sn, ib, lb] = Dn(In), [Ft, Nc] = xe(In, [
  lb,
  yt,
  zr
]), Wn = yt(), _c = zr(), [Rc, wt] = Ft(In), [cb, Fn] = Ft(In), Tc = (e) => {
  const { __scopeMenu: t, open: n = !1, children: r, dir: o, onOpenChange: a, modal: s = !0 } = e, i = Wn(t), [l, c] = d.useState(null), f = d.useRef(!1), u = we(a), m = It(o);
  return d.useEffect(() => {
    const h = () => {
      f.current = !0, document.addEventListener("pointerdown", b, { capture: !0, once: !0 }), document.addEventListener("pointermove", b, { capture: !0, once: !0 });
    }, b = () => f.current = !1;
    return document.addEventListener("keydown", h, { capture: !0 }), () => {
      document.removeEventListener("keydown", h, { capture: !0 }), document.removeEventListener("pointerdown", b, { capture: !0 }), document.removeEventListener("pointermove", b, { capture: !0 });
    };
  }, []), /* @__PURE__ */ p(Rn, { ...i, children: /* @__PURE__ */ p(
    Rc,
    {
      scope: t,
      open: n,
      onOpenChange: u,
      content: l,
      onContentChange: c,
      children: /* @__PURE__ */ p(
        cb,
        {
          scope: t,
          onClose: d.useCallback(() => u(!1), [u]),
          isUsingKeyboardRef: f,
          dir: m,
          modal: s,
          children: r
        }
      )
    }
  ) });
};
Tc.displayName = In;
var db = "MenuAnchor", Da = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, o = Wn(n);
    return /* @__PURE__ */ p(Tn, { ...o, ...r, ref: t });
  }
);
Da.displayName = db;
var Oa = "MenuPortal", [ub, Ac] = Ft(Oa, {
  forceMount: void 0
}), Ic = (e) => {
  const { __scopeMenu: t, forceMount: n, children: r, container: o } = e, a = wt(Oa, t);
  return /* @__PURE__ */ p(ub, { scope: t, forceMount: n, children: /* @__PURE__ */ p(Ce, { present: n || a.open, children: /* @__PURE__ */ p(rn, { asChild: !0, container: o, children: r }) }) });
};
Ic.displayName = Oa;
var Ae = "MenuContent", [fb, Na] = Ft(Ae), Wc = d.forwardRef(
  (e, t) => {
    const n = Ac(Ae, e.__scopeMenu), { forceMount: r = n.forceMount, ...o } = e, a = wt(Ae, e.__scopeMenu), s = Fn(Ae, e.__scopeMenu);
    return /* @__PURE__ */ p(Sn.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ p(Ce, { present: r || a.open, children: /* @__PURE__ */ p(Sn.Slot, { scope: e.__scopeMenu, children: s.modal ? /* @__PURE__ */ p(pb, { ...o, ref: t }) : /* @__PURE__ */ p(mb, { ...o, ref: t }) }) }) });
  }
), pb = d.forwardRef(
  (e, t) => {
    const n = wt(Ae, e.__scopeMenu), r = d.useRef(null), o = J(t, r);
    return d.useEffect(() => {
      const a = r.current;
      if (a) return Er(a);
    }, []), /* @__PURE__ */ p(
      _a,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: n.open,
        disableOutsideScroll: !0,
        onFocusOutside: A(
          e.onFocusOutside,
          (a) => a.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => n.onOpenChange(!1)
      }
    );
  }
), mb = d.forwardRef((e, t) => {
  const n = wt(Ae, e.__scopeMenu);
  return /* @__PURE__ */ p(
    _a,
    {
      ...e,
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => n.onOpenChange(!1)
    }
  );
}), hb = /* @__PURE__ */ mt("MenuContent.ScrollLock"), _a = d.forwardRef(
  (e, t) => {
    const {
      __scopeMenu: n,
      loop: r = !1,
      trapFocus: o,
      onOpenAutoFocus: a,
      onCloseAutoFocus: s,
      disableOutsidePointerEvents: i,
      onEntryFocus: l,
      onEscapeKeyDown: c,
      onPointerDownOutside: f,
      onFocusOutside: u,
      onInteractOutside: m,
      onDismiss: h,
      disableOutsideScroll: b,
      ...g
    } = e, v = wt(Ae, n), y = Fn(Ae, n), w = Wn(n), x = _c(n), S = ib(n), [k, C] = d.useState(null), E = d.useRef(null), M = J(t, E, v.onContentChange), O = d.useRef(0), R = d.useRef(""), W = d.useRef(0), Y = d.useRef(null), K = d.useRef("right"), H = d.useRef(0), Q = b ? Nn : d.Fragment, $ = b ? { as: hb, allowPinchZoom: !0 } : void 0, q = (T) => {
      const I = R.current + T, le = S().filter((_) => !_.disabled), D = document.activeElement, j = le.find((_) => _.ref.current === D)?.textValue, X = le.map((_) => _.textValue), F = Pb(X, I, j), U = le.find((_) => _.textValue === F)?.ref.current;
      (function _(ee) {
        R.current = ee, window.clearTimeout(O.current), ee !== "" && (O.current = window.setTimeout(() => _(""), 1e3));
      })(I), U && setTimeout(() => U.focus());
    };
    d.useEffect(() => () => window.clearTimeout(O.current), []), Cr();
    const z = d.useCallback((T) => K.current === Y.current?.side && Ob(T, Y.current?.area), []);
    return /* @__PURE__ */ p(
      fb,
      {
        scope: n,
        searchRef: R,
        onItemEnter: d.useCallback(
          (T) => {
            z(T) && T.preventDefault();
          },
          [z]
        ),
        onItemLeave: d.useCallback(
          (T) => {
            z(T) || (E.current?.focus(), C(null));
          },
          [z]
        ),
        onTriggerLeave: d.useCallback(
          (T) => {
            z(T) && T.preventDefault();
          },
          [z]
        ),
        pointerGraceTimerRef: W,
        onPointerGraceIntentChange: d.useCallback((T) => {
          Y.current = T;
        }, []),
        children: /* @__PURE__ */ p(Q, { ...$, children: /* @__PURE__ */ p(
          On,
          {
            asChild: !0,
            trapped: o,
            onMountAutoFocus: A(a, (T) => {
              T.preventDefault(), E.current?.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: s,
            children: /* @__PURE__ */ p(
              nn,
              {
                asChild: !0,
                disableOutsidePointerEvents: i,
                onEscapeKeyDown: c,
                onPointerDownOutside: f,
                onFocusOutside: u,
                onInteractOutside: m,
                onDismiss: h,
                children: /* @__PURE__ */ p(
                  Pc,
                  {
                    asChild: !0,
                    ...x,
                    dir: y.dir,
                    orientation: "vertical",
                    loop: r,
                    currentTabStopId: k,
                    onCurrentTabStopIdChange: C,
                    onEntryFocus: A(l, (T) => {
                      y.isUsingKeyboardRef.current || T.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ p(
                      Lr,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": Jc(v.open),
                        "data-radix-menu-content": "",
                        dir: y.dir,
                        ...w,
                        ...g,
                        ref: M,
                        style: { outline: "none", ...g.style },
                        onKeyDown: A(g.onKeyDown, (T) => {
                          const le = T.target.closest("[data-radix-menu-content]") === T.currentTarget, D = T.ctrlKey || T.altKey || T.metaKey, j = T.key.length === 1;
                          le && (T.key === "Tab" && T.preventDefault(), !D && j && q(T.key));
                          const X = E.current;
                          if (T.target !== X || !ob.includes(T.key)) return;
                          T.preventDefault();
                          const U = S().filter((_) => !_.disabled).map((_) => _.ref.current);
                          Oc.includes(T.key) && U.reverse(), Eb(U);
                        }),
                        onBlur: A(e.onBlur, (T) => {
                          T.currentTarget.contains(T.target) || (window.clearTimeout(O.current), R.current = "");
                        }),
                        onPointerMove: A(
                          e.onPointerMove,
                          Cn((T) => {
                            const I = T.target, le = H.current !== T.clientX;
                            if (T.currentTarget.contains(I) && le) {
                              const D = T.clientX > H.current ? "right" : "left";
                              K.current = D, H.current = T.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
Wc.displayName = Ae;
var gb = "MenuGroup", Ra = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ p(L.div, { role: "group", ...r, ref: t });
  }
);
Ra.displayName = gb;
var vb = "MenuLabel", Fc = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ p(L.div, { ...r, ref: t });
  }
);
Fc.displayName = vb;
var ur = "MenuItem", Ys = "menu.itemSelect", Br = d.forwardRef(
  (e, t) => {
    const { disabled: n = !1, onSelect: r, ...o } = e, a = d.useRef(null), s = Fn(ur, e.__scopeMenu), i = Na(ur, e.__scopeMenu), l = J(t, a), c = d.useRef(!1), f = () => {
      const u = a.current;
      if (!n && u) {
        const m = new CustomEvent(Ys, { bubbles: !0, cancelable: !0 });
        u.addEventListener(Ys, (h) => r?.(h), { once: !0 }), Wi(u, m), m.defaultPrevented ? c.current = !1 : s.onClose();
      }
    };
    return /* @__PURE__ */ p(
      Lc,
      {
        ...o,
        ref: l,
        disabled: n,
        onClick: A(e.onClick, f),
        onPointerDown: (u) => {
          e.onPointerDown?.(u), c.current = !0;
        },
        onPointerUp: A(e.onPointerUp, (u) => {
          c.current || u.currentTarget?.click();
        }),
        onKeyDown: A(e.onKeyDown, (u) => {
          const m = i.searchRef.current !== "";
          n || m && u.key === " " || Yo.includes(u.key) && (u.currentTarget.click(), u.preventDefault());
        })
      }
    );
  }
);
Br.displayName = ur;
var Lc = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, disabled: r = !1, textValue: o, ...a } = e, s = Na(ur, n), i = _c(n), l = d.useRef(null), c = J(t, l), [f, u] = d.useState(!1), [m, h] = d.useState("");
    return d.useEffect(() => {
      const b = l.current;
      b && h((b.textContent ?? "").trim());
    }, [a.children]), /* @__PURE__ */ p(
      Sn.ItemSlot,
      {
        scope: n,
        disabled: r,
        textValue: o ?? m,
        children: /* @__PURE__ */ p(Dc, { asChild: !0, ...i, focusable: !r, children: /* @__PURE__ */ p(
          L.div,
          {
            role: "menuitem",
            "data-highlighted": f ? "" : void 0,
            "aria-disabled": r || void 0,
            "data-disabled": r ? "" : void 0,
            ...a,
            ref: c,
            onPointerMove: A(
              e.onPointerMove,
              Cn((b) => {
                r ? s.onItemLeave(b) : (s.onItemEnter(b), b.defaultPrevented || b.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: A(
              e.onPointerLeave,
              Cn((b) => s.onItemLeave(b))
            ),
            onFocus: A(e.onFocus, () => u(!0)),
            onBlur: A(e.onBlur, () => u(!1))
          }
        ) })
      }
    );
  }
), bb = "MenuCheckboxItem", $c = d.forwardRef(
  (e, t) => {
    const { checked: n = !1, onCheckedChange: r, ...o } = e;
    return /* @__PURE__ */ p(Vc, { scope: e.__scopeMenu, checked: n, children: /* @__PURE__ */ p(
      Br,
      {
        role: "menuitemcheckbox",
        "aria-checked": fr(n) ? "mixed" : n,
        ...o,
        ref: t,
        "data-state": Ia(n),
        onSelect: A(
          o.onSelect,
          () => r?.(fr(n) ? !0 : !n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
$c.displayName = bb;
var zc = "MenuRadioGroup", [yb, wb] = Ft(
  zc,
  { value: void 0, onValueChange: () => {
  } }
), Bc = d.forwardRef(
  (e, t) => {
    const { value: n, onValueChange: r, ...o } = e, a = we(r);
    return /* @__PURE__ */ p(yb, { scope: e.__scopeMenu, value: n, onValueChange: a, children: /* @__PURE__ */ p(Ra, { ...o, ref: t }) });
  }
);
Bc.displayName = zc;
var Yc = "MenuRadioItem", Hc = d.forwardRef(
  (e, t) => {
    const { value: n, ...r } = e, o = wb(Yc, e.__scopeMenu), a = n === o.value;
    return /* @__PURE__ */ p(Vc, { scope: e.__scopeMenu, checked: a, children: /* @__PURE__ */ p(
      Br,
      {
        role: "menuitemradio",
        "aria-checked": a,
        ...r,
        ref: t,
        "data-state": Ia(a),
        onSelect: A(
          r.onSelect,
          () => o.onValueChange?.(n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
Hc.displayName = Yc;
var Ta = "MenuItemIndicator", [Vc, xb] = Ft(
  Ta,
  { checked: !1 }
), Gc = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, forceMount: r, ...o } = e, a = xb(Ta, n);
    return /* @__PURE__ */ p(
      Ce,
      {
        present: r || fr(a.checked) || a.checked === !0,
        children: /* @__PURE__ */ p(
          L.span,
          {
            ...o,
            ref: t,
            "data-state": Ia(a.checked)
          }
        )
      }
    );
  }
);
Gc.displayName = Ta;
var Sb = "MenuSeparator", Uc = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ p(
      L.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...r,
        ref: t
      }
    );
  }
);
Uc.displayName = Sb;
var Cb = "MenuArrow", jc = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, o = Wn(n);
    return /* @__PURE__ */ p($r, { ...o, ...r, ref: t });
  }
);
jc.displayName = Cb;
var Aa = "MenuSub", [kb, Kc] = Ft(Aa), qc = (e) => {
  const { __scopeMenu: t, children: n, open: r = !1, onOpenChange: o } = e, a = wt(Aa, t), s = Wn(t), [i, l] = d.useState(null), [c, f] = d.useState(null), u = we(o);
  return d.useEffect(() => (a.open === !1 && u(!1), () => u(!1)), [a.open, u]), /* @__PURE__ */ p(Rn, { ...s, children: /* @__PURE__ */ p(
    Rc,
    {
      scope: t,
      open: r,
      onOpenChange: u,
      content: c,
      onContentChange: f,
      children: /* @__PURE__ */ p(
        kb,
        {
          scope: t,
          contentId: ge(),
          triggerId: ge(),
          trigger: i,
          onTriggerChange: l,
          children: n
        }
      )
    }
  ) });
};
qc.displayName = Aa;
var gn = "MenuSubTrigger", Xc = d.forwardRef(
  (e, t) => {
    const n = wt(gn, e.__scopeMenu), r = Fn(gn, e.__scopeMenu), o = Kc(gn, e.__scopeMenu), a = Na(gn, e.__scopeMenu), s = d.useRef(null), { pointerGraceTimerRef: i, onPointerGraceIntentChange: l } = a, c = { __scopeMenu: e.__scopeMenu }, f = d.useCallback(() => {
      s.current && window.clearTimeout(s.current), s.current = null;
    }, []);
    return d.useEffect(() => f, [f]), d.useEffect(() => {
      const u = i.current;
      return () => {
        window.clearTimeout(u), l(null);
      };
    }, [i, l]), /* @__PURE__ */ p(Da, { asChild: !0, ...c, children: /* @__PURE__ */ p(
      Lc,
      {
        id: o.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": n.open,
        "aria-controls": o.contentId,
        "data-state": Jc(n.open),
        ...e,
        ref: nt(t, o.onTriggerChange),
        onClick: (u) => {
          e.onClick?.(u), !(e.disabled || u.defaultPrevented) && (u.currentTarget.focus(), n.open || n.onOpenChange(!0));
        },
        onPointerMove: A(
          e.onPointerMove,
          Cn((u) => {
            a.onItemEnter(u), !u.defaultPrevented && !e.disabled && !n.open && !s.current && (a.onPointerGraceIntentChange(null), s.current = window.setTimeout(() => {
              n.onOpenChange(!0), f();
            }, 100));
          })
        ),
        onPointerLeave: A(
          e.onPointerLeave,
          Cn((u) => {
            f();
            const m = n.content?.getBoundingClientRect();
            if (m) {
              const h = n.content?.dataset.side, b = h === "right", g = b ? -5 : 5, v = m[b ? "left" : "right"], y = m[b ? "right" : "left"];
              a.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: u.clientX + g, y: u.clientY },
                  { x: v, y: m.top },
                  { x: y, y: m.top },
                  { x: y, y: m.bottom },
                  { x: v, y: m.bottom }
                ],
                side: h
              }), window.clearTimeout(i.current), i.current = window.setTimeout(
                () => a.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (a.onTriggerLeave(u), u.defaultPrevented) return;
              a.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: A(e.onKeyDown, (u) => {
          const m = a.searchRef.current !== "";
          e.disabled || m && u.key === " " || ab[r.dir].includes(u.key) && (n.onOpenChange(!0), n.content?.focus(), u.preventDefault());
        })
      }
    ) });
  }
);
Xc.displayName = gn;
var Zc = "MenuSubContent", Qc = d.forwardRef(
  (e, t) => {
    const n = Ac(Ae, e.__scopeMenu), { forceMount: r = n.forceMount, ...o } = e, a = wt(Ae, e.__scopeMenu), s = Fn(Ae, e.__scopeMenu), i = Kc(Zc, e.__scopeMenu), l = d.useRef(null), c = J(t, l);
    return /* @__PURE__ */ p(Sn.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ p(Ce, { present: r || a.open, children: /* @__PURE__ */ p(Sn.Slot, { scope: e.__scopeMenu, children: /* @__PURE__ */ p(
      _a,
      {
        id: i.contentId,
        "aria-labelledby": i.triggerId,
        ...o,
        ref: c,
        align: "start",
        side: s.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (f) => {
          s.isUsingKeyboardRef.current && l.current?.focus(), f.preventDefault();
        },
        onCloseAutoFocus: (f) => f.preventDefault(),
        onFocusOutside: A(e.onFocusOutside, (f) => {
          f.target !== i.trigger && a.onOpenChange(!1);
        }),
        onEscapeKeyDown: A(e.onEscapeKeyDown, (f) => {
          s.onClose(), f.preventDefault();
        }),
        onKeyDown: A(e.onKeyDown, (f) => {
          const u = f.currentTarget.contains(f.target), m = sb[s.dir].includes(f.key);
          u && m && (a.onOpenChange(!1), i.trigger?.focus(), f.preventDefault());
        })
      }
    ) }) }) });
  }
);
Qc.displayName = Zc;
function Jc(e) {
  return e ? "open" : "closed";
}
function fr(e) {
  return e === "indeterminate";
}
function Ia(e) {
  return fr(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function Eb(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t)) return;
}
function Mb(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
function Pb(e, t, n) {
  const o = t.length > 1 && Array.from(t).every((c) => c === t[0]) ? t[0] : t, a = n ? e.indexOf(n) : -1;
  let s = Mb(e, Math.max(a, 0));
  o.length === 1 && (s = s.filter((c) => c !== n));
  const l = s.find(
    (c) => c.toLowerCase().startsWith(o.toLowerCase())
  );
  return l !== n ? l : void 0;
}
function Db(e, t) {
  const { x: n, y: r } = e;
  let o = !1;
  for (let a = 0, s = t.length - 1; a < t.length; s = a++) {
    const i = t[a], l = t[s], c = i.x, f = i.y, u = l.x, m = l.y;
    f > r != m > r && n < (u - c) * (r - f) / (m - f) + c && (o = !o);
  }
  return o;
}
function Ob(e, t) {
  if (!t) return !1;
  const n = { x: e.clientX, y: e.clientY };
  return Db(n, t);
}
function Cn(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var Nb = Tc, _b = Da, Rb = Ic, Tb = Wc, Ab = Ra, Ib = Fc, Wb = Br, Fb = $c, Lb = Bc, $b = Hc, zb = Gc, Bb = Uc, Yb = jc, Hb = qc, Vb = Xc, Gb = Qc, Yr = "DropdownMenu", [Ub] = xe(
  Yr,
  [Nc]
), Me = Nc(), [jb, ed] = Ub(Yr), td = (e) => {
  const {
    __scopeDropdownMenu: t,
    children: n,
    dir: r,
    open: o,
    defaultOpen: a,
    onOpenChange: s,
    modal: i = !0
  } = e, l = Me(t), c = d.useRef(null), [f, u] = ke({
    prop: o,
    defaultProp: a ?? !1,
    onChange: s,
    caller: Yr
  });
  return /* @__PURE__ */ p(
    jb,
    {
      scope: t,
      triggerId: ge(),
      triggerRef: c,
      contentId: ge(),
      open: f,
      onOpenChange: u,
      onOpenToggle: d.useCallback(() => u((m) => !m), [u]),
      modal: i,
      children: /* @__PURE__ */ p(Nb, { ...l, open: f, onOpenChange: u, dir: r, modal: i, children: n })
    }
  );
};
td.displayName = Yr;
var nd = "DropdownMenuTrigger", rd = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, disabled: r = !1, ...o } = e, a = ed(nd, n), s = Me(n);
    return /* @__PURE__ */ p(_b, { asChild: !0, ...s, children: /* @__PURE__ */ p(
      L.button,
      {
        type: "button",
        id: a.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": a.open,
        "aria-controls": a.open ? a.contentId : void 0,
        "data-state": a.open ? "open" : "closed",
        "data-disabled": r ? "" : void 0,
        disabled: r,
        ...o,
        ref: nt(t, a.triggerRef),
        onPointerDown: A(e.onPointerDown, (i) => {
          !r && i.button === 0 && i.ctrlKey === !1 && (a.onOpenToggle(), a.open || i.preventDefault());
        }),
        onKeyDown: A(e.onKeyDown, (i) => {
          r || (["Enter", " "].includes(i.key) && a.onOpenToggle(), i.key === "ArrowDown" && a.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(i.key) && i.preventDefault());
        })
      }
    ) });
  }
);
rd.displayName = nd;
var Kb = "DropdownMenuPortal", od = (e) => {
  const { __scopeDropdownMenu: t, ...n } = e, r = Me(t);
  return /* @__PURE__ */ p(Rb, { ...r, ...n });
};
od.displayName = Kb;
var ad = "DropdownMenuContent", sd = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = ed(ad, n), a = Me(n), s = d.useRef(!1);
    return /* @__PURE__ */ p(
      Tb,
      {
        id: o.contentId,
        "aria-labelledby": o.triggerId,
        ...a,
        ...r,
        ref: t,
        onCloseAutoFocus: A(e.onCloseAutoFocus, (i) => {
          s.current || o.triggerRef.current?.focus(), s.current = !1, i.preventDefault();
        }),
        onInteractOutside: A(e.onInteractOutside, (i) => {
          const l = i.detail.originalEvent, c = l.button === 0 && l.ctrlKey === !0, f = l.button === 2 || c;
          (!o.modal || f) && (s.current = !0);
        }),
        style: {
          ...e.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
sd.displayName = ad;
var qb = "DropdownMenuGroup", id = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = Me(n);
    return /* @__PURE__ */ p(Ab, { ...o, ...r, ref: t });
  }
);
id.displayName = qb;
var Xb = "DropdownMenuLabel", ld = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = Me(n);
    return /* @__PURE__ */ p(Ib, { ...o, ...r, ref: t });
  }
);
ld.displayName = Xb;
var Zb = "DropdownMenuItem", cd = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = Me(n);
    return /* @__PURE__ */ p(Wb, { ...o, ...r, ref: t });
  }
);
cd.displayName = Zb;
var Qb = "DropdownMenuCheckboxItem", dd = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Me(n);
  return /* @__PURE__ */ p(Fb, { ...o, ...r, ref: t });
});
dd.displayName = Qb;
var Jb = "DropdownMenuRadioGroup", ud = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Me(n);
  return /* @__PURE__ */ p(Lb, { ...o, ...r, ref: t });
});
ud.displayName = Jb;
var ey = "DropdownMenuRadioItem", fd = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Me(n);
  return /* @__PURE__ */ p($b, { ...o, ...r, ref: t });
});
fd.displayName = ey;
var ty = "DropdownMenuItemIndicator", pd = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Me(n);
  return /* @__PURE__ */ p(zb, { ...o, ...r, ref: t });
});
pd.displayName = ty;
var ny = "DropdownMenuSeparator", md = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Me(n);
  return /* @__PURE__ */ p(Bb, { ...o, ...r, ref: t });
});
md.displayName = ny;
var ry = "DropdownMenuArrow", oy = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = Me(n);
    return /* @__PURE__ */ p(Yb, { ...o, ...r, ref: t });
  }
);
oy.displayName = ry;
var ay = (e) => {
  const { __scopeDropdownMenu: t, children: n, open: r, onOpenChange: o, defaultOpen: a } = e, s = Me(t), [i, l] = ke({
    prop: r,
    defaultProp: a ?? !1,
    onChange: o,
    caller: "DropdownMenuSub"
  });
  return /* @__PURE__ */ p(Hb, { ...s, open: i, onOpenChange: l, children: n });
}, sy = "DropdownMenuSubTrigger", hd = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Me(n);
  return /* @__PURE__ */ p(Vb, { ...o, ...r, ref: t });
});
hd.displayName = sy;
var iy = "DropdownMenuSubContent", gd = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Me(n);
  return /* @__PURE__ */ p(
    Gb,
    {
      ...o,
      ...r,
      ref: t,
      style: {
        ...e.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
gd.displayName = iy;
var ly = td, cy = rd, vd = od, dy = sd, uy = id, fy = ld, py = cd, my = dd, hy = ud, gy = fd, bd = pd, vy = md, by = ay, yy = hd, wy = gd, xy = "Label", yd = d.forwardRef((e, t) => /* @__PURE__ */ p(
  L.label,
  {
    ...e,
    ref: t,
    onMouseDown: (n) => {
      n.target.closest("button, input, select, textarea") || (e.onMouseDown?.(n), !n.defaultPrevented && n.detail > 1 && n.preventDefault());
    }
  }
));
yd.displayName = xy;
var Sy = yd;
function kn(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
var Hr = "Popover", [wd] = xe(Hr, [
  yt
]), Ln = yt(), [Cy, xt] = wd(Hr), xd = (e) => {
  const {
    __scopePopover: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: a,
    modal: s = !1
  } = e, i = Ln(t), l = d.useRef(null), [c, f] = d.useState(!1), [u, m] = ke({
    prop: r,
    defaultProp: o ?? !1,
    onChange: a,
    caller: Hr
  });
  return /* @__PURE__ */ p(Rn, { ...i, children: /* @__PURE__ */ p(
    Cy,
    {
      scope: t,
      contentId: ge(),
      triggerRef: l,
      open: u,
      onOpenChange: m,
      onOpenToggle: d.useCallback(() => m((h) => !h), [m]),
      hasCustomAnchor: c,
      onCustomAnchorAdd: d.useCallback(() => f(!0), []),
      onCustomAnchorRemove: d.useCallback(() => f(!1), []),
      modal: s,
      children: n
    }
  ) });
};
xd.displayName = Hr;
var Sd = "PopoverAnchor", ky = d.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, o = xt(Sd, n), a = Ln(n), { onCustomAnchorAdd: s, onCustomAnchorRemove: i } = o;
    return d.useEffect(() => (s(), () => i()), [s, i]), /* @__PURE__ */ p(Tn, { ...a, ...r, ref: t });
  }
);
ky.displayName = Sd;
var Cd = "PopoverTrigger", kd = d.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, o = xt(Cd, n), a = Ln(n), s = J(t, o.triggerRef), i = /* @__PURE__ */ p(
      L.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": Od(o.open),
        ...r,
        ref: s,
        onClick: A(e.onClick, o.onOpenToggle)
      }
    );
    return o.hasCustomAnchor ? i : /* @__PURE__ */ p(Tn, { asChild: !0, ...a, children: i });
  }
);
kd.displayName = Cd;
var Wa = "PopoverPortal", [Ey, My] = wd(Wa, {
  forceMount: void 0
}), Ed = (e) => {
  const { __scopePopover: t, forceMount: n, children: r, container: o } = e, a = xt(Wa, t);
  return /* @__PURE__ */ p(Ey, { scope: t, forceMount: n, children: /* @__PURE__ */ p(Ce, { present: n || a.open, children: /* @__PURE__ */ p(rn, { asChild: !0, container: o, children: r }) }) });
};
Ed.displayName = Wa;
var Zt = "PopoverContent", Md = d.forwardRef(
  (e, t) => {
    const n = My(Zt, e.__scopePopover), { forceMount: r = n.forceMount, ...o } = e, a = xt(Zt, e.__scopePopover);
    return /* @__PURE__ */ p(Ce, { present: r || a.open, children: a.modal ? /* @__PURE__ */ p(Dy, { ...o, ref: t }) : /* @__PURE__ */ p(Oy, { ...o, ref: t }) });
  }
);
Md.displayName = Zt;
var Py = /* @__PURE__ */ mt("PopoverContent.RemoveScroll"), Dy = d.forwardRef(
  (e, t) => {
    const n = xt(Zt, e.__scopePopover), r = d.useRef(null), o = J(t, r), a = d.useRef(!1);
    return d.useEffect(() => {
      const s = r.current;
      if (s) return Er(s);
    }, []), /* @__PURE__ */ p(Nn, { as: Py, allowPinchZoom: !0, children: /* @__PURE__ */ p(
      Pd,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: A(e.onCloseAutoFocus, (s) => {
          s.preventDefault(), a.current || n.triggerRef.current?.focus();
        }),
        onPointerDownOutside: A(
          e.onPointerDownOutside,
          (s) => {
            const i = s.detail.originalEvent, l = i.button === 0 && i.ctrlKey === !0, c = i.button === 2 || l;
            a.current = c;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: A(
          e.onFocusOutside,
          (s) => s.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), Oy = d.forwardRef(
  (e, t) => {
    const n = xt(Zt, e.__scopePopover), r = d.useRef(!1), o = d.useRef(!1);
    return /* @__PURE__ */ p(
      Pd,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (a) => {
          e.onCloseAutoFocus?.(a), a.defaultPrevented || (r.current || n.triggerRef.current?.focus(), a.preventDefault()), r.current = !1, o.current = !1;
        },
        onInteractOutside: (a) => {
          e.onInteractOutside?.(a), a.defaultPrevented || (r.current = !0, a.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const s = a.target;
          n.triggerRef.current?.contains(s) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && o.current && a.preventDefault();
        }
      }
    );
  }
), Pd = d.forwardRef(
  (e, t) => {
    const {
      __scopePopover: n,
      trapFocus: r,
      onOpenAutoFocus: o,
      onCloseAutoFocus: a,
      disableOutsidePointerEvents: s,
      onEscapeKeyDown: i,
      onPointerDownOutside: l,
      onFocusOutside: c,
      onInteractOutside: f,
      ...u
    } = e, m = xt(Zt, n), h = Ln(n);
    return Cr(), /* @__PURE__ */ p(
      On,
      {
        asChild: !0,
        loop: !0,
        trapped: r,
        onMountAutoFocus: o,
        onUnmountAutoFocus: a,
        children: /* @__PURE__ */ p(
          nn,
          {
            asChild: !0,
            disableOutsidePointerEvents: s,
            onInteractOutside: f,
            onEscapeKeyDown: i,
            onPointerDownOutside: l,
            onFocusOutside: c,
            onDismiss: () => m.onOpenChange(!1),
            children: /* @__PURE__ */ p(
              Lr,
              {
                "data-state": Od(m.open),
                role: "dialog",
                id: m.contentId,
                ...h,
                ...u,
                ref: t,
                style: {
                  ...u.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), Dd = "PopoverClose", Ny = d.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, o = xt(Dd, n);
    return /* @__PURE__ */ p(
      L.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: A(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
Ny.displayName = Dd;
var _y = "PopoverArrow", Ry = d.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, o = Ln(n);
    return /* @__PURE__ */ p($r, { ...o, ...r, ref: t });
  }
);
Ry.displayName = _y;
function Od(e) {
  return e ? "open" : "closed";
}
var Ty = xd, Ay = kd, Iy = Ed, Wy = Md, Fa = "Progress", La = 100, [Fy] = xe(Fa), [Ly, $y] = Fy(Fa), Nd = d.forwardRef(
  (e, t) => {
    const {
      __scopeProgress: n,
      value: r = null,
      max: o,
      getValueLabel: a = zy,
      ...s
    } = e;
    (o || o === 0) && !Hs(o) && console.error(By(`${o}`, "Progress"));
    const i = Hs(o) ? o : La;
    r !== null && !Vs(r, i) && console.error(Yy(`${r}`, "Progress"));
    const l = Vs(r, i) ? r : null, c = pr(l) ? a(l, i) : void 0;
    return /* @__PURE__ */ p(Ly, { scope: n, value: l, max: i, children: /* @__PURE__ */ p(
      L.div,
      {
        "aria-valuemax": i,
        "aria-valuemin": 0,
        "aria-valuenow": pr(l) ? l : void 0,
        "aria-valuetext": c,
        role: "progressbar",
        "data-state": Td(l, i),
        "data-value": l ?? void 0,
        "data-max": i,
        ...s,
        ref: t
      }
    ) });
  }
);
Nd.displayName = Fa;
var _d = "ProgressIndicator", Rd = d.forwardRef(
  (e, t) => {
    const { __scopeProgress: n, ...r } = e, o = $y(_d, n);
    return /* @__PURE__ */ p(
      L.div,
      {
        "data-state": Td(o.value, o.max),
        "data-value": o.value ?? void 0,
        "data-max": o.max,
        ...r,
        ref: t
      }
    );
  }
);
Rd.displayName = _d;
function zy(e, t) {
  return `${Math.round(e / t * 100)}%`;
}
function Td(e, t) {
  return e == null ? "indeterminate" : e === t ? "complete" : "loading";
}
function pr(e) {
  return typeof e == "number";
}
function Hs(e) {
  return pr(e) && !isNaN(e) && e > 0;
}
function Vs(e, t) {
  return pr(e) && !isNaN(e) && e <= t && e >= 0;
}
function By(e, t) {
  return `Invalid prop \`max\` of value \`${e}\` supplied to \`${t}\`. Only numbers greater than 0 are valid max values. Defaulting to \`${La}\`.`;
}
function Yy(e, t) {
  return `Invalid prop \`value\` of value \`${e}\` supplied to \`${t}\`. The \`value\` prop must be:
  - a positive number
  - less than the value passed to \`max\` (or ${La} if no \`max\` prop is set)
  - \`null\` or \`undefined\` if the progress is indeterminate.

Defaulting to \`null\`.`;
}
var Hy = Nd, Vy = Rd;
function Gy(e, t) {
  return d.useReducer((n, r) => t[n][r] ?? n, e);
}
var $a = "ScrollArea", [Ad] = xe($a), [Uy, Ie] = Ad($a), Id = d.forwardRef(
  (e, t) => {
    const {
      __scopeScrollArea: n,
      type: r = "hover",
      dir: o,
      scrollHideDelay: a = 600,
      ...s
    } = e, [i, l] = d.useState(null), [c, f] = d.useState(null), [u, m] = d.useState(null), [h, b] = d.useState(null), [g, v] = d.useState(null), [y, w] = d.useState(0), [x, S] = d.useState(0), [k, C] = d.useState(!1), [E, M] = d.useState(!1), O = J(t, (W) => l(W)), R = It(o);
    return /* @__PURE__ */ p(
      Uy,
      {
        scope: n,
        type: r,
        dir: R,
        scrollHideDelay: a,
        scrollArea: i,
        viewport: c,
        onViewportChange: f,
        content: u,
        onContentChange: m,
        scrollbarX: h,
        onScrollbarXChange: b,
        scrollbarXEnabled: k,
        onScrollbarXEnabledChange: C,
        scrollbarY: g,
        onScrollbarYChange: v,
        scrollbarYEnabled: E,
        onScrollbarYEnabledChange: M,
        onCornerWidthChange: w,
        onCornerHeightChange: S,
        children: /* @__PURE__ */ p(
          L.div,
          {
            dir: R,
            ...s,
            ref: O,
            style: {
              position: "relative",
              // Pass corner sizes as CSS vars to reduce re-renders of context consumers
              "--radix-scroll-area-corner-width": y + "px",
              "--radix-scroll-area-corner-height": x + "px",
              ...e.style
            }
          }
        )
      }
    );
  }
);
Id.displayName = $a;
var Wd = "ScrollAreaViewport", Fd = d.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: n, children: r, nonce: o, ...a } = e, s = Ie(Wd, n), i = d.useRef(null), l = J(t, i, s.onViewportChange);
    return /* @__PURE__ */ ae(pt, { children: [
      /* @__PURE__ */ p(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: o
        }
      ),
      /* @__PURE__ */ p(
        L.div,
        {
          "data-radix-scroll-area-viewport": "",
          ...a,
          ref: l,
          style: {
            /**
             * We don't support `visible` because the intention is to have at least one scrollbar
             * if this component is used and `visible` will behave like `auto` in that case
             * https://developer.mozilla.org/en-US/docs/Web/CSS/overflow#description
             *
             * We don't handle `auto` because the intention is for the native implementation
             * to be hidden if using this component. We just want to ensure the node is scrollable
             * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
             * the browser from having to work out whether to render native scrollbars or not,
             * we tell it to with the intention of hiding them in CSS.
             */
            overflowX: s.scrollbarXEnabled ? "scroll" : "hidden",
            overflowY: s.scrollbarYEnabled ? "scroll" : "hidden",
            ...e.style
          },
          children: /* @__PURE__ */ p("div", { ref: s.onContentChange, style: { minWidth: "100%", display: "table" }, children: r })
        }
      )
    ] });
  }
);
Fd.displayName = Wd;
var Xe = "ScrollAreaScrollbar", Ld = d.forwardRef(
  (e, t) => {
    const { forceMount: n, ...r } = e, o = Ie(Xe, e.__scopeScrollArea), { onScrollbarXEnabledChange: a, onScrollbarYEnabledChange: s } = o, i = e.orientation === "horizontal";
    return d.useEffect(() => (i ? a(!0) : s(!0), () => {
      i ? a(!1) : s(!1);
    }), [i, a, s]), o.type === "hover" ? /* @__PURE__ */ p(jy, { ...r, ref: t, forceMount: n }) : o.type === "scroll" ? /* @__PURE__ */ p(Ky, { ...r, ref: t, forceMount: n }) : o.type === "auto" ? /* @__PURE__ */ p($d, { ...r, ref: t, forceMount: n }) : o.type === "always" ? /* @__PURE__ */ p(za, { ...r, ref: t }) : null;
  }
);
Ld.displayName = Xe;
var jy = d.forwardRef((e, t) => {
  const { forceMount: n, ...r } = e, o = Ie(Xe, e.__scopeScrollArea), [a, s] = d.useState(!1);
  return d.useEffect(() => {
    const i = o.scrollArea;
    let l = 0;
    if (i) {
      const c = () => {
        window.clearTimeout(l), s(!0);
      }, f = () => {
        l = window.setTimeout(() => s(!1), o.scrollHideDelay);
      };
      return i.addEventListener("pointerenter", c), i.addEventListener("pointerleave", f), () => {
        window.clearTimeout(l), i.removeEventListener("pointerenter", c), i.removeEventListener("pointerleave", f);
      };
    }
  }, [o.scrollArea, o.scrollHideDelay]), /* @__PURE__ */ p(Ce, { present: n || a, children: /* @__PURE__ */ p(
    $d,
    {
      "data-state": a ? "visible" : "hidden",
      ...r,
      ref: t
    }
  ) });
}), Ky = d.forwardRef((e, t) => {
  const { forceMount: n, ...r } = e, o = Ie(Xe, e.__scopeScrollArea), a = e.orientation === "horizontal", s = Gr(() => l("SCROLL_END"), 100), [i, l] = Gy("hidden", {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  return d.useEffect(() => {
    if (i === "idle") {
      const c = window.setTimeout(() => l("HIDE"), o.scrollHideDelay);
      return () => window.clearTimeout(c);
    }
  }, [i, o.scrollHideDelay, l]), d.useEffect(() => {
    const c = o.viewport, f = a ? "scrollLeft" : "scrollTop";
    if (c) {
      let u = c[f];
      const m = () => {
        const h = c[f];
        u !== h && (l("SCROLL"), s()), u = h;
      };
      return c.addEventListener("scroll", m), () => c.removeEventListener("scroll", m);
    }
  }, [o.viewport, a, l, s]), /* @__PURE__ */ p(Ce, { present: n || i !== "hidden", children: /* @__PURE__ */ p(
    za,
    {
      "data-state": i === "hidden" ? "hidden" : "visible",
      ...r,
      ref: t,
      onPointerEnter: A(e.onPointerEnter, () => l("POINTER_ENTER")),
      onPointerLeave: A(e.onPointerLeave, () => l("POINTER_LEAVE"))
    }
  ) });
}), $d = d.forwardRef((e, t) => {
  const n = Ie(Xe, e.__scopeScrollArea), { forceMount: r, ...o } = e, [a, s] = d.useState(!1), i = e.orientation === "horizontal", l = Gr(() => {
    if (n.viewport) {
      const c = n.viewport.offsetWidth < n.viewport.scrollWidth, f = n.viewport.offsetHeight < n.viewport.scrollHeight;
      s(i ? c : f);
    }
  }, 10);
  return Qt(n.viewport, l), Qt(n.content, l), /* @__PURE__ */ p(Ce, { present: r || a, children: /* @__PURE__ */ p(
    za,
    {
      "data-state": a ? "visible" : "hidden",
      ...o,
      ref: t
    }
  ) });
}), za = d.forwardRef((e, t) => {
  const { orientation: n = "vertical", ...r } = e, o = Ie(Xe, e.__scopeScrollArea), a = d.useRef(null), s = d.useRef(0), [i, l] = d.useState({
    content: 0,
    viewport: 0,
    scrollbar: { size: 0, paddingStart: 0, paddingEnd: 0 }
  }), c = Vd(i.viewport, i.content), f = {
    ...r,
    sizes: i,
    onSizesChange: l,
    hasThumb: c > 0 && c < 1,
    onThumbChange: (m) => a.current = m,
    onThumbPointerUp: () => s.current = 0,
    onThumbPointerDown: (m) => s.current = m
  };
  function u(m, h) {
    return ew(m, s.current, i, h);
  }
  return n === "horizontal" ? /* @__PURE__ */ p(
    qy,
    {
      ...f,
      ref: t,
      onThumbPositionChange: () => {
        if (o.viewport && a.current) {
          const m = o.viewport.scrollLeft, h = Gs(m, i, o.dir);
          a.current.style.transform = `translate3d(${h}px, 0, 0)`;
        }
      },
      onWheelScroll: (m) => {
        o.viewport && (o.viewport.scrollLeft = m);
      },
      onDragScroll: (m) => {
        o.viewport && (o.viewport.scrollLeft = u(m, o.dir));
      }
    }
  ) : n === "vertical" ? /* @__PURE__ */ p(
    Xy,
    {
      ...f,
      ref: t,
      onThumbPositionChange: () => {
        if (o.viewport && a.current) {
          const m = o.viewport.scrollTop, h = Gs(m, i);
          a.current.style.transform = `translate3d(0, ${h}px, 0)`;
        }
      },
      onWheelScroll: (m) => {
        o.viewport && (o.viewport.scrollTop = m);
      },
      onDragScroll: (m) => {
        o.viewport && (o.viewport.scrollTop = u(m));
      }
    }
  ) : null;
}), qy = d.forwardRef((e, t) => {
  const { sizes: n, onSizesChange: r, ...o } = e, a = Ie(Xe, e.__scopeScrollArea), [s, i] = d.useState(), l = d.useRef(null), c = J(t, l, a.onScrollbarXChange);
  return d.useEffect(() => {
    l.current && i(getComputedStyle(l.current));
  }, [l]), /* @__PURE__ */ p(
    Bd,
    {
      "data-orientation": "horizontal",
      ...o,
      ref: c,
      sizes: n,
      style: {
        bottom: 0,
        left: a.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
        right: a.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
        "--radix-scroll-area-thumb-width": Vr(n) + "px",
        ...e.style
      },
      onThumbPointerDown: (f) => e.onThumbPointerDown(f.x),
      onDragScroll: (f) => e.onDragScroll(f.x),
      onWheelScroll: (f, u) => {
        if (a.viewport) {
          const m = a.viewport.scrollLeft + f.deltaX;
          e.onWheelScroll(m), Ud(m, u) && f.preventDefault();
        }
      },
      onResize: () => {
        l.current && a.viewport && s && r({
          content: a.viewport.scrollWidth,
          viewport: a.viewport.offsetWidth,
          scrollbar: {
            size: l.current.clientWidth,
            paddingStart: hr(s.paddingLeft),
            paddingEnd: hr(s.paddingRight)
          }
        });
      }
    }
  );
}), Xy = d.forwardRef((e, t) => {
  const { sizes: n, onSizesChange: r, ...o } = e, a = Ie(Xe, e.__scopeScrollArea), [s, i] = d.useState(), l = d.useRef(null), c = J(t, l, a.onScrollbarYChange);
  return d.useEffect(() => {
    l.current && i(getComputedStyle(l.current));
  }, [l]), /* @__PURE__ */ p(
    Bd,
    {
      "data-orientation": "vertical",
      ...o,
      ref: c,
      sizes: n,
      style: {
        top: 0,
        right: a.dir === "ltr" ? 0 : void 0,
        left: a.dir === "rtl" ? 0 : void 0,
        bottom: "var(--radix-scroll-area-corner-height)",
        "--radix-scroll-area-thumb-height": Vr(n) + "px",
        ...e.style
      },
      onThumbPointerDown: (f) => e.onThumbPointerDown(f.y),
      onDragScroll: (f) => e.onDragScroll(f.y),
      onWheelScroll: (f, u) => {
        if (a.viewport) {
          const m = a.viewport.scrollTop + f.deltaY;
          e.onWheelScroll(m), Ud(m, u) && f.preventDefault();
        }
      },
      onResize: () => {
        l.current && a.viewport && s && r({
          content: a.viewport.scrollHeight,
          viewport: a.viewport.offsetHeight,
          scrollbar: {
            size: l.current.clientHeight,
            paddingStart: hr(s.paddingTop),
            paddingEnd: hr(s.paddingBottom)
          }
        });
      }
    }
  );
}), [Zy, zd] = Ad(Xe), Bd = d.forwardRef((e, t) => {
  const {
    __scopeScrollArea: n,
    sizes: r,
    hasThumb: o,
    onThumbChange: a,
    onThumbPointerUp: s,
    onThumbPointerDown: i,
    onThumbPositionChange: l,
    onDragScroll: c,
    onWheelScroll: f,
    onResize: u,
    ...m
  } = e, h = Ie(Xe, n), [b, g] = d.useState(null), v = J(t, (O) => g(O)), y = d.useRef(null), w = d.useRef(""), x = h.viewport, S = r.content - r.viewport, k = we(f), C = we(l), E = Gr(u, 10);
  function M(O) {
    if (y.current) {
      const R = O.clientX - y.current.left, W = O.clientY - y.current.top;
      c({ x: R, y: W });
    }
  }
  return d.useEffect(() => {
    const O = (R) => {
      const W = R.target;
      b?.contains(W) && k(R, S);
    };
    return document.addEventListener("wheel", O, { passive: !1 }), () => document.removeEventListener("wheel", O, { passive: !1 });
  }, [x, b, S, k]), d.useEffect(C, [r, C]), Qt(b, E), Qt(h.content, E), /* @__PURE__ */ p(
    Zy,
    {
      scope: n,
      scrollbar: b,
      hasThumb: o,
      onThumbChange: we(a),
      onThumbPointerUp: we(s),
      onThumbPositionChange: C,
      onThumbPointerDown: we(i),
      children: /* @__PURE__ */ p(
        L.div,
        {
          ...m,
          ref: v,
          style: { position: "absolute", ...m.style },
          onPointerDown: A(e.onPointerDown, (O) => {
            O.button === 0 && (O.target.setPointerCapture(O.pointerId), y.current = b.getBoundingClientRect(), w.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", h.viewport && (h.viewport.style.scrollBehavior = "auto"), M(O));
          }),
          onPointerMove: A(e.onPointerMove, M),
          onPointerUp: A(e.onPointerUp, (O) => {
            const R = O.target;
            R.hasPointerCapture(O.pointerId) && R.releasePointerCapture(O.pointerId), document.body.style.webkitUserSelect = w.current, h.viewport && (h.viewport.style.scrollBehavior = ""), y.current = null;
          })
        }
      )
    }
  );
}), mr = "ScrollAreaThumb", Yd = d.forwardRef(
  (e, t) => {
    const { forceMount: n, ...r } = e, o = zd(mr, e.__scopeScrollArea);
    return /* @__PURE__ */ p(Ce, { present: n || o.hasThumb, children: /* @__PURE__ */ p(Qy, { ref: t, ...r }) });
  }
), Qy = d.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: n, style: r, ...o } = e, a = Ie(mr, n), s = zd(mr, n), { onThumbPositionChange: i } = s, l = J(
      t,
      (u) => s.onThumbChange(u)
    ), c = d.useRef(void 0), f = Gr(() => {
      c.current && (c.current(), c.current = void 0);
    }, 100);
    return d.useEffect(() => {
      const u = a.viewport;
      if (u) {
        const m = () => {
          if (f(), !c.current) {
            const h = tw(u, i);
            c.current = h, i();
          }
        };
        return i(), u.addEventListener("scroll", m), () => u.removeEventListener("scroll", m);
      }
    }, [a.viewport, f, i]), /* @__PURE__ */ p(
      L.div,
      {
        "data-state": s.hasThumb ? "visible" : "hidden",
        ...o,
        ref: l,
        style: {
          width: "var(--radix-scroll-area-thumb-width)",
          height: "var(--radix-scroll-area-thumb-height)",
          ...r
        },
        onPointerDownCapture: A(e.onPointerDownCapture, (u) => {
          const h = u.target.getBoundingClientRect(), b = u.clientX - h.left, g = u.clientY - h.top;
          s.onThumbPointerDown({ x: b, y: g });
        }),
        onPointerUp: A(e.onPointerUp, s.onThumbPointerUp)
      }
    );
  }
);
Yd.displayName = mr;
var Ba = "ScrollAreaCorner", Hd = d.forwardRef(
  (e, t) => {
    const n = Ie(Ba, e.__scopeScrollArea), r = !!(n.scrollbarX && n.scrollbarY);
    return n.type !== "scroll" && r ? /* @__PURE__ */ p(Jy, { ...e, ref: t }) : null;
  }
);
Hd.displayName = Ba;
var Jy = d.forwardRef((e, t) => {
  const { __scopeScrollArea: n, ...r } = e, o = Ie(Ba, n), [a, s] = d.useState(0), [i, l] = d.useState(0), c = !!(a && i);
  return Qt(o.scrollbarX, () => {
    const f = o.scrollbarX?.offsetHeight || 0;
    o.onCornerHeightChange(f), l(f);
  }), Qt(o.scrollbarY, () => {
    const f = o.scrollbarY?.offsetWidth || 0;
    o.onCornerWidthChange(f), s(f);
  }), c ? /* @__PURE__ */ p(
    L.div,
    {
      ...r,
      ref: t,
      style: {
        width: a,
        height: i,
        position: "absolute",
        right: o.dir === "ltr" ? 0 : void 0,
        left: o.dir === "rtl" ? 0 : void 0,
        bottom: 0,
        ...e.style
      }
    }
  ) : null;
});
function hr(e) {
  return e ? parseInt(e, 10) : 0;
}
function Vd(e, t) {
  const n = e / t;
  return isNaN(n) ? 0 : n;
}
function Vr(e) {
  const t = Vd(e.viewport, e.content), n = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, r = (e.scrollbar.size - n) * t;
  return Math.max(r, 18);
}
function ew(e, t, n, r = "ltr") {
  const o = Vr(n), a = o / 2, s = t || a, i = o - s, l = n.scrollbar.paddingStart + s, c = n.scrollbar.size - n.scrollbar.paddingEnd - i, f = n.content - n.viewport, u = r === "ltr" ? [0, f] : [f * -1, 0];
  return Gd([l, c], u)(e);
}
function Gs(e, t, n = "ltr") {
  const r = Vr(t), o = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, a = t.scrollbar.size - o, s = t.content - t.viewport, i = a - r, l = n === "ltr" ? [0, s] : [s * -1, 0], c = kn(e, l);
  return Gd([0, s], [0, i])(c);
}
function Gd(e, t) {
  return (n) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const r = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + r * (n - e[0]);
  };
}
function Ud(e, t) {
  return e > 0 && e < t;
}
var tw = (e, t = () => {
}) => {
  let n = { left: e.scrollLeft, top: e.scrollTop }, r = 0;
  return (function o() {
    const a = { left: e.scrollLeft, top: e.scrollTop }, s = n.left !== a.left, i = n.top !== a.top;
    (s || i) && t(), n = a, r = window.requestAnimationFrame(o);
  })(), () => window.cancelAnimationFrame(r);
};
function Gr(e, t) {
  const n = we(e), r = d.useRef(0);
  return d.useEffect(() => () => window.clearTimeout(r.current), []), d.useCallback(() => {
    window.clearTimeout(r.current), r.current = window.setTimeout(n, t);
  }, [n, t]);
}
function Qt(e, t) {
  const n = we(t);
  ve(() => {
    let r = 0;
    if (e) {
      const o = new ResizeObserver(() => {
        cancelAnimationFrame(r), r = window.requestAnimationFrame(n);
      });
      return o.observe(e), () => {
        window.cancelAnimationFrame(r), o.unobserve(e);
      };
    }
  }, [e, n]);
}
var nw = Id, rw = Fd, ow = Hd, aw = [" ", "Enter", "ArrowUp", "ArrowDown"], sw = [" ", "Enter"], _t = "Select", [Ur, jr, iw] = Dn(_t), [sn] = xe(_t, [
  iw,
  yt
]), Kr = yt(), [lw, St] = sn(_t), [cw, dw] = sn(_t), jd = (e) => {
  const {
    __scopeSelect: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: a,
    value: s,
    defaultValue: i,
    onValueChange: l,
    dir: c,
    name: f,
    autoComplete: u,
    disabled: m,
    required: h,
    form: b
  } = e, g = Kr(t), [v, y] = d.useState(null), [w, x] = d.useState(null), [S, k] = d.useState(!1), C = It(c), [E, M] = ke({
    prop: r,
    defaultProp: o ?? !1,
    onChange: a,
    caller: _t
  }), [O, R] = ke({
    prop: s,
    defaultProp: i,
    onChange: l,
    caller: _t
  }), W = d.useRef(null), Y = v ? b || !!v.closest("form") : !0, [K, H] = d.useState(/* @__PURE__ */ new Set()), Q = Array.from(K).map(($) => $.props.value).join(";");
  return /* @__PURE__ */ p(Rn, { ...g, children: /* @__PURE__ */ ae(
    lw,
    {
      required: h,
      scope: t,
      trigger: v,
      onTriggerChange: y,
      valueNode: w,
      onValueNodeChange: x,
      valueNodeHasChildren: S,
      onValueNodeHasChildrenChange: k,
      contentId: ge(),
      value: O,
      onValueChange: R,
      open: E,
      onOpenChange: M,
      dir: C,
      triggerPointerDownPosRef: W,
      disabled: m,
      children: [
        /* @__PURE__ */ p(Ur.Provider, { scope: t, children: /* @__PURE__ */ p(
          cw,
          {
            scope: e.__scopeSelect,
            onNativeOptionAdd: d.useCallback(($) => {
              H((q) => new Set(q).add($));
            }, []),
            onNativeOptionRemove: d.useCallback(($) => {
              H((q) => {
                const z = new Set(q);
                return z.delete($), z;
              });
            }, []),
            children: n
          }
        ) }),
        Y ? /* @__PURE__ */ ae(
          bu,
          {
            "aria-hidden": !0,
            required: h,
            tabIndex: -1,
            name: f,
            autoComplete: u,
            value: O,
            onChange: ($) => R($.target.value),
            disabled: m,
            form: b,
            children: [
              O === void 0 ? /* @__PURE__ */ p("option", { value: "" }) : null,
              Array.from(K)
            ]
          },
          Q
        ) : null
      ]
    }
  ) });
};
jd.displayName = _t;
var Kd = "SelectTrigger", qd = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, disabled: r = !1, ...o } = e, a = Kr(n), s = St(Kd, n), i = s.disabled || r, l = J(t, s.onTriggerChange), c = jr(n), f = d.useRef("touch"), [u, m, h] = wu((g) => {
      const v = c().filter((x) => !x.disabled), y = v.find((x) => x.value === s.value), w = xu(v, g, y);
      w !== void 0 && s.onValueChange(w.value);
    }), b = (g) => {
      i || (s.onOpenChange(!0), h()), g && (s.triggerPointerDownPosRef.current = {
        x: Math.round(g.pageX),
        y: Math.round(g.pageY)
      });
    };
    return /* @__PURE__ */ p(Tn, { asChild: !0, ...a, children: /* @__PURE__ */ p(
      L.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": s.contentId,
        "aria-expanded": s.open,
        "aria-required": s.required,
        "aria-autocomplete": "none",
        dir: s.dir,
        "data-state": s.open ? "open" : "closed",
        disabled: i,
        "data-disabled": i ? "" : void 0,
        "data-placeholder": yu(s.value) ? "" : void 0,
        ...o,
        ref: l,
        onClick: A(o.onClick, (g) => {
          g.currentTarget.focus(), f.current !== "mouse" && b(g);
        }),
        onPointerDown: A(o.onPointerDown, (g) => {
          f.current = g.pointerType;
          const v = g.target;
          v.hasPointerCapture(g.pointerId) && v.releasePointerCapture(g.pointerId), g.button === 0 && g.ctrlKey === !1 && g.pointerType === "mouse" && (b(g), g.preventDefault());
        }),
        onKeyDown: A(o.onKeyDown, (g) => {
          const v = u.current !== "";
          !(g.ctrlKey || g.altKey || g.metaKey) && g.key.length === 1 && m(g.key), !(v && g.key === " ") && aw.includes(g.key) && (b(), g.preventDefault());
        })
      }
    ) });
  }
);
qd.displayName = Kd;
var Xd = "SelectValue", Zd = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: o, children: a, placeholder: s = "", ...i } = e, l = St(Xd, n), { onValueNodeHasChildrenChange: c } = l, f = a !== void 0, u = J(t, l.onValueNodeChange);
    return ve(() => {
      c(f);
    }, [c, f]), /* @__PURE__ */ p(
      L.span,
      {
        ...i,
        ref: u,
        style: { pointerEvents: "none" },
        children: yu(l.value) ? /* @__PURE__ */ p(pt, { children: s }) : a
      }
    );
  }
);
Zd.displayName = Xd;
var uw = "SelectIcon", Qd = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, children: r, ...o } = e;
    return /* @__PURE__ */ p(L.span, { "aria-hidden": !0, ...o, ref: t, children: r || "▼" });
  }
);
Qd.displayName = uw;
var fw = "SelectPortal", Jd = (e) => /* @__PURE__ */ p(rn, { asChild: !0, ...e });
Jd.displayName = fw;
var Rt = "SelectContent", eu = d.forwardRef(
  (e, t) => {
    const n = St(Rt, e.__scopeSelect), [r, o] = d.useState();
    if (ve(() => {
      o(new DocumentFragment());
    }, []), !n.open) {
      const a = r;
      return a ? yr.createPortal(
        /* @__PURE__ */ p(tu, { scope: e.__scopeSelect, children: /* @__PURE__ */ p(Ur.Slot, { scope: e.__scopeSelect, children: /* @__PURE__ */ p("div", { children: e.children }) }) }),
        a
      ) : null;
    }
    return /* @__PURE__ */ p(nu, { ...e, ref: t });
  }
);
eu.displayName = Rt;
var Fe = 10, [tu, Ct] = sn(Rt), pw = "SelectContentImpl", mw = /* @__PURE__ */ mt("SelectContent.RemoveScroll"), nu = d.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      position: r = "item-aligned",
      onCloseAutoFocus: o,
      onEscapeKeyDown: a,
      onPointerDownOutside: s,
      //
      // PopperContent props
      side: i,
      sideOffset: l,
      align: c,
      alignOffset: f,
      arrowPadding: u,
      collisionBoundary: m,
      collisionPadding: h,
      sticky: b,
      hideWhenDetached: g,
      avoidCollisions: v,
      //
      ...y
    } = e, w = St(Rt, n), [x, S] = d.useState(null), [k, C] = d.useState(null), E = J(t, (_) => S(_)), [M, O] = d.useState(null), [R, W] = d.useState(
      null
    ), Y = jr(n), [K, H] = d.useState(!1), Q = d.useRef(!1);
    d.useEffect(() => {
      if (x) return Er(x);
    }, [x]), Cr();
    const $ = d.useCallback(
      (_) => {
        const [ee, ...Z] = Y().map((pe) => pe.ref.current), [re] = Z.slice(-1), ce = document.activeElement;
        for (const pe of _)
          if (pe === ce || (pe?.scrollIntoView({ block: "nearest" }), pe === ee && k && (k.scrollTop = 0), pe === re && k && (k.scrollTop = k.scrollHeight), pe?.focus(), document.activeElement !== ce)) return;
      },
      [Y, k]
    ), q = d.useCallback(
      () => $([M, x]),
      [$, M, x]
    );
    d.useEffect(() => {
      K && q();
    }, [K, q]);
    const { onOpenChange: z, triggerPointerDownPosRef: T } = w;
    d.useEffect(() => {
      if (x) {
        let _ = { x: 0, y: 0 };
        const ee = (re) => {
          _ = {
            x: Math.abs(Math.round(re.pageX) - (T.current?.x ?? 0)),
            y: Math.abs(Math.round(re.pageY) - (T.current?.y ?? 0))
          };
        }, Z = (re) => {
          _.x <= 10 && _.y <= 10 ? re.preventDefault() : x.contains(re.target) || z(!1), document.removeEventListener("pointermove", ee), T.current = null;
        };
        return T.current !== null && (document.addEventListener("pointermove", ee), document.addEventListener("pointerup", Z, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", ee), document.removeEventListener("pointerup", Z, { capture: !0 });
        };
      }
    }, [x, z, T]), d.useEffect(() => {
      const _ = () => z(!1);
      return window.addEventListener("blur", _), window.addEventListener("resize", _), () => {
        window.removeEventListener("blur", _), window.removeEventListener("resize", _);
      };
    }, [z]);
    const [I, le] = wu((_) => {
      const ee = Y().filter((ce) => !ce.disabled), Z = ee.find((ce) => ce.ref.current === document.activeElement), re = xu(ee, _, Z);
      re && setTimeout(() => re.ref.current.focus());
    }), D = d.useCallback(
      (_, ee, Z) => {
        const re = !Q.current && !Z;
        (w.value !== void 0 && w.value === ee || re) && (O(_), re && (Q.current = !0));
      },
      [w.value]
    ), j = d.useCallback(() => x?.focus(), [x]), X = d.useCallback(
      (_, ee, Z) => {
        const re = !Q.current && !Z;
        (w.value !== void 0 && w.value === ee || re) && W(_);
      },
      [w.value]
    ), F = r === "popper" ? Ho : ru, U = F === Ho ? {
      side: i,
      sideOffset: l,
      align: c,
      alignOffset: f,
      arrowPadding: u,
      collisionBoundary: m,
      collisionPadding: h,
      sticky: b,
      hideWhenDetached: g,
      avoidCollisions: v
    } : {};
    return /* @__PURE__ */ p(
      tu,
      {
        scope: n,
        content: x,
        viewport: k,
        onViewportChange: C,
        itemRefCallback: D,
        selectedItem: M,
        onItemLeave: j,
        itemTextRefCallback: X,
        focusSelectedItem: q,
        selectedItemText: R,
        position: r,
        isPositioned: K,
        searchRef: I,
        children: /* @__PURE__ */ p(Nn, { as: mw, allowPinchZoom: !0, children: /* @__PURE__ */ p(
          On,
          {
            asChild: !0,
            trapped: w.open,
            onMountAutoFocus: (_) => {
              _.preventDefault();
            },
            onUnmountAutoFocus: A(o, (_) => {
              w.trigger?.focus({ preventScroll: !0 }), _.preventDefault();
            }),
            children: /* @__PURE__ */ p(
              nn,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: a,
                onPointerDownOutside: s,
                onFocusOutside: (_) => _.preventDefault(),
                onDismiss: () => w.onOpenChange(!1),
                children: /* @__PURE__ */ p(
                  F,
                  {
                    role: "listbox",
                    id: w.contentId,
                    "data-state": w.open ? "open" : "closed",
                    dir: w.dir,
                    onContextMenu: (_) => _.preventDefault(),
                    ...y,
                    ...U,
                    onPlaced: () => H(!0),
                    ref: E,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...y.style
                    },
                    onKeyDown: A(y.onKeyDown, (_) => {
                      const ee = _.ctrlKey || _.altKey || _.metaKey;
                      if (_.key === "Tab" && _.preventDefault(), !ee && _.key.length === 1 && le(_.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(_.key)) {
                        let re = Y().filter((ce) => !ce.disabled).map((ce) => ce.ref.current);
                        if (["ArrowUp", "End"].includes(_.key) && (re = re.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(_.key)) {
                          const ce = _.target, pe = re.indexOf(ce);
                          re = re.slice(pe + 1);
                        }
                        setTimeout(() => $(re)), _.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
nu.displayName = pw;
var hw = "SelectItemAlignedPosition", ru = d.forwardRef((e, t) => {
  const { __scopeSelect: n, onPlaced: r, ...o } = e, a = St(Rt, n), s = Ct(Rt, n), [i, l] = d.useState(null), [c, f] = d.useState(null), u = J(t, (E) => f(E)), m = jr(n), h = d.useRef(!1), b = d.useRef(!0), { viewport: g, selectedItem: v, selectedItemText: y, focusSelectedItem: w } = s, x = d.useCallback(() => {
    if (a.trigger && a.valueNode && i && c && g && v && y) {
      const E = a.trigger.getBoundingClientRect(), M = c.getBoundingClientRect(), O = a.valueNode.getBoundingClientRect(), R = y.getBoundingClientRect();
      if (a.dir !== "rtl") {
        const ce = R.left - M.left, pe = O.left - ce, Se = E.left - pe, Pe = E.width + Se, Lt = Math.max(Pe, M.width), dn = window.innerWidth - Fe, un = kn(pe, [
          Fe,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(Fe, dn - Lt)
        ]);
        i.style.minWidth = Pe + "px", i.style.left = un + "px";
      } else {
        const ce = M.right - R.right, pe = window.innerWidth - O.right - ce, Se = window.innerWidth - E.right - pe, Pe = E.width + Se, Lt = Math.max(Pe, M.width), dn = window.innerWidth - Fe, un = kn(pe, [
          Fe,
          Math.max(Fe, dn - Lt)
        ]);
        i.style.minWidth = Pe + "px", i.style.right = un + "px";
      }
      const W = m(), Y = window.innerHeight - Fe * 2, K = g.scrollHeight, H = window.getComputedStyle(c), Q = parseInt(H.borderTopWidth, 10), $ = parseInt(H.paddingTop, 10), q = parseInt(H.borderBottomWidth, 10), z = parseInt(H.paddingBottom, 10), T = Q + $ + K + z + q, I = Math.min(v.offsetHeight * 5, T), le = window.getComputedStyle(g), D = parseInt(le.paddingTop, 10), j = parseInt(le.paddingBottom, 10), X = E.top + E.height / 2 - Fe, F = Y - X, U = v.offsetHeight / 2, _ = v.offsetTop + U, ee = Q + $ + _, Z = T - ee;
      if (ee <= X) {
        const ce = W.length > 0 && v === W[W.length - 1].ref.current;
        i.style.bottom = "0px";
        const pe = c.clientHeight - g.offsetTop - g.offsetHeight, Se = Math.max(
          F,
          U + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (ce ? j : 0) + pe + q
        ), Pe = ee + Se;
        i.style.height = Pe + "px";
      } else {
        const ce = W.length > 0 && v === W[0].ref.current;
        i.style.top = "0px";
        const Se = Math.max(
          X,
          Q + g.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (ce ? D : 0) + U
        ) + Z;
        i.style.height = Se + "px", g.scrollTop = ee - X + g.offsetTop;
      }
      i.style.margin = `${Fe}px 0`, i.style.minHeight = I + "px", i.style.maxHeight = Y + "px", r?.(), requestAnimationFrame(() => h.current = !0);
    }
  }, [
    m,
    a.trigger,
    a.valueNode,
    i,
    c,
    g,
    v,
    y,
    a.dir,
    r
  ]);
  ve(() => x(), [x]);
  const [S, k] = d.useState();
  ve(() => {
    c && k(window.getComputedStyle(c).zIndex);
  }, [c]);
  const C = d.useCallback(
    (E) => {
      E && b.current === !0 && (x(), w?.(), b.current = !1);
    },
    [x, w]
  );
  return /* @__PURE__ */ p(
    vw,
    {
      scope: n,
      contentWrapper: i,
      shouldExpandOnScrollRef: h,
      onScrollButtonChange: C,
      children: /* @__PURE__ */ p(
        "div",
        {
          ref: l,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: S
          },
          children: /* @__PURE__ */ p(
            L.div,
            {
              ...o,
              ref: u,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...o.style
              }
            }
          )
        }
      )
    }
  );
});
ru.displayName = hw;
var gw = "SelectPopperPosition", Ho = d.forwardRef((e, t) => {
  const {
    __scopeSelect: n,
    align: r = "start",
    collisionPadding: o = Fe,
    ...a
  } = e, s = Kr(n);
  return /* @__PURE__ */ p(
    Lr,
    {
      ...s,
      ...a,
      ref: t,
      align: r,
      collisionPadding: o,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...a.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
Ho.displayName = gw;
var [vw, Ya] = sn(Rt, {}), Vo = "SelectViewport", ou = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, nonce: r, ...o } = e, a = Ct(Vo, n), s = Ya(Vo, n), i = J(t, a.onViewportChange), l = d.useRef(0);
    return /* @__PURE__ */ ae(pt, { children: [
      /* @__PURE__ */ p(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: r
        }
      ),
      /* @__PURE__ */ p(Ur.Slot, { scope: n, children: /* @__PURE__ */ p(
        L.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...o,
          ref: i,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...o.style
          },
          onScroll: A(o.onScroll, (c) => {
            const f = c.currentTarget, { contentWrapper: u, shouldExpandOnScrollRef: m } = s;
            if (m?.current && u) {
              const h = Math.abs(l.current - f.scrollTop);
              if (h > 0) {
                const b = window.innerHeight - Fe * 2, g = parseFloat(u.style.minHeight), v = parseFloat(u.style.height), y = Math.max(g, v);
                if (y < b) {
                  const w = y + h, x = Math.min(b, w), S = w - x;
                  u.style.height = x + "px", u.style.bottom === "0px" && (f.scrollTop = S > 0 ? S : 0, u.style.justifyContent = "flex-end");
                }
              }
            }
            l.current = f.scrollTop;
          })
        }
      ) })
    ] });
  }
);
ou.displayName = Vo;
var au = "SelectGroup", [bw, yw] = sn(au), su = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, o = ge();
    return /* @__PURE__ */ p(bw, { scope: n, id: o, children: /* @__PURE__ */ p(L.div, { role: "group", "aria-labelledby": o, ...r, ref: t }) });
  }
);
su.displayName = au;
var iu = "SelectLabel", lu = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, o = yw(iu, n);
    return /* @__PURE__ */ p(L.div, { id: o.id, ...r, ref: t });
  }
);
lu.displayName = iu;
var gr = "SelectItem", [ww, cu] = sn(gr), du = d.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      value: r,
      disabled: o = !1,
      textValue: a,
      ...s
    } = e, i = St(gr, n), l = Ct(gr, n), c = i.value === r, [f, u] = d.useState(a ?? ""), [m, h] = d.useState(!1), b = J(
      t,
      (w) => l.itemRefCallback?.(w, r, o)
    ), g = ge(), v = d.useRef("touch"), y = () => {
      o || (i.onValueChange(r), i.onOpenChange(!1));
    };
    if (r === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ p(
      ww,
      {
        scope: n,
        value: r,
        disabled: o,
        textId: g,
        isSelected: c,
        onItemTextChange: d.useCallback((w) => {
          u((x) => x || (w?.textContent ?? "").trim());
        }, []),
        children: /* @__PURE__ */ p(
          Ur.ItemSlot,
          {
            scope: n,
            value: r,
            disabled: o,
            textValue: f,
            children: /* @__PURE__ */ p(
              L.div,
              {
                role: "option",
                "aria-labelledby": g,
                "data-highlighted": m ? "" : void 0,
                "aria-selected": c && m,
                "data-state": c ? "checked" : "unchecked",
                "aria-disabled": o || void 0,
                "data-disabled": o ? "" : void 0,
                tabIndex: o ? void 0 : -1,
                ...s,
                ref: b,
                onFocus: A(s.onFocus, () => h(!0)),
                onBlur: A(s.onBlur, () => h(!1)),
                onClick: A(s.onClick, () => {
                  v.current !== "mouse" && y();
                }),
                onPointerUp: A(s.onPointerUp, () => {
                  v.current === "mouse" && y();
                }),
                onPointerDown: A(s.onPointerDown, (w) => {
                  v.current = w.pointerType;
                }),
                onPointerMove: A(s.onPointerMove, (w) => {
                  v.current = w.pointerType, o ? l.onItemLeave?.() : v.current === "mouse" && w.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: A(s.onPointerLeave, (w) => {
                  w.currentTarget === document.activeElement && l.onItemLeave?.();
                }),
                onKeyDown: A(s.onKeyDown, (w) => {
                  l.searchRef?.current !== "" && w.key === " " || (sw.includes(w.key) && y(), w.key === " " && w.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
du.displayName = gr;
var vn = "SelectItemText", uu = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: o, ...a } = e, s = St(vn, n), i = Ct(vn, n), l = cu(vn, n), c = dw(vn, n), [f, u] = d.useState(null), m = J(
      t,
      (y) => u(y),
      l.onItemTextChange,
      (y) => i.itemTextRefCallback?.(y, l.value, l.disabled)
    ), h = f?.textContent, b = d.useMemo(
      () => /* @__PURE__ */ p("option", { value: l.value, disabled: l.disabled, children: h }, l.value),
      [l.disabled, l.value, h]
    ), { onNativeOptionAdd: g, onNativeOptionRemove: v } = c;
    return ve(() => (g(b), () => v(b)), [g, v, b]), /* @__PURE__ */ ae(pt, { children: [
      /* @__PURE__ */ p(L.span, { id: l.textId, ...a, ref: m }),
      l.isSelected && s.valueNode && !s.valueNodeHasChildren ? yr.createPortal(a.children, s.valueNode) : null
    ] });
  }
);
uu.displayName = vn;
var fu = "SelectItemIndicator", pu = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return cu(fu, n).isSelected ? /* @__PURE__ */ p(L.span, { "aria-hidden": !0, ...r, ref: t }) : null;
  }
);
pu.displayName = fu;
var Go = "SelectScrollUpButton", mu = d.forwardRef((e, t) => {
  const n = Ct(Go, e.__scopeSelect), r = Ya(Go, e.__scopeSelect), [o, a] = d.useState(!1), s = J(t, r.onScrollButtonChange);
  return ve(() => {
    if (n.viewport && n.isPositioned) {
      let i = function() {
        const c = l.scrollTop > 0;
        a(c);
      };
      const l = n.viewport;
      return i(), l.addEventListener("scroll", i), () => l.removeEventListener("scroll", i);
    }
  }, [n.viewport, n.isPositioned]), o ? /* @__PURE__ */ p(
    gu,
    {
      ...e,
      ref: s,
      onAutoScroll: () => {
        const { viewport: i, selectedItem: l } = n;
        i && l && (i.scrollTop = i.scrollTop - l.offsetHeight);
      }
    }
  ) : null;
});
mu.displayName = Go;
var Uo = "SelectScrollDownButton", hu = d.forwardRef((e, t) => {
  const n = Ct(Uo, e.__scopeSelect), r = Ya(Uo, e.__scopeSelect), [o, a] = d.useState(!1), s = J(t, r.onScrollButtonChange);
  return ve(() => {
    if (n.viewport && n.isPositioned) {
      let i = function() {
        const c = l.scrollHeight - l.clientHeight, f = Math.ceil(l.scrollTop) < c;
        a(f);
      };
      const l = n.viewport;
      return i(), l.addEventListener("scroll", i), () => l.removeEventListener("scroll", i);
    }
  }, [n.viewport, n.isPositioned]), o ? /* @__PURE__ */ p(
    gu,
    {
      ...e,
      ref: s,
      onAutoScroll: () => {
        const { viewport: i, selectedItem: l } = n;
        i && l && (i.scrollTop = i.scrollTop + l.offsetHeight);
      }
    }
  ) : null;
});
hu.displayName = Uo;
var gu = d.forwardRef((e, t) => {
  const { __scopeSelect: n, onAutoScroll: r, ...o } = e, a = Ct("SelectScrollButton", n), s = d.useRef(null), i = jr(n), l = d.useCallback(() => {
    s.current !== null && (window.clearInterval(s.current), s.current = null);
  }, []);
  return d.useEffect(() => () => l(), [l]), ve(() => {
    i().find((f) => f.ref.current === document.activeElement)?.ref.current?.scrollIntoView({ block: "nearest" });
  }, [i]), /* @__PURE__ */ p(
    L.div,
    {
      "aria-hidden": !0,
      ...o,
      ref: t,
      style: { flexShrink: 0, ...o.style },
      onPointerDown: A(o.onPointerDown, () => {
        s.current === null && (s.current = window.setInterval(r, 50));
      }),
      onPointerMove: A(o.onPointerMove, () => {
        a.onItemLeave?.(), s.current === null && (s.current = window.setInterval(r, 50));
      }),
      onPointerLeave: A(o.onPointerLeave, () => {
        l();
      })
    }
  );
}), xw = "SelectSeparator", vu = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return /* @__PURE__ */ p(L.div, { "aria-hidden": !0, ...r, ref: t });
  }
);
vu.displayName = xw;
var jo = "SelectArrow", Sw = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, o = Kr(n), a = St(jo, n), s = Ct(jo, n);
    return a.open && s.position === "popper" ? /* @__PURE__ */ p($r, { ...o, ...r, ref: t }) : null;
  }
);
Sw.displayName = jo;
var Cw = "SelectBubbleInput", bu = d.forwardRef(
  ({ __scopeSelect: e, value: t, ...n }, r) => {
    const o = d.useRef(null), a = J(r, o), s = _r(t);
    return d.useEffect(() => {
      const i = o.current;
      if (!i) return;
      const l = window.HTMLSelectElement.prototype, f = Object.getOwnPropertyDescriptor(
        l,
        "value"
      ).set;
      if (s !== t && f) {
        const u = new Event("change", { bubbles: !0 });
        f.call(i, t), i.dispatchEvent(u);
      }
    }, [s, t]), /* @__PURE__ */ p(
      L.select,
      {
        ...n,
        style: { ...Fi, ...n.style },
        ref: a,
        defaultValue: t
      }
    );
  }
);
bu.displayName = Cw;
function yu(e) {
  return e === "" || e === void 0;
}
function wu(e) {
  const t = we(e), n = d.useRef(""), r = d.useRef(0), o = d.useCallback(
    (s) => {
      const i = n.current + s;
      t(i), (function l(c) {
        n.current = c, window.clearTimeout(r.current), c !== "" && (r.current = window.setTimeout(() => l(""), 1e3));
      })(i);
    },
    [t]
  ), a = d.useCallback(() => {
    n.current = "", window.clearTimeout(r.current);
  }, []);
  return d.useEffect(() => () => window.clearTimeout(r.current), []), [n, o, a];
}
function xu(e, t, n) {
  const o = t.length > 1 && Array.from(t).every((c) => c === t[0]) ? t[0] : t, a = n ? e.indexOf(n) : -1;
  let s = kw(e, Math.max(a, 0));
  o.length === 1 && (s = s.filter((c) => c !== n));
  const l = s.find(
    (c) => c.textValue.toLowerCase().startsWith(o.toLowerCase())
  );
  return l !== n ? l : void 0;
}
function kw(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var Ew = jd, Mw = qd, Pw = Zd, Dw = Qd, Ow = Jd, Nw = eu, _w = ou, Rw = su, Tw = lu, Aw = du, Iw = uu, Ww = pu, Fw = mu, Lw = hu, $w = vu, zw = "Separator", Us = "horizontal", Bw = ["horizontal", "vertical"], Su = d.forwardRef((e, t) => {
  const { decorative: n, orientation: r = Us, ...o } = e, a = Yw(r) ? r : Us, i = n ? { role: "none" } : { "aria-orientation": a === "vertical" ? a : void 0, role: "separator" };
  return /* @__PURE__ */ p(
    L.div,
    {
      "data-orientation": a,
      ...i,
      ...o,
      ref: t
    }
  );
});
Su.displayName = zw;
function Yw(e) {
  return Bw.includes(e);
}
var Hw = Su, Cu = ["PageUp", "PageDown"], ku = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], Eu = {
  "from-left": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-right": ["Home", "PageDown", "ArrowDown", "ArrowRight"],
  "from-bottom": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-top": ["Home", "PageDown", "ArrowUp", "ArrowLeft"]
}, ln = "Slider", [Ko, Vw, Gw] = Dn(ln), [Mu] = xe(ln, [
  Gw
]), [Uw, qr] = Mu(ln), Pu = d.forwardRef(
  (e, t) => {
    const {
      name: n,
      min: r = 0,
      max: o = 100,
      step: a = 1,
      orientation: s = "horizontal",
      disabled: i = !1,
      minStepsBetweenThumbs: l = 0,
      defaultValue: c = [r],
      value: f,
      onValueChange: u = () => {
      },
      onValueCommit: m = () => {
      },
      inverted: h = !1,
      form: b,
      ...g
    } = e, v = d.useRef(/* @__PURE__ */ new Set()), y = d.useRef(0), x = s === "horizontal" ? jw : Kw, [S = [], k] = ke({
      prop: f,
      defaultProp: c,
      onChange: (W) => {
        [...v.current][y.current]?.focus(), u(W);
      }
    }), C = d.useRef(S);
    function E(W) {
      const Y = Jw(S, W);
      R(W, Y);
    }
    function M(W) {
      R(W, y.current);
    }
    function O() {
      const W = C.current[y.current];
      S[y.current] !== W && m(S);
    }
    function R(W, Y, { commit: K } = { commit: !1 }) {
      const H = rx(a), Q = ox(Math.round((W - r) / a) * a + r, H), $ = kn(Q, [r, o]);
      k((q = []) => {
        const z = Zw(q, $, Y);
        if (nx(z, l * a)) {
          y.current = z.indexOf($);
          const T = String(z) !== String(q);
          return T && K && m(z), T ? z : q;
        } else
          return q;
      });
    }
    return /* @__PURE__ */ p(
      Uw,
      {
        scope: e.__scopeSlider,
        name: n,
        disabled: i,
        min: r,
        max: o,
        valueIndexToChangeRef: y,
        thumbs: v.current,
        values: S,
        orientation: s,
        form: b,
        children: /* @__PURE__ */ p(Ko.Provider, { scope: e.__scopeSlider, children: /* @__PURE__ */ p(Ko.Slot, { scope: e.__scopeSlider, children: /* @__PURE__ */ p(
          x,
          {
            "aria-disabled": i,
            "data-disabled": i ? "" : void 0,
            ...g,
            ref: t,
            onPointerDown: A(g.onPointerDown, () => {
              i || (C.current = S);
            }),
            min: r,
            max: o,
            inverted: h,
            onSlideStart: i ? void 0 : E,
            onSlideMove: i ? void 0 : M,
            onSlideEnd: i ? void 0 : O,
            onHomeKeyDown: () => !i && R(r, 0, { commit: !0 }),
            onEndKeyDown: () => !i && R(o, S.length - 1, { commit: !0 }),
            onStepKeyDown: ({ event: W, direction: Y }) => {
              if (!i) {
                const Q = Cu.includes(W.key) || W.shiftKey && ku.includes(W.key) ? 10 : 1, $ = y.current, q = S[$], z = a * Q * Y;
                R(q + z, $, { commit: !0 });
              }
            }
          }
        ) }) })
      }
    );
  }
);
Pu.displayName = ln;
var [Du, Ou] = Mu(ln, {
  startEdge: "left",
  endEdge: "right",
  size: "width",
  direction: 1
}), jw = d.forwardRef(
  (e, t) => {
    const {
      min: n,
      max: r,
      dir: o,
      inverted: a,
      onSlideStart: s,
      onSlideMove: i,
      onSlideEnd: l,
      onStepKeyDown: c,
      ...f
    } = e, [u, m] = d.useState(null), h = J(t, (x) => m(x)), b = d.useRef(void 0), g = It(o), v = g === "ltr", y = v && !a || !v && a;
    function w(x) {
      const S = b.current || u.getBoundingClientRect(), k = [0, S.width], E = Ha(k, y ? [n, r] : [r, n]);
      return b.current = S, E(x - S.left);
    }
    return /* @__PURE__ */ p(
      Du,
      {
        scope: e.__scopeSlider,
        startEdge: y ? "left" : "right",
        endEdge: y ? "right" : "left",
        direction: y ? 1 : -1,
        size: "width",
        children: /* @__PURE__ */ p(
          Nu,
          {
            dir: g,
            "data-orientation": "horizontal",
            ...f,
            ref: h,
            style: {
              ...f.style,
              "--radix-slider-thumb-transform": "translateX(-50%)"
            },
            onSlideStart: (x) => {
              const S = w(x.clientX);
              s?.(S);
            },
            onSlideMove: (x) => {
              const S = w(x.clientX);
              i?.(S);
            },
            onSlideEnd: () => {
              b.current = void 0, l?.();
            },
            onStepKeyDown: (x) => {
              const k = Eu[y ? "from-left" : "from-right"].includes(x.key);
              c?.({ event: x, direction: k ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), Kw = d.forwardRef(
  (e, t) => {
    const {
      min: n,
      max: r,
      inverted: o,
      onSlideStart: a,
      onSlideMove: s,
      onSlideEnd: i,
      onStepKeyDown: l,
      ...c
    } = e, f = d.useRef(null), u = J(t, f), m = d.useRef(void 0), h = !o;
    function b(g) {
      const v = m.current || f.current.getBoundingClientRect(), y = [0, v.height], x = Ha(y, h ? [r, n] : [n, r]);
      return m.current = v, x(g - v.top);
    }
    return /* @__PURE__ */ p(
      Du,
      {
        scope: e.__scopeSlider,
        startEdge: h ? "bottom" : "top",
        endEdge: h ? "top" : "bottom",
        size: "height",
        direction: h ? 1 : -1,
        children: /* @__PURE__ */ p(
          Nu,
          {
            "data-orientation": "vertical",
            ...c,
            ref: u,
            style: {
              ...c.style,
              "--radix-slider-thumb-transform": "translateY(50%)"
            },
            onSlideStart: (g) => {
              const v = b(g.clientY);
              a?.(v);
            },
            onSlideMove: (g) => {
              const v = b(g.clientY);
              s?.(v);
            },
            onSlideEnd: () => {
              m.current = void 0, i?.();
            },
            onStepKeyDown: (g) => {
              const y = Eu[h ? "from-bottom" : "from-top"].includes(g.key);
              l?.({ event: g, direction: y ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), Nu = d.forwardRef(
  (e, t) => {
    const {
      __scopeSlider: n,
      onSlideStart: r,
      onSlideMove: o,
      onSlideEnd: a,
      onHomeKeyDown: s,
      onEndKeyDown: i,
      onStepKeyDown: l,
      ...c
    } = e, f = qr(ln, n);
    return /* @__PURE__ */ p(
      L.span,
      {
        ...c,
        ref: t,
        onKeyDown: A(e.onKeyDown, (u) => {
          u.key === "Home" ? (s(u), u.preventDefault()) : u.key === "End" ? (i(u), u.preventDefault()) : Cu.concat(ku).includes(u.key) && (l(u), u.preventDefault());
        }),
        onPointerDown: A(e.onPointerDown, (u) => {
          const m = u.target;
          m.setPointerCapture(u.pointerId), u.preventDefault(), f.thumbs.has(m) ? m.focus() : r(u);
        }),
        onPointerMove: A(e.onPointerMove, (u) => {
          u.target.hasPointerCapture(u.pointerId) && o(u);
        }),
        onPointerUp: A(e.onPointerUp, (u) => {
          const m = u.target;
          m.hasPointerCapture(u.pointerId) && (m.releasePointerCapture(u.pointerId), a(u));
        })
      }
    );
  }
), _u = "SliderTrack", Ru = d.forwardRef(
  (e, t) => {
    const { __scopeSlider: n, ...r } = e, o = qr(_u, n);
    return /* @__PURE__ */ p(
      L.span,
      {
        "data-disabled": o.disabled ? "" : void 0,
        "data-orientation": o.orientation,
        ...r,
        ref: t
      }
    );
  }
);
Ru.displayName = _u;
var qo = "SliderRange", Tu = d.forwardRef(
  (e, t) => {
    const { __scopeSlider: n, ...r } = e, o = qr(qo, n), a = Ou(qo, n), s = d.useRef(null), i = J(t, s), l = o.values.length, c = o.values.map(
      (m) => Wu(m, o.min, o.max)
    ), f = l > 1 ? Math.min(...c) : 0, u = 100 - Math.max(...c);
    return /* @__PURE__ */ p(
      L.span,
      {
        "data-orientation": o.orientation,
        "data-disabled": o.disabled ? "" : void 0,
        ...r,
        ref: i,
        style: {
          ...e.style,
          [a.startEdge]: f + "%",
          [a.endEdge]: u + "%"
        }
      }
    );
  }
);
Tu.displayName = qo;
var Xo = "SliderThumb", Au = d.forwardRef(
  (e, t) => {
    const n = Vw(e.__scopeSlider), [r, o] = d.useState(null), a = J(t, (i) => o(i)), s = d.useMemo(
      () => r ? n().findIndex((i) => i.ref.current === r) : -1,
      [n, r]
    );
    return /* @__PURE__ */ p(qw, { ...e, ref: a, index: s });
  }
), qw = d.forwardRef(
  (e, t) => {
    const { __scopeSlider: n, index: r, name: o, ...a } = e, s = qr(Xo, n), i = Ou(Xo, n), [l, c] = d.useState(null), f = J(t, (w) => c(w)), u = l ? s.form || !!l.closest("form") : !0, m = Rr(l), h = s.values[r], b = h === void 0 ? 0 : Wu(h, s.min, s.max), g = Qw(r, s.values.length), v = m?.[i.size], y = v ? ex(v, b, i.direction) : 0;
    return d.useEffect(() => {
      if (l)
        return s.thumbs.add(l), () => {
          s.thumbs.delete(l);
        };
    }, [l, s.thumbs]), /* @__PURE__ */ ae(
      "span",
      {
        style: {
          transform: "var(--radix-slider-thumb-transform)",
          position: "absolute",
          [i.startEdge]: `calc(${b}% + ${y}px)`
        },
        children: [
          /* @__PURE__ */ p(Ko.ItemSlot, { scope: e.__scopeSlider, children: /* @__PURE__ */ p(
            L.span,
            {
              role: "slider",
              "aria-label": e["aria-label"] || g,
              "aria-valuemin": s.min,
              "aria-valuenow": h,
              "aria-valuemax": s.max,
              "aria-orientation": s.orientation,
              "data-orientation": s.orientation,
              "data-disabled": s.disabled ? "" : void 0,
              tabIndex: s.disabled ? void 0 : 0,
              ...a,
              ref: f,
              style: h === void 0 ? { display: "none" } : e.style,
              onFocus: A(e.onFocus, () => {
                s.valueIndexToChangeRef.current = r;
              })
            }
          ) }),
          u && /* @__PURE__ */ p(
            Iu,
            {
              name: o ?? (s.name ? s.name + (s.values.length > 1 ? "[]" : "") : void 0),
              form: s.form,
              value: h
            },
            r
          )
        ]
      }
    );
  }
);
Au.displayName = Xo;
var Xw = "RadioBubbleInput", Iu = d.forwardRef(
  ({ __scopeSlider: e, value: t, ...n }, r) => {
    const o = d.useRef(null), a = J(o, r), s = _r(t);
    return d.useEffect(() => {
      const i = o.current;
      if (!i) return;
      const l = window.HTMLInputElement.prototype, f = Object.getOwnPropertyDescriptor(l, "value").set;
      if (s !== t && f) {
        const u = new Event("input", { bubbles: !0 });
        f.call(i, t), i.dispatchEvent(u);
      }
    }, [s, t]), /* @__PURE__ */ p(
      L.input,
      {
        style: { display: "none" },
        ...n,
        ref: a,
        defaultValue: t
      }
    );
  }
);
Iu.displayName = Xw;
function Zw(e = [], t, n) {
  const r = [...e];
  return r[n] = t, r.sort((o, a) => o - a);
}
function Wu(e, t, n) {
  const a = 100 / (n - t) * (e - t);
  return kn(a, [0, 100]);
}
function Qw(e, t) {
  return t > 2 ? `Value ${e + 1} of ${t}` : t === 2 ? ["Minimum", "Maximum"][e] : void 0;
}
function Jw(e, t) {
  if (e.length === 1) return 0;
  const n = e.map((o) => Math.abs(o - t)), r = Math.min(...n);
  return n.indexOf(r);
}
function ex(e, t, n) {
  const r = e / 2, a = Ha([0, 50], [0, r]);
  return (r - a(t) * n) * n;
}
function tx(e) {
  return e.slice(0, -1).map((t, n) => e[n + 1] - t);
}
function nx(e, t) {
  if (t > 0) {
    const n = tx(e);
    return Math.min(...n) >= t;
  }
  return !0;
}
function Ha(e, t) {
  return (n) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const r = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + r * (n - e[0]);
  };
}
function rx(e) {
  return (String(e).split(".")[1] || "").length;
}
function ox(e, t) {
  const n = Math.pow(10, t);
  return Math.round(e * n) / n;
}
var ax = Pu, sx = Ru, ix = Tu, lx = Au, Xr = "Switch", [cx] = xe(Xr), [dx, ux] = cx(Xr), Fu = d.forwardRef(
  (e, t) => {
    const {
      __scopeSwitch: n,
      name: r,
      checked: o,
      defaultChecked: a,
      required: s,
      disabled: i,
      value: l = "on",
      onCheckedChange: c,
      form: f,
      ...u
    } = e, [m, h] = d.useState(null), b = J(t, (x) => h(x)), g = d.useRef(!1), v = m ? f || !!m.closest("form") : !0, [y, w] = ke({
      prop: o,
      defaultProp: a ?? !1,
      onChange: c,
      caller: Xr
    });
    return /* @__PURE__ */ ae(dx, { scope: n, checked: y, disabled: i, children: [
      /* @__PURE__ */ p(
        L.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": y,
          "aria-required": s,
          "data-state": Bu(y),
          "data-disabled": i ? "" : void 0,
          disabled: i,
          value: l,
          ...u,
          ref: b,
          onClick: A(e.onClick, (x) => {
            w((S) => !S), v && (g.current = x.isPropagationStopped(), g.current || x.stopPropagation());
          })
        }
      ),
      v && /* @__PURE__ */ p(
        zu,
        {
          control: m,
          bubbles: !g.current,
          name: r,
          value: l,
          checked: y,
          required: s,
          disabled: i,
          form: f,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
Fu.displayName = Xr;
var Lu = "SwitchThumb", $u = d.forwardRef(
  (e, t) => {
    const { __scopeSwitch: n, ...r } = e, o = ux(Lu, n);
    return /* @__PURE__ */ p(
      L.span,
      {
        "data-state": Bu(o.checked),
        "data-disabled": o.disabled ? "" : void 0,
        ...r,
        ref: t
      }
    );
  }
);
$u.displayName = Lu;
var fx = "SwitchBubbleInput", zu = d.forwardRef(
  ({
    __scopeSwitch: e,
    control: t,
    checked: n,
    bubbles: r = !0,
    ...o
  }, a) => {
    const s = d.useRef(null), i = J(s, a), l = _r(n), c = Rr(t);
    return d.useEffect(() => {
      const f = s.current;
      if (!f) return;
      const u = window.HTMLInputElement.prototype, h = Object.getOwnPropertyDescriptor(
        u,
        "checked"
      ).set;
      if (l !== n && h) {
        const b = new Event("click", { bubbles: r });
        h.call(f, n), f.dispatchEvent(b);
      }
    }, [l, n, r]), /* @__PURE__ */ p(
      "input",
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: n,
        ...o,
        tabIndex: -1,
        ref: i,
        style: {
          ...o.style,
          ...c,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
zu.displayName = fx;
function Bu(e) {
  return e ? "checked" : "unchecked";
}
var px = Fu, mx = $u, Yu = "Toggle", Va = d.forwardRef((e, t) => {
  const { pressed: n, defaultPressed: r, onPressedChange: o, ...a } = e, [s, i] = ke({
    prop: n,
    onChange: o,
    defaultProp: r ?? !1,
    caller: Yu
  });
  return /* @__PURE__ */ p(
    L.button,
    {
      type: "button",
      "aria-pressed": s,
      "data-state": s ? "on" : "off",
      "data-disabled": e.disabled ? "" : void 0,
      ...a,
      ref: t,
      onClick: A(e.onClick, () => {
        e.disabled || i(!s);
      })
    }
  );
});
Va.displayName = Yu;
var hx = Va, kt = "ToggleGroup", [Hu] = xe(kt, [
  zr
]), Vu = zr(), Ga = N.forwardRef((e, t) => {
  const { type: n, ...r } = e;
  if (n === "single")
    return /* @__PURE__ */ p(gx, { ...r, ref: t });
  if (n === "multiple")
    return /* @__PURE__ */ p(vx, { ...r, ref: t });
  throw new Error(`Missing prop \`type\` expected on \`${kt}\``);
});
Ga.displayName = kt;
var [Gu, Uu] = Hu(kt), gx = N.forwardRef((e, t) => {
  const {
    value: n,
    defaultValue: r,
    onValueChange: o = () => {
    },
    ...a
  } = e, [s, i] = ke({
    prop: n,
    defaultProp: r ?? "",
    onChange: o,
    caller: kt
  });
  return /* @__PURE__ */ p(
    Gu,
    {
      scope: e.__scopeToggleGroup,
      type: "single",
      value: N.useMemo(() => s ? [s] : [], [s]),
      onItemActivate: i,
      onItemDeactivate: N.useCallback(() => i(""), [i]),
      children: /* @__PURE__ */ p(ju, { ...a, ref: t })
    }
  );
}), vx = N.forwardRef((e, t) => {
  const {
    value: n,
    defaultValue: r,
    onValueChange: o = () => {
    },
    ...a
  } = e, [s, i] = ke({
    prop: n,
    defaultProp: r ?? [],
    onChange: o,
    caller: kt
  }), l = N.useCallback(
    (f) => i((u = []) => [...u, f]),
    [i]
  ), c = N.useCallback(
    (f) => i((u = []) => u.filter((m) => m !== f)),
    [i]
  );
  return /* @__PURE__ */ p(
    Gu,
    {
      scope: e.__scopeToggleGroup,
      type: "multiple",
      value: s,
      onItemActivate: l,
      onItemDeactivate: c,
      children: /* @__PURE__ */ p(ju, { ...a, ref: t })
    }
  );
});
Ga.displayName = kt;
var [bx, yx] = Hu(kt), ju = N.forwardRef(
  (e, t) => {
    const {
      __scopeToggleGroup: n,
      disabled: r = !1,
      rovingFocus: o = !0,
      orientation: a,
      dir: s,
      loop: i = !0,
      ...l
    } = e, c = Vu(n), f = It(s), u = { role: "group", dir: f, ...l };
    return /* @__PURE__ */ p(bx, { scope: n, rovingFocus: o, disabled: r, children: o ? /* @__PURE__ */ p(
      Pc,
      {
        asChild: !0,
        ...c,
        orientation: a,
        dir: f,
        loop: i,
        children: /* @__PURE__ */ p(L.div, { ...u, ref: t })
      }
    ) : /* @__PURE__ */ p(L.div, { ...u, ref: t }) });
  }
), vr = "ToggleGroupItem", Ku = N.forwardRef(
  (e, t) => {
    const n = Uu(vr, e.__scopeToggleGroup), r = yx(vr, e.__scopeToggleGroup), o = Vu(e.__scopeToggleGroup), a = n.value.includes(e.value), s = r.disabled || e.disabled, i = { ...e, pressed: a, disabled: s }, l = N.useRef(null);
    return r.rovingFocus ? /* @__PURE__ */ p(
      Dc,
      {
        asChild: !0,
        ...o,
        focusable: !s,
        active: a,
        ref: l,
        children: /* @__PURE__ */ p(js, { ...i, ref: t })
      }
    ) : /* @__PURE__ */ p(js, { ...i, ref: t });
  }
);
Ku.displayName = vr;
var js = N.forwardRef(
  (e, t) => {
    const { __scopeToggleGroup: n, value: r, ...o } = e, a = Uu(vr, n), s = { role: "radio", "aria-checked": e.pressed, "aria-pressed": void 0 }, i = a.type === "single" ? s : void 0;
    return /* @__PURE__ */ p(
      Va,
      {
        ...i,
        ...o,
        ref: t,
        onPressedChange: (l) => {
          l ? a.onItemActivate(r) : a.onItemDeactivate(r);
        }
      }
    );
  }
), wx = Ga, xx = Ku, [Zr] = xe("Tooltip", [
  yt
]), Qr = yt(), qu = "TooltipProvider", Sx = 700, Zo = "tooltip.open", [Cx, Ua] = Zr(qu), Xu = (e) => {
  const {
    __scopeTooltip: t,
    delayDuration: n = Sx,
    skipDelayDuration: r = 300,
    disableHoverableContent: o = !1,
    children: a
  } = e, s = d.useRef(!0), i = d.useRef(!1), l = d.useRef(0);
  return d.useEffect(() => {
    const c = l.current;
    return () => window.clearTimeout(c);
  }, []), /* @__PURE__ */ p(
    Cx,
    {
      scope: t,
      isOpenDelayedRef: s,
      delayDuration: n,
      onOpen: d.useCallback(() => {
        window.clearTimeout(l.current), s.current = !1;
      }, []),
      onClose: d.useCallback(() => {
        window.clearTimeout(l.current), l.current = window.setTimeout(
          () => s.current = !0,
          r
        );
      }, [r]),
      isPointerInTransitRef: i,
      onPointerInTransitChange: d.useCallback((c) => {
        i.current = c;
      }, []),
      disableHoverableContent: o,
      children: a
    }
  );
};
Xu.displayName = qu;
var En = "Tooltip", [kx, $n] = Zr(En), Zu = (e) => {
  const {
    __scopeTooltip: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: a,
    disableHoverableContent: s,
    delayDuration: i
  } = e, l = Ua(En, e.__scopeTooltip), c = Qr(t), [f, u] = d.useState(null), m = ge(), h = d.useRef(0), b = s ?? l.disableHoverableContent, g = i ?? l.delayDuration, v = d.useRef(!1), [y, w] = ke({
    prop: r,
    defaultProp: o ?? !1,
    onChange: (E) => {
      E ? (l.onOpen(), document.dispatchEvent(new CustomEvent(Zo))) : l.onClose(), a?.(E);
    },
    caller: En
  }), x = d.useMemo(() => y ? v.current ? "delayed-open" : "instant-open" : "closed", [y]), S = d.useCallback(() => {
    window.clearTimeout(h.current), h.current = 0, v.current = !1, w(!0);
  }, [w]), k = d.useCallback(() => {
    window.clearTimeout(h.current), h.current = 0, w(!1);
  }, [w]), C = d.useCallback(() => {
    window.clearTimeout(h.current), h.current = window.setTimeout(() => {
      v.current = !0, w(!0), h.current = 0;
    }, g);
  }, [g, w]);
  return d.useEffect(() => () => {
    h.current && (window.clearTimeout(h.current), h.current = 0);
  }, []), /* @__PURE__ */ p(Rn, { ...c, children: /* @__PURE__ */ p(
    kx,
    {
      scope: t,
      contentId: m,
      open: y,
      stateAttribute: x,
      trigger: f,
      onTriggerChange: u,
      onTriggerEnter: d.useCallback(() => {
        l.isOpenDelayedRef.current ? C() : S();
      }, [l.isOpenDelayedRef, C, S]),
      onTriggerLeave: d.useCallback(() => {
        b ? k() : (window.clearTimeout(h.current), h.current = 0);
      }, [k, b]),
      onOpen: S,
      onClose: k,
      disableHoverableContent: b,
      children: n
    }
  ) });
};
Zu.displayName = En;
var Qo = "TooltipTrigger", Qu = d.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, o = $n(Qo, n), a = Ua(Qo, n), s = Qr(n), i = d.useRef(null), l = J(t, i, o.onTriggerChange), c = d.useRef(!1), f = d.useRef(!1), u = d.useCallback(() => c.current = !1, []);
    return d.useEffect(() => () => document.removeEventListener("pointerup", u), [u]), /* @__PURE__ */ p(Tn, { asChild: !0, ...s, children: /* @__PURE__ */ p(
      L.button,
      {
        "aria-describedby": o.open ? o.contentId : void 0,
        "data-state": o.stateAttribute,
        ...r,
        ref: l,
        onPointerMove: A(e.onPointerMove, (m) => {
          m.pointerType !== "touch" && !f.current && !a.isPointerInTransitRef.current && (o.onTriggerEnter(), f.current = !0);
        }),
        onPointerLeave: A(e.onPointerLeave, () => {
          o.onTriggerLeave(), f.current = !1;
        }),
        onPointerDown: A(e.onPointerDown, () => {
          o.open && o.onClose(), c.current = !0, document.addEventListener("pointerup", u, { once: !0 });
        }),
        onFocus: A(e.onFocus, () => {
          c.current || o.onOpen();
        }),
        onBlur: A(e.onBlur, o.onClose),
        onClick: A(e.onClick, o.onClose)
      }
    ) });
  }
);
Qu.displayName = Qo;
var ja = "TooltipPortal", [Ex, Mx] = Zr(ja, {
  forceMount: void 0
}), Ju = (e) => {
  const { __scopeTooltip: t, forceMount: n, children: r, container: o } = e, a = $n(ja, t);
  return /* @__PURE__ */ p(Ex, { scope: t, forceMount: n, children: /* @__PURE__ */ p(Ce, { present: n || a.open, children: /* @__PURE__ */ p(rn, { asChild: !0, container: o, children: r }) }) });
};
Ju.displayName = ja;
var Jt = "TooltipContent", ef = d.forwardRef(
  (e, t) => {
    const n = Mx(Jt, e.__scopeTooltip), { forceMount: r = n.forceMount, side: o = "top", ...a } = e, s = $n(Jt, e.__scopeTooltip);
    return /* @__PURE__ */ p(Ce, { present: r || s.open, children: s.disableHoverableContent ? /* @__PURE__ */ p(tf, { side: o, ...a, ref: t }) : /* @__PURE__ */ p(Px, { side: o, ...a, ref: t }) });
  }
), Px = d.forwardRef((e, t) => {
  const n = $n(Jt, e.__scopeTooltip), r = Ua(Jt, e.__scopeTooltip), o = d.useRef(null), a = J(t, o), [s, i] = d.useState(null), { trigger: l, onClose: c } = n, f = o.current, { onPointerInTransitChange: u } = r, m = d.useCallback(() => {
    i(null), u(!1);
  }, [u]), h = d.useCallback(
    (b, g) => {
      const v = b.currentTarget, y = { x: b.clientX, y: b.clientY }, w = _x(y, v.getBoundingClientRect()), x = Rx(y, w), S = Tx(g.getBoundingClientRect()), k = Ix([...x, ...S]);
      i(k), u(!0);
    },
    [u]
  );
  return d.useEffect(() => () => m(), [m]), d.useEffect(() => {
    if (l && f) {
      const b = (v) => h(v, f), g = (v) => h(v, l);
      return l.addEventListener("pointerleave", b), f.addEventListener("pointerleave", g), () => {
        l.removeEventListener("pointerleave", b), f.removeEventListener("pointerleave", g);
      };
    }
  }, [l, f, h, m]), d.useEffect(() => {
    if (s) {
      const b = (g) => {
        const v = g.target, y = { x: g.clientX, y: g.clientY }, w = l?.contains(v) || f?.contains(v), x = !Ax(y, s);
        w ? m() : x && (m(), c());
      };
      return document.addEventListener("pointermove", b), () => document.removeEventListener("pointermove", b);
    }
  }, [l, f, s, c, m]), /* @__PURE__ */ p(tf, { ...e, ref: a });
}), [Dx, Ox] = Zr(En, { isInside: !1 }), Nx = /* @__PURE__ */ Ii("TooltipContent"), tf = d.forwardRef(
  (e, t) => {
    const {
      __scopeTooltip: n,
      children: r,
      "aria-label": o,
      onEscapeKeyDown: a,
      onPointerDownOutside: s,
      ...i
    } = e, l = $n(Jt, n), c = Qr(n), { onClose: f } = l;
    return d.useEffect(() => (document.addEventListener(Zo, f), () => document.removeEventListener(Zo, f)), [f]), d.useEffect(() => {
      if (l.trigger) {
        const u = (m) => {
          m.target?.contains(l.trigger) && f();
        };
        return window.addEventListener("scroll", u, { capture: !0 }), () => window.removeEventListener("scroll", u, { capture: !0 });
      }
    }, [l.trigger, f]), /* @__PURE__ */ p(
      nn,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: a,
        onPointerDownOutside: s,
        onFocusOutside: (u) => u.preventDefault(),
        onDismiss: f,
        children: /* @__PURE__ */ ae(
          Lr,
          {
            "data-state": l.stateAttribute,
            ...c,
            ...i,
            ref: t,
            style: {
              ...i.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ p(Nx, { children: r }),
              /* @__PURE__ */ p(Dx, { scope: n, isInside: !0, children: /* @__PURE__ */ p(pm, { id: l.contentId, role: "tooltip", children: o || r }) })
            ]
          }
        )
      }
    );
  }
);
ef.displayName = Jt;
var nf = "TooltipArrow", rf = d.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, o = Qr(n);
    return Ox(
      nf,
      n
    ).isInside ? null : /* @__PURE__ */ p($r, { ...o, ...r, ref: t });
  }
);
rf.displayName = nf;
function _x(e, t) {
  const n = Math.abs(t.top - e.y), r = Math.abs(t.bottom - e.y), o = Math.abs(t.right - e.x), a = Math.abs(t.left - e.x);
  switch (Math.min(n, r, o, a)) {
    case a:
      return "left";
    case o:
      return "right";
    case n:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function Rx(e, t, n = 5) {
  const r = [];
  switch (t) {
    case "top":
      r.push(
        { x: e.x - n, y: e.y + n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "bottom":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x + n, y: e.y - n }
      );
      break;
    case "left":
      r.push(
        { x: e.x + n, y: e.y - n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "right":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x - n, y: e.y + n }
      );
      break;
  }
  return r;
}
function Tx(e) {
  const { top: t, right: n, bottom: r, left: o } = e;
  return [
    { x: o, y: t },
    { x: n, y: t },
    { x: n, y: r },
    { x: o, y: r }
  ];
}
function Ax(e, t) {
  const { x: n, y: r } = e;
  let o = !1;
  for (let a = 0, s = t.length - 1; a < t.length; s = a++) {
    const i = t[a], l = t[s], c = i.x, f = i.y, u = l.x, m = l.y;
    f > r != m > r && n < (u - c) * (r - f) / (m - f) + c && (o = !o);
  }
  return o;
}
function Ix(e) {
  const t = e.slice();
  return t.sort((n, r) => n.x < r.x ? -1 : n.x > r.x ? 1 : n.y < r.y ? -1 : n.y > r.y ? 1 : 0), Wx(t);
}
function Wx(e) {
  if (e.length <= 1) return e.slice();
  const t = [];
  for (let r = 0; r < e.length; r++) {
    const o = e[r];
    for (; t.length >= 2; ) {
      const a = t[t.length - 1], s = t[t.length - 2];
      if ((a.x - s.x) * (o.y - s.y) >= (a.y - s.y) * (o.x - s.x)) t.pop();
      else break;
    }
    t.push(o);
  }
  t.pop();
  const n = [];
  for (let r = e.length - 1; r >= 0; r--) {
    const o = e[r];
    for (; n.length >= 2; ) {
      const a = n[n.length - 1], s = n[n.length - 2];
      if ((a.x - s.x) * (o.y - s.y) >= (a.y - s.y) * (o.x - s.x)) n.pop();
      else break;
    }
    n.push(o);
  }
  return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
var Fx = Xu, Lx = Zu, $x = Qu, zx = Ju, Bx = ef, Yx = rf;
function Hx({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ p(
    Sy,
    {
      "data-slot": "label",
      className: P(
        "flex items-center gap-2 text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
        e
      ),
      ...t
    }
  );
}
function Vx({
  className: e,
  orientation: t = "horizontal",
  decorative: n = !0,
  ...r
}) {
  return /* @__PURE__ */ p(
    Hw,
    {
      "data-slot": "separator",
      decorative: n,
      orientation: t,
      className: P(
        "shrink-0 bg-border data-horizontal:h-px data-horizontal:w-full data-vertical:w-px data-vertical:self-stretch",
        e
      ),
      ...r
    }
  );
}
function Jk({ className: e, ...t }) {
  return /* @__PURE__ */ p(
    "fieldset",
    {
      "data-slot": "field-set",
      className: P(
        "flex flex-col gap-4 has-[>[data-slot=checkbox-group]]:gap-3 has-[>[data-slot=radio-group]]:gap-3",
        e
      ),
      ...t
    }
  );
}
function eE({
  className: e,
  variant: t = "legend",
  ...n
}) {
  return /* @__PURE__ */ p(
    "legend",
    {
      "data-slot": "field-legend",
      "data-variant": t,
      className: P(
        "mb-1.5 font-medium data-[variant=label]:text-sm data-[variant=legend]:text-base",
        e
      ),
      ...n
    }
  );
}
function tE({ className: e, ...t }) {
  return /* @__PURE__ */ p(
    "div",
    {
      "data-slot": "field-group",
      className: P(
        "group/field-group @container/field-group flex w-full flex-col gap-5 data-[slot=checkbox-group]:gap-3 *:data-[slot=field-group]:gap-4",
        e
      ),
      ...t
    }
  );
}
const Gx = tn(
  "group/field flex w-full gap-2 data-[invalid=true]:text-destructive",
  {
    variants: {
      orientation: {
        vertical: "flex-col *:w-full [&>.sr-only]:w-auto",
        horizontal: "flex-row items-center has-[>[data-slot=field-content]]:items-start *:data-[slot=field-label]:flex-auto has-[>[data-slot=field-content]]:[&>[role=checkbox],[role=radio]]:mt-px",
        responsive: "flex-col *:w-full @md/field-group:flex-row @md/field-group:items-center @md/field-group:*:w-auto @md/field-group:has-[>[data-slot=field-content]]:items-start @md/field-group:*:data-[slot=field-label]:flex-auto [&>.sr-only]:w-auto @md/field-group:has-[>[data-slot=field-content]]:[&>[role=checkbox],[role=radio]]:mt-px"
      }
    },
    defaultVariants: {
      orientation: "vertical"
    }
  }
);
function Ux({
  className: e,
  orientation: t = "vertical",
  ...n
}) {
  return /* @__PURE__ */ p(
    "div",
    {
      role: "group",
      "data-slot": "field",
      "data-orientation": t,
      className: P(Gx({ orientation: t }), e),
      ...n
    }
  );
}
function nE({ className: e, ...t }) {
  return /* @__PURE__ */ p(
    "div",
    {
      "data-slot": "field-content",
      className: P(
        "group/field-content flex flex-1 flex-col gap-0.5 leading-snug",
        e
      ),
      ...t
    }
  );
}
function rE({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ p(
    Hx,
    {
      "data-slot": "field-label",
      className: P(
        "group/field-label peer/field-label flex w-fit gap-2 leading-snug group-data-[disabled=true]/field:opacity-50 has-data-checked:border-primary/30 has-data-checked:bg-primary/5 has-[>[data-slot=field]]:rounded-lg has-[>[data-slot=field]]:border *:data-[slot=field]:p-2.5 dark:has-data-checked:border-primary/20 dark:has-data-checked:bg-primary/10",
        "has-[>[data-slot=field]]:w-full has-[>[data-slot=field]]:flex-col",
        e
      ),
      ...t
    }
  );
}
function oE({ className: e, ...t }) {
  return /* @__PURE__ */ p(
    "div",
    {
      "data-slot": "field-label",
      className: P(
        "flex w-fit items-center gap-2 text-sm leading-snug font-medium group-data-[disabled=true]/field:opacity-50",
        e
      ),
      ...t
    }
  );
}
function aE({ className: e, ...t }) {
  return /* @__PURE__ */ p(
    "p",
    {
      "data-slot": "field-description",
      className: P(
        "text-left text-sm leading-normal font-normal text-muted-foreground group-has-data-horizontal/field:text-balance [[data-variant=legend]+&]:-mt-1.5",
        "last:mt-0 nth-last-2:-mt-1",
        "[&>a]:underline [&>a]:underline-offset-4 [&>a:hover]:text-primary",
        e
      ),
      ...t
    }
  );
}
function sE({
  children: e,
  className: t,
  ...n
}) {
  return /* @__PURE__ */ ae(
    "div",
    {
      "data-slot": "field-separator",
      "data-content": !!e,
      className: P(
        "relative -my-2 h-5 text-sm group-data-[variant=outline]/field-group:-mb-2",
        t
      ),
      ...n,
      children: [
        /* @__PURE__ */ p(Vx, { className: "absolute inset-0 top-1/2" }),
        e && /* @__PURE__ */ p(
          "span",
          {
            className: "relative mx-auto block w-fit bg-background px-2 text-muted-foreground",
            "data-slot": "field-separator-content",
            children: e
          }
        )
      ]
    }
  );
}
function iE({
  className: e,
  children: t,
  errors: n,
  ...r
}) {
  const o = wn(() => {
    if (t)
      return t;
    if (!n?.length)
      return null;
    const a = [
      ...new Map(n.map((s) => [s?.message, s])).values()
    ];
    return a?.length === 1 ? a[0]?.message : /* @__PURE__ */ p("ul", { className: "ml-4 flex list-disc flex-col gap-1", children: a.map(
      (s, i) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: no stable key available for error list
        s?.message && /* @__PURE__ */ p("li", { children: s.message }, i)
      )
    ) });
  }, [t, n]);
  return o ? /* @__PURE__ */ p(
    "div",
    {
      role: "alert",
      "data-slot": "field-error",
      className: P("text-sm font-normal text-destructive", e),
      ...r,
      children: o
    }
  ) : null;
}
const Jo = tn(
  "group/button inline-flex shrink-0 cursor-pointer items-center justify-center rounded-lg border border-transparent bg-clip-padding text-sm font-medium whitespace-nowrap transition-all outline-none select-none focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 active:translate-y-px disabled:pointer-events-none disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
  // override: added cursor-pointer so buttons always show a pointer cursor
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground [a]:hover:bg-primary/80",
        outline: "border-border bg-background hover:bg-muted hover:text-foreground aria-expanded:bg-muted aria-expanded:text-foreground dark:border-input dark:bg-input/30 dark:hover:bg-input/50",
        secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80 aria-expanded:bg-secondary aria-expanded:text-secondary-foreground",
        ghost: "hover:bg-muted hover:text-foreground aria-expanded:bg-muted aria-expanded:text-foreground dark:hover:bg-muted/50",
        destructive: "bg-destructive/10 text-destructive hover:bg-destructive/20 focus-visible:border-destructive/40 focus-visible:ring-destructive/20 dark:bg-destructive/20 dark:hover:bg-destructive/30 dark:focus-visible:ring-destructive/40",
        link: "text-primary underline-offset-4 hover:underline"
      },
      size: {
        default: "h-8 gap-1.5 px-2.5 has-data-[icon=inline-end]:pr-2 has-data-[icon=inline-start]:pl-2",
        xs: "h-6 gap-1 rounded-[min(var(--radius-md),10px)] px-2 text-xs in-data-[slot=button-group]:rounded-lg has-data-[icon=inline-end]:pr-1.5 has-data-[icon=inline-start]:pl-1.5 [&_svg:not([class*='size-'])]:size-3",
        sm: "h-7 gap-1 rounded-[min(var(--radius-md),12px)] px-2.5 text-[0.8rem] in-data-[slot=button-group]:rounded-lg has-data-[icon=inline-end]:pr-1.5 has-data-[icon=inline-start]:pl-1.5 [&_svg:not([class*='size-'])]:size-3.5",
        lg: "h-9 gap-1.5 px-2.5 has-data-[icon=inline-end]:pr-3 has-data-[icon=inline-start]:pl-3",
        icon: "size-8",
        "icon-xs": "size-6 rounded-[min(var(--radius-md),10px)] in-data-[slot=button-group]:rounded-lg [&_svg:not([class*='size-'])]:size-3",
        "icon-sm": "size-7 rounded-[min(var(--radius-md),12px)] in-data-[slot=button-group]:rounded-lg",
        "icon-lg": "size-9"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
);
function Et({
  className: e,
  variant: t = "default",
  size: n = "default",
  asChild: r = !1,
  ...o
}) {
  return /* @__PURE__ */ p(
    r ? Ti : "button",
    {
      "data-slot": "button",
      "data-variant": t,
      "data-size": n,
      className: P(Jo({ variant: t, size: n, className: e })),
      ...o
    }
  );
}
function lE({ className: e, ...t }) {
  return /* @__PURE__ */ p(
    "div",
    {
      "data-slot": "button-group",
      role: "group",
      className: P(
        "flex h-7 items-center -space-x-px [&>*:first-child]:rounded-l-md [&>*:first-child]:rounded-r-none [&>*:last-child]:rounded-l-none [&>*:last-child]:rounded-r-md [&>*:not(:first-child):not(:last-child)]:rounded-none",
        e
      ),
      ...t
    }
  );
}
const of = (...e) => e.filter((t, n, r) => !!t && t.trim() !== "" && r.indexOf(t) === n).join(" ").trim();
const jx = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const Kx = (e) => e.replace(
  /^([A-Z])|[\s-_]+(\w)/g,
  (t, n, r) => r ? r.toUpperCase() : n.toLowerCase()
);
const Ks = (e) => {
  const t = Kx(e);
  return t.charAt(0).toUpperCase() + t.slice(1);
};
var ko = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
const qx = (e) => {
  for (const t in e)
    if (t.startsWith("aria-") || t === "role" || t === "title")
      return !0;
  return !1;
}, Xx = hi({}), Zx = () => mi(Xx), Qx = gi(
  ({ color: e, size: t, strokeWidth: n, absoluteStrokeWidth: r, className: o = "", children: a, iconNode: s, ...i }, l) => {
    const {
      size: c = 24,
      strokeWidth: f = 2,
      absoluteStrokeWidth: u = !1,
      color: m = "currentColor",
      className: h = ""
    } = Zx() ?? {}, b = r ?? u ? Number(n ?? f) * 24 / Number(t ?? c) : n ?? f;
    return To(
      "svg",
      {
        ref: l,
        ...ko,
        width: t ?? c ?? ko.width,
        height: t ?? c ?? ko.height,
        stroke: e ?? m,
        strokeWidth: b,
        className: of("lucide", h, o),
        ...!a && !qx(i) && { "aria-hidden": "true" },
        ...i
      },
      [
        ...s.map(([g, v]) => To(g, v)),
        ...Array.isArray(a) ? a : [a]
      ]
    );
  }
);
const it = (e, t) => {
  const n = gi(
    ({ className: r, ...o }, a) => To(Qx, {
      ref: a,
      iconNode: t,
      className: of(
        `lucide-${jx(Ks(e))}`,
        `lucide-${e}`,
        r
      ),
      ...o
    })
  );
  return n.displayName = Ks(e), n;
};
const Jx = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }]
], eS = it("calendar", Jx);
const tS = [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]], Jr = it("check", tS);
const nS = [["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]], eo = it("chevron-down", nS);
const rS = [["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]], af = it("chevron-left", rS);
const oS = [["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]], Ka = it("chevron-right", oS);
const aS = [["path", { d: "m18 15-6-6-6 6", key: "153udz" }]], sf = it("chevron-up", aS);
const sS = [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "19", cy: "12", r: "1", key: "1wjl8i" }],
  ["circle", { cx: "5", cy: "12", r: "1", key: "1pcz8c" }]
], iS = it("ellipsis", sS);
const lS = [
  ["path", { d: "m21 21-4.34-4.34", key: "14j7rj" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }]
], cS = it("search", lS);
const dS = [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
], lf = it("x", dS);
function cE({
  ...e
}) {
  return /* @__PURE__ */ p(Ew, { "data-slot": "select", ...e });
}
function dE({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ p(
    Rw,
    {
      "data-slot": "select-group",
      className: P("scroll-my-1 p-1", e),
      ...t
    }
  );
}
function uE({
  ...e
}) {
  return /* @__PURE__ */ p(Pw, { "data-slot": "select-value", ...e });
}
function fE({
  className: e,
  size: t = "default",
  children: n,
  ...r
}) {
  return /* @__PURE__ */ ae(
    Mw,
    {
      "data-slot": "select-trigger",
      "data-size": t,
      className: P(
        "flex w-fit items-center justify-between gap-1.5 rounded-lg border border-input bg-transparent py-2 pr-2 pl-2.5 text-sm whitespace-nowrap transition-colors outline-none select-none focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 data-placeholder:text-muted-foreground data-[size=default]:h-8 data-[size=sm]:h-7 data-[size=sm]:rounded-[min(var(--radius-md),10px)] *:data-[slot=select-value]:line-clamp-1 *:data-[slot=select-value]:flex *:data-[slot=select-value]:items-center *:data-[slot=select-value]:gap-1.5 dark:bg-input/30 dark:hover:bg-input/50 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...r,
      children: [
        n,
        /* @__PURE__ */ p(Dw, { asChild: !0, children: /* @__PURE__ */ p(eo, { className: "pointer-events-none size-4 text-muted-foreground" }) })
      ]
    }
  );
}
function pE({
  className: e,
  children: t,
  position: n = "item-aligned",
  align: r = "center",
  ...o
}) {
  return /* @__PURE__ */ p(Ow, { children: /* @__PURE__ */ ae(
    Nw,
    {
      "data-slot": "select-content",
      "data-align-trigger": n === "item-aligned",
      className: P(
        "relative z-50 max-h-(--radix-select-content-available-height) min-w-36 origin-(--radix-select-content-transform-origin) overflow-x-hidden overflow-y-auto rounded-lg bg-popover text-popover-foreground shadow-md ring-1 ring-foreground/10 duration-100 data-[align-trigger=true]:animate-none data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95",
        n === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
        e
      ),
      position: n,
      align: r,
      ...o,
      children: [
        /* @__PURE__ */ p(uS, {}),
        /* @__PURE__ */ p(
          _w,
          {
            "data-position": n,
            className: P(
              "data-[position=popper]:h-(--radix-select-trigger-height) data-[position=popper]:w-full data-[position=popper]:min-w-(--radix-select-trigger-width)",
              n === "popper" && ""
            ),
            children: t
          }
        ),
        /* @__PURE__ */ p(fS, {})
      ]
    }
  ) });
}
function mE({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ p(
    Tw,
    {
      "data-slot": "select-label",
      className: P("px-1.5 py-1 text-xs text-muted-foreground", e),
      ...t
    }
  );
}
function hE({
  className: e,
  children: t,
  ...n
}) {
  return /* @__PURE__ */ ae(
    Aw,
    {
      "data-slot": "select-item",
      className: P(
        "relative flex w-full cursor-default items-center gap-1.5 rounded-md py-1 pr-8 pl-1.5 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground not-data-[variant=destructive]:focus:**:text-accent-foreground data-disabled:pointer-events-none data-disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 *:[span]:last:flex *:[span]:last:items-center *:[span]:last:gap-2",
        e
      ),
      ...n,
      children: [
        /* @__PURE__ */ p("span", { className: "pointer-events-none absolute right-2 flex size-4 items-center justify-center", children: /* @__PURE__ */ p(Ww, { children: /* @__PURE__ */ p(Jr, { className: "pointer-events-none" }) }) }),
        /* @__PURE__ */ p(Iw, { children: t })
      ]
    }
  );
}
function gE({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ p(
    $w,
    {
      "data-slot": "select-separator",
      className: P("pointer-events-none -mx-1 my-1 h-px bg-border", e),
      ...t
    }
  );
}
function uS({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ p(
    Fw,
    {
      "data-slot": "select-scroll-up-button",
      className: P(
        "z-10 flex cursor-default items-center justify-center bg-popover py-1 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...t,
      children: /* @__PURE__ */ p(sf, {})
    }
  );
}
function fS({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ p(
    Lw,
    {
      "data-slot": "select-scroll-down-button",
      className: P(
        "z-10 flex cursor-default items-center justify-center bg-popover py-1 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...t,
      children: /* @__PURE__ */ p(eo, {})
    }
  );
}
function vE({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ p(
    ql,
    {
      "data-slot": "checkbox",
      className: P(
        "peer relative flex size-4 shrink-0 items-center justify-center rounded-[4px] border border-input transition-colors outline-none group-has-disabled/field:opacity-50 after:absolute after:-inset-x-3 after:-inset-y-2 focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 aria-invalid:aria-checked:border-primary dark:bg-input/30 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40 data-checked:border-primary data-checked:bg-primary data-checked:text-primary-foreground dark:data-checked:bg-primary",
        e
      ),
      ...t,
      children: /* @__PURE__ */ p(
        Zl,
        {
          "data-slot": "checkbox-indicator",
          className: "grid place-content-center text-current transition-none [&>svg]:size-3.5",
          children: /* @__PURE__ */ p(Jr, {})
        }
      )
    }
  );
}
function bE({
  className: e,
  size: t = "default",
  ...n
}) {
  return /* @__PURE__ */ p(
    px,
    {
      "data-slot": "switch",
      "data-size": t,
      className: P(
        "peer group/switch relative inline-flex shrink-0 items-center rounded-full border border-transparent transition-all outline-none after:absolute after:-inset-x-3 after:-inset-y-2 focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 data-[size=default]:h-[18.4px] data-[size=default]:w-[32px] data-[size=sm]:h-[14px] data-[size=sm]:w-[24px] dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40 data-checked:bg-primary data-unchecked:bg-input dark:data-unchecked:bg-input/80 data-disabled:cursor-not-allowed data-disabled:opacity-50",
        e
      ),
      ...n,
      children: /* @__PURE__ */ p(
        mx,
        {
          "data-slot": "switch-thumb",
          className: "pointer-events-none block rounded-full bg-background ring-0 transition-transform group-data-[size=default]/switch:size-4 group-data-[size=sm]/switch:size-3 group-data-[size=default]/switch:data-checked:translate-x-[calc(100%-2px)] group-data-[size=sm]/switch:data-checked:translate-x-[calc(100%-2px)] dark:data-checked:bg-primary-foreground group-data-[size=default]/switch:data-unchecked:translate-x-0 group-data-[size=sm]/switch:data-unchecked:translate-x-0 dark:data-unchecked:bg-foreground"
        }
      )
    }
  );
}
function yE({
  className: e,
  defaultValue: t,
  value: n,
  min: r = 0,
  max: o = 100,
  ...a
}) {
  const s = d.useMemo(
    () => Array.isArray(n) ? n : Array.isArray(t) ? t : [r, o],
    [n, t, r, o]
  );
  return /* @__PURE__ */ ae(
    ax,
    {
      "data-slot": "slider",
      defaultValue: t,
      value: n,
      min: r,
      max: o,
      className: P(
        "relative flex w-full touch-none items-center select-none data-disabled:opacity-50 data-vertical:h-full data-vertical:min-h-40 data-vertical:w-auto data-vertical:flex-col",
        e
      ),
      ...a,
      children: [
        /* @__PURE__ */ p(
          sx,
          {
            "data-slot": "slider-track",
            className: "relative grow overflow-hidden rounded-full bg-muted data-horizontal:h-1 data-horizontal:w-full data-vertical:h-full data-vertical:w-1",
            children: /* @__PURE__ */ p(
              ix,
              {
                "data-slot": "slider-range",
                className: "absolute bg-primary select-none data-horizontal:h-full data-vertical:w-full"
              }
            )
          }
        ),
        Array.from({ length: s.length }, (i, l) => /* @__PURE__ */ p(
          lx,
          {
            "data-slot": "slider-thumb",
            className: "relative block size-3 shrink-0 rounded-full border border-ring bg-white ring-ring/50 transition-[color,box-shadow] select-none after:absolute after:-inset-2 hover:ring-3 focus-visible:ring-3 focus-visible:outline-hidden active:ring-3 disabled:pointer-events-none disabled:opacity-50"
          },
          l
        ))
      ]
    }
  );
}
function pS({ className: e, type: t, ...n }) {
  return /* @__PURE__ */ p(
    "input",
    {
      type: t,
      "data-slot": "input",
      className: P(
        "h-8 w-full min-w-0 rounded-lg border border-input bg-transparent px-2.5 py-1 text-base transition-colors outline-none file:inline-flex file:h-6 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-input/50 disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 md:text-sm dark:bg-input/30 dark:disabled:bg-input/80 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40",
        e
      ),
      ...n
    }
  );
}
function mS({ className: e, ...t }) {
  return /* @__PURE__ */ p(
    "textarea",
    {
      "data-slot": "textarea",
      className: P(
        "flex field-sizing-content min-h-16 w-full rounded-lg border border-input bg-transparent px-2.5 py-2 text-base transition-colors outline-none placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:bg-input/50 disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 md:text-sm dark:bg-input/30 dark:disabled:bg-input/80 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40",
        e
      ),
      ...t
    }
  );
}
function hS({ className: e, ...t }) {
  return /* @__PURE__ */ p(
    "div",
    {
      "data-slot": "input-group",
      role: "group",
      className: P(
        "group/input-group relative flex h-7 w-full min-w-0 items-center rounded-md border border-input transition-colors outline-none in-data-[slot=combobox-content]:focus-within:border-inherit in-data-[slot=combobox-content]:focus-within:ring-0 has-disabled:bg-input/50 has-disabled:opacity-50 has-[[data-slot=input-group-control]:focus-visible]:border-ring has-[[data-slot=input-group-control]:focus-visible]:ring-3 has-[[data-slot=input-group-control]:focus-visible]:ring-ring/50 has-[[data-slot][aria-invalid=true]]:border-destructive has-[[data-slot][aria-invalid=true]]:ring-3 has-[[data-slot][aria-invalid=true]]:ring-destructive/20 has-[>[data-align=block-end]]:h-auto has-[>[data-align=block-end]]:flex-col has-[>[data-align=block-start]]:h-auto has-[>[data-align=block-start]]:flex-col has-[>textarea]:h-auto dark:bg-input/30 dark:has-disabled:bg-input/80 dark:has-[[data-slot][aria-invalid=true]]:ring-destructive/40 has-[>[data-align=block-end]]:[&>input]:pt-3 has-[>[data-align=block-start]]:[&>input]:pb-3 has-[>[data-align=inline-end]]:[&>input]:pr-1.5 has-[>[data-align=inline-start]]:[&>input]:pl-1.5",
        e
      ),
      ...t
    }
  );
}
const gS = tn(
  "flex h-auto cursor-text items-center justify-center gap-2 py-1.5 text-sm font-medium text-muted-foreground select-none group-data-[disabled=true]/input-group:opacity-50 [&>kbd]:rounded-[calc(var(--radius)-5px)] [&>svg:not([class*='size-'])]:size-4",
  {
    variants: {
      align: {
        "inline-start": "order-first pl-2 has-[>button]:ml-[-0.3rem] has-[>kbd]:ml-[-0.15rem]",
        "inline-end": "order-last pr-2 has-[>button]:mr-[-0.3rem] has-[>kbd]:mr-[-0.15rem]",
        "block-start": "order-first w-full justify-start px-2.5 pt-2 group-has-[>input]/input-group:pt-2 [.border-b]:pb-2",
        "block-end": "order-last w-full justify-start px-2.5 pb-2 group-has-[>input]/input-group:pb-2 [.border-t]:pt-2"
      }
    },
    defaultVariants: {
      align: "inline-start"
    }
  }
);
function vS({
  className: e,
  align: t = "inline-start",
  ...n
}) {
  return /* @__PURE__ */ p(
    "div",
    {
      role: "group",
      "data-slot": "input-group-addon",
      "data-align": t,
      className: P(gS({ align: t }), e),
      onClick: (r) => {
        r.target.closest("button") || r.currentTarget.parentElement?.querySelector("input")?.focus();
      },
      ...n
    }
  );
}
const bS = tn(
  "flex items-center gap-2 text-sm shadow-none",
  {
    variants: {
      size: {
        xs: "h-6 gap-1 rounded-[calc(var(--radius)-3px)] px-1.5 [&>svg:not([class*='size-'])]:size-3.5",
        sm: "",
        "icon-xs": "size-6 rounded-[calc(var(--radius)-3px)] p-0 has-[>svg]:p-0",
        "icon-sm": "size-8 p-0 has-[>svg]:p-0"
      }
    },
    defaultVariants: {
      size: "xs"
    }
  }
);
function yS({
  className: e,
  type: t = "button",
  variant: n = "ghost",
  size: r = "xs",
  ...o
}) {
  return /* @__PURE__ */ p(
    Et,
    {
      type: t,
      "data-size": r,
      variant: n,
      className: P(bS({ size: r }), e),
      ...o
    }
  );
}
function wE({ className: e, ...t }) {
  return /* @__PURE__ */ p(
    "span",
    {
      className: P(
        "flex items-center gap-2 text-sm text-muted-foreground [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...t
    }
  );
}
function wS({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ p(
    pS,
    {
      "data-slot": "input-group-control",
      className: P(
        "flex-1 rounded-none border-0 bg-transparent shadow-none ring-0 focus-visible:ring-0 disabled:bg-transparent aria-invalid:ring-0 dark:bg-transparent dark:disabled:bg-transparent",
        e
      ),
      ...t
    }
  );
}
function xE({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ p(
    mS,
    {
      "data-slot": "input-group-control",
      className: P(
        "flex-1 resize-none rounded-none border-0 bg-transparent py-2 shadow-none ring-0 focus-visible:ring-0 disabled:bg-transparent aria-invalid:ring-0 dark:bg-transparent dark:disabled:bg-transparent",
        e
      ),
      ...t
    }
  );
}
function SE({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ p(
    $m,
    {
      "data-slot": "accordion",
      className: P("flex w-full flex-col", e),
      ...t
    }
  );
}
function CE({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ p(
    zm,
    {
      "data-slot": "accordion-item",
      className: P("not-last:border-b", e),
      ...t
    }
  );
}
function kE({
  className: e,
  children: t,
  ...n
}) {
  return /* @__PURE__ */ p(Bm, { className: "flex", children: /* @__PURE__ */ ae(
    Ym,
    {
      "data-slot": "accordion-trigger",
      className: P(
        "group/accordion-trigger relative flex flex-1 items-start justify-between rounded-lg border border-transparent py-2.5 text-left text-sm font-medium transition-all outline-none hover:underline focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 focus-visible:after:border-ring disabled:pointer-events-none disabled:opacity-50 **:data-[slot=accordion-trigger-icon]:ml-auto **:data-[slot=accordion-trigger-icon]:size-4 **:data-[slot=accordion-trigger-icon]:text-muted-foreground",
        e
      ),
      ...n,
      children: [
        t,
        /* @__PURE__ */ p(
          eo,
          {
            "data-slot": "accordion-trigger-icon",
            className: "pointer-events-none shrink-0 group-aria-expanded/accordion-trigger:hidden"
          }
        ),
        /* @__PURE__ */ p(
          sf,
          {
            "data-slot": "accordion-trigger-icon",
            className: "pointer-events-none hidden shrink-0 group-aria-expanded/accordion-trigger:inline"
          }
        )
      ]
    }
  ) });
}
function EE({
  className: e,
  children: t,
  ...n
}) {
  return /* @__PURE__ */ p(
    Hm,
    {
      "data-slot": "accordion-content",
      className: "overflow-hidden text-sm data-open:animate-accordion-down data-closed:animate-accordion-up",
      ...n,
      children: /* @__PURE__ */ p(
        "div",
        {
          className: P(
            "h-(--radix-accordion-content-height) pt-0 pb-2.5 [&_a]:underline [&_a]:underline-offset-3 [&_a]:hover:text-foreground [&_p:not(:last-child)]:mb-4",
            e
          ),
          children: t
        }
      )
    }
  );
}
function ME({
  className: e,
  size: t = "default",
  ...n
}) {
  return /* @__PURE__ */ p(
    "div",
    {
      "data-slot": "card",
      "data-size": t,
      className: P(
        "group/card flex flex-col gap-4 overflow-hidden rounded-xl bg-card py-4 text-sm text-card-foreground ring-1 ring-foreground/10 has-data-[slot=card-footer]:pb-0 has-[>img:first-child]:pt-0 data-[size=sm]:gap-3 data-[size=sm]:py-3 data-[size=sm]:has-data-[slot=card-footer]:pb-0 *:[img:first-child]:rounded-t-xl *:[img:last-child]:rounded-b-xl",
        e
      ),
      ...n
    }
  );
}
function PE({ className: e, ...t }) {
  return /* @__PURE__ */ p(
    "div",
    {
      "data-slot": "card-header",
      className: P(
        "group/card-header @container/card-header grid auto-rows-min items-start gap-1 rounded-t-xl px-4 group-data-[size=sm]/card:px-3 has-data-[slot=card-action]:grid-cols-[1fr_auto] has-data-[slot=card-description]:grid-rows-[auto_auto] [.border-b]:pb-4 group-data-[size=sm]/card:[.border-b]:pb-3",
        e
      ),
      ...t
    }
  );
}
function DE({ className: e, ...t }) {
  return /* @__PURE__ */ p(
    "div",
    {
      "data-slot": "card-title",
      className: P(
        "text-base leading-snug font-medium group-data-[size=sm]/card:text-sm",
        e
      ),
      ...t
    }
  );
}
function OE({ className: e, ...t }) {
  return /* @__PURE__ */ p(
    "div",
    {
      "data-slot": "card-description",
      className: P("text-sm text-muted-foreground", e),
      ...t
    }
  );
}
function NE({ className: e, ...t }) {
  return /* @__PURE__ */ p(
    "div",
    {
      "data-slot": "card-action",
      className: P(
        "col-start-2 row-span-2 row-start-1 self-start justify-self-end",
        e
      ),
      ...t
    }
  );
}
function _E({ className: e, ...t }) {
  return /* @__PURE__ */ p(
    "div",
    {
      "data-slot": "card-content",
      className: P("px-4 group-data-[size=sm]/card:px-3", e),
      ...t
    }
  );
}
function RE({ className: e, ...t }) {
  return /* @__PURE__ */ p(
    "div",
    {
      "data-slot": "card-footer",
      className: P(
        "flex items-center rounded-b-xl border-t bg-muted/50 p-4 group-data-[size=sm]/card:p-3",
        e
      ),
      ...t
    }
  );
}
function TE({
  className: e,
  children: t,
  ...n
}) {
  return /* @__PURE__ */ ae(
    nw,
    {
      "data-slot": "scroll-area",
      type: "always",
      className: P("relative flex flex-col overflow-hidden", e),
      ...n,
      children: [
        /* @__PURE__ */ p(
          rw,
          {
            "data-slot": "scroll-area-viewport",
            className: "w-full grow rounded-[inherit] transition-[color,box-shadow] outline-none focus-visible:ring-[3px] focus-visible:ring-ring/50 focus-visible:outline-1",
            children: t
          }
        ),
        /* @__PURE__ */ p(xS, {}),
        /* @__PURE__ */ p(ow, {})
      ]
    }
  );
}
function xS({
  className: e,
  orientation: t = "vertical",
  ...n
}) {
  return /* @__PURE__ */ p(
    Ld,
    {
      "data-slot": "scroll-area-scrollbar",
      "data-orientation": t,
      orientation: t,
      className: P(
        "flex touch-none p-px transition-colors select-none data-horizontal:h-2.5 data-horizontal:flex-col data-horizontal:border-t data-horizontal:border-t-transparent data-vertical:h-full data-vertical:w-2.5 data-vertical:border-l data-vertical:border-l-transparent",
        e
      ),
      ...n,
      children: /* @__PURE__ */ p(
        Yd,
        {
          "data-slot": "scroll-area-thumb",
          className: "relative flex-1 rounded-full bg-border"
        }
      )
    }
  );
}
function AE({ className: e, ...t }) {
  return /* @__PURE__ */ p(
    "div",
    {
      "data-slot": "skeleton",
      className: P("animate-pulse rounded-md bg-muted", e),
      ...t
    }
  );
}
function IE({
  className: e,
  size: t = "default",
  ...n
}) {
  return /* @__PURE__ */ p(
    Dg,
    {
      "data-slot": "avatar",
      "data-size": t,
      className: P(
        "group/avatar relative flex size-8 shrink-0 rounded-full select-none after:absolute after:inset-0 after:rounded-full after:border after:border-border after:mix-blend-darken data-[size=lg]:size-10 data-[size=sm]:size-6 dark:after:mix-blend-lighten",
        e
      ),
      ...n
    }
  );
}
function WE({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ p(
    Og,
    {
      "data-slot": "avatar-image",
      className: P(
        "aspect-square size-full rounded-full object-cover",
        e
      ),
      ...t
    }
  );
}
function FE({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ p(
    Ng,
    {
      "data-slot": "avatar-fallback",
      className: P(
        "flex size-full items-center justify-center rounded-full bg-muted text-sm text-muted-foreground group-data-[size=sm]/avatar:text-xs",
        e
      ),
      ...t
    }
  );
}
function LE({ className: e, ...t }) {
  return /* @__PURE__ */ p(
    "span",
    {
      "data-slot": "avatar-badge",
      className: P(
        "absolute right-0 bottom-0 z-10 inline-flex items-center justify-center rounded-full bg-primary text-primary-foreground bg-blend-color ring-2 ring-background select-none",
        "group-data-[size=sm]/avatar:size-2 group-data-[size=sm]/avatar:[&>svg]:hidden",
        "group-data-[size=default]/avatar:size-2.5 group-data-[size=default]/avatar:[&>svg]:size-2",
        "group-data-[size=lg]/avatar:size-3 group-data-[size=lg]/avatar:[&>svg]:size-2",
        e
      ),
      ...t
    }
  );
}
function $E({ className: e, ...t }) {
  return /* @__PURE__ */ p(
    "div",
    {
      "data-slot": "avatar-group",
      className: P(
        "group/avatar-group flex -space-x-2 *:data-[slot=avatar]:ring-2 *:data-[slot=avatar]:ring-background",
        e
      ),
      ...t
    }
  );
}
function zE({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ p(
    "div",
    {
      "data-slot": "avatar-group-count",
      className: P(
        "relative flex size-8 shrink-0 items-center justify-center rounded-full bg-muted text-sm text-muted-foreground ring-2 ring-background group-has-data-[size=lg]/avatar-group:size-10 group-has-data-[size=sm]/avatar-group:size-6 [&>svg]:size-4 group-has-data-[size=lg]/avatar-group:[&>svg]:size-5 group-has-data-[size=sm]/avatar-group:[&>svg]:size-3",
        e
      ),
      ...t
    }
  );
}
function BE({
  className: e,
  value: t,
  ...n
}) {
  const [r, o] = d.useState(0);
  return d.useEffect(() => {
    const a = requestAnimationFrame(() => o(t || 0));
    return () => cancelAnimationFrame(a);
  }, [t]), /* @__PURE__ */ p(
    Hy,
    {
      "data-slot": "progress",
      value: t,
      className: P(
        "relative flex h-1 w-full items-center overflow-x-hidden rounded-full bg-muted",
        e
      ),
      ...n,
      children: /* @__PURE__ */ p(
        Vy,
        {
          "data-slot": "progress-indicator",
          className: "size-full flex-1 bg-primary transition-all",
          style: { transform: `translateX(-${100 - r}%)` }
        }
      )
    }
  );
}
const SS = tn(
  "group/badge inline-flex h-5 w-fit shrink-0 items-center justify-center gap-1 overflow-hidden rounded-4xl border border-transparent px-2 py-0.5 text-xs font-medium whitespace-nowrap transition-all focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 has-data-[icon=inline-end]:pr-1.5 has-data-[icon=inline-start]:pl-1.5 aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 [&>svg]:pointer-events-none [&>svg]:size-3!",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground [a]:hover:bg-primary/80",
        secondary: "bg-secondary text-secondary-foreground [a]:hover:bg-secondary/80",
        destructive: "bg-destructive/10 text-destructive focus-visible:ring-destructive/20 dark:bg-destructive/20 dark:focus-visible:ring-destructive/40 [a]:hover:bg-destructive/20",
        outline: "border-border text-foreground [a]:hover:bg-muted [a]:hover:text-muted-foreground",
        ghost: "hover:bg-muted hover:text-muted-foreground dark:hover:bg-muted/50",
        link: "text-primary underline-offset-4 hover:underline"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
function YE({
  className: e,
  variant: t = "default",
  asChild: n = !1,
  ...r
}) {
  return /* @__PURE__ */ p(
    n ? Ti : "span",
    {
      "data-slot": "badge",
      "data-variant": t,
      className: P(SS({ variant: t }), e),
      ...r
    }
  );
}
const cf = tn(
  "group/toggle inline-flex items-center justify-center gap-1 rounded-lg text-sm font-medium whitespace-nowrap transition-all outline-none hover:bg-muted hover:text-foreground focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:pointer-events-none disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 aria-pressed:bg-muted data-[state=on]:bg-muted dark:aria-invalid:ring-destructive/40 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
  {
    variants: {
      variant: {
        default: "bg-transparent",
        outline: "border border-input bg-transparent hover:bg-muted"
      },
      size: {
        default: "h-8 min-w-8 px-2",
        sm: "h-7 min-w-7 rounded-[min(var(--radius-md),12px)] px-1.5 text-[0.8rem]",
        lg: "h-9 min-w-9 px-2.5"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
);
function HE({
  className: e,
  variant: t = "default",
  size: n = "default",
  ...r
}) {
  return /* @__PURE__ */ p(
    hx,
    {
      "data-slot": "toggle",
      className: P(cf({ variant: t, size: n, className: e })),
      ...r
    }
  );
}
const df = d.createContext({
  size: "default",
  variant: "default",
  spacing: 0,
  orientation: "horizontal"
});
function VE({
  className: e,
  variant: t,
  size: n,
  spacing: r = 0,
  orientation: o = "horizontal",
  children: a,
  ...s
}) {
  return /* @__PURE__ */ p(
    wx,
    {
      "data-slot": "toggle-group",
      "data-variant": t,
      "data-size": n,
      "data-spacing": r,
      "data-orientation": o,
      style: { "--gap": r },
      className: P(
        "group/toggle-group flex w-fit flex-row items-center bg-background shadow-lg p-1 ring-1 ring-border gap-[--spacing(var(--gap))] rounded-xl data-[size=sm]:rounded-[min(var(--radius-md),10px)] data-vertical:flex-col data-vertical:items-stretch",
        e
      ),
      ...s,
      children: /* @__PURE__ */ p(
        df.Provider,
        {
          value: { variant: t, size: n, spacing: r, orientation: o },
          children: a
        }
      )
    }
  );
}
function GE({
  className: e,
  children: t,
  variant: n = "default",
  size: r = "default",
  ...o
}) {
  const a = d.useContext(df);
  return /* @__PURE__ */ p(
    xx,
    {
      "data-slot": "toggle-group-item",
      "data-variant": a.variant || n,
      "data-size": a.size || r,
      "data-spacing": a.spacing,
      className: P(
        "shrink-0 group-data-[spacing=0]/toggle-group:rounded-none group-data-[spacing=0]/toggle-group:px-2 focus:z-10 focus-visible:z-10 group-data-horizontal/toggle-group:data-[spacing=0]:first:rounded-l-lg group-data-vertical/toggle-group:data-[spacing=0]:first:rounded-t-lg group-data-horizontal/toggle-group:data-[spacing=0]:last:rounded-r-lg group-data-vertical/toggle-group:data-[spacing=0]:last:rounded-b-lg group-data-horizontal/toggle-group:data-[spacing=0]:data-[variant=outline]:border-l-0 group-data-vertical/toggle-group:data-[spacing=0]:data-[variant=outline]:border-t-0 group-data-horizontal/toggle-group:data-[spacing=0]:data-[variant=outline]:first:border-l group-data-vertical/toggle-group:data-[spacing=0]:data-[variant=outline]:first:border-t",
        cf({
          variant: a.variant || n,
          size: a.size || r
        }),
        e
      ),
      ...o,
      children: t
    }
  );
}
function UE({ className: e, ...t }) {
  return /* @__PURE__ */ p(
    "div",
    {
      "data-slot": "table-container",
      className: "relative w-full overflow-x-auto",
      children: /* @__PURE__ */ p(
        "table",
        {
          "data-slot": "table",
          className: P("w-full caption-bottom text-sm", e),
          ...t
        }
      )
    }
  );
}
function jE({ className: e, ...t }) {
  return /* @__PURE__ */ p(
    "thead",
    {
      "data-slot": "table-header",
      className: P("[&_tr]:border-b", e),
      ...t
    }
  );
}
function KE({ className: e, ...t }) {
  return /* @__PURE__ */ p(
    "tbody",
    {
      "data-slot": "table-body",
      className: P("[&_tr:last-child]:border-0", e),
      ...t
    }
  );
}
function qE({ className: e, ...t }) {
  return /* @__PURE__ */ p(
    "tfoot",
    {
      "data-slot": "table-footer",
      className: P(
        "border-t bg-muted/50 font-medium [&>tr]:last:border-b-0",
        e
      ),
      ...t
    }
  );
}
function XE({ className: e, ...t }) {
  return /* @__PURE__ */ p(
    "tr",
    {
      "data-slot": "table-row",
      className: P(
        "border-b transition-colors hover:bg-muted/50 data-[state=selected]:bg-muted",
        e
      ),
      ...t
    }
  );
}
function ZE({ className: e, ...t }) {
  return /* @__PURE__ */ p(
    "th",
    {
      "data-slot": "table-head",
      className: P(
        "h-10 px-2 text-left align-middle font-medium whitespace-nowrap text-foreground [&:has([role=checkbox])]:pr-0",
        e
      ),
      ...t
    }
  );
}
function QE({ className: e, ...t }) {
  return /* @__PURE__ */ p(
    "td",
    {
      "data-slot": "table-cell",
      className: P(
        "p-2 align-middle whitespace-nowrap [&:has([role=checkbox])]:pr-0",
        e
      ),
      ...t
    }
  );
}
function JE({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ p(
    "caption",
    {
      "data-slot": "table-caption",
      className: P("mt-4 text-sm text-muted-foreground", e),
      ...t
    }
  );
}
function eM({ className: e, ...t }) {
  return /* @__PURE__ */ p(
    "nav",
    {
      "aria-label": "pagination",
      "data-slot": "pagination",
      className: P("mx-auto flex w-full justify-center", e),
      ...t
    }
  );
}
function tM({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ p(
    "ul",
    {
      "data-slot": "pagination-content",
      className: P("flex items-center gap-0.5", e),
      ...t
    }
  );
}
function nM({ ...e }) {
  return /* @__PURE__ */ p("li", { "data-slot": "pagination-item", ...e });
}
function uf({
  className: e,
  isActive: t,
  size: n = "icon",
  ...r
}) {
  return /* @__PURE__ */ p(
    Et,
    {
      asChild: !0,
      variant: t ? "outline" : "ghost",
      size: n,
      className: P(e),
      children: /* @__PURE__ */ p(
        "a",
        {
          "aria-current": t ? "page" : void 0,
          "data-slot": "pagination-link",
          "data-active": t,
          ...r
        }
      )
    }
  );
}
function rM({
  className: e,
  text: t = "Previous",
  ...n
}) {
  return /* @__PURE__ */ ae(
    uf,
    {
      "aria-label": "Go to previous page",
      size: "default",
      className: P("pl-1.5!", e),
      ...n,
      children: [
        /* @__PURE__ */ p(af, { "data-icon": "inline-start" }),
        /* @__PURE__ */ p("span", { className: "hidden sm:block", children: t })
      ]
    }
  );
}
function oM({
  className: e,
  text: t = "Next",
  ...n
}) {
  return /* @__PURE__ */ ae(
    uf,
    {
      "aria-label": "Go to next page",
      size: "default",
      className: P("pr-1.5!", e),
      ...n,
      children: [
        /* @__PURE__ */ p("span", { className: "hidden sm:block", children: t }),
        /* @__PURE__ */ p(Ka, { "data-icon": "inline-end" })
      ]
    }
  );
}
function aM({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ ae(
    "span",
    {
      "aria-hidden": !0,
      "data-slot": "pagination-ellipsis",
      className: P(
        "flex size-8 items-center justify-center [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...t,
      children: [
        /* @__PURE__ */ p(iS, {}),
        /* @__PURE__ */ p("span", { className: "sr-only", children: "More pages" })
      ]
    }
  );
}
function sM({
  ...e
}) {
  return /* @__PURE__ */ p(dg, { "data-slot": "alert-dialog", ...e });
}
function iM({
  ...e
}) {
  return /* @__PURE__ */ p(ug, { "data-slot": "alert-dialog-trigger", ...e });
}
function CS({
  ...e
}) {
  return /* @__PURE__ */ p(fg, { "data-slot": "alert-dialog-portal", ...e });
}
function kS({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ p(
    pg,
    {
      "data-slot": "alert-dialog-overlay",
      className: P(
        "fixed inset-0 z-50 bg-black/10 duration-100 supports-backdrop-filter:backdrop-blur-xs data-open:animate-in data-open:fade-in-0 data-closed:animate-out data-closed:fade-out-0",
        e
      ),
      ...t
    }
  );
}
function lM({
  className: e,
  size: t = "default",
  ...n
}) {
  return /* @__PURE__ */ ae(CS, { children: [
    /* @__PURE__ */ p(kS, {}),
    /* @__PURE__ */ p(
      mg,
      {
        "data-slot": "alert-dialog-content",
        "data-size": t,
        className: P(
          "group/alert-dialog-content fixed top-1/2 left-1/2 z-50 grid w-full -translate-x-1/2 -translate-y-1/2 gap-4 rounded-xl bg-popover p-4 text-popover-foreground ring-1 ring-foreground/10 duration-100 outline-none data-[size=default]:max-w-xs data-[size=sm]:max-w-xs data-[size=default]:sm:max-w-sm data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95",
          e
        ),
        ...n
      }
    )
  ] });
}
function cM({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ p(
    "div",
    {
      "data-slot": "alert-dialog-header",
      className: P(
        "grid grid-rows-[auto_1fr] place-items-center gap-1.5 text-center has-data-[slot=alert-dialog-media]:grid-rows-[auto_auto_1fr] has-data-[slot=alert-dialog-media]:gap-x-4 sm:group-data-[size=default]/alert-dialog-content:place-items-start sm:group-data-[size=default]/alert-dialog-content:text-left sm:group-data-[size=default]/alert-dialog-content:has-data-[slot=alert-dialog-media]:grid-rows-[auto_1fr]",
        e
      ),
      ...t
    }
  );
}
function dM({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ p(
    "div",
    {
      "data-slot": "alert-dialog-footer",
      className: P(
        "-mx-4 -mb-4 flex flex-col-reverse gap-2 rounded-b-xl border-t bg-muted/50 p-4 group-data-[size=sm]/alert-dialog-content:grid group-data-[size=sm]/alert-dialog-content:grid-cols-2 sm:flex-row sm:justify-end",
        e
      ),
      ...t
    }
  );
}
function uM({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ p(
    "div",
    {
      "data-slot": "alert-dialog-media",
      className: P(
        "mb-2 inline-flex size-10 items-center justify-center rounded-md bg-muted sm:group-data-[size=default]/alert-dialog-content:row-span-2 *:[svg:not([class*='size-'])]:size-6",
        e
      ),
      ...t
    }
  );
}
function fM({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ p(
    vg,
    {
      "data-slot": "alert-dialog-title",
      className: P(
        "text-base font-medium sm:group-data-[size=default]/alert-dialog-content:group-has-data-[slot=alert-dialog-media]/alert-dialog-content:col-start-2",
        e
      ),
      ...t
    }
  );
}
function pM({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ p(
    bg,
    {
      "data-slot": "alert-dialog-description",
      className: P(
        "text-sm text-balance text-muted-foreground md:text-pretty *:[a]:underline *:[a]:underline-offset-3 *:[a]:hover:text-foreground",
        e
      ),
      ...t
    }
  );
}
function mM({
  className: e,
  variant: t = "default",
  size: n = "default",
  ...r
}) {
  return /* @__PURE__ */ p(Et, { variant: t, size: n, asChild: !0, children: /* @__PURE__ */ p(
    hg,
    {
      "data-slot": "alert-dialog-action",
      className: P(e),
      ...r
    }
  ) });
}
function hM({
  className: e,
  variant: t = "outline",
  size: n = "default",
  ...r
}) {
  return /* @__PURE__ */ p(Et, { variant: t, size: n, asChild: !0, children: /* @__PURE__ */ p(
    gg,
    {
      "data-slot": "alert-dialog-cancel",
      className: P(e),
      ...r
    }
  ) });
}
function ES({
  ...e
}) {
  return /* @__PURE__ */ p(Ty, { "data-slot": "popover", ...e });
}
function MS({
  ...e
}) {
  return /* @__PURE__ */ p(Ay, { "data-slot": "popover-trigger", ...e });
}
function PS({
  className: e,
  align: t = "center",
  sideOffset: n = 4,
  ...r
}) {
  return /* @__PURE__ */ p(Iy, { children: /* @__PURE__ */ p(
    Wy,
    {
      "data-slot": "popover-content",
      align: t,
      sideOffset: n,
      className: P(
        "z-50 flex w-72 origin-(--radix-popover-content-transform-origin) flex-col gap-2.5 rounded-lg bg-popover p-2.5 text-sm text-popover-foreground shadow-md ring-1 ring-foreground/10 outline-hidden duration-100 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95",
        e
      ),
      ...r
    }
  ) });
}
function gM({ className: e, ...t }) {
  return /* @__PURE__ */ p(
    "div",
    {
      "data-slot": "popover-header",
      className: P("flex flex-col gap-0.5 text-sm", e),
      ...t
    }
  );
}
function vM({ className: e, ...t }) {
  return /* @__PURE__ */ p(
    "div",
    {
      "data-slot": "popover-title",
      className: P("font-medium", e),
      ...t
    }
  );
}
function bM({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ p(
    "p",
    {
      "data-slot": "popover-description",
      className: P("text-muted-foreground", e),
      ...t
    }
  );
}
var qs = 1, DS = 0.9, OS = 0.8, NS = 0.17, Eo = 0.1, Mo = 0.999, _S = 0.9999, RS = 0.99, TS = /[\\\/_+.#"@\[\(\{&]/, AS = /[\\\/_+.#"@\[\(\{&]/g, IS = /[\s-]/, ff = /[\s-]/g;
function ea(e, t, n, r, o, a, s) {
  if (a === t.length) return o === e.length ? qs : RS;
  var i = `${o},${a}`;
  if (s[i] !== void 0) return s[i];
  for (var l = r.charAt(a), c = n.indexOf(l, o), f = 0, u, m, h, b; c >= 0; ) u = ea(e, t, n, r, c + 1, a + 1, s), u > f && (c === o ? u *= qs : TS.test(e.charAt(c - 1)) ? (u *= OS, h = e.slice(o, c - 1).match(AS), h && o > 0 && (u *= Math.pow(Mo, h.length))) : IS.test(e.charAt(c - 1)) ? (u *= DS, b = e.slice(o, c - 1).match(ff), b && o > 0 && (u *= Math.pow(Mo, b.length))) : (u *= NS, o > 0 && (u *= Math.pow(Mo, c - o))), e.charAt(c) !== t.charAt(a) && (u *= _S)), (u < Eo && n.charAt(c - 1) === r.charAt(a + 1) || r.charAt(a + 1) === r.charAt(a) && n.charAt(c - 1) !== r.charAt(a)) && (m = ea(e, t, n, r, c + 1, a + 2, s), m * Eo > u && (u = m * Eo)), u > f && (f = u), c = n.indexOf(l, c + 1);
  return s[i] = f, f;
}
function Xs(e) {
  return e.toLowerCase().replace(ff, " ");
}
function WS(e, t, n) {
  return e = n && n.length > 0 ? `${e + " " + n.join(" ")}` : e, ea(e, t, Xs(e), Xs(t), 0, 0, {});
}
var pn = '[cmdk-group=""]', Po = '[cmdk-group-items=""]', FS = '[cmdk-group-heading=""]', pf = '[cmdk-item=""]', Zs = `${pf}:not([aria-disabled="true"])`, ta = "cmdk-item-select", Vt = "data-value", LS = (e, t, n) => WS(e, t, n), mf = d.createContext(void 0), zn = () => d.useContext(mf), hf = d.createContext(void 0), qa = () => d.useContext(hf), gf = d.createContext(void 0), vf = d.forwardRef((e, t) => {
  let n = Gt(() => {
    var D, j;
    return { search: "", value: (j = (D = e.value) != null ? D : e.defaultValue) != null ? j : "", selectedItemId: void 0, filtered: { count: 0, items: /* @__PURE__ */ new Map(), groups: /* @__PURE__ */ new Set() } };
  }), r = Gt(() => /* @__PURE__ */ new Set()), o = Gt(() => /* @__PURE__ */ new Map()), a = Gt(() => /* @__PURE__ */ new Map()), s = Gt(() => /* @__PURE__ */ new Set()), i = bf(e), { label: l, children: c, value: f, onValueChange: u, filter: m, shouldFilter: h, loop: b, disablePointerSelection: g = !1, vimBindings: v = !0, ...y } = e, w = ge(), x = ge(), S = ge(), k = d.useRef(null), C = qS();
  Tt(() => {
    if (f !== void 0) {
      let D = f.trim();
      n.current.value = D, E.emit();
    }
  }, [f]), Tt(() => {
    C(6, K);
  }, []);
  let E = d.useMemo(() => ({ subscribe: (D) => (s.current.add(D), () => s.current.delete(D)), snapshot: () => n.current, setState: (D, j, X) => {
    var F, U, _, ee;
    if (!Object.is(n.current[D], j)) {
      if (n.current[D] = j, D === "search") Y(), R(), C(1, W);
      else if (D === "value") {
        if (document.activeElement.hasAttribute("cmdk-input") || document.activeElement.hasAttribute("cmdk-root")) {
          let Z = document.getElementById(S);
          Z ? Z.focus() : (F = document.getElementById(w)) == null || F.focus();
        }
        if (C(7, () => {
          var Z;
          n.current.selectedItemId = (Z = H()) == null ? void 0 : Z.id, E.emit();
        }), X || C(5, K), ((U = i.current) == null ? void 0 : U.value) !== void 0) {
          let Z = j ?? "";
          (ee = (_ = i.current).onValueChange) == null || ee.call(_, Z);
          return;
        }
      }
      E.emit();
    }
  }, emit: () => {
    s.current.forEach((D) => D());
  } }), []), M = d.useMemo(() => ({ value: (D, j, X) => {
    var F;
    j !== ((F = a.current.get(D)) == null ? void 0 : F.value) && (a.current.set(D, { value: j, keywords: X }), n.current.filtered.items.set(D, O(j, X)), C(2, () => {
      R(), E.emit();
    }));
  }, item: (D, j) => (r.current.add(D), j && (o.current.has(j) ? o.current.get(j).add(D) : o.current.set(j, /* @__PURE__ */ new Set([D]))), C(3, () => {
    Y(), R(), n.current.value || W(), E.emit();
  }), () => {
    a.current.delete(D), r.current.delete(D), n.current.filtered.items.delete(D);
    let X = H();
    C(4, () => {
      Y(), X?.getAttribute("id") === D && W(), E.emit();
    });
  }), group: (D) => (o.current.has(D) || o.current.set(D, /* @__PURE__ */ new Set()), () => {
    a.current.delete(D), o.current.delete(D);
  }), filter: () => i.current.shouldFilter, label: l || e["aria-label"], getDisablePointerSelection: () => i.current.disablePointerSelection, listId: w, inputId: S, labelId: x, listInnerRef: k }), []);
  function O(D, j) {
    var X, F;
    let U = (F = (X = i.current) == null ? void 0 : X.filter) != null ? F : LS;
    return D ? U(D, n.current.search, j) : 0;
  }
  function R() {
    if (!n.current.search || i.current.shouldFilter === !1) return;
    let D = n.current.filtered.items, j = [];
    n.current.filtered.groups.forEach((F) => {
      let U = o.current.get(F), _ = 0;
      U.forEach((ee) => {
        let Z = D.get(ee);
        _ = Math.max(Z, _);
      }), j.push([F, _]);
    });
    let X = k.current;
    Q().sort((F, U) => {
      var _, ee;
      let Z = F.getAttribute("id"), re = U.getAttribute("id");
      return ((_ = D.get(re)) != null ? _ : 0) - ((ee = D.get(Z)) != null ? ee : 0);
    }).forEach((F) => {
      let U = F.closest(Po);
      U ? U.appendChild(F.parentElement === U ? F : F.closest(`${Po} > *`)) : X.appendChild(F.parentElement === X ? F : F.closest(`${Po} > *`));
    }), j.sort((F, U) => U[1] - F[1]).forEach((F) => {
      var U;
      let _ = (U = k.current) == null ? void 0 : U.querySelector(`${pn}[${Vt}="${encodeURIComponent(F[0])}"]`);
      _?.parentElement.appendChild(_);
    });
  }
  function W() {
    let D = Q().find((X) => X.getAttribute("aria-disabled") !== "true"), j = D?.getAttribute(Vt);
    E.setState("value", j || void 0);
  }
  function Y() {
    var D, j, X, F;
    if (!n.current.search || i.current.shouldFilter === !1) {
      n.current.filtered.count = r.current.size;
      return;
    }
    n.current.filtered.groups = /* @__PURE__ */ new Set();
    let U = 0;
    for (let _ of r.current) {
      let ee = (j = (D = a.current.get(_)) == null ? void 0 : D.value) != null ? j : "", Z = (F = (X = a.current.get(_)) == null ? void 0 : X.keywords) != null ? F : [], re = O(ee, Z);
      n.current.filtered.items.set(_, re), re > 0 && U++;
    }
    for (let [_, ee] of o.current) for (let Z of ee) if (n.current.filtered.items.get(Z) > 0) {
      n.current.filtered.groups.add(_);
      break;
    }
    n.current.filtered.count = U;
  }
  function K() {
    var D, j, X;
    let F = H();
    F && (((D = F.parentElement) == null ? void 0 : D.firstChild) === F && ((X = (j = F.closest(pn)) == null ? void 0 : j.querySelector(FS)) == null || X.scrollIntoView({ block: "nearest" })), F.scrollIntoView({ block: "nearest" }));
  }
  function H() {
    var D;
    return (D = k.current) == null ? void 0 : D.querySelector(`${pf}[aria-selected="true"]`);
  }
  function Q() {
    var D;
    return Array.from(((D = k.current) == null ? void 0 : D.querySelectorAll(Zs)) || []);
  }
  function $(D) {
    let j = Q()[D];
    j && E.setState("value", j.getAttribute(Vt));
  }
  function q(D) {
    var j;
    let X = H(), F = Q(), U = F.findIndex((ee) => ee === X), _ = F[U + D];
    (j = i.current) != null && j.loop && (_ = U + D < 0 ? F[F.length - 1] : U + D === F.length ? F[0] : F[U + D]), _ && E.setState("value", _.getAttribute(Vt));
  }
  function z(D) {
    let j = H(), X = j?.closest(pn), F;
    for (; X && !F; ) X = D > 0 ? jS(X, pn) : KS(X, pn), F = X?.querySelector(Zs);
    F ? E.setState("value", F.getAttribute(Vt)) : q(D);
  }
  let T = () => $(Q().length - 1), I = (D) => {
    D.preventDefault(), D.metaKey ? T() : D.altKey ? z(1) : q(1);
  }, le = (D) => {
    D.preventDefault(), D.metaKey ? $(0) : D.altKey ? z(-1) : q(-1);
  };
  return d.createElement(L.div, { ref: t, tabIndex: -1, ...y, "cmdk-root": "", onKeyDown: (D) => {
    var j;
    (j = y.onKeyDown) == null || j.call(y, D);
    let X = D.nativeEvent.isComposing || D.keyCode === 229;
    if (!(D.defaultPrevented || X)) switch (D.key) {
      case "n":
      case "j": {
        v && D.ctrlKey && I(D);
        break;
      }
      case "ArrowDown": {
        I(D);
        break;
      }
      case "p":
      case "k": {
        v && D.ctrlKey && le(D);
        break;
      }
      case "ArrowUp": {
        le(D);
        break;
      }
      case "Home": {
        D.preventDefault(), $(0);
        break;
      }
      case "End": {
        D.preventDefault(), T();
        break;
      }
      case "Enter": {
        D.preventDefault();
        let F = H();
        if (F) {
          let U = new Event(ta);
          F.dispatchEvent(U);
        }
      }
    }
  } }, d.createElement("label", { "cmdk-label": "", htmlFor: M.inputId, id: M.labelId, style: ZS }, l), to(e, (D) => d.createElement(hf.Provider, { value: E }, d.createElement(mf.Provider, { value: M }, D))));
}), $S = d.forwardRef((e, t) => {
  var n, r;
  let o = ge(), a = d.useRef(null), s = d.useContext(gf), i = zn(), l = bf(e), c = (r = (n = l.current) == null ? void 0 : n.forceMount) != null ? r : s?.forceMount;
  Tt(() => {
    if (!c) return i.item(o, s?.id);
  }, [c]);
  let f = yf(o, a, [e.value, e.children, a], e.keywords), u = qa(), m = vt((C) => C.value && C.value === f.current), h = vt((C) => c || i.filter() === !1 ? !0 : C.search ? C.filtered.items.get(o) > 0 : !0);
  d.useEffect(() => {
    let C = a.current;
    if (!(!C || e.disabled)) return C.addEventListener(ta, b), () => C.removeEventListener(ta, b);
  }, [h, e.onSelect, e.disabled]);
  function b() {
    var C, E;
    g(), (E = (C = l.current).onSelect) == null || E.call(C, f.current);
  }
  function g() {
    u.setState("value", f.current, !0);
  }
  if (!h) return null;
  let { disabled: v, value: y, onSelect: w, forceMount: x, keywords: S, ...k } = e;
  return d.createElement(L.div, { ref: nt(a, t), ...k, id: o, "cmdk-item": "", role: "option", "aria-disabled": !!v, "aria-selected": !!m, "data-disabled": !!v, "data-selected": !!m, onPointerMove: v || i.getDisablePointerSelection() ? void 0 : g, onClick: v ? void 0 : b }, e.children);
}), zS = d.forwardRef((e, t) => {
  let { heading: n, children: r, forceMount: o, ...a } = e, s = ge(), i = d.useRef(null), l = d.useRef(null), c = ge(), f = zn(), u = vt((h) => o || f.filter() === !1 ? !0 : h.search ? h.filtered.groups.has(s) : !0);
  Tt(() => f.group(s), []), yf(s, i, [e.value, e.heading, l]);
  let m = d.useMemo(() => ({ id: s, forceMount: o }), [o]);
  return d.createElement(L.div, { ref: nt(i, t), ...a, "cmdk-group": "", role: "presentation", hidden: u ? void 0 : !0 }, n && d.createElement("div", { ref: l, "cmdk-group-heading": "", "aria-hidden": !0, id: c }, n), to(e, (h) => d.createElement("div", { "cmdk-group-items": "", role: "group", "aria-labelledby": n ? c : void 0 }, d.createElement(gf.Provider, { value: m }, h))));
}), BS = d.forwardRef((e, t) => {
  let { alwaysRender: n, ...r } = e, o = d.useRef(null), a = vt((s) => !s.search);
  return !n && !a ? null : d.createElement(L.div, { ref: nt(o, t), ...r, "cmdk-separator": "", role: "separator" });
}), YS = d.forwardRef((e, t) => {
  let { onValueChange: n, ...r } = e, o = e.value != null, a = qa(), s = vt((c) => c.search), i = vt((c) => c.selectedItemId), l = zn();
  return d.useEffect(() => {
    e.value != null && a.setState("search", e.value);
  }, [e.value]), d.createElement(L.input, { ref: t, ...r, "cmdk-input": "", autoComplete: "off", autoCorrect: "off", spellCheck: !1, "aria-autocomplete": "list", role: "combobox", "aria-expanded": !0, "aria-controls": l.listId, "aria-labelledby": l.labelId, "aria-activedescendant": i, id: l.inputId, type: "text", value: o ? e.value : s, onChange: (c) => {
    o || a.setState("search", c.target.value), n?.(c.target.value);
  } });
}), HS = d.forwardRef((e, t) => {
  let { children: n, label: r = "Suggestions", ...o } = e, a = d.useRef(null), s = d.useRef(null), i = vt((c) => c.selectedItemId), l = zn();
  return d.useEffect(() => {
    if (s.current && a.current) {
      let c = s.current, f = a.current, u, m = new ResizeObserver(() => {
        u = requestAnimationFrame(() => {
          let h = c.offsetHeight;
          f.style.setProperty("--cmdk-list-height", h.toFixed(1) + "px");
        });
      });
      return m.observe(c), () => {
        cancelAnimationFrame(u), m.unobserve(c);
      };
    }
  }, []), d.createElement(L.div, { ref: nt(a, t), ...o, "cmdk-list": "", role: "listbox", tabIndex: -1, "aria-activedescendant": i, "aria-label": r, id: l.listId }, to(e, (c) => d.createElement("div", { ref: nt(s, l.listInnerRef), "cmdk-list-sizer": "" }, c)));
}), VS = d.forwardRef((e, t) => {
  let { open: n, onOpenChange: r, overlayClassName: o, contentClassName: a, container: s, ...i } = e;
  return d.createElement(Pr, { open: n, onOpenChange: r }, d.createElement(Dr, { container: s }, d.createElement(Or, { "cmdk-overlay": "", className: o }), d.createElement(Nr, { "aria-label": e.label, "cmdk-dialog": "", className: a }, d.createElement(vf, { ref: t, ...i }))));
}), GS = d.forwardRef((e, t) => vt((n) => n.filtered.count === 0) ? d.createElement(L.div, { ref: t, ...e, "cmdk-empty": "", role: "presentation" }) : null), US = d.forwardRef((e, t) => {
  let { progress: n, children: r, label: o = "Loading...", ...a } = e;
  return d.createElement(L.div, { ref: t, ...a, "cmdk-loading": "", role: "progressbar", "aria-valuenow": n, "aria-valuemin": 0, "aria-valuemax": 100, "aria-label": o }, to(e, (s) => d.createElement("div", { "aria-hidden": !0 }, s)));
}), Bn = Object.assign(vf, { List: HS, Item: $S, Input: YS, Group: zS, Separator: BS, Dialog: VS, Empty: GS, Loading: US });
function jS(e, t) {
  let n = e.nextElementSibling;
  for (; n; ) {
    if (n.matches(t)) return n;
    n = n.nextElementSibling;
  }
}
function KS(e, t) {
  let n = e.previousElementSibling;
  for (; n; ) {
    if (n.matches(t)) return n;
    n = n.previousElementSibling;
  }
}
function bf(e) {
  let t = d.useRef(e);
  return Tt(() => {
    t.current = e;
  }), t;
}
var Tt = typeof window > "u" ? d.useEffect : d.useLayoutEffect;
function Gt(e) {
  let t = d.useRef();
  return t.current === void 0 && (t.current = e()), t;
}
function vt(e) {
  let t = qa(), n = () => e(t.snapshot());
  return d.useSyncExternalStore(t.subscribe, n, n);
}
function yf(e, t, n, r = []) {
  let o = d.useRef(), a = zn();
  return Tt(() => {
    var s;
    let i = (() => {
      var c;
      for (let f of n) {
        if (typeof f == "string") return f.trim();
        if (typeof f == "object" && "current" in f) return f.current ? (c = f.current.textContent) == null ? void 0 : c.trim() : o.current;
      }
    })(), l = r.map((c) => c.trim());
    a.value(e, i, l), (s = t.current) == null || s.setAttribute(Vt, i), o.current = i;
  }), o;
}
var qS = () => {
  let [e, t] = d.useState(), n = Gt(() => /* @__PURE__ */ new Map());
  return Tt(() => {
    n.current.forEach((r) => r()), n.current = /* @__PURE__ */ new Map();
  }, [e]), (r, o) => {
    n.current.set(r, o), t({});
  };
};
function XS(e) {
  let t = e.type;
  return typeof t == "function" ? t(e.props) : "render" in t ? t.render(e.props) : e;
}
function to({ asChild: e, children: t }, n) {
  return e && d.isValidElement(t) ? d.cloneElement(XS(t), { ref: t.ref }, n(t.props.children)) : n(t);
}
var ZS = { position: "absolute", width: "1px", height: "1px", padding: "0", margin: "-1px", overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0" };
function yM({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ p(
    Bn,
    {
      "data-slot": "command",
      className: P(
        "flex h-full w-full flex-col overflow-hidden rounded-md bg-popover text-popover-foreground",
        e
      ),
      ...t
    }
  );
}
function wM({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ ae(
    "div",
    {
      "data-slot": "command-input-wrapper",
      className: "flex h-9 items-center gap-2 border-b px-3",
      children: [
        /* @__PURE__ */ p(cS, { className: "size-4 shrink-0 opacity-50" }),
        /* @__PURE__ */ p(
          Bn.Input,
          {
            "data-slot": "command-input",
            className: P(
              "flex h-10 w-full rounded-md bg-transparent py-3 text-sm outline-none placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50",
              e
            ),
            ...t
          }
        )
      ]
    }
  );
}
function xM({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ p(
    Bn.List,
    {
      "data-slot": "command-list",
      className: P(
        "max-h-[300px] scroll-py-1 overflow-x-hidden overflow-y-auto",
        e
      ),
      ...t
    }
  );
}
function SM({
  ...e
}) {
  return /* @__PURE__ */ p(
    Bn.Empty,
    {
      "data-slot": "command-empty",
      className: "py-6 text-center text-sm",
      ...e
    }
  );
}
function CM({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ p(
    Bn.Item,
    {
      "data-slot": "command-item",
      className: P(
        "relative flex cursor-default select-none items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none data-[disabled=true]:pointer-events-none data-[selected=true]:bg-accent data-[selected=true]:text-accent-foreground data-[disabled=true]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...t
    }
  );
}
function kM({ ...e }) {
  return /* @__PURE__ */ p(Pr, { "data-slot": "sheet", ...e });
}
function EM({
  ...e
}) {
  return /* @__PURE__ */ p(ha, { "data-slot": "sheet-trigger", ...e });
}
function MM({
  ...e
}) {
  return /* @__PURE__ */ p(Wt, { "data-slot": "sheet-close", ...e });
}
function QS({
  ...e
}) {
  return /* @__PURE__ */ p(Dr, { "data-slot": "sheet-portal", ...e });
}
function JS({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ p(
    Or,
    {
      "data-slot": "sheet-overlay",
      className: P(
        "fixed inset-0 z-50 bg-black/10 duration-100 supports-backdrop-filter:backdrop-blur-xs data-open:animate-in data-open:fade-in-0 data-closed:animate-out data-closed:fade-out-0",
        e
      ),
      ...t
    }
  );
}
function PM({
  className: e,
  children: t,
  side: n = "right",
  showCloseButton: r = !0,
  ...o
}) {
  return /* @__PURE__ */ ae(QS, { children: [
    /* @__PURE__ */ p(JS, {}),
    /* @__PURE__ */ ae(
      Nr,
      {
        "data-slot": "sheet-content",
        "data-side": n,
        className: P(
          "fixed z-50 flex flex-col gap-4 bg-popover bg-clip-padding text-sm text-popover-foreground shadow-lg transition duration-200 ease-in-out data-[side=bottom]:inset-x-0 data-[side=bottom]:bottom-0 data-[side=bottom]:h-auto data-[side=bottom]:border-t data-[side=left]:inset-y-0 data-[side=left]:left-0 data-[side=left]:h-full data-[side=left]:w-3/4 data-[side=left]:border-r data-[side=right]:inset-y-0 data-[side=right]:right-0 data-[side=right]:h-full data-[side=right]:w-3/4 data-[side=right]:border-l data-[side=top]:inset-x-0 data-[side=top]:top-0 data-[side=top]:h-auto data-[side=top]:border-b data-[side=left]:sm:max-w-sm data-[side=right]:sm:max-w-sm data-open:animate-in data-open:fade-in-0 data-[side=bottom]:data-open:slide-in-from-bottom-10 data-[side=left]:data-open:slide-in-from-left-10 data-[side=right]:data-open:slide-in-from-right-10 data-[side=top]:data-open:slide-in-from-top-10 data-closed:animate-out data-closed:fade-out-0 data-[side=bottom]:data-closed:slide-out-to-bottom-10 data-[side=left]:data-closed:slide-out-to-left-10 data-[side=right]:data-closed:slide-out-to-right-10 data-[side=top]:data-closed:slide-out-to-top-10",
          e
        ),
        ...o,
        children: [
          t,
          r && /* @__PURE__ */ p(Wt, { "data-slot": "sheet-close", asChild: !0, children: /* @__PURE__ */ ae(
            Et,
            {
              variant: "ghost",
              className: "absolute top-3 right-3",
              size: "icon-sm",
              children: [
                /* @__PURE__ */ p(lf, {}),
                /* @__PURE__ */ p("span", { className: "sr-only", children: "Close" })
              ]
            }
          ) })
        ]
      }
    )
  ] });
}
function DM({ className: e, ...t }) {
  return /* @__PURE__ */ p(
    "div",
    {
      "data-slot": "sheet-header",
      className: P("flex flex-col gap-0.5 p-4", e),
      ...t
    }
  );
}
function OM({ className: e, ...t }) {
  return /* @__PURE__ */ p(
    "div",
    {
      "data-slot": "sheet-footer",
      className: P("mt-auto flex flex-col gap-2 p-4", e),
      ...t
    }
  );
}
function NM({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ p(
    ga,
    {
      "data-slot": "sheet-title",
      className: P("text-base font-medium text-foreground", e),
      ...t
    }
  );
}
function _M({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ p(
    va,
    {
      "data-slot": "sheet-description",
      className: P("text-sm text-muted-foreground", e),
      ...t
    }
  );
}
function RM({
  ...e
}) {
  return /* @__PURE__ */ p(Yi, { "data-slot": "collapsible", ...e });
}
function TM({
  ...e
}) {
  return /* @__PURE__ */ p(
    aa,
    {
      "data-slot": "collapsible-trigger",
      ...e
    }
  );
}
function AM({
  ...e
}) {
  return /* @__PURE__ */ p(
    ia,
    {
      "data-slot": "collapsible-content",
      ...e
    }
  );
}
function IM({
  // Override: default delay is 700ms; 0 gives instant tooltips app-wide
  delayDuration: e = 0,
  ...t
}) {
  return /* @__PURE__ */ p(
    Fx,
    {
      "data-slot": "tooltip-provider",
      delayDuration: e,
      ...t
    }
  );
}
function WM({
  ...e
}) {
  return /* @__PURE__ */ p(Lx, { "data-slot": "tooltip", ...e });
}
function FM({
  ...e
}) {
  return /* @__PURE__ */ p($x, { "data-slot": "tooltip-trigger", ...e });
}
function LM({
  className: e,
  sideOffset: t = 0,
  children: n,
  ...r
}) {
  return /* @__PURE__ */ p(zx, { children: /* @__PURE__ */ ae(
    Bx,
    {
      "data-slot": "tooltip-content",
      sideOffset: t,
      className: P(
        "z-50 inline-flex w-fit max-w-xs origin-(--radix-tooltip-content-transform-origin) items-center gap-1.5 rounded-md bg-foreground px-3 py-1.5 text-xs text-background has-data-[slot=kbd]:pr-1.5 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 **:data-[slot=kbd]:relative **:data-[slot=kbd]:isolate **:data-[slot=kbd]:z-50 **:data-[slot=kbd]:rounded-sm data-[state=delayed-open]:animate-in data-[state=delayed-open]:fade-in-0 data-[state=delayed-open]:zoom-in-95 data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95",
        e
      ),
      ...r,
      children: [
        n,
        /* @__PURE__ */ p(Yx, { className: "z-50 size-2.5 translate-y-[calc(-50%_-_2px)] rotate-45 rounded-[2px] bg-foreground fill-foreground" })
      ]
    }
  ) });
}
function $M({
  ...e
}) {
  return /* @__PURE__ */ p(Pr, { "data-slot": "dialog", ...e });
}
function zM({
  ...e
}) {
  return /* @__PURE__ */ p(ha, { "data-slot": "dialog-trigger", ...e });
}
function eC({
  ...e
}) {
  return /* @__PURE__ */ p(Dr, { "data-slot": "dialog-portal", ...e });
}
function BM({
  ...e
}) {
  return /* @__PURE__ */ p(Wt, { "data-slot": "dialog-close", ...e });
}
function tC({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ p(
    Or,
    {
      "data-slot": "dialog-overlay",
      className: P(
        "fixed inset-0 isolate z-50 bg-black/10 duration-100 supports-backdrop-filter:backdrop-blur-xs data-open:animate-in data-open:fade-in-0 data-closed:animate-out data-closed:fade-out-0",
        e
      ),
      ...t
    }
  );
}
function YM({
  className: e,
  children: t,
  showCloseButton: n = !0,
  ...r
}) {
  return /* @__PURE__ */ ae(eC, { children: [
    /* @__PURE__ */ p(tC, {}),
    /* @__PURE__ */ ae(
      Nr,
      {
        "data-slot": "dialog-content",
        className: P(
          "fixed top-1/2 left-1/2 z-50 grid w-full max-w-[calc(100%-2rem)] -translate-x-1/2 -translate-y-1/2 gap-4 rounded-xl bg-popover p-4 text-sm text-popover-foreground ring-1 ring-foreground/10 duration-100 outline-none sm:max-w-sm data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95",
          e
        ),
        ...r,
        children: [
          t,
          n && /* @__PURE__ */ p(Wt, { "data-slot": "dialog-close", asChild: !0, children: /* @__PURE__ */ ae(
            Et,
            {
              variant: "ghost",
              className: "absolute top-2 right-2",
              size: "icon-sm",
              children: [
                /* @__PURE__ */ p(lf, {}),
                /* @__PURE__ */ p("span", { className: "sr-only", children: "Close" })
              ]
            }
          ) })
        ]
      }
    )
  ] });
}
function HM({ className: e, ...t }) {
  return /* @__PURE__ */ p(
    "div",
    {
      "data-slot": "dialog-header",
      className: P("flex flex-col gap-2", e),
      ...t
    }
  );
}
function VM({
  className: e,
  showCloseButton: t = !1,
  children: n,
  ...r
}) {
  return /* @__PURE__ */ ae(
    "div",
    {
      "data-slot": "dialog-footer",
      className: P(
        "-mx-4 -mb-4 flex flex-col-reverse gap-2 rounded-b-xl border-t bg-muted/50 p-4 sm:flex-row sm:justify-end",
        e
      ),
      ...r,
      children: [
        n,
        t && /* @__PURE__ */ p(Wt, { asChild: !0, children: /* @__PURE__ */ p(Et, { variant: "outline", children: "Close" }) })
      ]
    }
  );
}
function GM({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ p(
    ga,
    {
      "data-slot": "dialog-title",
      className: P(
        "cn-font-heading text-base leading-none font-medium",
        e
      ),
      ...t
    }
  );
}
function UM({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ p(
    va,
    {
      "data-slot": "dialog-description",
      className: P(
        "text-sm text-muted-foreground *:[a]:underline *:[a]:underline-offset-3 *:[a]:hover:text-foreground",
        e
      ),
      ...t
    }
  );
}
function jM({
  ...e
}) {
  return /* @__PURE__ */ p(ly, { "data-slot": "dropdown-menu", ...e });
}
function KM({
  ...e
}) {
  return /* @__PURE__ */ p(vd, { "data-slot": "dropdown-menu-portal", ...e });
}
function qM({
  ...e
}) {
  return /* @__PURE__ */ p(
    cy,
    {
      "data-slot": "dropdown-menu-trigger",
      ...e
    }
  );
}
function XM({
  className: e,
  align: t = "start",
  sideOffset: n = 4,
  ...r
}) {
  return /* @__PURE__ */ p(vd, { children: /* @__PURE__ */ p(
    dy,
    {
      "data-slot": "dropdown-menu-content",
      sideOffset: n,
      align: t,
      className: P(
        "z-50 max-h-(--radix-dropdown-menu-content-available-height) w-(--radix-dropdown-menu-trigger-width) min-w-32 origin-(--radix-dropdown-menu-content-transform-origin) overflow-x-hidden overflow-y-auto rounded-lg bg-popover p-1 text-popover-foreground shadow-md ring-1 ring-foreground/10 duration-100 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:overflow-hidden data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95",
        e
      ),
      ...r
    }
  ) });
}
function ZM({
  ...e
}) {
  return /* @__PURE__ */ p(uy, { "data-slot": "dropdown-menu-group", ...e });
}
function QM({
  className: e,
  inset: t,
  variant: n = "default",
  ...r
}) {
  return /* @__PURE__ */ p(
    py,
    {
      "data-slot": "dropdown-menu-item",
      "data-inset": t,
      "data-variant": n,
      className: P(
        "group/dropdown-menu-item relative flex cursor-default items-center gap-1.5 rounded-md px-1.5 py-1 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground not-data-[variant=destructive]:focus:**:text-accent-foreground data-inset:pl-7 data-[variant=destructive]:text-destructive data-[variant=destructive]:focus:bg-destructive/10 data-[variant=destructive]:focus:text-destructive dark:data-[variant=destructive]:focus:bg-destructive/20 data-disabled:pointer-events-none data-disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 data-[variant=destructive]:*:[svg]:text-destructive",
        e
      ),
      ...r
    }
  );
}
function JM({
  className: e,
  children: t,
  checked: n,
  inset: r,
  ...o
}) {
  return /* @__PURE__ */ ae(
    my,
    {
      "data-slot": "dropdown-menu-checkbox-item",
      "data-inset": r,
      className: P(
        "relative flex cursor-default items-center gap-1.5 rounded-md py-1 pr-8 pl-1.5 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground focus:**:text-accent-foreground data-inset:pl-7 data-disabled:pointer-events-none data-disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      checked: n,
      ...o,
      children: [
        /* @__PURE__ */ p(
          "span",
          {
            className: "pointer-events-none absolute right-2 flex items-center justify-center",
            "data-slot": "dropdown-menu-checkbox-item-indicator",
            children: /* @__PURE__ */ p(bd, { children: /* @__PURE__ */ p(Jr, {}) })
          }
        ),
        t
      ]
    }
  );
}
function eP({
  ...e
}) {
  return /* @__PURE__ */ p(
    hy,
    {
      "data-slot": "dropdown-menu-radio-group",
      ...e
    }
  );
}
function tP({
  className: e,
  children: t,
  inset: n,
  ...r
}) {
  return /* @__PURE__ */ ae(
    gy,
    {
      "data-slot": "dropdown-menu-radio-item",
      "data-inset": n,
      className: P(
        "relative flex cursor-default items-center gap-1.5 rounded-md py-1 pr-8 pl-1.5 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground focus:**:text-accent-foreground data-inset:pl-7 data-disabled:pointer-events-none data-disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...r,
      children: [
        /* @__PURE__ */ p(
          "span",
          {
            className: "pointer-events-none absolute right-2 flex items-center justify-center",
            "data-slot": "dropdown-menu-radio-item-indicator",
            children: /* @__PURE__ */ p(bd, { children: /* @__PURE__ */ p(Jr, {}) })
          }
        ),
        t
      ]
    }
  );
}
function nP({
  className: e,
  inset: t,
  ...n
}) {
  return /* @__PURE__ */ p(
    fy,
    {
      "data-slot": "dropdown-menu-label",
      "data-inset": t,
      className: P(
        "px-1.5 py-1 text-xs font-medium text-muted-foreground data-inset:pl-7",
        e
      ),
      ...n
    }
  );
}
function rP({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ p(
    vy,
    {
      "data-slot": "dropdown-menu-separator",
      className: P("-mx-1 my-1 h-px bg-border", e),
      ...t
    }
  );
}
function oP({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ p(
    "span",
    {
      "data-slot": "dropdown-menu-shortcut",
      className: P(
        "ml-auto text-xs tracking-widest text-muted-foreground group-focus/dropdown-menu-item:text-accent-foreground",
        e
      ),
      ...t
    }
  );
}
function aP({
  ...e
}) {
  return /* @__PURE__ */ p(by, { "data-slot": "dropdown-menu-sub", ...e });
}
function sP({
  className: e,
  inset: t,
  children: n,
  ...r
}) {
  return /* @__PURE__ */ ae(
    yy,
    {
      "data-slot": "dropdown-menu-sub-trigger",
      "data-inset": t,
      className: P(
        "flex cursor-default items-center gap-1.5 rounded-md px-1.5 py-1 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground not-data-[variant=destructive]:focus:**:text-accent-foreground data-inset:pl-7 data-open:bg-accent data-open:text-accent-foreground [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...r,
      children: [
        n,
        /* @__PURE__ */ p(Ka, { className: "cn-rtl-flip ml-auto" })
      ]
    }
  );
}
function iP({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ p(
    wy,
    {
      "data-slot": "dropdown-menu-sub-content",
      className: P(
        "z-50 min-w-[96px] origin-(--radix-dropdown-menu-content-transform-origin) overflow-hidden rounded-lg bg-popover p-1 text-popover-foreground shadow-lg ring-1 ring-foreground/10 duration-100 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95",
        e
      ),
      ...t
    }
  );
}
function nC(e, t, n = "long") {
  return new Intl.DateTimeFormat("en-US", {
    // Enforces engine to render the time. Without the option JavaScriptCore omits it.
    hour: "numeric",
    timeZone: e,
    timeZoneName: n
  }).format(t).split(/\s/g).slice(2).join(" ");
}
const rC = {}, bn = {};
function Je(e, t) {
  try {
    const r = (rC[e] ||= new Intl.DateTimeFormat("en-US", {
      timeZone: e,
      timeZoneName: "longOffset"
    }).format)(t).split("GMT")[1];
    return r in bn ? bn[r] : Qs(r, r.split(":"));
  } catch {
    if (e in bn) return bn[e];
    const n = e?.match(oC);
    return n ? Qs(e, n.slice(1)) : NaN;
  }
}
const oC = /([+-]\d\d):?(\d\d)?/;
function Qs(e, t) {
  const n = +(t[0] || 0), r = +(t[1] || 0), o = +(t[2] || 0) / 60;
  return bn[e] = n * 60 + r > 0 ? n * 60 + r + o : n * 60 - r - o;
}
class je extends Date {
  //#region static
  constructor(...t) {
    super(), t.length > 1 && typeof t[t.length - 1] == "string" && (this.timeZone = t.pop()), this.internal = /* @__PURE__ */ new Date(), isNaN(Je(this.timeZone, this)) ? this.setTime(NaN) : t.length ? typeof t[0] == "number" && (t.length === 1 || t.length === 2 && typeof t[1] != "number") ? this.setTime(t[0]) : typeof t[0] == "string" ? this.setTime(+new Date(t[0])) : t[0] instanceof Date ? this.setTime(+t[0]) : (this.setTime(+new Date(...t)), wf(this, t)) : this.setTime(Date.now());
  }
  static tz(t, ...n) {
    return n.length ? new je(...n, t) : new je(Date.now(), t);
  }
  //#endregion
  //#region time zone
  withTimeZone(t) {
    return new je(+this, t);
  }
  getTimezoneOffset() {
    const t = -Je(this.timeZone, this);
    return t > 0 ? Math.floor(t) : Math.ceil(t);
  }
  //#endregion
  //#region time
  setTime(t) {
    return Date.prototype.setTime.apply(this, arguments), br(this), +this;
  }
  //#endregion
  //#region date-fns integration
  [/* @__PURE__ */ Symbol.for("constructDateFrom")](t) {
    return new je(+new Date(t), this.timeZone);
  }
  //#endregion
}
const Js = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((e) => {
  if (!Js.test(e)) return;
  const t = e.replace(Js, "$1UTC");
  je.prototype[t] && (e.startsWith("get") ? je.prototype[e] = function() {
    return this.internal[t]();
  } : (je.prototype[e] = function() {
    return Date.prototype[t].apply(this.internal, arguments), aC(this), +this;
  }, je.prototype[t] = function() {
    return Date.prototype[t].apply(this, arguments), br(this), +this;
  }));
});
function br(e) {
  e.internal.setTime(+e), e.internal.setUTCSeconds(e.internal.getUTCSeconds() - // Round after converting minutes to seconds to avoid fractional offset
  // precision errors from historical offsets.
  Math.round(-Je(e.timeZone, e) * 60));
}
function aC(e) {
  Date.prototype.setFullYear.call(e, e.internal.getUTCFullYear(), e.internal.getUTCMonth(), e.internal.getUTCDate()), Date.prototype.setHours.call(e, e.internal.getUTCHours(), e.internal.getUTCMinutes(), e.internal.getUTCSeconds(), e.internal.getUTCMilliseconds()), wf(e);
}
function wf(e, t) {
  const n = Array.isArray(t) ? sC(t) : +e.internal, r = Je(e.timeZone, e), o = r > 0 ? Math.floor(r) : Math.ceil(r), a = /* @__PURE__ */ new Date(+e);
  a.setUTCHours(a.getUTCHours() - 1);
  const s = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset(), i = -(/* @__PURE__ */ new Date(+a)).getTimezoneOffset(), l = s - i;
  let c = s;
  if (l && s !== o) {
    const O = Date.prototype.getHours.apply(e), R = Array.isArray(t) ? t[3] || 0 : e.internal.getUTCHours();
    if (O !== R) {
      const W = /* @__PURE__ */ new Date(+e), Y = s - o;
      Y && W.setUTCMinutes(W.getUTCMinutes() + Y);
      const K = Je(e.timeZone, W);
      (K > 0 ? Math.floor(K) : Math.ceil(K)) === o && (c = i);
    }
  }
  const f = c - o;
  f && Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + f);
  const u = /* @__PURE__ */ new Date(+e);
  u.setUTCSeconds(0);
  const m = s > 0 ? u.getSeconds() : (u.getSeconds() - 60) % 60, h = Math.round(-(Je(e.timeZone, e) * 60)) % 60;
  (h || m) && Date.prototype.setUTCSeconds.call(e, Date.prototype.getUTCSeconds.call(e) + h + m);
  const b = Je(e.timeZone, e), g = b > 0 ? Math.floor(b) : Math.ceil(b), y = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset() - g, w = g !== o, x = y - f, S = g - o, k = n - g * 60 * 1e3, C = S > 0 && ei(e) - n === S * 60 * 1e3 && ei(e, k) !== n;
  if (w && x && !C) {
    Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + x);
    const O = Je(e.timeZone, e), R = O > 0 ? Math.floor(O) : Math.ceil(O), W = g - R;
    W && x < 0 && Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + W);
  }
  br(e);
  const M = (t ? n : n + h * 1e3) - +e.internal;
  M && Math.abs(M) < 1800 * 1e3 && (Date.prototype.setTime.call(e, +e + M), br(e));
}
function sC(e) {
  return Date.UTC(e[0], e.length > 1 ? e[1] : 0, e.length > 2 ? e[2] : 1, ...e.slice(3));
}
function ei(e, t) {
  const n = new Date(t ?? +e);
  return n.setUTCSeconds(n.getUTCSeconds() - Math.round(-Je(e.timeZone, n) * 60)), +n;
}
class Ee extends je {
  //#region static
  static tz(t, ...n) {
    return n.length ? new Ee(...n, t) : new Ee(Date.now(), t);
  }
  //#endregion
  //#region representation
  toISOString() {
    const [t, n, r] = this.tzComponents(), o = `${t}${n}:${r}`;
    return this.internal.toISOString().slice(0, -1) + o;
  }
  toString() {
    return `${this.toDateString()} ${this.toTimeString()}`;
  }
  toDateString() {
    const [t, n, r, o] = this.internal.toUTCString().split(" ");
    return `${t?.slice(0, -1)} ${r} ${n} ${o}`;
  }
  toTimeString() {
    const t = this.internal.toUTCString().split(" ")[4], [n, r, o] = this.tzComponents();
    return `${t} GMT${n}${r}${o} (${nC(this.timeZone, this)})`;
  }
  toLocaleString(t, n) {
    return Date.prototype.toLocaleString.call(this, t, {
      ...n,
      timeZone: n?.timeZone || this.timeZone
    });
  }
  toLocaleDateString(t, n) {
    return Date.prototype.toLocaleDateString.call(this, t, {
      ...n,
      timeZone: n?.timeZone || this.timeZone
    });
  }
  toLocaleTimeString(t, n) {
    return Date.prototype.toLocaleTimeString.call(this, t, {
      ...n,
      timeZone: n?.timeZone || this.timeZone
    });
  }
  //#endregion
  //#region private
  tzComponents() {
    const t = this.getTimezoneOffset(), n = t > 0 ? "-" : "+", r = String(Math.floor(Math.abs(t) / 60)).padStart(2, "0"), o = String(Math.abs(t) % 60).padStart(2, "0");
    return [n, r, o];
  }
  //#endregion
  withTimeZone(t) {
    return new Ee(+this, t);
  }
  //#region date-fns integration
  [/* @__PURE__ */ Symbol.for("constructDateFrom")](t) {
    return new Ee(+new Date(t), this.timeZone);
  }
  //#endregion
}
const xf = 6048e5, iC = 864e5, ti = /* @__PURE__ */ Symbol.for("constructDateFrom");
function be(e, t) {
  return typeof e == "function" ? e(t) : e && typeof e == "object" && ti in e ? e[ti](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
function fe(e, t) {
  return be(t || e, e);
}
function Sf(e, t, n) {
  const r = fe(e, n?.in);
  return isNaN(t) ? be(e, NaN) : (t && r.setDate(r.getDate() + t), r);
}
function Cf(e, t, n) {
  const r = fe(e, n?.in);
  if (isNaN(t)) return be(e, NaN);
  if (!t)
    return r;
  const o = r.getDate(), a = be(e, r.getTime());
  a.setMonth(r.getMonth() + t + 1, 0);
  const s = a.getDate();
  return o >= s ? a : (r.setFullYear(
    a.getFullYear(),
    a.getMonth(),
    o
  ), r);
}
let lC = {};
function Yn() {
  return lC;
}
function en(e, t) {
  const n = Yn(), r = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, o = fe(e, t?.in), a = o.getDay(), s = (a < r ? 7 : 0) + a - r;
  return o.setDate(o.getDate() - s), o.setHours(0, 0, 0, 0), o;
}
function Mn(e, t) {
  return en(e, { ...t, weekStartsOn: 1 });
}
function kf(e, t) {
  const n = fe(e, t?.in), r = n.getFullYear(), o = be(n, 0);
  o.setFullYear(r + 1, 0, 4), o.setHours(0, 0, 0, 0);
  const a = Mn(o), s = be(n, 0);
  s.setFullYear(r, 0, 4), s.setHours(0, 0, 0, 0);
  const i = Mn(s);
  return n.getTime() >= a.getTime() ? r + 1 : n.getTime() >= i.getTime() ? r : r - 1;
}
function ni(e) {
  const t = fe(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function cn(e, ...t) {
  const n = be.bind(
    null,
    t.find((r) => typeof r == "object")
  );
  return t.map(n);
}
function Pn(e, t) {
  const n = fe(e, t?.in);
  return n.setHours(0, 0, 0, 0), n;
}
function Xa(e, t, n) {
  const [r, o] = cn(
    n?.in,
    e,
    t
  ), a = Pn(r), s = Pn(o), i = +a - ni(a), l = +s - ni(s);
  return Math.round((i - l) / iC);
}
function cC(e, t) {
  const n = kf(e, t), r = be(e, 0);
  return r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0), Mn(r);
}
function dC(e, t, n) {
  return Sf(e, t * 7, n);
}
function uC(e, t, n) {
  return Cf(e, t * 12, n);
}
function fC(e, t) {
  let n, r = t?.in;
  return e.forEach((o) => {
    !r && typeof o == "object" && (r = be.bind(null, o));
    const a = fe(o, r);
    (!n || n < a || isNaN(+a)) && (n = a);
  }), be(r, n || NaN);
}
function pC(e, t) {
  let n, r = t?.in;
  return e.forEach((o) => {
    !r && typeof o == "object" && (r = be.bind(null, o));
    const a = fe(o, r);
    (!n || n > a || isNaN(+a)) && (n = a);
  }), be(r, n || NaN);
}
function mC(e, t, n) {
  const [r, o] = cn(
    n?.in,
    e,
    t
  );
  return +Pn(r) == +Pn(o);
}
function Ef(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function hC(e) {
  return !(!Ef(e) && typeof e != "number" || isNaN(+fe(e)));
}
function Mf(e, t, n) {
  const [r, o] = cn(
    n?.in,
    e,
    t
  ), a = r.getFullYear() - o.getFullYear(), s = r.getMonth() - o.getMonth();
  return a * 12 + s;
}
function gC(e, t) {
  const n = fe(e, t?.in), r = n.getMonth();
  return n.setFullYear(n.getFullYear(), r + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function Pf(e, t) {
  const [n, r] = cn(e, t.start, t.end);
  return { start: n, end: r };
}
function vC(e, t) {
  const { start: n, end: r } = Pf(t?.in, e);
  let o = +n > +r;
  const a = o ? +n : +r, s = o ? r : n;
  s.setHours(0, 0, 0, 0), s.setDate(1);
  let i = 1;
  const l = [];
  for (; +s <= a; )
    l.push(be(n, s)), s.setMonth(s.getMonth() + i);
  return o ? l.reverse() : l;
}
function bC(e, t) {
  const n = fe(e, t?.in);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function yC(e, t) {
  const n = fe(e, t?.in), r = n.getFullYear();
  return n.setFullYear(r + 1, 0, 0), n.setHours(23, 59, 59, 999), n;
}
function Df(e, t) {
  const n = fe(e, t?.in);
  return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function wC(e, t) {
  const { start: n, end: r } = Pf(t?.in, e);
  let o = +n > +r;
  const a = o ? +n : +r, s = o ? r : n;
  s.setHours(0, 0, 0, 0), s.setMonth(0, 1);
  let i = 1;
  const l = [];
  for (; +s <= a; )
    l.push(be(n, s)), s.setFullYear(s.getFullYear() + i);
  return o ? l.reverse() : l;
}
function Of(e, t) {
  const n = Yn(), r = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, o = fe(e, t?.in), a = o.getDay(), s = (a < r ? -7 : 0) + 6 - (a - r);
  return o.setDate(o.getDate() + s), o.setHours(23, 59, 59, 999), o;
}
function xC(e, t) {
  return Of(e, { ...t, weekStartsOn: 1 });
}
const SC = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, CC = (e, t, n) => {
  let r;
  const o = SC[e];
  return typeof o == "string" ? r = o : t === 1 ? r = o.one : r = o.other.replace("{{count}}", t.toString()), n?.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function Do(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const kC = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, EC = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, MC = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, PC = {
  date: Do({
    formats: kC,
    defaultWidth: "full"
  }),
  time: Do({
    formats: EC,
    defaultWidth: "full"
  }),
  dateTime: Do({
    formats: MC,
    defaultWidth: "full"
  })
}, DC = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, OC = (e, t, n, r) => DC[e];
function mn(e) {
  return (t, n) => {
    const r = n?.context ? String(n.context) : "standalone";
    let o;
    if (r === "formatting" && e.formattingValues) {
      const s = e.defaultFormattingWidth || e.defaultWidth, i = n?.width ? String(n.width) : s;
      o = e.formattingValues[i] || e.formattingValues[s];
    } else {
      const s = e.defaultWidth, i = n?.width ? String(n.width) : e.defaultWidth;
      o = e.values[i] || e.values[s];
    }
    const a = e.argumentCallback ? e.argumentCallback(t) : t;
    return o[a];
  };
}
const NC = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, _C = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, RC = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, TC = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, AC = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, IC = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, WC = (e, t) => {
  const n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, FC = {
  ordinalNumber: WC,
  era: mn({
    values: NC,
    defaultWidth: "wide"
  }),
  quarter: mn({
    values: _C,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: mn({
    values: RC,
    defaultWidth: "wide"
  }),
  day: mn({
    values: TC,
    defaultWidth: "wide"
  }),
  dayPeriod: mn({
    values: AC,
    defaultWidth: "wide",
    formattingValues: IC,
    defaultFormattingWidth: "wide"
  })
};
function hn(e) {
  return (t, n = {}) => {
    const r = n.width, o = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], a = t.match(o);
    if (!a)
      return null;
    const s = a[0], i = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(i) ? $C(i, (u) => u.test(s)) : (
      // [TODO] -- I challenge you to fix the type
      LC(i, (u) => u.test(s))
    );
    let c;
    c = e.valueCallback ? e.valueCallback(l) : l, c = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(c)
    ) : c;
    const f = t.slice(s.length);
    return { value: c, rest: f };
  };
}
function LC(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function $C(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function zC(e) {
  return (t, n = {}) => {
    const r = t.match(e.matchPattern);
    if (!r) return null;
    const o = r[0], a = t.match(e.parsePattern);
    if (!a) return null;
    let s = e.valueCallback ? e.valueCallback(a[0]) : a[0];
    s = n.valueCallback ? n.valueCallback(s) : s;
    const i = t.slice(o.length);
    return { value: s, rest: i };
  };
}
const BC = /^(\d+)(th|st|nd|rd)?/i, YC = /\d+/i, HC = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, VC = {
  any: [/^b/i, /^(a|c)/i]
}, GC = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, UC = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, jC = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, KC = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, qC = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, XC = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, ZC = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, QC = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, JC = {
  ordinalNumber: zC({
    matchPattern: BC,
    parsePattern: YC,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: hn({
    matchPatterns: HC,
    defaultMatchWidth: "wide",
    parsePatterns: VC,
    defaultParseWidth: "any"
  }),
  quarter: hn({
    matchPatterns: GC,
    defaultMatchWidth: "wide",
    parsePatterns: UC,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: hn({
    matchPatterns: jC,
    defaultMatchWidth: "wide",
    parsePatterns: KC,
    defaultParseWidth: "any"
  }),
  day: hn({
    matchPatterns: qC,
    defaultMatchWidth: "wide",
    parsePatterns: XC,
    defaultParseWidth: "any"
  }),
  dayPeriod: hn({
    matchPatterns: ZC,
    defaultMatchWidth: "any",
    parsePatterns: QC,
    defaultParseWidth: "any"
  })
}, Ut = {
  code: "en-US",
  formatDistance: CC,
  formatLong: PC,
  formatRelative: OC,
  localize: FC,
  match: JC,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function e0(e, t) {
  const n = fe(e, t?.in);
  return Xa(n, Df(n)) + 1;
}
function Za(e, t) {
  const n = fe(e, t?.in), r = +Mn(n) - +cC(n);
  return Math.round(r / xf) + 1;
}
function Nf(e, t) {
  const n = fe(e, t?.in), r = n.getFullYear(), o = Yn(), a = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? o.firstWeekContainsDate ?? o.locale?.options?.firstWeekContainsDate ?? 1, s = be(t?.in || e, 0);
  s.setFullYear(r + 1, 0, a), s.setHours(0, 0, 0, 0);
  const i = en(s, t), l = be(t?.in || e, 0);
  l.setFullYear(r, 0, a), l.setHours(0, 0, 0, 0);
  const c = en(l, t);
  return +n >= +i ? r + 1 : +n >= +c ? r : r - 1;
}
function t0(e, t) {
  const n = Yn(), r = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? n.firstWeekContainsDate ?? n.locale?.options?.firstWeekContainsDate ?? 1, o = Nf(e, t), a = be(t?.in || e, 0);
  return a.setFullYear(o, 0, r), a.setHours(0, 0, 0, 0), en(a, t);
}
function Qa(e, t) {
  const n = fe(e, t?.in), r = +en(n, t) - +t0(n, t);
  return Math.round(r / xf) + 1;
}
function ue(e, t) {
  const n = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(t, "0");
  return n + r;
}
const dt = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), r = n > 0 ? n : 1 - n;
    return ue(t === "yy" ? r % 100 : r, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : ue(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return ue(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return ue(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return ue(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return ue(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return ue(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, r = e.getMilliseconds(), o = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return ue(o, t.length);
  }
}, Yt = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, ri = {
  // Era
  G: function(e, t, n) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const r = e.getFullYear(), o = r > 0 ? r : 1 - r;
      return n.ordinalNumber(o, { unit: "year" });
    }
    return dt.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, r) {
    const o = Nf(e, r), a = o > 0 ? o : 1 - o;
    if (t === "YY") {
      const s = a % 100;
      return ue(s, 2);
    }
    return t === "Yo" ? n.ordinalNumber(a, { unit: "year" }) : ue(a, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = kf(e);
    return ue(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return ue(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "Q":
        return String(r);
      // 01, 02, 03, 04
      case "QQ":
        return ue(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "q":
        return String(r);
      // 01, 02, 03, 04
      case "qq":
        return ue(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return dt.M(e, t);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      // 1, 2, ..., 12
      case "L":
        return String(r + 1);
      // 01, 02, ..., 12
      case "LL":
        return ue(r + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, r) {
    const o = Qa(e, r);
    return t === "wo" ? n.ordinalNumber(o, { unit: "week" }) : ue(o, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const r = Za(e);
    return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : ue(r, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : dt.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const r = e0(e);
    return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : ue(r, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const r = e.getDay();
    switch (t) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, r) {
    const o = e.getDay(), a = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(a);
      // Padded numerical value
      case "ee":
        return ue(a, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return n.ordinalNumber(a, { unit: "day" });
      case "eee":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, r) {
    const o = e.getDay(), a = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (same as in `e`)
      case "c":
        return String(a);
      // Padded numerical value
      case "cc":
        return ue(a, t.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return n.ordinalNumber(a, { unit: "day" });
      case "ccc":
        return n.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return n.day(o, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(o, {
          width: "short",
          context: "standalone"
        });
      default:
        return n.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const r = e.getDay(), o = r === 0 ? 7 : r;
    switch (t) {
      // 2
      case "i":
        return String(o);
      // 02
      case "ii":
        return ue(o, t.length);
      // 2nd
      case "io":
        return n.ordinalNumber(o, { unit: "day" });
      // Tue
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const o = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r === 12 ? o = Yt.noon : r === 0 ? o = Yt.midnight : o = r / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r >= 17 ? o = Yt.evening : r >= 12 ? o = Yt.afternoon : r >= 4 ? o = Yt.morning : o = Yt.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return dt.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : dt.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const r = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : ue(r, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let r = e.getHours();
    return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : ue(r, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : dt.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : dt.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return dt.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (t) {
      // Hours and optional minutes
      case "X":
        return ai(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return Dt(r);
      // Hours and minutes with `:` delimiter
      default:
        return Dt(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Hours and optional minutes
      case "x":
        return ai(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return Dt(r);
      // Hours and minutes with `:` delimiter
      default:
        return Dt(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + oi(r, ":");
      default:
        return "GMT" + Dt(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + oi(r, ":");
      default:
        return "GMT" + Dt(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const r = Math.trunc(+e / 1e3);
    return ue(r, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    return ue(+e, t.length);
  }
};
function oi(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = Math.trunc(r / 60), a = r % 60;
  return a === 0 ? n + String(o) : n + String(o) + t + ue(a, 2);
}
function ai(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + ue(Math.abs(e) / 60, 2) : Dt(e, t);
}
function Dt(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = ue(Math.trunc(r / 60), 2), a = ue(r % 60, 2);
  return n + o + t + a;
}
const si = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    default:
      return t.date({ width: "full" });
  }
}, _f = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    default:
      return t.time({ width: "full" });
  }
}, n0 = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], r = n[1], o = n[2];
  if (!o)
    return si(e, t);
  let a;
  switch (r) {
    case "P":
      a = t.dateTime({ width: "short" });
      break;
    case "PP":
      a = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      a = t.dateTime({ width: "long" });
      break;
    default:
      a = t.dateTime({ width: "full" });
      break;
  }
  return a.replace("{{date}}", si(r, t)).replace("{{time}}", _f(o, t));
}, r0 = {
  p: _f,
  P: n0
}, o0 = /^D+$/, a0 = /^Y+$/, s0 = ["D", "DD", "YY", "YYYY"];
function i0(e) {
  return o0.test(e);
}
function l0(e) {
  return a0.test(e);
}
function c0(e, t, n) {
  const r = d0(e, t, n);
  if (console.warn(r), s0.includes(e)) throw new RangeError(r);
}
function d0(e, t, n) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const u0 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, f0 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, p0 = /^'([^]*?)'?$/, m0 = /''/g, h0 = /[a-zA-Z]/;
function yn(e, t, n) {
  const r = Yn(), o = n?.locale ?? r.locale ?? Ut, a = n?.firstWeekContainsDate ?? n?.locale?.options?.firstWeekContainsDate ?? r.firstWeekContainsDate ?? r.locale?.options?.firstWeekContainsDate ?? 1, s = n?.weekStartsOn ?? n?.locale?.options?.weekStartsOn ?? r.weekStartsOn ?? r.locale?.options?.weekStartsOn ?? 0, i = fe(e, n?.in);
  if (!hC(i))
    throw new RangeError("Invalid time value");
  let l = t.match(f0).map((f) => {
    const u = f[0];
    if (u === "p" || u === "P") {
      const m = r0[u];
      return m(f, o.formatLong);
    }
    return f;
  }).join("").match(u0).map((f) => {
    if (f === "''")
      return { isToken: !1, value: "'" };
    const u = f[0];
    if (u === "'")
      return { isToken: !1, value: g0(f) };
    if (ri[u])
      return { isToken: !0, value: f };
    if (u.match(h0))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + u + "`"
      );
    return { isToken: !1, value: f };
  });
  o.localize.preprocessor && (l = o.localize.preprocessor(i, l));
  const c = {
    firstWeekContainsDate: a,
    weekStartsOn: s,
    locale: o
  };
  return l.map((f) => {
    if (!f.isToken) return f.value;
    const u = f.value;
    (!n?.useAdditionalWeekYearTokens && l0(u) || !n?.useAdditionalDayOfYearTokens && i0(u)) && c0(u, t, String(e));
    const m = ri[u[0]];
    return m(i, u, o.localize, c);
  }).join("");
}
function g0(e) {
  const t = e.match(p0);
  return t ? t[1].replace(m0, "'") : e;
}
function v0(e, t) {
  const n = fe(e, t?.in), r = n.getFullYear(), o = n.getMonth(), a = be(n, 0);
  return a.setFullYear(r, o + 1, 0), a.setHours(0, 0, 0, 0), a.getDate();
}
function b0(e, t) {
  return fe(e, t?.in).getMonth();
}
function y0(e, t) {
  return fe(e, t?.in).getFullYear();
}
function w0(e, t) {
  return +fe(e) > +fe(t);
}
function x0(e, t) {
  return +fe(e) < +fe(t);
}
function S0(e, t, n) {
  const [r, o] = cn(
    n?.in,
    e,
    t
  );
  return r.getFullYear() === o.getFullYear() && r.getMonth() === o.getMonth();
}
function C0(e, t, n) {
  const [r, o] = cn(
    n?.in,
    e,
    t
  );
  return r.getFullYear() === o.getFullYear();
}
function k0(e, t, n) {
  const r = fe(e, n?.in), o = r.getFullYear(), a = r.getDate(), s = be(e, 0);
  s.setFullYear(o, t, 15), s.setHours(0, 0, 0, 0);
  const i = v0(s);
  return r.setMonth(t, Math.min(a, i)), r;
}
function E0(e, t, n) {
  const r = fe(e, n?.in);
  return isNaN(+r) ? be(e, NaN) : (r.setFullYear(t), r);
}
const ii = 5, M0 = 4;
function P0(e, t) {
  const n = t.startOfMonth(e), r = n.getDay() > 0 ? n.getDay() : 7, o = t.addDays(e, -r + 1), a = t.addDays(o, ii * 7 - 1);
  return t.getMonth(e) === t.getMonth(a) ? ii : M0;
}
function Rf(e, t) {
  const n = t.startOfMonth(e), r = n.getDay();
  return r === 1 ? n : r === 0 ? t.addDays(n, -6) : t.addDays(n, -1 * (r - 1));
}
function D0(e, t) {
  const n = Rf(e, t), r = P0(e, t);
  return t.addDays(n, r * 7 - 1);
}
const Tf = {
  ...Ut,
  labels: {
    labelDayButton: (e, t, n, r) => {
      let o;
      r && typeof r.format == "function" ? o = r.format.bind(r) : o = (s, i) => yn(s, i, { locale: Ut, ...n });
      let a = o(e, "PPPP");
      return t.today && (a = `Today, ${a}`), t.selected && (a = `${a}, selected`), a;
    },
    labelMonthDropdown: "Choose the Month",
    labelNext: "Go to the Next Month",
    labelPrevious: "Go to the Previous Month",
    labelWeekNumber: (e) => `Week ${e}`,
    labelYearDropdown: "Choose the Year",
    labelGrid: (e, t, n) => {
      let r;
      return n && typeof n.format == "function" ? r = n.format.bind(n) : r = (o, a) => yn(o, a, { locale: Ut, ...t }), r(e, "LLLL yyyy");
    },
    labelGridcell: (e, t, n, r) => {
      let o;
      r && typeof r.format == "function" ? o = r.format.bind(r) : o = (s, i) => yn(s, i, { locale: Ut, ...n });
      let a = o(e, "PPPP");
      return t?.today && (a = `Today, ${a}`), a;
    },
    labelNav: "Navigation bar",
    labelWeekNumberHeader: "Week Number",
    labelWeekday: (e, t, n) => {
      let r;
      return n && typeof n.format == "function" ? r = n.format.bind(n) : r = (o, a) => yn(o, a, { locale: Ut, ...t }), r(e, "cccc");
    }
  }
};
class _e {
  /**
   * Creates an instance of `DateLib`.
   *
   * @param options Configuration options for the date library.
   * @param overrides Custom overrides for the date library functions.
   */
  constructor(t, n) {
    this.today = () => {
      if (this.overrides?.today)
        return this.overrides.today();
      if (this.options.timeZone)
        return Ee.tz(this.options.timeZone);
      const r = this.options.Date ?? Date;
      return new r();
    }, this.newDate = (r, o, a) => this.overrides?.newDate ? this.overrides.newDate(r, o, a) : this.options.timeZone ? new Ee(r, o, a, this.options.timeZone) : new Date(r, o, a), this.addDays = (r, o) => this.overrides?.addDays ? this.overrides.addDays(r, o) : Sf(r, o), this.addMonths = (r, o) => this.overrides?.addMonths ? this.overrides.addMonths(r, o) : Cf(r, o), this.addWeeks = (r, o) => this.overrides?.addWeeks ? this.overrides.addWeeks(r, o) : dC(r, o), this.addYears = (r, o) => this.overrides?.addYears ? this.overrides.addYears(r, o) : uC(r, o), this.differenceInCalendarDays = (r, o) => this.overrides?.differenceInCalendarDays ? this.overrides.differenceInCalendarDays(r, o) : Xa(r, o), this.differenceInCalendarMonths = (r, o) => this.overrides?.differenceInCalendarMonths ? this.overrides.differenceInCalendarMonths(r, o) : Mf(r, o), this.eachMonthOfInterval = (r) => this.overrides?.eachMonthOfInterval ? this.overrides.eachMonthOfInterval(r) : vC(r), this.eachYearOfInterval = (r) => {
      const o = this.overrides?.eachYearOfInterval ? this.overrides.eachYearOfInterval(r) : wC(r), a = new Set(o.map((i) => this.getYear(i)));
      if (a.size === o.length)
        return o;
      const s = [];
      return a.forEach((i) => {
        s.push(new Date(i, 0, 1));
      }), s;
    }, this.endOfBroadcastWeek = (r) => this.overrides?.endOfBroadcastWeek ? this.overrides.endOfBroadcastWeek(r) : D0(r, this), this.endOfISOWeek = (r) => this.overrides?.endOfISOWeek ? this.overrides.endOfISOWeek(r) : xC(r), this.endOfMonth = (r) => this.overrides?.endOfMonth ? this.overrides.endOfMonth(r) : gC(r), this.endOfWeek = (r, o) => this.overrides?.endOfWeek ? this.overrides.endOfWeek(r, o) : Of(r, this.options), this.endOfYear = (r) => this.overrides?.endOfYear ? this.overrides.endOfYear(r) : yC(r), this.format = (r, o, a) => {
      const s = this.overrides?.format ? this.overrides.format(r, o, this.options) : yn(r, o, this.options);
      return this.options.numerals && this.options.numerals !== "latn" ? this.replaceDigits(s) : s;
    }, this.getISOWeek = (r) => this.overrides?.getISOWeek ? this.overrides.getISOWeek(r) : Za(r), this.getMonth = (r, o) => this.overrides?.getMonth ? this.overrides.getMonth(r, this.options) : b0(r, this.options), this.getYear = (r, o) => this.overrides?.getYear ? this.overrides.getYear(r, this.options) : y0(r, this.options), this.getWeek = (r, o) => this.overrides?.getWeek ? this.overrides.getWeek(r, this.options) : Qa(r, this.options), this.isAfter = (r, o) => this.overrides?.isAfter ? this.overrides.isAfter(r, o) : w0(r, o), this.isBefore = (r, o) => this.overrides?.isBefore ? this.overrides.isBefore(r, o) : x0(r, o), this.isDate = (r) => this.overrides?.isDate ? this.overrides.isDate(r) : Ef(r), this.isSameDay = (r, o) => this.overrides?.isSameDay ? this.overrides.isSameDay(r, o) : mC(r, o), this.isSameMonth = (r, o) => this.overrides?.isSameMonth ? this.overrides.isSameMonth(r, o) : S0(r, o), this.isSameYear = (r, o) => this.overrides?.isSameYear ? this.overrides.isSameYear(r, o) : C0(r, o), this.max = (r) => this.overrides?.max ? this.overrides.max(r) : fC(r), this.min = (r) => this.overrides?.min ? this.overrides.min(r) : pC(r), this.setMonth = (r, o) => this.overrides?.setMonth ? this.overrides.setMonth(r, o) : k0(r, o), this.setYear = (r, o) => this.overrides?.setYear ? this.overrides.setYear(r, o) : E0(r, o), this.startOfBroadcastWeek = (r, o) => this.overrides?.startOfBroadcastWeek ? this.overrides.startOfBroadcastWeek(r, this) : Rf(r, this), this.startOfDay = (r) => this.overrides?.startOfDay ? this.overrides.startOfDay(r) : Pn(r), this.startOfISOWeek = (r) => this.overrides?.startOfISOWeek ? this.overrides.startOfISOWeek(r) : Mn(r), this.startOfMonth = (r) => this.overrides?.startOfMonth ? this.overrides.startOfMonth(r) : bC(r), this.startOfWeek = (r, o) => this.overrides?.startOfWeek ? this.overrides.startOfWeek(r, this.options) : en(r, this.options), this.startOfYear = (r) => this.overrides?.startOfYear ? this.overrides.startOfYear(r) : Df(r), this.options = { locale: Tf, ...t }, this.overrides = n;
  }
  /**
   * Generates a mapping of Arabic digits (0-9) to the target numbering system
   * digits.
   *
   * @since 9.5.0
   * @returns A record mapping Arabic digits to the target numerals.
   */
  getDigitMap() {
    const { numerals: t = "latn" } = this.options, n = new Intl.NumberFormat("en-US", {
      numberingSystem: t
    }), r = {};
    for (let o = 0; o < 10; o++)
      r[o.toString()] = n.format(o);
    return r;
  }
  /**
   * Replaces Arabic digits in a string with the target numbering system digits.
   *
   * @since 9.5.0
   * @param input The string containing Arabic digits.
   * @returns The string with digits replaced.
   */
  replaceDigits(t) {
    const n = this.getDigitMap();
    return t.replace(/\d/g, (r) => n[r] || r);
  }
  /**
   * Formats a number using the configured numbering system.
   *
   * @since 9.5.0
   * @param value The number to format.
   * @returns The formatted number as a string.
   */
  formatNumber(t) {
    return this.replaceDigits(t.toString());
  }
  /**
   * Returns the preferred ordering for month and year labels for the current
   * locale.
   */
  getMonthYearOrder() {
    const t = this.options.locale?.code;
    return t && _e.yearFirstLocales.has(t) ? "year-first" : "month-first";
  }
  /**
   * Formats the month/year pair respecting locale conventions.
   *
   * @since 9.11.0
   */
  formatMonthYear(t) {
    const { locale: n, timeZone: r, numerals: o } = this.options, a = n?.code;
    if (a && _e.yearFirstLocales.has(a))
      try {
        return new Intl.DateTimeFormat(a, {
          month: "long",
          year: "numeric",
          timeZone: r,
          numberingSystem: o
        }).format(t);
      } catch {
      }
    const s = this.getMonthYearOrder() === "year-first" ? "y LLLL" : "LLLL y";
    return this.format(t, s);
  }
}
_e.yearFirstLocales = /* @__PURE__ */ new Set([
  "eu",
  "hu",
  "ja",
  "ja-Hira",
  "ja-JP",
  "ko",
  "ko-KR",
  "lt",
  "lt-LT",
  "lv",
  "lv-LV",
  "mn",
  "mn-MN",
  "zh",
  "zh-CN",
  "zh-HK",
  "zh-TW"
]);
const Ze = new _e();
class Af {
  constructor(t, n, r = Ze) {
    this.date = t, this.displayMonth = n, this.outside = !!(n && !r.isSameMonth(t, n)), this.dateLib = r, this.isoDate = r.format(t, "yyyy-MM-dd"), this.displayMonthId = r.format(n, "yyyy-MM"), this.dateMonthId = r.format(t, "yyyy-MM");
  }
  /**
   * Checks if this day is equal to another `CalendarDay`, considering both the
   * date and the displayed month.
   *
   * @param day The `CalendarDay` to compare with.
   * @returns `true` if the days are equal, otherwise `false`.
   */
  isEqualTo(t) {
    return this.dateLib.isSameDay(t.date, this.date) && this.dateLib.isSameMonth(t.displayMonth, this.displayMonth);
  }
}
class O0 {
  constructor(t, n) {
    this.date = t, this.weeks = n;
  }
}
class N0 {
  constructor(t, n) {
    this.days = n, this.weekNumber = t;
  }
}
function _0(e) {
  return N.createElement("span", { ...e });
}
function R0(e) {
  const { size: t = 24, orientation: n = "left", className: r, style: o } = e;
  return N.createElement(
    "svg",
    { className: r, style: o, width: t, height: t, viewBox: "0 0 24 24" },
    n === "up" && N.createElement("polygon", { points: "6.77 17 12.5 11.43 18.24 17 20 15.28 12.5 8 5 15.28" }),
    n === "down" && N.createElement("polygon", { points: "6.77 8 12.5 13.57 18.24 8 20 9.72 12.5 17 5 9.72" }),
    n === "left" && N.createElement("polygon", { points: "16 18.112 9.81111111 12 16 5.87733333 14.0888889 4 6 12 14.0888889 20" }),
    n === "right" && N.createElement("polygon", { points: "8 18.112 14.18888889 12 8 5.87733333 9.91111111 4 18 12 9.91111111 20" })
  );
}
function T0(e) {
  const { day: t, modifiers: n, ...r } = e;
  return N.createElement("td", { ...r });
}
function A0(e) {
  const { day: t, modifiers: n, ...r } = e, o = N.useRef(null);
  return N.useEffect(() => {
    n.focused && o.current?.focus();
  }, [n.focused]), N.createElement("button", { ref: o, ...r });
}
var B;
(function(e) {
  e.Root = "root", e.Chevron = "chevron", e.Day = "day", e.DayButton = "day_button", e.CaptionLabel = "caption_label", e.Dropdowns = "dropdowns", e.Dropdown = "dropdown", e.DropdownRoot = "dropdown_root", e.Footer = "footer", e.MonthGrid = "month_grid", e.MonthCaption = "month_caption", e.MonthsDropdown = "months_dropdown", e.Month = "month", e.Months = "months", e.Nav = "nav", e.NextMonthButton = "button_next", e.PreviousMonthButton = "button_previous", e.Week = "week", e.Weeks = "weeks", e.Weekday = "weekday", e.Weekdays = "weekdays", e.WeekNumber = "week_number", e.WeekNumberHeader = "week_number_header", e.YearsDropdown = "years_dropdown";
})(B || (B = {}));
var me;
(function(e) {
  e.disabled = "disabled", e.hidden = "hidden", e.outside = "outside", e.focused = "focused", e.today = "today";
})(me || (me = {}));
var Le;
(function(e) {
  e.range_end = "range_end", e.range_middle = "range_middle", e.range_start = "range_start", e.selected = "selected";
})(Le || (Le = {}));
var De;
(function(e) {
  e.weeks_before_enter = "weeks_before_enter", e.weeks_before_exit = "weeks_before_exit", e.weeks_after_enter = "weeks_after_enter", e.weeks_after_exit = "weeks_after_exit", e.caption_after_enter = "caption_after_enter", e.caption_after_exit = "caption_after_exit", e.caption_before_enter = "caption_before_enter", e.caption_before_exit = "caption_before_exit";
})(De || (De = {}));
const If = hi(void 0);
function no() {
  const e = mi(If);
  if (e === void 0)
    throw new Error("useDayPicker() must be used within a custom component.");
  return e;
}
function I0(e) {
  const { options: t, className: n, ...r } = e, { classNames: o, components: a, styles: s } = no(), i = [o[B.Dropdown], n].join(" "), l = t?.find(({ value: c }) => c === r.value);
  return N.createElement(
    "span",
    { "data-disabled": r.disabled, className: o[B.DropdownRoot], style: s?.[B.DropdownRoot] },
    N.createElement(a.Select, { className: i, ...r }, t?.map(({ value: c, label: f, disabled: u }) => N.createElement(a.Option, { key: c, value: c, disabled: u }, f))),
    N.createElement(
      "span",
      { className: o[B.CaptionLabel], style: s?.[B.CaptionLabel], "aria-hidden": !0 },
      l?.label,
      N.createElement(a.Chevron, { orientation: "down", size: 18, className: o[B.Chevron], style: s?.[B.Chevron] })
    )
  );
}
function W0(e) {
  return N.createElement("div", { ...e });
}
function F0(e) {
  return N.createElement("div", { ...e });
}
function L0(e) {
  const { calendarMonth: t, displayIndex: n, ...r } = e;
  return N.createElement("div", { ...r }, e.children);
}
function $0(e) {
  const { calendarMonth: t, displayIndex: n, ...r } = e;
  return N.createElement("div", { ...r });
}
function z0(e) {
  return N.createElement("table", { ...e });
}
function B0(e) {
  return N.createElement("div", { ...e });
}
function Y0(e) {
  const { components: t } = no();
  return N.createElement(t.Dropdown, { ...e });
}
function H0(e) {
  const { onPreviousClick: t, onNextClick: n, previousMonth: r, nextMonth: o, ...a } = e, { components: s, classNames: i, styles: l, labels: { labelPrevious: c, labelNext: f } } = no(), u = Re((h) => {
    o && n?.(h);
  }, [o, n]), m = Re((h) => {
    r && t?.(h);
  }, [r, t]);
  return N.createElement(
    "nav",
    { ...a },
    N.createElement(
      s.PreviousMonthButton,
      { type: "button", className: i[B.PreviousMonthButton], style: l?.[B.PreviousMonthButton], tabIndex: r ? void 0 : -1, "aria-disabled": r ? void 0 : !0, "aria-label": c(r), onClick: m },
      N.createElement(s.Chevron, { disabled: r ? void 0 : !0, className: i[B.Chevron], style: l?.[B.Chevron], orientation: "left" })
    ),
    N.createElement(
      s.NextMonthButton,
      { type: "button", className: i[B.NextMonthButton], style: l?.[B.NextMonthButton], tabIndex: o ? void 0 : -1, "aria-disabled": o ? void 0 : !0, "aria-label": f(o), onClick: u },
      N.createElement(s.Chevron, { disabled: o ? void 0 : !0, orientation: "right", className: i[B.Chevron], style: l?.[B.Chevron] })
    )
  );
}
function V0(e) {
  return N.createElement("button", { ...e });
}
function G0(e) {
  return N.createElement("option", { ...e });
}
function U0(e) {
  return N.createElement("button", { ...e });
}
function j0(e) {
  const { rootRef: t, ...n } = e;
  return N.createElement("div", { ...n, ref: t });
}
function K0(e) {
  return N.createElement("select", { ...e });
}
function q0(e) {
  const { week: t, ...n } = e;
  return N.createElement("tr", { ...n });
}
function X0(e) {
  return N.createElement("th", { ...e });
}
function Z0(e) {
  return N.createElement(
    "thead",
    { "aria-hidden": !0 },
    N.createElement("tr", { ...e })
  );
}
function Q0(e) {
  const { week: t, ...n } = e;
  return N.createElement("th", { ...n });
}
function J0(e) {
  return N.createElement("th", { ...e });
}
function ek(e) {
  return N.createElement("tbody", { ...e });
}
function tk(e) {
  const { components: t } = no();
  return N.createElement(t.Dropdown, { ...e });
}
const nk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CaptionLabel: _0,
  Chevron: R0,
  Day: T0,
  DayButton: A0,
  Dropdown: I0,
  DropdownNav: W0,
  Footer: F0,
  Month: L0,
  MonthCaption: $0,
  MonthGrid: z0,
  Months: B0,
  MonthsDropdown: Y0,
  Nav: H0,
  NextMonthButton: V0,
  Option: G0,
  PreviousMonthButton: U0,
  Root: j0,
  Select: K0,
  Week: q0,
  WeekNumber: Q0,
  WeekNumberHeader: J0,
  Weekday: X0,
  Weekdays: Z0,
  Weeks: ek,
  YearsDropdown: tk
}, Symbol.toStringTag, { value: "Module" }));
function et(e, t, n = !1, r = Ze) {
  let { from: o, to: a } = e;
  const { differenceInCalendarDays: s, isSameDay: i } = r;
  return o && a ? (s(a, o) < 0 && ([o, a] = [a, o]), s(t, o) >= (n ? 1 : 0) && s(a, t) >= (n ? 1 : 0)) : !n && a ? i(a, t) : !n && o ? i(o, t) : !1;
}
function Ja(e) {
  return !!(e && typeof e == "object" && "before" in e && "after" in e);
}
function ro(e) {
  return !!(e && typeof e == "object" && "from" in e);
}
function es(e) {
  return !!(e && typeof e == "object" && "after" in e);
}
function ts(e) {
  return !!(e && typeof e == "object" && "before" in e);
}
function Wf(e) {
  return !!(e && typeof e == "object" && "dayOfWeek" in e);
}
function Ff(e, t) {
  return Array.isArray(e) && e.every(t.isDate);
}
function tt(e, t, n = Ze) {
  const r = Array.isArray(t) ? t : [t], { isSameDay: o, differenceInCalendarDays: a, isAfter: s } = n;
  return r.some((i) => {
    if (typeof i == "boolean")
      return i;
    if (n.isDate(i))
      return o(e, i);
    if (Ff(i, n))
      return i.some((l) => o(e, l));
    if (ro(i))
      return et(i, e, !1, n);
    if (Wf(i))
      return Array.isArray(i.dayOfWeek) ? i.dayOfWeek.includes(e.getDay()) : i.dayOfWeek === e.getDay();
    if (Ja(i)) {
      const l = a(i.before, e), c = a(i.after, e), f = l > 0, u = c < 0;
      return s(i.before, i.after) ? u && f : f || u;
    }
    return es(i) ? a(e, i.after) > 0 : ts(i) ? a(i.before, e) > 0 : typeof i == "function" ? i(e) : !1;
  });
}
function rk(e, t, n, r, o) {
  const { disabled: a, hidden: s, modifiers: i, showOutsideDays: l, broadcastCalendar: c, today: f = o.today() } = t, { isSameDay: u, isSameMonth: m, startOfMonth: h, isBefore: b, endOfMonth: g, isAfter: v } = o, y = n && h(n), w = r && g(r), x = {
    [me.focused]: [],
    [me.outside]: [],
    [me.disabled]: [],
    [me.hidden]: [],
    [me.today]: []
  }, S = {};
  for (const k of e) {
    const { date: C, displayMonth: E } = k, M = !!(E && !m(C, E)), O = !!(y && b(C, y)), R = !!(w && v(C, w)), W = !!(a && tt(C, a, o)), Y = !!(s && tt(C, s, o)) || O || R || // Broadcast calendar will show outside days as default
    !c && !l && M || c && l === !1 && M, K = u(C, f);
    M && x.outside.push(k), W && x.disabled.push(k), Y && x.hidden.push(k), K && x.today.push(k), i && Object.keys(i).forEach((H) => {
      const Q = i?.[H];
      Q && tt(C, Q, o) && (S[H] ? S[H].push(k) : S[H] = [k]);
    });
  }
  return (k) => {
    const C = {
      [me.focused]: !1,
      [me.disabled]: !1,
      [me.hidden]: !1,
      [me.outside]: !1,
      [me.today]: !1
    }, E = {};
    for (const M in x) {
      const O = x[M];
      C[M] = O.some((R) => R === k);
    }
    for (const M in S)
      E[M] = S[M].some((O) => O === k);
    return {
      ...C,
      // custom modifiers should override all the previous ones
      ...E
    };
  };
}
function ok(e, t, n = {}) {
  return Object.entries(e).filter(([, o]) => o === !0).reduce((o, [a]) => (n[a] ? o.push(n[a]) : t[me[a]] ? o.push(t[me[a]]) : t[Le[a]] && o.push(t[Le[a]]), o), [t[B.Day]]);
}
function ak(e) {
  return {
    ...nk,
    ...e
  };
}
function sk(e) {
  const t = {
    "data-mode": e.mode ?? void 0,
    "data-required": "required" in e ? e.required : void 0,
    "data-multiple-months": e.numberOfMonths && e.numberOfMonths > 1 || void 0,
    "data-week-numbers": e.showWeekNumber || void 0,
    "data-broadcast-calendar": e.broadcastCalendar || void 0,
    "data-nav-layout": e.navLayout || void 0
  };
  return Object.entries(e).forEach(([n, r]) => {
    n.startsWith("data-") && (t[n] = r);
  }), t;
}
function ns() {
  const e = {};
  for (const t in B)
    e[B[t]] = `rdp-${B[t]}`;
  for (const t in me)
    e[me[t]] = `rdp-${me[t]}`;
  for (const t in Le)
    e[Le[t]] = `rdp-${Le[t]}`;
  for (const t in De)
    e[De[t]] = `rdp-${De[t]}`;
  return e;
}
function ik(e, t, n) {
  return (n ?? new _e(t)).formatMonthYear(e);
}
function lk(e, t, n) {
  return (n ?? new _e(t)).format(e, "d");
}
function ck(e, t = Ze) {
  return t.format(e, "LLLL");
}
function dk(e, t, n) {
  return (n ?? new _e(t)).format(e, "cccccc");
}
function uk(e, t = Ze) {
  return e < 10 ? t.formatNumber(`0${e.toLocaleString()}`) : t.formatNumber(`${e.toLocaleString()}`);
}
function fk() {
  return "";
}
function pk(e, t = Ze) {
  return t.format(e, "yyyy");
}
const mk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  formatCaption: ik,
  formatDay: lk,
  formatMonthDropdown: ck,
  formatWeekNumber: uk,
  formatWeekNumberHeader: fk,
  formatWeekdayName: dk,
  formatYearDropdown: pk
}, Symbol.toStringTag, { value: "Module" }));
function hk(e) {
  return {
    ...mk,
    ...e
  };
}
function Lf(e, t, n, r) {
  let o = (r ?? new _e(n)).format(e, "PPPP");
  return t.today && (o = `Today, ${o}`), t.selected && (o = `${o}, selected`), o;
}
function $f(e, t, n) {
  return (n ?? new _e(t)).formatMonthYear(e);
}
function zf(e, t, n, r) {
  let o = (r ?? new _e(n)).format(e, "PPPP");
  return t?.today && (o = `Today, ${o}`), o;
}
function Bf(e) {
  return "Choose the Month";
}
function Yf() {
  return "";
}
const gk = "Go to the Next Month";
function Hf(e, t) {
  return gk;
}
function Vf(e) {
  return "Go to the Previous Month";
}
function Gf(e, t, n) {
  return (n ?? new _e(t)).format(e, "cccc");
}
function Uf(e, t) {
  return `Week ${e}`;
}
function jf(e) {
  return "Week Number";
}
function Kf(e) {
  return "Choose the Year";
}
const vk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  labelDayButton: Lf,
  labelGrid: $f,
  labelGridcell: zf,
  labelMonthDropdown: Bf,
  labelNav: Yf,
  labelNext: Hf,
  labelPrevious: Vf,
  labelWeekNumber: Uf,
  labelWeekNumberHeader: jf,
  labelWeekday: Gf,
  labelYearDropdown: Kf
}, Symbol.toStringTag, { value: "Module" })), We = (e, t, n) => t || (n ? typeof n == "function" ? n : (...r) => n : e);
function bk(e, t) {
  const n = t.locale?.labels ?? {};
  return {
    ...vk,
    ...e ?? {},
    labelDayButton: We(Lf, e?.labelDayButton, n.labelDayButton),
    labelMonthDropdown: We(Bf, e?.labelMonthDropdown, n.labelMonthDropdown),
    labelNext: We(Hf, e?.labelNext, n.labelNext),
    labelPrevious: We(Vf, e?.labelPrevious, n.labelPrevious),
    labelWeekNumber: We(Uf, e?.labelWeekNumber, n.labelWeekNumber),
    labelYearDropdown: We(Kf, e?.labelYearDropdown, n.labelYearDropdown),
    labelGrid: We($f, e?.labelGrid, n.labelGrid),
    labelGridcell: We(zf, e?.labelGridcell, n.labelGridcell),
    labelNav: We(Yf, e?.labelNav, n.labelNav),
    labelWeekNumberHeader: We(jf, e?.labelWeekNumberHeader, n.labelWeekNumberHeader),
    labelWeekday: We(Gf, e?.labelWeekday, n.labelWeekday)
  };
}
function yk(e, t, n, r, o) {
  const { startOfMonth: a, startOfYear: s, endOfYear: i, eachMonthOfInterval: l, getMonth: c } = o;
  return l({
    start: s(e),
    end: i(e)
  }).map((m) => {
    const h = r.formatMonthDropdown(m, o), b = c(m), g = t && m < a(t) || n && m > a(n) || !1;
    return { value: b, label: h, disabled: g };
  });
}
function wk(e, t = {}, n = {}) {
  let r = { ...t?.[B.Day] };
  return Object.entries(e).filter(([, o]) => o === !0).forEach(([o]) => {
    r = {
      ...r,
      ...n?.[o]
    };
  }), r;
}
function xk(e, t, n, r) {
  const o = r ?? e.today(), a = n ? e.startOfBroadcastWeek(o, e) : t ? e.startOfISOWeek(o) : e.startOfWeek(o), s = [];
  for (let i = 0; i < 7; i++) {
    const l = e.addDays(a, i);
    s.push(l);
  }
  return s;
}
function Sk(e, t, n, r, o = !1) {
  if (!e || !t)
    return;
  const { startOfYear: a, endOfYear: s, eachYearOfInterval: i, getYear: l } = r, c = a(e), f = s(t), u = i({ start: c, end: f });
  return o && u.reverse(), u.map((m) => {
    const h = n.formatYearDropdown(m, r);
    return {
      value: l(m),
      label: h,
      disabled: !1
    };
  });
}
function Ck(e, t = {}) {
  const { weekStartsOn: n, locale: r } = t, o = n ?? r?.options?.weekStartsOn ?? 0, a = (i) => {
    const l = typeof i == "number" || typeof i == "string" ? new Date(i) : i;
    return new Ee(l.getFullYear(), l.getMonth(), l.getDate(), 12, 0, 0, e);
  }, s = (i) => {
    const l = a(i);
    return new Date(l.getFullYear(), l.getMonth(), l.getDate(), 0, 0, 0, 0);
  };
  return {
    today: () => a(Ee.tz(e)),
    newDate: (i, l, c) => new Ee(i, l, c, 12, 0, 0, e),
    startOfDay: (i) => a(i),
    startOfWeek: (i, l) => {
      const c = a(i), f = l?.weekStartsOn ?? o, u = (c.getDay() - f + 7) % 7;
      return c.setDate(c.getDate() - u), c;
    },
    startOfISOWeek: (i) => {
      const l = a(i), c = (l.getDay() - 1 + 7) % 7;
      return l.setDate(l.getDate() - c), l;
    },
    startOfMonth: (i) => {
      const l = a(i);
      return l.setDate(1), l;
    },
    startOfYear: (i) => {
      const l = a(i);
      return l.setMonth(0, 1), l;
    },
    endOfWeek: (i, l) => {
      const c = a(i), m = (((l?.weekStartsOn ?? o) + 6) % 7 - c.getDay() + 7) % 7;
      return c.setDate(c.getDate() + m), c;
    },
    endOfISOWeek: (i) => {
      const l = a(i), c = (7 - l.getDay()) % 7;
      return l.setDate(l.getDate() + c), l;
    },
    endOfMonth: (i) => {
      const l = a(i);
      return l.setMonth(l.getMonth() + 1, 0), l;
    },
    endOfYear: (i) => {
      const l = a(i);
      return l.setMonth(11, 31), l;
    },
    eachMonthOfInterval: (i) => {
      const l = a(i.start), c = a(i.end), f = [], u = new Ee(l.getFullYear(), l.getMonth(), 1, 12, 0, 0, e), m = c.getFullYear() * 12 + c.getMonth();
      for (; u.getFullYear() * 12 + u.getMonth() <= m; )
        f.push(new Ee(u, e)), u.setMonth(u.getMonth() + 1, 1);
      return f;
    },
    // Normalize to noon once before arithmetic (avoid DST/midnight edge cases),
    // mutate the same TZDate, and return it.
    addDays: (i, l) => {
      const c = a(i);
      return c.setDate(c.getDate() + l), c;
    },
    addWeeks: (i, l) => {
      const c = a(i);
      return c.setDate(c.getDate() + l * 7), c;
    },
    addMonths: (i, l) => {
      const c = a(i);
      return c.setMonth(c.getMonth() + l), c;
    },
    addYears: (i, l) => {
      const c = a(i);
      return c.setFullYear(c.getFullYear() + l), c;
    },
    eachYearOfInterval: (i) => {
      const l = a(i.start), c = a(i.end), f = [], u = new Ee(l.getFullYear(), 0, 1, 12, 0, 0, e);
      for (; u.getFullYear() <= c.getFullYear(); )
        f.push(new Ee(u, e)), u.setFullYear(u.getFullYear() + 1, 0, 1);
      return f;
    },
    getWeek: (i, l) => {
      const c = s(i);
      return Qa(c, {
        weekStartsOn: l?.weekStartsOn ?? o,
        firstWeekContainsDate: l?.firstWeekContainsDate ?? r?.options?.firstWeekContainsDate ?? 1
      });
    },
    getISOWeek: (i) => {
      const l = s(i);
      return Za(l);
    },
    differenceInCalendarDays: (i, l) => {
      const c = s(i), f = s(l);
      return Xa(c, f);
    },
    differenceInCalendarMonths: (i, l) => {
      const c = s(i), f = s(l);
      return Mf(c, f);
    }
  };
}
const Hn = (e) => e instanceof HTMLElement ? e : null, Oo = (e) => [
  ...e.querySelectorAll("[data-animated-month]") ?? []
], kk = (e) => Hn(e.querySelector("[data-animated-month]")), No = (e) => Hn(e.querySelector("[data-animated-caption]")), _o = (e) => Hn(e.querySelector("[data-animated-weeks]")), Ek = (e) => Hn(e.querySelector("[data-animated-nav]")), Mk = (e) => Hn(e.querySelector("[data-animated-weekdays]"));
function Pk(e, t, { classNames: n, months: r, focused: o, dateLib: a }) {
  const s = Jn(null), i = Jn(r), l = Jn(!1);
  pi(() => {
    const c = i.current;
    if (i.current = r, !t || !e.current || // safety check because the ref can be set to anything by consumers
    !(e.current instanceof HTMLElement) || // validation required for the animation to work as expected
    r.length === 0 || c.length === 0 || r.length !== c.length)
      return;
    const f = a.isSameMonth(r[0].date, c[0].date), u = a.isAfter(r[0].date, c[0].date), m = u ? n[De.caption_after_enter] : n[De.caption_before_enter], h = u ? n[De.weeks_after_enter] : n[De.weeks_before_enter], b = s.current, g = e.current.cloneNode(!0);
    if (g instanceof HTMLElement ? (Oo(g).forEach((x) => {
      if (!(x instanceof HTMLElement))
        return;
      const S = kk(x);
      S && x.contains(S) && x.removeChild(S);
      const k = No(x);
      k && k.classList.remove(m);
      const C = _o(x);
      C && C.classList.remove(h);
    }), s.current = g) : s.current = null, l.current || f || // skip animation if a day is focused because it can cause issues to the animation and is better for a11y
    o)
      return;
    const v = b instanceof HTMLElement ? Oo(b) : [], y = Oo(e.current);
    if (y?.every((w) => w instanceof HTMLElement) && v?.every((w) => w instanceof HTMLElement)) {
      l.current = !0, e.current.style.isolation = "isolate";
      const w = Ek(e.current);
      w && (w.style.zIndex = "1"), y.forEach((x, S) => {
        const k = v[S];
        if (!k)
          return;
        x.style.position = "relative", x.style.overflow = "hidden";
        const C = No(x);
        C && C.classList.add(m);
        const E = _o(x);
        E && E.classList.add(h);
        const M = () => {
          l.current = !1, e.current && (e.current.style.isolation = ""), w && (w.style.zIndex = ""), C && C.classList.remove(m), E && E.classList.remove(h), x.style.position = "", x.style.overflow = "", x.contains(k) && x.removeChild(k);
        };
        k.style.pointerEvents = "none", k.style.position = "absolute", k.style.overflow = "hidden", k.setAttribute("aria-hidden", "true");
        const O = Mk(k);
        O && (O.style.opacity = "0");
        const R = No(k);
        R && (R.classList.add(u ? n[De.caption_before_exit] : n[De.caption_after_exit]), R.addEventListener("animationend", M));
        const W = _o(k);
        W && W.classList.add(u ? n[De.weeks_before_exit] : n[De.weeks_after_exit]), x.insertBefore(k, x.firstChild);
      });
    }
  });
}
function Dk(e, t, n, r) {
  const o = e[0], a = e[e.length - 1], { ISOWeek: s, fixedWeeks: i, broadcastCalendar: l } = n ?? {}, { addDays: c, differenceInCalendarDays: f, differenceInCalendarMonths: u, endOfBroadcastWeek: m, endOfISOWeek: h, endOfMonth: b, endOfWeek: g, isAfter: v, startOfBroadcastWeek: y, startOfISOWeek: w, startOfWeek: x } = r, S = l ? y(o, r) : s ? w(o) : x(o), k = l ? m(a) : s ? h(b(a)) : g(b(a)), C = t && (l ? m(t) : s ? h(t) : g(t)), E = C && v(k, C) ? C : k, M = f(E, S), O = u(a, o) + 1, R = [];
  for (let K = 0; K <= M; K++) {
    const H = c(S, K);
    R.push(H);
  }
  const Y = (l ? 35 : 42) * O;
  if (i && R.length < Y) {
    const K = Y - R.length;
    for (let H = 0; H < K; H++) {
      const Q = c(R[R.length - 1], 1);
      R.push(Q);
    }
  }
  return R;
}
function Ok(e) {
  const t = [];
  return e.reduce((n, r) => {
    const o = r.weeks.reduce((a, s) => a.concat(s.days.slice()), t.slice());
    return n.concat(o.slice());
  }, t.slice());
}
function Nk(e, t, n, r) {
  const { numberOfMonths: o = 1 } = n, a = [];
  for (let s = 0; s < o; s++) {
    const i = r.addMonths(e, s);
    if (t && i > t)
      break;
    a.push(i);
  }
  return a;
}
function li(e, t, n, r) {
  const { month: o, defaultMonth: a, today: s = r.today(), numberOfMonths: i = 1 } = e;
  let l = o || a || s;
  const { differenceInCalendarMonths: c, addMonths: f, startOfMonth: u } = r;
  if (n && c(n, l) < i - 1) {
    const m = -1 * (i - 1);
    l = f(n, m);
  }
  return t && c(l, t) < 0 && (l = t), u(l);
}
function _k(e, t, n, r) {
  const { addDays: o, endOfBroadcastWeek: a, endOfISOWeek: s, endOfMonth: i, endOfWeek: l, getISOWeek: c, getWeek: f, startOfBroadcastWeek: u, startOfISOWeek: m, startOfWeek: h } = r, b = e.reduce((g, v) => {
    const y = n.broadcastCalendar ? u(v, r) : n.ISOWeek ? m(v) : h(v), w = n.broadcastCalendar ? a(v) : n.ISOWeek ? s(i(v)) : l(i(v)), x = t.filter((E) => E >= y && E <= w), S = n.broadcastCalendar ? 35 : 42;
    if (n.fixedWeeks && x.length < S) {
      const E = t.filter((M) => {
        const O = S - x.length;
        return M > w && M <= o(w, O);
      });
      x.push(...E);
    }
    const k = x.reduce((E, M) => {
      const O = n.ISOWeek ? c(M) : f(M), R = E.find((Y) => Y.weekNumber === O), W = new Af(M, v, r);
      return R ? R.days.push(W) : E.push(new N0(O, [W])), E;
    }, []), C = new O0(v, k);
    return g.push(C), g;
  }, []);
  return n.reverseMonths ? b.reverse() : b;
}
function Rk(e, t) {
  let { startMonth: n, endMonth: r } = e;
  const { startOfYear: o, startOfDay: a, startOfMonth: s, endOfMonth: i, addYears: l, endOfYear: c, today: f } = t, u = e.captionLayout === "dropdown" || e.captionLayout === "dropdown-years";
  return n ? n = s(n) : !n && u && (n = o(l(e.today ?? f(), -100))), r ? r = i(r) : !r && u && (r = c(e.today ?? f())), [
    n && a(n),
    r && a(r)
  ];
}
function Tk(e, t, n, r) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: o, numberOfMonths: a = 1 } = n, { startOfMonth: s, addMonths: i, differenceInCalendarMonths: l } = r, c = o ? a : 1, f = s(e);
  if (!t)
    return i(f, c);
  if (!(l(t, e) < a))
    return i(f, c);
}
function Ak(e, t, n, r) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: o, numberOfMonths: a } = n, { startOfMonth: s, addMonths: i, differenceInCalendarMonths: l } = r, c = o ? a ?? 1 : 1, f = s(e);
  if (!t)
    return i(f, -c);
  if (!(l(f, t) <= 0))
    return i(f, -c);
}
function Ik(e) {
  const t = [];
  return e.reduce((n, r) => n.concat(r.weeks.slice()), t.slice());
}
function oo(e, t) {
  const [n, r] = rr(e);
  return [t === void 0 ? n : t, r];
}
function Wk(e, t) {
  const [n, r] = Rk(e, t), { startOfMonth: o, endOfMonth: a } = t, s = li(e, n, r, t), [i, l] = oo(
    s,
    // initialMonth is always computed from props.month if provided
    e.month ? s : void 0
  );
  gp(() => {
    const S = li(e, n, r, t);
    l(S);
  }, [e.timeZone]);
  const { months: c, weeks: f, days: u, previousMonth: m, nextMonth: h } = wn(() => {
    const S = Nk(i, r, { numberOfMonths: e.numberOfMonths }, t), k = Dk(S, e.endMonth ? a(e.endMonth) : void 0, {
      ISOWeek: e.ISOWeek,
      fixedWeeks: e.fixedWeeks,
      broadcastCalendar: e.broadcastCalendar
    }, t), C = _k(S, k, {
      broadcastCalendar: e.broadcastCalendar,
      fixedWeeks: e.fixedWeeks,
      ISOWeek: e.ISOWeek,
      reverseMonths: e.reverseMonths
    }, t), E = Ik(C), M = Ok(C), O = Ak(i, n, e, t), R = Tk(i, r, e, t);
    return {
      months: C,
      weeks: E,
      days: M,
      previousMonth: O,
      nextMonth: R
    };
  }, [
    t,
    i.getTime(),
    r?.getTime(),
    n?.getTime(),
    e.disableNavigation,
    e.broadcastCalendar,
    e.endMonth?.getTime(),
    e.fixedWeeks,
    e.ISOWeek,
    e.numberOfMonths,
    e.pagedNavigation,
    e.reverseMonths
  ]), { disableNavigation: b, onMonthChange: g } = e, v = (S) => f.some((k) => k.days.some((C) => C.isEqualTo(S))), y = (S) => {
    if (b)
      return;
    let k = o(S);
    n && k < o(n) && (k = o(n)), r && k > o(r) && (k = o(r)), l(k), g?.(k);
  };
  return {
    months: c,
    weeks: f,
    days: u,
    navStart: n,
    navEnd: r,
    previousMonth: m,
    nextMonth: h,
    goToMonth: y,
    goToDay: (S) => {
      v(S) || y(S.date);
    }
  };
}
var Ve;
(function(e) {
  e[e.Today = 0] = "Today", e[e.Selected = 1] = "Selected", e[e.LastFocused = 2] = "LastFocused", e[e.FocusedModifier = 3] = "FocusedModifier";
})(Ve || (Ve = {}));
function ci(e) {
  return !e[me.disabled] && !e[me.hidden] && !e[me.outside];
}
function Fk(e, t, n, r) {
  let o, a = -1;
  for (const s of e) {
    const i = t(s);
    ci(i) && (i[me.focused] && a < Ve.FocusedModifier ? (o = s, a = Ve.FocusedModifier) : r?.isEqualTo(s) && a < Ve.LastFocused ? (o = s, a = Ve.LastFocused) : n(s.date) && a < Ve.Selected ? (o = s, a = Ve.Selected) : i[me.today] && a < Ve.Today && (o = s, a = Ve.Today));
  }
  return o || (o = e.find((s) => ci(t(s)))), o;
}
function Lk(e, t, n, r, o, a, s) {
  const { ISOWeek: i, broadcastCalendar: l } = a, { addDays: c, addMonths: f, addWeeks: u, addYears: m, endOfBroadcastWeek: h, endOfISOWeek: b, endOfWeek: g, max: v, min: y, startOfBroadcastWeek: w, startOfISOWeek: x, startOfWeek: S } = s;
  let C = {
    day: c,
    week: u,
    month: f,
    year: m,
    startOfWeek: (E) => l ? w(E, s) : i ? x(E) : S(E),
    endOfWeek: (E) => l ? h(E) : i ? b(E) : g(E)
  }[e](n, t === "after" ? 1 : -1);
  return t === "before" && r ? C = v([r, C]) : t === "after" && o && (C = y([o, C])), C;
}
function qf(e, t, n, r, o, a, s, i = 0) {
  if (i > 365)
    return;
  const l = Lk(e, t, n.date, r, o, a, s), c = !!(a.disabled && tt(l, a.disabled, s)), f = !!(a.hidden && tt(l, a.hidden, s)), u = l, m = new Af(l, u, s);
  return !c && !f ? m : qf(e, t, m, r, o, a, s, i + 1);
}
function $k(e, t, n, r, o) {
  const { autoFocus: a } = e, [s, i] = rr(), l = Fk(t.days, n, r || (() => !1), s), [c, f] = rr(a ? l : void 0);
  return {
    isFocusTarget: (g) => !!l?.isEqualTo(g),
    setFocused: f,
    focused: c,
    blur: () => {
      i(c), f(void 0);
    },
    moveFocus: (g, v) => {
      if (!c)
        return;
      const y = qf(g, v, c, t.navStart, t.navEnd, e, o);
      y && (e.disableNavigation && !t.days.some((x) => x.isEqualTo(y)) || (t.goToDay(y), f(y)));
    }
  };
}
function zk(e, t) {
  const { selected: n, required: r, onSelect: o } = e, [a, s] = oo(n, o ? n : void 0), i = o ? n : a, { isSameDay: l } = t, c = (h) => i?.some((b) => l(b, h)) ?? !1, { min: f, max: u } = e;
  return {
    selected: i,
    select: (h, b, g) => {
      let v = [...i ?? []];
      if (c(h)) {
        if (i?.length === f || r && i?.length === 1)
          return;
        v = i?.filter((y) => !l(y, h));
      } else
        i?.length === u ? v = [h] : v = [...v, h];
      return o || s(v), o?.(v, h, b, g), v;
    },
    isSelected: c
  };
}
function Bk(e, t, n = 0, r = 0, o = !1, a = Ze) {
  const { from: s, to: i } = t || {}, { isSameDay: l, isAfter: c, isBefore: f } = a;
  let u;
  if (!s && !i)
    u = { from: e, to: n > 0 ? void 0 : e };
  else if (s && !i)
    l(s, e) ? n === 0 ? u = { from: s, to: e } : o ? u = { from: s, to: void 0 } : u = void 0 : f(e, s) ? u = { from: e, to: s } : u = { from: s, to: e };
  else if (s && i)
    if (l(s, e) && l(i, e))
      o ? u = { from: s, to: i } : u = void 0;
    else if (l(s, e))
      u = { from: s, to: n > 0 ? void 0 : e };
    else if (l(i, e))
      u = { from: e, to: n > 0 ? void 0 : e };
    else if (f(e, s))
      u = { from: e, to: i };
    else if (c(e, s))
      u = { from: s, to: e };
    else if (c(e, i))
      u = { from: s, to: e };
    else
      throw new Error("Invalid range");
  if (u?.from && u?.to) {
    const m = a.differenceInCalendarDays(u.to, u.from);
    r > 0 && m > r ? u = { from: e, to: void 0 } : n > 1 && m < n && (u = { from: e, to: void 0 });
  }
  return u;
}
function Yk(e, t, n = Ze) {
  const r = Array.isArray(t) ? t : [t];
  let o = e.from;
  const a = n.differenceInCalendarDays(e.to, e.from), s = Math.min(a, 6);
  for (let i = 0; i <= s; i++) {
    if (r.includes(o.getDay()))
      return !0;
    o = n.addDays(o, 1);
  }
  return !1;
}
function di(e, t, n = Ze) {
  return et(e, t.from, !1, n) || et(e, t.to, !1, n) || et(t, e.from, !1, n) || et(t, e.to, !1, n);
}
function Hk(e, t, n = Ze) {
  const r = Array.isArray(t) ? t : [t];
  if (r.filter((i) => typeof i != "function").some((i) => typeof i == "boolean" ? i : n.isDate(i) ? et(e, i, !1, n) : Ff(i, n) ? i.some((l) => et(e, l, !1, n)) : ro(i) ? i.from && i.to ? di(e, { from: i.from, to: i.to }, n) : !1 : Wf(i) ? Yk(e, i.dayOfWeek, n) : Ja(i) ? n.isAfter(i.before, i.after) ? di(e, {
    from: n.addDays(i.after, 1),
    to: n.addDays(i.before, -1)
  }, n) : tt(e.from, i, n) || tt(e.to, i, n) : es(i) || ts(i) ? tt(e.from, i, n) || tt(e.to, i, n) : !1))
    return !0;
  const s = r.filter((i) => typeof i == "function");
  if (s.length) {
    let i = e.from;
    const l = n.differenceInCalendarDays(e.to, e.from);
    for (let c = 0; c <= l; c++) {
      if (s.some((f) => f(i)))
        return !0;
      i = n.addDays(i, 1);
    }
  }
  return !1;
}
function Vk(e, t) {
  const { disabled: n, excludeDisabled: r, resetOnSelect: o, selected: a, required: s, onSelect: i } = e, [l, c] = oo(a, i ? a : void 0), f = i ? a : l;
  return {
    selected: f,
    select: (h, b, g) => {
      const { min: v, max: y } = e;
      let w;
      if (h) {
        const x = f?.from, S = f?.to, k = !!x && !!S, C = !!x && !!S && t.isSameDay(x, S) && t.isSameDay(h, x);
        o && (k || !f?.from) ? !s && C ? w = void 0 : w = { from: h, to: void 0 } : w = Bk(h, f, v, y, s, t);
      }
      return r && n && w?.from && w.to && Hk({ from: w.from, to: w.to }, n, t) && (w.from = h, w.to = void 0), i || c(w), i?.(w, h, b, g), w;
    },
    isSelected: (h) => f && et(f, h, !1, t)
  };
}
function Gk(e, t) {
  const { selected: n, required: r, onSelect: o } = e, [a, s] = oo(n, o ? n : void 0), i = o ? n : a, { isSameDay: l } = t;
  return {
    selected: i,
    select: (u, m, h) => {
      let b = u;
      return !r && i && i && l(u, i) && (b = void 0), o || s(b), o?.(b, u, m, h), b;
    },
    isSelected: (u) => i ? l(i, u) : !1
  };
}
function Uk(e, t) {
  const n = Gk(e, t), r = zk(e, t), o = Vk(e, t);
  switch (e.mode) {
    case "single":
      return n;
    case "multiple":
      return r;
    case "range":
      return o;
    default:
      return;
  }
}
function Te(e, t) {
  return e instanceof Ee && e.timeZone === t ? e : new Ee(e, t);
}
function Ht(e, t, n) {
  return Te(e, t);
}
function ui(e, t, n) {
  return typeof e == "boolean" || typeof e == "function" ? e : e instanceof Date ? Ht(e, t) : Array.isArray(e) ? e.map((r) => r instanceof Date ? Ht(r, t) : r) : ro(e) ? {
    ...e,
    from: e.from ? Te(e.from, t) : e.from,
    to: e.to ? Te(e.to, t) : e.to
  } : Ja(e) ? {
    before: Ht(e.before, t),
    after: Ht(e.after, t)
  } : es(e) ? {
    after: Ht(e.after, t)
  } : ts(e) ? {
    before: Ht(e.before, t)
  } : e;
}
function Ro(e, t, n) {
  return e && (Array.isArray(e) ? e.map((r) => ui(r, t)) : ui(e, t));
}
function jk(e) {
  let t = e;
  const n = t.timeZone;
  if (n && (t = {
    ...e,
    timeZone: n
  }, t.today && (t.today = Te(t.today, n)), t.month && (t.month = Te(t.month, n)), t.defaultMonth && (t.defaultMonth = Te(t.defaultMonth, n)), t.startMonth && (t.startMonth = Te(t.startMonth, n)), t.endMonth && (t.endMonth = Te(t.endMonth, n)), t.mode === "single" && t.selected ? t.selected = Te(t.selected, n) : t.mode === "multiple" && t.selected ? t.selected = t.selected?.map((te) => Te(te, n)) : t.mode === "range" && t.selected && (t.selected = {
    from: t.selected.from ? Te(t.selected.from, n) : t.selected.from,
    to: t.selected.to ? Te(t.selected.to, n) : t.selected.to
  }), t.disabled !== void 0 && (t.disabled = Ro(t.disabled, n)), t.hidden !== void 0 && (t.hidden = Ro(t.hidden, n)), t.modifiers)) {
    const te = {};
    Object.keys(t.modifiers).forEach((se) => {
      te[se] = Ro(t.modifiers?.[se], n);
    }), t.modifiers = te;
  }
  const { components: r, formatters: o, labels: a, dateLib: s, locale: i, classNames: l } = wn(() => {
    const te = { ...Tf, ...t.locale }, se = t.broadcastCalendar ? 1 : t.weekStartsOn, oe = t.noonSafe && t.timeZone ? Ck(t.timeZone, {
      weekStartsOn: se,
      locale: te
    }) : void 0, he = t.dateLib && oe ? { ...oe, ...t.dateLib } : t.dateLib ?? oe, de = new _e({
      locale: te,
      weekStartsOn: se,
      firstWeekContainsDate: t.firstWeekContainsDate,
      useAdditionalWeekYearTokens: t.useAdditionalWeekYearTokens,
      useAdditionalDayOfYearTokens: t.useAdditionalDayOfYearTokens,
      timeZone: t.timeZone,
      numerals: t.numerals
    }, he);
    return {
      dateLib: de,
      components: ak(t.components),
      formatters: hk(t.formatters),
      labels: bk(t.labels, de.options),
      locale: te,
      classNames: { ...ns(), ...t.classNames }
    };
  }, [
    t.locale,
    t.broadcastCalendar,
    t.weekStartsOn,
    t.firstWeekContainsDate,
    t.useAdditionalWeekYearTokens,
    t.useAdditionalDayOfYearTokens,
    t.timeZone,
    t.numerals,
    t.dateLib,
    t.noonSafe,
    t.components,
    t.formatters,
    t.labels,
    t.classNames
  ]);
  t.today || (t = { ...t, today: s.today() });
  const { captionLayout: c, mode: f, navLayout: u, numberOfMonths: m = 1, onDayBlur: h, onDayClick: b, onDayFocus: g, onDayKeyDown: v, onDayMouseEnter: y, onDayMouseLeave: w, onNextClick: x, onPrevClick: S, showWeekNumber: k, styles: C } = t, { formatCaption: E, formatDay: M, formatMonthDropdown: O, formatWeekNumber: R, formatWeekNumberHeader: W, formatWeekdayName: Y, formatYearDropdown: K } = o, H = Wk(t, s), { days: Q, months: $, navStart: q, navEnd: z, previousMonth: T, nextMonth: I, goToMonth: le } = H, D = rk(Q, t, q, z, s), { isSelected: j, select: X, selected: F } = Uk(t, s) ?? {}, { blur: U, focused: _, isFocusTarget: ee, moveFocus: Z, setFocused: re } = $k(t, H, D, j ?? (() => !1), s), { labelDayButton: ce, labelGridcell: pe, labelGrid: Se, labelMonthDropdown: Pe, labelNav: Lt, labelPrevious: dn, labelNext: un, labelWeekday: Xf, labelWeekNumber: Zf, labelWeekNumberHeader: Qf, labelYearDropdown: Jf } = a, ep = wn(() => xk(s, t.ISOWeek, t.broadcastCalendar, t.today), [s, t.ISOWeek, t.broadcastCalendar, t.today]), rs = f !== void 0 || b !== void 0, ao = Re(() => {
    T && (le(T), S?.(T));
  }, [T, le, S]), so = Re(() => {
    I && (le(I), x?.(I));
  }, [le, I, x]), tp = Re((te, se) => (oe) => {
    oe.preventDefault(), oe.stopPropagation(), re(te), !se.disabled && (X?.(te.date, se, oe), b?.(te.date, se, oe));
  }, [X, b, re]), np = Re((te, se) => (oe) => {
    re(te), g?.(te.date, se, oe);
  }, [g, re]), rp = Re((te, se) => (oe) => {
    U(), h?.(te.date, se, oe);
  }, [U, h]), op = Re((te, se) => (oe) => {
    const he = {
      ArrowLeft: [
        oe.shiftKey ? "month" : "day",
        t.dir === "rtl" ? "after" : "before"
      ],
      ArrowRight: [
        oe.shiftKey ? "month" : "day",
        t.dir === "rtl" ? "before" : "after"
      ],
      ArrowDown: [oe.shiftKey ? "year" : "week", "after"],
      ArrowUp: [oe.shiftKey ? "year" : "week", "before"],
      PageUp: [oe.shiftKey ? "year" : "month", "before"],
      PageDown: [oe.shiftKey ? "year" : "month", "after"],
      Home: ["startOfWeek", "before"],
      End: ["endOfWeek", "after"]
    };
    if (he[oe.key]) {
      oe.preventDefault(), oe.stopPropagation();
      const [de, He] = he[oe.key];
      Z(de, He);
    }
    v?.(te.date, se, oe);
  }, [Z, v, t.dir]), ap = Re((te, se) => (oe) => {
    y?.(te.date, se, oe);
  }, [y]), sp = Re((te, se) => (oe) => {
    w?.(te.date, se, oe);
  }, [w]), ip = Re((te, se) => (oe) => {
    const he = Number(oe.target.value), de = s.setMonth(s.startOfMonth(te), he);
    le(s.addMonths(de, -se));
  }, [s, le]), lp = Re((te, se) => (oe) => {
    const he = Number(oe.target.value), de = s.setYear(s.startOfMonth(te), he);
    le(s.addMonths(de, -se));
  }, [s, le]), { className: cp, style: dp } = wn(() => ({
    className: [l[B.Root], t.className].filter(Boolean).join(" "),
    style: { ...C?.[B.Root], ...t.style }
  }), [l, t.className, t.style, C]), up = sk(t), os = (te) => {
    const se = C?.[B.Dropdown], oe = C?.[te];
    if (!(!se && !oe))
      return {
        ...se,
        ...oe
      };
  }, as = Jn(null);
  Pk(as, !!t.animate, {
    classNames: l,
    months: $,
    focused: _,
    dateLib: s
  });
  const fp = {
    dayPickerProps: t,
    selected: F,
    select: X,
    isSelected: j,
    months: $,
    nextMonth: I,
    previousMonth: T,
    goToMonth: le,
    getModifiers: D,
    components: r,
    classNames: l,
    styles: C,
    labels: a,
    formatters: o
  };
  return N.createElement(
    If.Provider,
    { value: fp },
    N.createElement(
      r.Root,
      { rootRef: t.animate ? as : void 0, className: cp, style: dp, dir: t.dir, id: t.id, lang: t.lang ?? i.code, nonce: t.nonce, title: t.title, role: t.role, "aria-label": t["aria-label"], "aria-labelledby": t["aria-labelledby"], ...up },
      N.createElement(
        r.Months,
        { className: l[B.Months], style: C?.[B.Months] },
        !t.hideNavigation && !u && N.createElement(r.Nav, { "data-animated-nav": t.animate ? "true" : void 0, className: l[B.Nav], style: C?.[B.Nav], "aria-label": Lt(), onPreviousClick: ao, onNextClick: so, previousMonth: T, nextMonth: I }),
        $.map((te, se) => {
          const oe = t.reverseMonths ? $.length - 1 - se : se;
          return N.createElement(
            r.Month,
            {
              "data-animated-month": t.animate ? "true" : void 0,
              className: l[B.Month],
              style: C?.[B.Month],
              // biome-ignore lint/suspicious/noArrayIndexKey: breaks animation
              key: se,
              displayIndex: se,
              calendarMonth: te
            },
            u === "around" && !t.hideNavigation && se === 0 && N.createElement(
              r.PreviousMonthButton,
              { type: "button", className: l[B.PreviousMonthButton], style: C?.[B.PreviousMonthButton], tabIndex: T ? void 0 : -1, "aria-disabled": T ? void 0 : !0, "aria-label": dn(T), onClick: ao, "data-animated-button": t.animate ? "true" : void 0 },
              N.createElement(r.Chevron, { disabled: T ? void 0 : !0, className: l[B.Chevron], style: C?.[B.Chevron], orientation: t.dir === "rtl" ? "right" : "left" })
            ),
            N.createElement(r.MonthCaption, { "data-animated-caption": t.animate ? "true" : void 0, className: l[B.MonthCaption], style: C?.[B.MonthCaption], calendarMonth: te, displayIndex: se }, c?.startsWith("dropdown") ? N.createElement(
              r.DropdownNav,
              { className: l[B.Dropdowns], style: C?.[B.Dropdowns] },
              (() => {
                const he = c === "dropdown" || c === "dropdown-months" ? N.createElement(r.MonthsDropdown, { key: "month", className: l[B.MonthsDropdown], "aria-label": Pe(), disabled: !!t.disableNavigation, onChange: ip(te.date, oe), options: yk(te.date, q, z, o, s), style: os(B.MonthsDropdown), value: s.getMonth(te.date) }) : N.createElement("span", { key: "month" }, O(te.date, s)), de = c === "dropdown" || c === "dropdown-years" ? N.createElement(r.YearsDropdown, { key: "year", className: l[B.YearsDropdown], "aria-label": Jf(s.options), disabled: !!t.disableNavigation, onChange: lp(te.date, oe), options: Sk(q, z, o, s, !!t.reverseYears), style: os(B.YearsDropdown), value: s.getYear(te.date) }) : N.createElement("span", { key: "year" }, K(te.date, s));
                return s.getMonthYearOrder() === "year-first" ? [de, he] : [he, de];
              })(),
              N.createElement("span", { role: "status", "aria-live": "polite", style: {
                border: 0,
                clip: "rect(0 0 0 0)",
                height: "1px",
                margin: "-1px",
                overflow: "hidden",
                padding: 0,
                position: "absolute",
                width: "1px",
                whiteSpace: "nowrap",
                wordWrap: "normal"
              } }, E(te.date, s.options, s))
            ) : N.createElement(r.CaptionLabel, { className: l[B.CaptionLabel], style: C?.[B.CaptionLabel], role: "status", "aria-live": "polite" }, E(te.date, s.options, s))),
            u === "around" && !t.hideNavigation && se === m - 1 && N.createElement(
              r.NextMonthButton,
              { type: "button", className: l[B.NextMonthButton], style: C?.[B.NextMonthButton], tabIndex: I ? void 0 : -1, "aria-disabled": I ? void 0 : !0, "aria-label": un(I), onClick: so, "data-animated-button": t.animate ? "true" : void 0 },
              N.createElement(r.Chevron, { disabled: I ? void 0 : !0, className: l[B.Chevron], style: C?.[B.Chevron], orientation: t.dir === "rtl" ? "left" : "right" })
            ),
            se === m - 1 && u === "after" && !t.hideNavigation && N.createElement(r.Nav, { "data-animated-nav": t.animate ? "true" : void 0, className: l[B.Nav], style: C?.[B.Nav], "aria-label": Lt(), onPreviousClick: ao, onNextClick: so, previousMonth: T, nextMonth: I }),
            N.createElement(
              r.MonthGrid,
              { role: "grid", "aria-multiselectable": f === "multiple" || f === "range", "aria-label": Se(te.date, s.options, s) || void 0, className: l[B.MonthGrid], style: C?.[B.MonthGrid] },
              !t.hideWeekdays && N.createElement(
                r.Weekdays,
                { "data-animated-weekdays": t.animate ? "true" : void 0, className: l[B.Weekdays], style: C?.[B.Weekdays] },
                k && N.createElement(r.WeekNumberHeader, { "aria-label": Qf(s.options), className: l[B.WeekNumberHeader], style: C?.[B.WeekNumberHeader], scope: "col" }, W()),
                ep.map((he) => N.createElement(r.Weekday, { "aria-label": Xf(he, s.options, s), className: l[B.Weekday], key: String(he), style: C?.[B.Weekday], scope: "col" }, Y(he, s.options, s)))
              ),
              N.createElement(r.Weeks, { "data-animated-weeks": t.animate ? "true" : void 0, className: l[B.Weeks], style: C?.[B.Weeks] }, te.weeks.map((he) => N.createElement(
                r.Week,
                { className: l[B.Week], key: he.weekNumber, style: C?.[B.Week], week: he },
                k && N.createElement(r.WeekNumber, { week: he, style: C?.[B.WeekNumber], "aria-label": Zf(he.weekNumber, {
                  locale: i
                }), className: l[B.WeekNumber], scope: "row", role: "rowheader" }, R(he.weekNumber, s)),
                he.days.map((de) => {
                  const { date: He } = de, ie = D(de);
                  if (ie[me.focused] = !ie.hidden && !!_?.isEqualTo(de), ie[Le.selected] = j?.(He) || ie.selected, ro(F)) {
                    const { from: io, to: lo } = F;
                    ie[Le.range_start] = !!(io && lo && s.isSameDay(He, io)), ie[Le.range_end] = !!(io && lo && s.isSameDay(He, lo)), ie[Le.range_middle] = et(F, He, !0, s);
                  }
                  const pp = wk(ie, C, t.modifiersStyles), mp = ok(ie, l, t.modifiersClassNames), hp = !rs && !ie.hidden ? pe(He, ie, s.options, s) : void 0;
                  return N.createElement(r.Day, { key: `${de.isoDate}_${de.displayMonthId}`, day: de, modifiers: ie, className: mp.join(" "), style: pp, role: "gridcell", "aria-selected": ie.selected || void 0, "aria-label": hp, "data-day": de.isoDate, "data-month": de.outside ? de.dateMonthId : void 0, "data-selected": ie.selected || void 0, "data-disabled": ie.disabled || void 0, "data-hidden": ie.hidden || void 0, "data-outside": de.outside || void 0, "data-focused": ie.focused || void 0, "data-today": ie.today || void 0 }, !ie.hidden && rs ? N.createElement(r.DayButton, { className: l[B.DayButton], style: C?.[B.DayButton], type: "button", day: de, modifiers: ie, disabled: !ie.focused && ie.disabled || void 0, "aria-disabled": ie.focused && ie.disabled || void 0, tabIndex: ee(de) ? 0 : -1, "aria-label": ce(He, ie, s.options, s), onClick: tp(de, ie), onBlur: rp(de, ie), onFocus: np(de, ie), onKeyDown: op(de, ie), onMouseEnter: ap(de, ie), onMouseLeave: sp(de, ie) }, M(He, s.options, s)) : !ie.hidden && M(de.date, s.options, s));
                })
              )))
            )
          );
        })
      ),
      t.footer && N.createElement(r.Footer, { className: l[B.Footer], style: C?.[B.Footer], role: "status", "aria-live": "polite" }, t.footer)
    )
  );
}
function Kk({
  className: e,
  classNames: t,
  showOutsideDays: n = !0,
  captionLayout: r = "label",
  buttonVariant: o = "ghost",
  locale: a,
  formatters: s,
  components: i,
  ...l
}) {
  const c = ns();
  return /* @__PURE__ */ p(
    jk,
    {
      showOutsideDays: n,
      className: P(
        "group/calendar bg-background p-2 [--cell-radius:var(--radius-md)] [--cell-size:--spacing(7)] in-data-[slot=card-content]:bg-transparent in-data-[slot=popover-content]:bg-transparent",
        String.raw`rtl:**:[.rdp-button\_next>svg]:rotate-180`,
        String.raw`rtl:**:[.rdp-button\_previous>svg]:rotate-180`,
        e
      ),
      captionLayout: r,
      locale: a,
      formatters: {
        formatMonthDropdown: (f) => f.toLocaleString(a?.code, { month: "short" }),
        ...s
      },
      classNames: {
        root: P("w-fit", c.root),
        months: P(
          "relative flex flex-col gap-4 md:flex-row",
          c.months
        ),
        month: P("flex w-full flex-col gap-4", c.month),
        nav: P(
          "absolute inset-x-0 top-0 flex w-full items-center justify-between gap-1",
          c.nav
        ),
        button_previous: P(
          Jo({ variant: o }),
          "size-(--cell-size) p-0 select-none aria-disabled:opacity-50",
          c.button_previous
        ),
        button_next: P(
          Jo({ variant: o }),
          "size-(--cell-size) p-0 select-none aria-disabled:opacity-50",
          c.button_next
        ),
        month_caption: P(
          "flex h-(--cell-size) w-full items-center justify-center px-(--cell-size)",
          c.month_caption
        ),
        dropdowns: P(
          "flex h-(--cell-size) w-full items-center justify-center gap-1.5 text-sm font-medium",
          c.dropdowns
        ),
        dropdown_root: P(
          "relative rounded-(--cell-radius)",
          c.dropdown_root
        ),
        dropdown: P(
          "absolute inset-0 bg-popover opacity-0",
          c.dropdown
        ),
        caption_label: P(
          "font-medium select-none",
          r === "label" ? "text-sm" : "flex items-center gap-1 rounded-(--cell-radius) text-sm [&>svg]:size-3.5 [&>svg]:text-muted-foreground",
          c.caption_label
        ),
        month_grid: P("w-full border-collapse", c.month_grid),
        weekdays: P("flex", c.weekdays),
        weekday: P(
          "flex-1 rounded-(--cell-radius) text-[0.8rem] font-normal text-muted-foreground select-none",
          c.weekday
        ),
        week: P("mt-2 flex w-full", c.week),
        week_number_header: P(
          "w-(--cell-size) select-none",
          c.week_number_header
        ),
        week_number: P(
          "text-[0.8rem] text-muted-foreground select-none",
          c.week_number
        ),
        day: P(
          "group/day relative aspect-square h-full w-full rounded-(--cell-radius) p-0 text-center select-none [&:last-child[data-selected=true]_button]:rounded-r-(--cell-radius)",
          l.showWeekNumber ? "[&:nth-child(2)[data-selected=true]_button]:rounded-l-(--cell-radius)" : "[&:first-child[data-selected=true]_button]:rounded-l-(--cell-radius)",
          c.day
        ),
        range_start: P(
          "relative isolate z-0 rounded-l-(--cell-radius) bg-muted after:absolute after:inset-y-0 after:right-0 after:w-4 after:bg-muted",
          c.range_start
        ),
        range_middle: P("rounded-none", c.range_middle),
        range_end: P(
          "relative isolate z-0 rounded-r-(--cell-radius) bg-muted after:absolute after:inset-y-0 after:left-0 after:w-4 after:bg-muted",
          c.range_end
        ),
        today: P(
          "rounded-(--cell-radius) bg-muted text-foreground data-[selected=true]:rounded-none",
          c.today
        ),
        outside: P(
          "text-muted-foreground aria-selected:text-muted-foreground",
          c.outside
        ),
        disabled: P(
          "text-muted-foreground opacity-50",
          c.disabled
        ),
        hidden: P("invisible", c.hidden),
        ...t
      },
      components: {
        Root: ({ className: f, rootRef: u, ...m }) => /* @__PURE__ */ p(
          "div",
          {
            "data-slot": "calendar",
            ref: u,
            className: P(f),
            ...m
          }
        ),
        Chevron: ({ className: f, orientation: u, ...m }) => u === "left" ? /* @__PURE__ */ p(af, { className: P("size-4", f), ...m }) : u === "right" ? /* @__PURE__ */ p(Ka, { className: P("size-4", f), ...m }) : /* @__PURE__ */ p(eo, { className: P("size-4", f), ...m }),
        DayButton: ({ ...f }) => /* @__PURE__ */ p(qk, { locale: a, ...f }),
        WeekNumber: ({ children: f, ...u }) => /* @__PURE__ */ p("td", { ...u, children: /* @__PURE__ */ p("div", { className: "flex size-(--cell-size) items-center justify-center text-center", children: f }) }),
        ...i
      },
      ...l
    }
  );
}
function qk({
  className: e,
  day: t,
  modifiers: n,
  locale: r,
  ...o
}) {
  const a = ns(), s = d.useRef(null);
  return d.useEffect(() => {
    n.focused && s.current?.focus();
  }, [n.focused]), /* @__PURE__ */ p(
    Et,
    {
      ref: s,
      variant: "ghost",
      size: "icon",
      "data-day": t.date.toLocaleDateString(r?.code),
      "data-selected-single": n.selected && !n.range_start && !n.range_end && !n.range_middle,
      "data-range-start": n.range_start,
      "data-range-end": n.range_end,
      "data-range-middle": n.range_middle,
      className: P(
        "relative isolate z-10 flex aspect-square size-auto w-full min-w-(--cell-size) flex-col gap-1 border-0 leading-none font-normal group-data-[focused=true]/day:relative group-data-[focused=true]/day:z-10 group-data-[focused=true]/day:border-ring group-data-[focused=true]/day:ring-[3px] group-data-[focused=true]/day:ring-ring/50 data-[range-end=true]:rounded-(--cell-radius) data-[range-end=true]:rounded-r-(--cell-radius) data-[range-end=true]:bg-primary data-[range-end=true]:text-primary-foreground data-[range-middle=true]:rounded-none data-[range-middle=true]:bg-muted data-[range-middle=true]:text-foreground data-[range-start=true]:rounded-(--cell-radius) data-[range-start=true]:rounded-l-(--cell-radius) data-[range-start=true]:bg-primary data-[range-start=true]:text-primary-foreground data-[selected-single=true]:bg-primary data-[selected-single=true]:text-primary-foreground dark:hover:text-foreground [&>span]:text-xs [&>span]:opacity-70",
        a.day,
        e
      ),
      ...o
    }
  );
}
function lP({
  value: e,
  onChange: t,
  disabled: n
}) {
  const [r, o] = d.useState(!1), a = d.useMemo(() => new Date(e), [e]), [s, i] = d.useState(a), l = fi(a, !0), c = d.useRef(null);
  return /* @__PURE__ */ p(Ux, { className: "w-full", children: /* @__PURE__ */ ae(hS, { children: [
    /* @__PURE__ */ p(
      wS,
      {
        id: "date-required",
        value: l,
        readOnly: !0,
        disabled: n
      }
    ),
    /* @__PURE__ */ p(vS, { align: "inline-end", children: /* @__PURE__ */ ae(ES, { open: r, onOpenChange: o, children: [
      /* @__PURE__ */ p(MS, { asChild: !0, children: /* @__PURE__ */ ae(
        yS,
        {
          id: "date-picker",
          variant: "ghost",
          size: "icon-xs",
          "aria-label": "Select date",
          disabled: n,
          children: [
            /* @__PURE__ */ p(eS, {}),
            /* @__PURE__ */ p("span", { className: "sr-only", children: "Select date" })
          ]
        }
      ) }),
      /* @__PURE__ */ p(
        PS,
        {
          ref: c,
          className: "w-auto overflow-hidden p-0 h-[295px]",
          align: "end",
          alignOffset: -8,
          sideOffset: 10,
          onFocusOutside: (u) => u.preventDefault(),
          onInteractOutside: (u) => {
            const m = u.target;
            m && c.current?.contains(m) && u.preventDefault();
          },
          children: /* @__PURE__ */ p(
            Kk,
            {
              mode: "single",
              selected: a,
              month: s,
              onMonthChange: i,
              onSelect: (u) => {
                if (!u) {
                  o(!1);
                  return;
                }
                o(!1), t?.(fi(u));
              }
            }
          )
        }
      )
    ] }) })
  ] }) });
}
function fi(e, t = !1) {
  if (!e)
    return "";
  if (t)
    return e.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric"
    });
  const n = e.getFullYear(), r = String(e.getMonth() + 1).padStart(2, "0"), o = String(e.getDate()).padStart(2, "0");
  return `${n}-${r}-${o}`;
}
export {
  SE as Accordion,
  EE as AccordionContent,
  CE as AccordionItem,
  kE as AccordionTrigger,
  sM as AlertDialog,
  mM as AlertDialogAction,
  hM as AlertDialogCancel,
  lM as AlertDialogContent,
  pM as AlertDialogDescription,
  dM as AlertDialogFooter,
  cM as AlertDialogHeader,
  uM as AlertDialogMedia,
  fM as AlertDialogTitle,
  iM as AlertDialogTrigger,
  IE as Avatar,
  LE as AvatarBadge,
  FE as AvatarFallback,
  $E as AvatarGroup,
  zE as AvatarGroupCount,
  WE as AvatarImage,
  YE as Badge,
  Et as Button,
  lE as ButtonGroup,
  Kk as Calendar,
  qk as CalendarDayButton,
  ME as Card,
  NE as CardAction,
  _E as CardContent,
  OE as CardDescription,
  RE as CardFooter,
  PE as CardHeader,
  DE as CardTitle,
  vE as Checkbox,
  RM as Collapsible,
  AM as CollapsibleContent,
  TM as CollapsibleTrigger,
  yM as Command,
  SM as CommandEmpty,
  wM as CommandInput,
  CM as CommandItem,
  xM as CommandList,
  lP as DatePicker,
  $M as Dialog,
  BM as DialogClose,
  YM as DialogContent,
  UM as DialogDescription,
  VM as DialogFooter,
  HM as DialogHeader,
  tC as DialogOverlay,
  eC as DialogPortal,
  GM as DialogTitle,
  zM as DialogTrigger,
  jM as DropdownMenu,
  JM as DropdownMenuCheckboxItem,
  XM as DropdownMenuContent,
  ZM as DropdownMenuGroup,
  QM as DropdownMenuItem,
  nP as DropdownMenuLabel,
  KM as DropdownMenuPortal,
  eP as DropdownMenuRadioGroup,
  tP as DropdownMenuRadioItem,
  rP as DropdownMenuSeparator,
  oP as DropdownMenuShortcut,
  aP as DropdownMenuSub,
  iP as DropdownMenuSubContent,
  sP as DropdownMenuSubTrigger,
  qM as DropdownMenuTrigger,
  Ux as Field,
  nE as FieldContent,
  aE as FieldDescription,
  iE as FieldError,
  tE as FieldGroup,
  rE as FieldLabel,
  eE as FieldLegend,
  sE as FieldSeparator,
  Jk as FieldSet,
  oE as FieldTitle,
  pS as Input,
  hS as InputGroup,
  vS as InputGroupAddon,
  yS as InputGroupButton,
  wS as InputGroupInput,
  wE as InputGroupText,
  xE as InputGroupTextarea,
  Hx as Label,
  eM as Pagination,
  tM as PaginationContent,
  aM as PaginationEllipsis,
  nM as PaginationItem,
  uf as PaginationLink,
  oM as PaginationNext,
  rM as PaginationPrevious,
  ES as Popover,
  PS as PopoverContent,
  bM as PopoverDescription,
  gM as PopoverHeader,
  vM as PopoverTitle,
  MS as PopoverTrigger,
  BE as Progress,
  TE as ScrollArea,
  xS as ScrollBar,
  cE as Select,
  pE as SelectContent,
  dE as SelectGroup,
  hE as SelectItem,
  mE as SelectLabel,
  fS as SelectScrollDownButton,
  uS as SelectScrollUpButton,
  gE as SelectSeparator,
  fE as SelectTrigger,
  uE as SelectValue,
  Vx as Separator,
  kM as Sheet,
  MM as SheetClose,
  PM as SheetContent,
  _M as SheetDescription,
  OM as SheetFooter,
  DM as SheetHeader,
  NM as SheetTitle,
  EM as SheetTrigger,
  AE as Skeleton,
  yE as Slider,
  bE as Switch,
  UE as Table,
  KE as TableBody,
  JE as TableCaption,
  QE as TableCell,
  qE as TableFooter,
  ZE as TableHead,
  jE as TableHeader,
  XE as TableRow,
  mS as Textarea,
  HE as Toggle,
  VE as ToggleGroup,
  GE as ToggleGroupItem,
  WM as Tooltip,
  LM as TooltipContent,
  IM as TooltipProvider,
  FM as TooltipTrigger,
  SS as badgeVariants,
  Jo as buttonVariants,
  P as cn,
  cf as toggleVariants
};
